<template>
	<div class="medical-workstation">
		<div class="main-container">
			<div class="sidebar-collapse-btn left" @click="toggleLeftSidebar"
				:style="{ left: leftSidebarCollapsed ? '0' : '16.1%' }"
				:title="leftSidebarCollapsed ? '展开左侧边栏' : '收起左侧边栏'">
				<i :class="leftSidebarCollapsed ? 'el-icon-caret-right' : 'el-icon-caret-left'"></i>
			</div>
			<!-- 左侧边栏 -->
			<el-aside width="16%" class="modern-sidebar" v-show="!leftSidebarCollapsed">
				<div class="sidebar-container">
					<!-- 待诊病人表格 (30%高度) -->
					<div class="waiting-table">
						<div class="table-header">
							<span class="title">待诊病人 ({{ tableData1.length }})人</span>
							<el-button size="mini" type="primary" @click="handleRefreshTable">刷新</el-button>
						</div>
						<el-table size="mini" border ref="tableData1" :data="tableData1" class="sticky-header-table"
							@row-contextmenu="handleReceptionClick" @row-click="handleClickRow">
							<el-table-column v-for="(col, inx) in tableRows1" :key="inx" :type="col.type"
								:prop="col.prop" :label="col.name" :render-header="labelHead" align="center"
								:min-width="getColumnWidth(col.label,col.prop,tableData1)" />
						</el-table>
						<div v-show="showReception" class="context-menu"
							:style="{left: contextMenuLeft + 'px', top: contextMenuTop + 'px'}">
							<div class="menu-item" @click="handleMenuClick(1)">接诊</div>
						</div>
					</div>

					<!-- 接诊病人表格 (70%高度) -->
					<div class="reception-table">
						<div class="table-header">
							<span class="title">接诊病人 ({{ tableData2.length }})人</span>
							<el-button size="mini" type="primary" @click="handleFastReceptionClick"
								v-if="$store.getters.hasPermission('system:outpatientPhysician:fastReception')">快速接诊
							</el-button>
						</div>
						<el-table size="mini" border :data="tableData2" class="sticky-header-table"
							@row-contextmenu="handleCancelReceptionClick" @row-click="handleClickReceptionRow">
							<el-table-column v-for="(col, inx) in tableRows2" :key="inx" :type="col.type"
								:prop="col.prop" :label="col.name" :render-header="labelHead" align="center"
								:min-width="getColumnWidth(col.label,col.prop,tableData2)">
								<template #default="{ row }">
									{{ safeGetMappedValue(col, row) }}
								</template>
							</el-table-column>
						</el-table>
						<!-- 右键菜单 -->
						<div v-show="showCancelReception" class="context-menu"
							:style="{left: contextMenuLeft + 'px', top: contextMenuTop + 'px'}">
							<div class="menu-item" @click="handleMenuClick(3)">完成接诊</div>
							<div class="menu-item" @click="handleMenuClick(2)">取消接诊</div>
						</div>
					</div>
				</div>
			</el-aside>

			<!-- 主内容区 -->
			<el-main class="content" :style="{
        width: 'calc(100% - ' +
                (leftSidebarCollapsed ? 0 : 16) + '% - ' +
                (rightSidebarCollapsed ? 0 : 17) + '%)'
      }">
				<!-- 标签页头部 -->
        <div class="tab-header">
          <div class="tab-container">
            <!-- 标签页部分 -->
            <div class="custom-tabs">
              <div class="custom-tab-item" :class="{ active: activeTab === 'outpatient' }"
                   @click="activeTab = 'outpatient'">
                <i class="el-icon-document"></i>
                <span>门诊</span>
              </div>

              <div v-if="patientForm.name !== ''" class="custom-tab-item"
                   :class="{ active: activeTab === 'charge' }" @click="activeTab = 'charge'">
                <i class="el-icon-money"></i>
                <span>收费</span>
              </div>

              <div v-if="patientForm.name !== ''" class="custom-tab-item"
                   :class="{ active: activeTab === 'dispensing' }" @click="activeTab = 'dispensing'">
                <i class="el-icon-s-order"></i>
                <span>发药</span>
              </div>

<!--              <div v-if="patientForm.name !== ''" class="custom-tab-item"
                   :class="{ active: activeTab === 'print' }" @click="activeTab = 'print'">
                <i class="el-icon-printer"></i>
                <span>打印</span>
              </div>-->

              <div v-if="patientForm.name !== ''" class="custom-tab-item"
                   :class="{ active: activeTab === 'followup' }" @click="activeTab = 'followup'">
                <i class="el-icon-date"></i>
                <span>随访执行</span>
              </div>

<!--              <div v-if="patientForm.name !== ''" class="custom-tab-item"
                   :class="{ active: activeTab === 'outpatientRecord' }" @click="activeTab = 'outpatientRecord'">
                <i class="el-icon-edit-outline"></i>
                <span>门诊记录</span>
              </div>-->
            </div>

            <!-- 右侧按钮组 - 保持原有位置和功能 -->
            <div class="header-actions">
              <span class="visit-count" v-if="patientForm.repeated">第{{ patientForm.repeated }}次就诊</span>
              <el-dropdown size="mini" trigger="click" placement="bottom-start"
                           :disabled="patientForm.patId === ''">
                <el-button size="mini" type="primary" :disabled="patientForm.patId === ''">
                  打印
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" class="button-style-dropdown">
                  <el-dropdown-item
                      v-if="$store.getters.hasPermission('system:outpatientPhysician:medicalRecordDocument')"
                      class="dropdown-button-item">
                    <el-button size="mini" type="primary"
                               @click.native="handleOpenDrawer('medicalRecord')"
                               style="width: 100%; border: none; background: transparent; color: inherit;">
                      病历文书
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-if="$store.getters.hasPermission('system:outpatientPhysician:diagnosisAndTreatment')"
                      class="dropdown-button-item">
                    <el-button @click.native="handleOpenDrawer('outpatientsDiagnosis')" size="mini"
                               type="primary"
                               style="width: 100%; border: none; background: transparent; color: inherit;">
                      门诊诊疗
                    </el-button>
                  </el-dropdown-item>
<!--                  <el-dropdown-item class="dropdown-button-item">
                    <el-button @click.native="handleGetDataDistributeAndPrint(doctorAdviceRowData)"
                               size="mini" type="primary"
                               style="width: 100%; border: none; background: transparent; color: inherit;">
                      打印处方
                    </el-button>
                  </el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>

              <el-button size="mini" type="primary" :disabled="patientForm.patId === ''" @click="openFollowDialog">随访</el-button>
<!--              <el-button size="mini" type="primary" @click="handleRecordingModalData"
                         v-if="$store.getters.hasPermission('system:outpatientPhysician:audioRecording')"
                         :disabled="patientForm.patId === ''">录音记录
              </el-button>-->
              <el-button size="mini" type="primary" @click="handleSavenData"
                         v-if="$store.getters.hasPermission('system:outpatientPhysician:medicalVisitRecord')">
                就诊记录
              </el-button>
            </div>
          </div>
        </div>

				<!-- 门诊标签页内容 -->
				<div v-show="activeTab === 'outpatient'" class="tab-content">
					<div class="seedoctorMedical">
            <!-- 患者信息展示区 -->
            <div class="patient-info-card" v-if="patientForm.patId">
              <div class="info-grid">
                <!-- 姓名 -->
                <div class="info-item">
                  <i class="el-icon-user-solid" style="color: #409EFF; font-size: 14px; margin-right: 4px;"></i>
                  <span class="info-value name-value">{{ patientForm.name || '-' }}</span>
                </div>
                <!-- 性别 -->
                <div class="info-item">
                  <i class="el-icon-male" style="color: #409EFF; font-size: 14px; margin-right: 4px;"></i>
                  <span class="info-value">{{ patientForm.sex === '1' ? '男' : patientForm.sex === '2' ? '女' : '-' }}</span>
                </div>
                <!-- 年龄 -->
                <div class="info-item">
                  <i class="el-icon-date" style="color: #409EFF; font-size: 14px; margin-right: 4px;"></i>
                  <span class="info-value">
        <template v-if="patientForm.ageYear || patientForm.ageMonth">
          {{ patientForm.ageYear || 0 }}岁{{ patientForm.ageMonth || 0 }}月
        </template>
        <template v-else>-</template>
      </span>
                </div>
                <!-- 电话 -->
                <div class="info-item">
                  <i class="el-icon-phone" style="color: #409EFF; font-size: 14px; margin-right: 4px;"></i>
                  <span class="info-value">{{ patientForm.tel || '-' }}</span>
                </div>
                <!-- 科室 -->
                <div class="info-item">
                  <i class="el-icon-location" style="color: #409EFF; font-size: 14px; margin-right: 4px;"></i>
                  <span class="info-value">{{ deptOptions.find(item => item.id === userInfo.selDept)?.label || '-' }}</span>
                </div>
                <!-- 支付类型 -->
                <div class="info-item">
                  <i class="el-icon-credit-card" style="color: #409EFF; font-size: 14px; margin-right: 4px;"></i>
                  <el-select
                      v-model="paymentType"
                      size="mini"
                      style="width: 76px;"
                      placeholder="支付类型"
                      class="borderless-select">
                    <el-option label="自费" value="0"></el-option>
                    <el-option label="医保" value="1"></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <!-- 无患者时显示占位提示 -->
            <div class="empty-placeholder" v-else>
              <span style="color: #909399; font-size: 14px;">请选择患者开始接诊</span>
            </div>
						<div class="medical-header">
							<span class="clinic-title">病历</span>
<!--							<div class="header-actions">
								<el-button style="padding: 7px 8px;" size="mini" @click.stop="showRecordingModal = true"
									:disabled="patientForm.patId === ''"
									v-if="$store.getters.hasPermission('system:outpatientPhysician:medicalRecordRecording')">
									<div style="display: flex; align-items: center;">
										<i class="el-icon-microphone"
											style="font-size: 14px; color: #E6A23C;margin: 0"></i>
										<span style="font-size: 12px;">{{ isRecording ? '录制中' : '病历录音' }}</span>
									</div>
								</el-button>
							</div>-->
						</div>
						<el-descriptions class="medical-history" :column="1" size="mini" border>
              <el-descriptions-item>
                <template slot="label">
                  <div style="text-align: center; width: 100%">生命体征</div>
                </template>

                <!-- 三个输入框同一行 -->
                <div style="display: flex; align-items: center; gap: 8px;">
                  <!-- 收缩压 -->
                  <div style="flex: 1; min-width: 0;">
                    <el-input
                        ref="syspreRef"
                        prop="syspre"
                        v-model.number="patientForm.syspre"
                        size="mini"
                        :style="{ color: isSyspreInvalid ? '#F56C6C' : '' }"
                        placeholder="收缩压"
                        @input="handleBloodPressureInput('syspre', $event)"
                        @blur="validateBloodPressure"
                        class="cell-input"
                    />
                  </div>

                  <span style="color: #ccc;">/</span>

                  <!-- 舒张压 -->
                  <div style="flex: 1; min-width: 0;">
                    <el-input
                        ref="diapreRef"
                        prop="diapre"
                        v-model.number="patientForm.diapre"
                        size="mini"
                        :style="{ color: isDiapreInvalid ? '#F56C6C' : '' }"
                        placeholder="舒张压"
                        @input="handleBloodPressureInput('diapre', $event)"
                        @blur="validateBloodPressure"
                        class="cell-input"
                    />
                  </div>

                  <span style="color: #ddd; margin: 0 2px;">|</span>

                  <!-- 血糖：下拉选择 + 输入框 -->
                  <div style="flex: 1.2; min-width: 0; display: flex; align-items: center; gap: 4px;">
                    <el-dropdown
                        size="mini"
                        @command="(val) => { patientForm.bloodType = val; handleSaveIfValid(); }"
                        trigger="click"
                        style="display: inline-flex; align-items: center; flex-shrink: 0;">
        <span style="cursor: pointer; font-size: 12px; color: #409EFF; display: inline-flex; align-items: center; border: 1px solid #dcdfe6; border-radius: 4px; padding: 0 6px; height: 24px; background: #fff;">
          {{ getBloodTypeLabel(patientForm.bloodType) || '选择' }}
          <i class="el-icon-arrow-down" style="font-size: 12px; margin-left: 2px;"></i>
        </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="item in bloodTypeOptions"
                            :key="item.id"
                            :command="item.id">
                          {{ item.label }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-input
                        v-model="patientForm.bloodNumber"
                        ref="bloodNumberRef"
                        prop="bloodNumber"
                        size="mini"
                        style="flex: 1; min-width: 50px;"
                        :class="{ 'blood-error': isBloodNumberInvalid }"
                        :disabled="!patientForm.bloodType"
                        placeholder="血糖"
                        @input="handleBloodNumberInput($event)"
                        @blur="validateBloodNumber"
                        class="cell-input"
                    />
                  </div>
                </div>
              </el-descriptions-item>              <el-descriptions-item>
								<template slot="label">
									<div style="text-align: center; width: 100%">主诉</div>
								</template>
								<el-input size="mini" v-if="!showPatientTellSelect" data-field="patientTell"
									placeholder="单击选择诊断" v-model="addSeedoctorForm.patientTell"
									@dblclick.native="switchToSelect(1)" @focus="handleGetMedicalKeywordList(1)"
									@blur="choosePatientTell" style="width: 100%" :border="false"
									class="cell-input"></el-input>
								<el-select v-else size="mini" ref="showPatientTellSelect"
									v-model="addSeedoctorForm.patientTell" filterable clearable allow-create
									placeholder="选择或输入诊断" style="width: 100%; font-size: 12px;" @blur="handleBlur"
									@change="choosePatientTell">
									<el-option v-for="item in complainTemplateOptions" :key="item.id"
										:label="item.label" :value="item.label">
										<span style="float: right"
											v-if="$store.getters.hasPermission('system:complaintemplate:edit')">
											<el-button size="mini" type="primary" plain
												@click="handleEditAllTemplate(1,item)"
												style="margin-left: 6px; padding: 4px;">修改</el-button>
										</span>
										<span style="float: left; color: #8492a6; font-size: 12px;">
											{{ item.label }} - 备注:{{ item.data?.remark ? `（${item.data.remark}）` : '' }}
										</span>
									</el-option>
									<el-option :value="undefined" disabled style="cursor: pointer"
										v-if="$store.getters.hasPermission('system:complaintemplate:add')">
										<el-button type="text" @click="handleAddAllTemplate(1)" style="padding: 0;">
											<i class="el-icon-plus" style="font-weight: bold"></i> 新增主诉模板
										</el-button>
									</el-option>
								</el-select>
							</el-descriptions-item>

							<el-descriptions-item>
								<template slot="label">
									<div style="text-align: center; width: 100%">现病史</div>
								</template>
								<el-input v-if="!showNowHistorySelect" data-field="nowHistory" placeholder="单击选择诊断"
									v-model="addSeedoctorForm.nowHistory" @focus="handleGetMedicalKeywordList(2)"
									@dblclick.native="switchToSelect(2)" @blur="chooseNowHistory" style="width: 100%"
									:border="false" size="mini" class="cell-input"></el-input>
								<el-select v-else size="mini" ref="showNowHistorySelect"
									v-model="addSeedoctorForm.nowHistory" filterable clearable allow-create
									placeholder="选择或输入诊断" style="width: 100%; font-size: 12px;" @blur="handleBlur"
									@change="chooseNowHistory">
									<el-option v-for="item in nowHistoryTemplateOptions" :key="item.id"
										:label="item.label" :value="item.label">
										<span style="float: right"
											v-if="$store.getters.hasPermission('system:nowsickness:edit')">
											<el-button size="mini" type="primary" plain
												@click="handleEditAllTemplate(2,item)"
												style="margin-left: 6px; padding: 4px;">修改</el-button>
										</span>
										<span style="float: left; color: #8492a6; font-size: 12px;">
											{{ item.label }} - 备注:
											{{ item.data?.remark ? `（${item.data.remark}）` : '' }}
										</span>
									</el-option>
									<el-option :value="undefined" disabled style="cursor: pointer"
										v-if="$store.getters.hasPermission('system:nowsickness:add')">
										<el-button type="text" @click="handleAddAllTemplate(2)" style="padding: 0;">
											<i class="el-icon-plus" style="font-weight: bold"></i> 新增现病史模板
										</el-button>
									</el-option>
								</el-select>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<div style="text-align: center; width: 100%">既往史</div>
								</template>
								<el-input v-if="!showBeforeHistorySelect" data-field="beforeHistory"
									placeholder="单击选择诊断" v-model="addSeedoctorForm.beforeHistory"
									@focus="handleGetMedicalKeywordList(3)" @dblclick.native="switchToSelect(3)"
									@blur="chooseBeforeHistory" style="width: 100%" :border="false" size="mini"
									class="cell-input"></el-input>
								<el-select v-else size="mini" ref="showBeforeHistorySelect"
									v-model="addSeedoctorForm.beforeHistory" filterable clearable allow-create
									placeholder="选择或输入诊断" style="width: 100%; font-size: 12px;" @blur="handleBlur"
									@change="chooseBeforeHistory">
									<el-option v-for="item in beforeHistoryTemplateOptions" :key="item.id"
										:label="item.label" :value="item.label">
										<span style="float: right"
											v-if="$store.getters.hasPermission('system:history:edit')">
											<el-button size="mini" type="primary" plain
												@click="handleEditAllTemplate(3,item)"
												style="margin-left: 6px; padding: 4px;">修改</el-button>
										</span>
										<span style="float: left; color: #8492a6; font-size: 12px;">
											{{ item.label }} - 备注:
											{{ item.data?.remark ? `（${item.data.remark}）` : '' }}
										</span>
									</el-option>
									<el-option :value="undefined" disabled style="cursor: pointer"
										v-if="$store.getters.hasPermission('system:history:add')">
										<el-button type="text" @click="handleAddAllTemplate(3)" style="padding: 0;">
											<i class="el-icon-plus" style="font-weight: bold"></i> 新增既往史模板
										</el-button>
									</el-option>
								</el-select>

							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<div style="text-align: center; width: 100%">西医诊断</div>
								</template>
								<el-input size="mini" class="cell-input" v-model="addSeedoctorForm.westernDiagnos"
									placeholder="双击选择诊断" readonly clearable
									style="width: 100%; font-size: 12px; padding-right: 30px;"
									:autosize="{ minRows: 1, maxRows: 2 }" @dblclick.native="getWesternDiagnosisData">
								</el-input>
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									<div style="text-align: center; width: 100%">中医诊断</div>
								</template>
								<el-input size="mini" class="cell-input" v-model="addSeedoctorForm.chinaDiagnose"
									placeholder="双击选择诊断" readonly clearable
									style="width: 100%; font-size: 12px; padding-right: 30px;"
									:autosize="{ minRows: 1, maxRows: 2 }" @dblclick.native="getChinaDiagnosisOptions">
								</el-input>
							</el-descriptions-item>
						</el-descriptions>

						<div class="keywords-panel" v-if="keywordsVisible" @click.stop>
							<div class="keywords-content-expanded">
								<div v-for="group in keywordGroups[activeField]" :key="group.type"
									class="group-section">
									<div class="group-title">
										{{ group.title }}
									</div>
									<div class="group-keywords">
										<el-tag v-for="(word, index) in group.keywords" :key="index"
											@click.native="addKeyword(word)" class="keyword-tag">
											{{ word }}
										</el-tag>
									</div>
								</div>
							</div>
						</div>
					</div>

          <!-- 处置项目 -->
          <div class="seedoctorMedical">
            <div class="medical-header">
              <span class="clinic-title">处置项目</span>
<!--              <div class="header-actions">
                <el-button size="mini" style="padding: 7px 8px;" @click="handleClearAllDispose" :disabled="patientForm.patId === ''">
                  <div style="display: flex; align-items: center;">
                    <i class="el-icon-delete" style="font-size: 14px; color: #E6A23C;margin: 0"></i>
                    <span style="font-size: 12px;">清空</span>
                  </div>
                </el-button>
                <el-button size="mini" style="padding: 7px 8px;" @click="handleConfirmDisposeItem"
                           v-if="!isShowPrescription" :disabled="patientForm.patId === ''">
                  <div style="display: flex; align-items: center;">
                    <i class="el-icon-edit-outline" style="font-size: 14px; color: #E6A23C;margin: 0"></i>
                    <span style="font-size: 12px;">提交处置</span>
                  </div>
                </el-button>
              </div>-->
            </div>

            <!-- 处置项目表格 -->
            <div style="border: 1px solid #DCDFE6; border-top: none; border-radius: 0 0 8px 8px;">
              <el-table size="mini" ref="disposeTableData"
                        style="width: 100% !important;margin: 0 !important;border-radius: 0 0 8px 8px;"
                        :data="doctordisposeTableData" border highlight-current-row row-key="id"
                        :class="{ 'disabled-table': isShowPrescription }">

                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <template v-if="getDisposeDataCount() > 1">
                      <el-button :disabled="isShowPrescription || scope.row.adviceId > 0" size="mini" type="text"
                                 @click="removeDoctordisposeSelected(scope.$index)">移除
                      </el-button>
                    </template>
                    <template v-else>
                      <span style="color: #c0c4cc; font-size: 12px;">-</span>
                    </template>
                  </template>
                </el-table-column>

                <el-table-column
                    v-for="(col, inx) in tableRowsDispose"
                    :key="inx"
                    :prop="col.prop"
                    :label="col.name"
                    align="center"
                    :min-width="col.prop === 'costname' ? '180px' : (col.minWidth || '100')">

                  <template slot-scope="scope">
                    <!-- 处置项目列 -->
                    <template v-if="col.prop === 'costname'">
                      <el-select
                          v-model="scope.row.costname"
                          size="mini"
                          filterable
                          remote
                          reserve-keyword
                          placeholder="搜索处置项目"
                          :remote-method="(query) => searchDisposeItems(scope.row, query)"
                          :loading="scope.row._searchLoading"
                          @focus="initDisposeRowSearch(scope.row)"
                          @change="(val) => handleSelectDisposeItem(scope.row, val)"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'costname')"
                          :disabled="isShowPrescription"
                          style="width: 100%"
                          popper-class="dispose-select-popper"
                          :ref="`disposeNameSelect_${scope.$index}`">
                        <el-option
                            v-for="item in scope.row._searchResults"
                            :key="item.id"
                            :label="item.label || item.costname || item.name"
                            :value="item.label || item.costname || item.name">
                          <div style="display: flex; justify-content: space-between; align-items: center; font-size: 12px;">
                            <span style="font-weight: 500;">{{ item.label || item.costname || item.name }}</span>
                            <span style="color: #909399;">¥{{ item.odcost || 0 }}</span>
                          </div>
                        </el-option>
                        <template slot="empty">
                          <div style="padding: 12px; text-align: center; color: #909399; font-size: 13px;">
                            {{ scope.row._searchKeyword ? '未找到匹配项目' : '请输入关键词搜索' }}
                          </div>
                        </template>
                      </el-select>
                    </template>

                    <!-- 单价 -->
                    <template v-else-if="col.prop === 'odcost'">
                      <span>{{ scope.row.odcost || 0 }}</span>
                    </template>

                    <!-- 执行科室 -->
                    <template v-else-if="col.prop === 'deptName'">
                      <el-select
                          v-model="scope.row.deptName"
                          size="mini"
                          filterable
                          :disabled="isShowPrescription || scope.row.depexecutetype === 0"
                          placeholder="请选择科室"
                          style="width: 100%"
                          @change="updateDisposeRow(scope.row)"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'deptName')"
                          :ref="`disposeDeptSelect_${scope.$index}`">
                        <el-option v-for="item in deptOptions" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                    </template>

                    <!-- 执行频率 -->
                    <template v-else-if="col.prop === 'exeFrquId'">
                      <el-select
                          v-model="scope.row.exeFrquId"
                          size="mini"
                          filterable
                          :disabled="isShowPrescription || scope.row.executemode !== 1"
                          placeholder="请选择频率"
                          style="width: 100%"
                          @change="computeDisposeFrequency(scope.row)"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'exeFrquId')"
                          :ref="`disposeFrquSelect_${scope.$index}`">
                        <el-option v-for="item in medicationFrequencyOptions" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                    </template>

                    <!-- 执行天数 -->
                    <template v-else-if="col.prop === 'prdDays'">
                      <el-input
                          v-model="scope.row.prdDays"
                          size="mini"
                          type="number"
                          min="1"
                          :disabled="isShowPrescription"
                          placeholder="请输入天数"
                          @input="computeDisposeDay(scope.row)"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'prdDays')"
                          :ref="`disposeDaysInput_${scope.$index}`"
                          style="width: 100%">
                      </el-input>
                    </template>

                    <!-- 执行次数 -->
                    <template v-else-if="col.prop === 'periodCount'">
                      <el-input
                          v-model="scope.row.periodCount"
                          size="mini"
                          type="number"
                          min="1"
                          disabled
                          @input="computeDisposePeriod(scope.row)"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'periodCount')"
                          :ref="`disposePeriodInput_${scope.$index}`"
                          style="width: 100%">
                      </el-input>
                    </template>

                    <!-- 执行数量 -->
                    <template v-else-if="col.prop === 'frquCnt'">
                      <el-input
                          v-model="scope.row.frquCnt"
                          size="mini"
                          type="number"
                          min="1"
                          :disabled="isShowPrescription"
                          placeholder="请输入数量"
                          @input="updateDisposeRow(scope.row)"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'frquCnt')"
                          :ref="`disposeCntInput_${scope.$index}`"
                          style="width: 100%">
                      </el-input>
                    </template>

                    <!-- 备注 -->
                    <template v-else-if="col.prop === 'remark'">
                      <el-input
                          v-model="scope.row.remark"
                          size="mini"
                          :disabled="isShowPrescription"
                          placeholder="请输入备注"
                          @keydown.enter.native.prevent="focusNextDispose(scope.$index, 'remark')"
                          :ref="`disposeRemarkInput_${scope.$index}`"
                          style="width: 100%">
                      </el-input>
                    </template>

                    <!-- 其他只读列 -->
                    <template v-else>
                      {{ safeGetMappedValue(col, scope.row, 'disposition') }}
                    </template>
                  </template>
                </el-table-column>             </el-table>
            </div>
          </div>
          <div class="seedoctorMedical">
            <div class="medical-header">
              <div class="medical-type-buttons">
                <el-button
                    :class="['medical-type-btn', { 'active': DropDownedName === '西药医嘱' }]"
                    @click="handleCommand('a')"
                    size="mini">
                  西药医嘱
                </el-button>
                <el-button
                    :class="['medical-type-btn', { 'active': DropDownedName === '中药医嘱' }]"
                    @click="handleCommand('b')"
                    size="mini">
                  中药医嘱
                </el-button>
              </div>
              <!-- 顶部搜索框（保留兼容，但主要用表格内搜索） -->
              <el-popover placement="bottom-start" width="1000" trigger="click" v-model="showWestTable"
                          popper-class="modern-medicine-popover">
                <div class="modern-table-wrapper" style="max-height: 500px; overflow: auto;">
                  <el-table
                      :data="DropDownedName === '西药医嘱' ? queryWestMedicineData : queryChinaMedicineData"
                      :key="tableMedicineKey" style="width: 100%" border size="mini"
                      v-loading="loading" :empty-text="searchTriggered ? '未找到相关药品' : '请在上方输入框输入搜索条件'"
                      highlight-current-row @row-click="handleTableRowClick"
                      :row-class-name="tableRowClassName">
                    <template #empty>
                      <div class="empty-state">
                        <p>{{ searchTriggered ? '未找到匹配药品' : '请输入搜索条件' }}</p>
                      </div>
                    </template>
                    <el-table-column
                        v-for="(col, index) in (DropDownedName === '西药医嘱' ? getFilteredTableRows11() : getFilteredTableRows12())"
                        :key="`west_col_${index}`"
                        :type="col.type"
                        :prop="col.prop"
                        :label="col.name"
                        :render-header="labelHead"
                        align="center"
                        :min-width="getColumnWidth(col.label, col.prop, DropDownedName === '西药医嘱' ? queryWestMedicineData : queryChinaMedicineData)">
                      <template #default="{ row }">
                        <template v-if="col.prop === 'pacPrice'">
                          {{ row.isFixPrice === 1 ? row.fixPacSalePric : row.maxSalePric }}
                        </template>
                        <template v-else-if="col.prop === 'minPrice'">
                          {{ row.isFixPrice === 1 ? row.fixMinSalePric : row.minSalePric }}
                        </template>
                        <template v-else>
                          {{ safeGetMappedValue(col, row, 0) }}
                        </template>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-popover>
              <div class="header-actions">
                <el-button size="mini" style="padding: 7px 8px;" @click="handleOpenSelChinaWestTemplate"
                           v-if="!isShowPrescription" :disabled="patientForm.patId === ''">
                  <div style="display: flex; align-items: center;">
                    <i class="el-icon-edit-outline" style="font-size: 14px; color: #E6A23C;margin: 0"></i>
                    <span style="font-size: 12px;">药品模板</span>
                  </div>
                </el-button>
                <el-button size="mini" style="padding: 7px 8px;" @click="handleConfirmMedicalAdvice"
                           v-if="!isShowPrescription" :disabled="patientForm.patId === ''">
                  <div style="display: flex; align-items: center;">
                    <i class="el-icon-edit-outline" style="font-size: 14px; color: #E6A23C;margin: 0"></i>
                    <span style="font-size: 12px;">提交医嘱</span>
                  </div>
                </el-button>
              </div>
            </div>

            <!-- 一体化输入区域 -->
            <div>
              <!-- 西药 -->
              <div style="flex-grow: 1; display: flex; flex-wrap: wrap; align-items: center; gap: 5px;margin: 0;
      position: relative; width: 100%; overflow: hidden;" v-if="DropDownedName === '西药医嘱'">
                <el-table size="mini" ref="westMedicineTableData"
                          style="width: 100% !important;margin: 0 !important;border-radius: 0 0 8px 8px;"
                          :data="westMedicineTableData" border highlight-current-row row-key="id"
                          @selection-change="handleWestGroups" @row-contextmenu="handleWestGroupsFixed"
                          @row-dblclick="handleShowDataDetail"
                          :class="{ 'disabled-table': isShowPrescription }">

                  <el-table-column type="selection" width="55" align="center"></el-table-column>

                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="scope">
                      <!-- 可以移除的条件：有数据行数>1 或者 总行数>2 -->
                      <template v-if="canRemove()">
                        <el-button
                            :disabled="isShowPrescription || scope.row.adviceId > 0"
                            size="mini"
                            type="text"
                            @click="removeWestMedicineTableData(scope.$index)">
                          移除
                        </el-button>
                      </template>
                      <template v-else>
                        <span style="color: #c0c4cc; font-size: 12px;">-</span>
                      </template>
                    </template>
                  </el-table-column>

                  <!-- 动态列 -->
                  <el-table-column
                      v-for="(col, inx) in getFilteredTableRows7()"
                      :key="inx"
                      :type="col.type"
                      :label="col.name"
                      :render-header="labelHead"
                      align="center"
                      :width="col.prop === 'drugName' ? '200px' : (col.prop === 'pacSpec' ? '200px' : null)"
                      :min-width="col.prop === 'drugName' ? '180px' : getColumnWidth(col.label, col.prop, westMedicineTableData)">

                    <template slot-scope="scope">
                      <!-- ===== 药品名称列 - 可搜索下拉 ===== -->
                      <template v-if="col.prop === 'drugName'">
                        <el-popover
                            placement="bottom-start"
                            trigger="click"   width="600"
                            v-model="scope.row._popoverVisible"
                            popper-class="modern-medicine-popover">

                          <!-- 气泡里只有表格，没有搜索框 -->
                          <div class="modern-table-wrapper" style="max-height: 400px; overflow: auto;">
                            <el-table
                                :data="scope.row._searchResults"
                                :key="tableMedicineKey"
                                style="width: 100%"
                                border
                                size="mini"
                                v-loading="scope.row._searchLoading"
                                highlight-current-row
                                @row-click="(row) => handleSelectDrugFromPopover(scope.row, row)">
                              <el-table-column
                                  v-for="(col, index) in (DropDownedName === '西药医嘱' ? getFilteredTableRows11() : getFilteredTableRows12())"
                                  :key="`popover_col_${index}`"
                                  :prop="col.prop"
                                  :label="col.name"
                                  align="center"
                                  :min-width="getColumnWidth(col.label, col.prop, scope.row._searchResults)">
                                <template #default="{ row }">
                                  <template v-if="col.prop === 'pacPrice'">
                                    {{ row.isFixPrice === 1 ? row.fixPacSalePric : row.maxSalePric }}
                                  </template>
                                  <template v-else-if="col.prop === 'drugType'">
  <span :style="{ color: row.drugType === 1 ? 'blue' : row.drugType === 2 ? 'red' : row.drugType === 3 ? 'green' : '' }">
    {{ safeGetMappedValue(col, row, 0) }}
  </span>
                                  </template>
                                  <template v-else-if="col.prop === 'minPrice'">
                                    {{ row.isFixPrice === 1 ? row.fixMinSalePric : row.minSalePric }}
                                  </template>
                                  <template v-else>
                                    {{ safeGetMappedValue(col, row, 0) }}
                                  </template>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>

                          <!-- 触发输入框 -->
                          <el-input
                              size="mini"
                              slot="reference"
                              v-model="scope.row.drugName"
                              placeholder="搜索药品"
                              :disabled="isShowPrescription"
                              @input="(val) => searchDrugsForRow(scope.row, val)"
                              @keydown.enter.native.prevent="handleDrugNameEnter(scope.$index)"
                              :ref="`drugNameInput_${scope.$index}`"
                              class="drug-name-input">
                          </el-input>
                        </el-popover>
                      </template>

                      <template v-else-if="col.prop === 'drugType'">
  <span :style="{ color: scope.row.drugType === 1 ? '#409EFF' : scope.row.drugType === 2 ? '#F56C6C' : scope.row.drugType === 3 ? '#67C23A' : '' }">
    {{ safeGetMappedValue2(col, scope.row) }}
  </span>
                      </template>

                      <!-- ===== 剂量 ===== -->
                      <template v-else-if="col.prop === 'sdoseCnt'">
                        <el-input
                            size="mini"
                            v-model="scope.row[col.prop]"
                            placeholder="请输入"
                            :disabled="isShowPrescription"
                            :class="{'special-input': col.prop === 'sdoseCnt'}"
                            @input="handleNumberInput(scope.row, 'sdoseCnt')"
                            @keydown.enter.native.prevent="focusNext(scope.$index, 'sdoseCnt')"
                            :ref="`sdoseCntInput_${scope.$index}`">
                        </el-input>
                      </template>

                      <!-- ===== 频率 ===== -->
                      <template v-else-if="col.prop === 'usedfrquId'">
                        <el-select
                            size="mini"
                            v-model="scope.row.usedfrquId"
                            filterable
                            placeholder="请选择"
                            @change="getWestSdoseSum(scope.row)"
                            @keydown.enter.native="handleSelectEnter(scope.$index, 'usedfrquId', scope.row)"
                            @keydown.enter.native.prevent.stop
                            :ref="`usedfrquIdSelect_${scope.$index}`">
                          <el-option
                              v-for="item in medicationFrequencyOptions"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </template>

                      <!-- ===== 单位 ===== -->
                      <template v-else-if="col.prop === 'saleUnt'">
                        <el-select
                            size="mini"
                            v-model="scope.row.saleUnt"
                            filterable
                            :disabled="scope.row._isFrquDisabled"
                            placeholder="请选择"
                            @change="calculateSaleAmt(scope.row)"
                            @keydown.enter.native="handleSelectEnter(scope.$index, 'saleUnt', scope.row)"
                            @keydown.enter.native.prevent.stop
                            :ref="`saleUntSelect_${scope.$index}`">
                          <el-option
                              v-for="item in scope.row.saleUntOption"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </template>

                      <!-- ===== 天数 ===== -->
                      <template v-else-if="col.prop === 'prdDays'">
                        <el-input
                            size="mini"
                            v-model="scope.row[col.prop]"
                            @input="handleNumberInput(scope.row, 'prdDays');"
                            :class="{'special-input': col.prop === 'prdDays'}"
                            placeholder="请输入"
                            @keydown.enter.native.prevent="focusNext(scope.$index, 'prdDays')"
                            :ref="`prdDaysInput_${scope.$index}`">
                        </el-input>
                      </template>

                      <!-- ===== 数量 ===== -->
                      <template v-else-if="col.prop === 'cnt'">
                        <el-input
                            size="mini"
                            v-model="scope.row[col.prop]"
                            @input="handleNumberInput(scope.row, 'cnt');"
                            :class="{'special-input': col.prop === 'cnt'}"
                            placeholder="请输入"
                            @keydown.enter.native.prevent="focusNext(scope.$index, 'cnt')"
                            :ref="`cntInput_${scope.$index}`">
                        </el-input>
                      </template>

                      <!-- ===== 金额 ===== -->
                      <template v-else-if="col.prop === 'saleAmt'">
                        <el-input
                            size="mini"
                            v-model="scope.row[col.prop]"
                            @input="handleNumberInput(scope.row, 'saleAmt'); onSaleAmtChange(scope.row, $event)"
                            :class="{'special-input': col.prop === 'saleAmt'}"
                            placeholder="请输入"
                            :disabled="scope.row.manualPric === 0"
                            @keydown.enter.native.prevent="focusNext(scope.$index, 'saleAmt')"
                            :ref="`saleAmtInput_${scope.$index}`">
                        </el-input>
                      </template>

                      <!-- ===== 用法 ===== -->
                      <template v-else-if="col.prop === 'medcWayId'">
                        <el-select
                            size="mini"
                            v-model="scope.row.medcWayId"
                            @change="(value) => { isTransfusion(value, scope.row); focusNext(scope.$index, 'medcWayId'); }"
                            filterable
                            :disabled="scope.row._isMedcWayDisabled"
                            placeholder="请选择"
                            @keydown.enter.native="handleSelectEnter(scope.$index, 'medcWayId', scope.row)"
                            @keydown.enter.native.prevent.stop
                            :ref="`medcWayIdSelect_${scope.$index}`">
                          <el-option
                              v-for="item in routeOptions"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </template>

                      <!-- ===== 剂量单位 ===== -->
                      <template v-else-if="col.prop === 'dosaUnt'">
                        <el-select
                            size="mini"
                            v-model="scope.row.dosaUnt"
                            filterable
                            clearable
                            placeholder="请选择"
                            :disabled="isShowPrescription"
                            @keyup.enter.native.prevent="focusNext(scope.$index, 'dosaUnt')"
                            :ref="`dosaUntSelect_${scope.$index}`">
                          <el-option
                              v-for="item in dosaUntOptions"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </template>

                      <!-- ===== 总剂量 ===== -->
                      <template v-else-if="col.prop === 'prdCnt'">
                        <el-input
                            size="mini"
                            v-model="scope.row[col.prop]"
                            :class="{'special-input': col.prop === 'prdCnt'}"
                            @change="getWestSdoseSum(scope.row)"
                            placeholder="请输入"
                            disabled>
                        </el-input>
                      </template>

                      <!-- ===== 备注 ===== -->
                      <template v-else-if="col.prop === 'remark'">
                        <el-input
                            size="mini"
                            type="textarea"
                            v-model="scope.row[col.prop]"
                            :class="{'hide-input-border': true}"
                            :disabled="isShowPrescription"
                            placeholder="请输入"
                            @keydown.enter.native.prevent="focusNext(scope.$index, 'remark')"
                            :ref="`remarksInput_${scope.$index}`">
                        </el-input>
                      </template>

                      <!-- ===== 速度（输液） ===== -->
                      <template v-else-if="col.prop === 'speed' && (scope.row.medcWayId === 1 || scope.row.medcWayId === 2)">
                        <el-input
                            size="mini"
                            v-model="scope.row[col.prop]"
                            :class="{'special-input': col.prop === 'speed'}"
                            @input="handleNumberInput(scope.row, 'speed'); handleGroupInfusionSync(scope.row)"
                            :disabled="isShowPrescription"
                            @keydown.enter.native.prevent="focusNext(scope.$index, 'speed')"
                            :ref="`speedInput_${scope.$index}`"
                            placeholder="请输入">
                        </el-input>
                      </template>

                      <!-- ===== 其他只读列 ===== -->
                      <template v-else>
                        {{ safeGetMappedValue2(col, scope.row) }}
                      </template>

                    </template>
                  </el-table-column>
                </el-table>

                <!-- 右键菜单 -->
                <div v-show="showWestGroupsClick" class="context-menu"
                     :style="{left: contextMenuLeft + 'px', top: contextMenuTop + 'px'}">
                  <div class="menu-item" @click="handleMenuClick(5)">分组</div>
                  <div class="menu-item" @click="handleMenuClick(6)">取消分组</div>
                </div>
              </div>

              <!-- 中药 -->
              <!-- 中药 -->
              <div v-else>
                <div style="flex-grow: 1; display: flex; flex-wrap: wrap; align-items: center; gap: 5px;margin: 0;
      position: relative; width: 100%; overflow: hidden;">
                  <el-table size="mini" ref="chinaMedicineTableData"
                            style="width: 100% !important;margin: 0 !important;border-radius: 0 0 8px 8px;"
                            :data="chinaMedicineTableData" border highlight-current-row row-key="id"
                            :class="{ 'disabled-table': isShowPrescription }">


                    <el-table-column label="操作" width="80" align="center">
                      <template slot-scope="scope">
                        <template v-if="canRemoveChina()">
                          <el-button
                              :disabled="isShowPrescription || scope.row.adviceId > 0"
                              size="mini"
                              type="text"
                              @click="removeChinaMedicineTableData(scope.$index)">
                            移除
                          </el-button>
                        </template>
                        <template v-else>
                          <span style="color: #c0c4cc; font-size: 12px;">-</span>
                        </template>
                      </template>
                    </el-table-column>

                    <!-- 动态列 - 复用西药列配置 -->
                    <el-table-column
                        v-for="(col, inx) in getFilteredTableRows12China()"
                        :key="inx"
                        :prop="col.prop"
                        :label="col.name"
                        align="center"
                        :width="col.prop === 'drugName' ? '200px' : (col.width || null)"
                        :min-width="col.prop === 'drugName' ? '180px' : (col.minWidth || '100')">

                      <template slot-scope="scope">

                        <!-- ===== 药品名称列 - 可搜索下拉（中药接口） ===== -->
                        <template v-if="col.prop === 'drugName'">
                          <el-popover
                              placement="bottom-start"
                              trigger="click" width="600"
                              v-model="scope.row._popoverVisible"
                              popper-class="modern-medicine-popover">

                            <div class="modern-table-wrapper" style="max-height: 400px; overflow: auto;">
                              <el-table
                                  :data="scope.row._searchResults"
                                  :key="tableMedicineKey"
                                  style="width: 100%"
                                  border
                                  size="mini"
                                  v-loading="scope.row._searchLoading"
                                  highlight-current-row
                                  @row-click="(row) => handleSelectChinaDrugFromPopover(scope.row,row)">
                                <el-table-column
                                    v-for="(col, index) in getFilteredTableRows12()"
                                    :key="`popover_col_${index}`"
                                    :prop="col.prop"
                                    :label="col.name"
                                    align="center"
                                    :min-width="getColumnWidth(col.label, col.prop, scope.row._searchResults)">
                                  <template #default="{ row }">
                                    {{ safeGetMappedValue(col, row, 0) }}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>

                            <el-input
                                slot="reference"
                                v-model="scope.row.drugName"
                                size="mini"
                                placeholder="搜索中药"
                                :disabled="isShowPrescription"
                                @input="(val) => searchChinaDrugsForRow(scope.row, val)"
                                @keydown.enter.native.prevent="handleDrugNameEnter(scope.$index)"
                                :ref="`drugNameInput_${scope.$index}`"
                                class="drug-name-input">
                            </el-input>
                          </el-popover>
                        </template>


                        <!-- ===== 单次剂量 ===== -->
                        <template v-else-if="col.prop === 'sdoseCnt'">
                          <el-input
                              size="mini"
                              v-model="scope.row[col.prop]"
                              placeholder="请输入剂量"
                              @input="getChinaSdoseSum(scope.row)"
                              @keydown.enter.native.prevent="focusNextChina(scope.$index, 'sdoseCnt')"
                              :ref="`sdoseCntInput_${scope.$index}`">
                          </el-input>
                        </template>


                        <!-- ===== 金额 ===== -->
                        <template v-else-if="col.prop === 'saleAmt'">
                          <el-input
                              v-model="scope.row[col.prop]"
                              :disabled="true"
                              @keydown.enter.native.prevent="focusNextChina(scope.$index, 'saleAmt')"
                              :ref="`saleAmtInput_${scope.$index}`">
                          </el-input>
                        </template>

                        <!-- ===== 备注 ===== -->
                        <template v-else-if="col.prop === 'remark'">
                          <el-input
                              type="textarea"
                              v-model="scope.row[col.prop]"
                              :class="{'hide-input-border': true}"
                              :disabled="isShowPrescription"
                              placeholder="请输入"
                              @keydown.enter.native.prevent="focusNextChina(scope.$index, 'remark')"
                              :ref="`remarksInput_${scope.$index}`"
                              :autosize="{ minRows: 1, maxRows: 3 }">
                          </el-input>
                        </template>

                        <!-- ===== 其他只读列 ===== -->
                        <template v-else>
                          {{ safeGetMappedValue2(col, scope.row) }}
                        </template>

                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>

          <!-- 处方列表 - 动态盒子展示 -->
          <!-- 处方列表 - 动态盒子展示 -->
          <div class="seedoctorMedical prescription-module">
            <div class="medical-header">
              <span class="clinic-title">处方列表</span>
              <div class="header-actions">
                <!-- 待收费合计放在标题右侧 -->
                <span v-if="prescriptionList && prescriptionList.length > 0" class="total-unpaid-header">
        待收费合计：<span class="amount-red">¥{{ getTotalUnpaidAmount() }}</span>
      </span>
              </div>
            </div>

            <!-- 处方盒子列表 -->
            <div class="prescription-list-container">
              <!-- 空状态 -->
              <div v-if="!prescriptionList || prescriptionList.length === 0" class="empty-prescription">
                <i class="el-icon-document" style="font-size: 48px; color: #c0c4cc;"></i>
                <p style="color: #909399; margin-top: 12px;">暂无处方</p>
              </div>

              <!-- 每个处方一个盒子 -->
              <div
                  v-for="(prescription, index) in prescriptionList"
                  :key="prescription.id || index"
                  class="prescription-box"
                  :class="{ 'prescription-box-west': prescription.tcm === null, 'prescription-box-tcm': prescription.tcm !== null }">

                <div class="prescription-box-header">
                  <div class="header-left">
                    <span class="order-no">处方号：{{ prescription.orderNo || '-' }}</span>
                    <span class="order-status">
      <el-tag size="mini" :type="prescription.status === 0 ? 'info' : prescription.status === 1 ? 'success' : 'danger'">
        {{ prescription.status === 0 ? '草稿' : prescription.status === 1 ? '已提交' : prescription.status === 2 ? '已取消' : '未知' }}
      </el-tag>
    </span>
                    <span class="order-time">
      <i class="el-icon-time"></i>
      {{ prescription.orderedAt}}
    </span>
                  </div>
                  <div class="header-right">
    <span class="total-amount">
      合计：<span style="font-size: 18px; font-weight: 700;">¥{{ prescription.totalAmount || 0 }}</span>
    </span>
                    <span class="order-count">共 {{ (prescription.items || []).length }} 项</span>
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-printer"
                        :disabled="isPrescriptionPrintDisabled(prescription)"
                        @click="handlePrintPrescription(prescription)">
                      打印
                    </el-button>
                    <el-button size="mini" type="text" :disabled="prescription.chargeStatus !== 0" @click="handleEditPrescription(prescription)">修改</el-button>
                  </div>
                </div>
                <!-- 盒子内容 -->
                <div class="prescription-box-body">
                  <el-table
                      :data="prescription.items || []"
                      border
                      size="mini"
                      style="width: 100%"
                      :header-cell-style="{
            background: '#fafbfc',
            color: '#606266',
            fontWeight: '600',
            fontSize: '12px',
            padding: '4px 0'
          }"
                      :cell-style="{ padding: '3px 0', fontSize: '12px' }">

                    <!-- 动态列 -->
                    <template v-for="(col, inx) in getFilteredTableRows13(prescription.items[0]?.itemType)">
                      <el-table-column
                          :key="inx"
                          :prop="col.prop"
                          :label="col.name"
                          align="center"
                          :width="col.width || null"
                          :min-width="col.minWidth || '100'">
                        <template #default="scope">
                          {{ safeGetMappedValue(col, scope.row, 0) }}
                        </template>
                      </el-table-column>
                    </template>
                  </el-table>
                </div>
              </div>
            </div>
          </div>        </div>
				<!-- 标签页内容 -->
				<div v-show="activeTab === 'charge'" class="tab-content">
					<OutpatientCharge ref="outpatientChargeRef" @payment-complete="handlePaymentComplete" />
				</div>
        <div v-show="activeTab === 'dispensing'" class="tab-content">
					<NewGiveMedici ref="newGiveMedici"  />
				</div>

        <div v-show="activeTab === 'followup'" class="tab-content">
          <FollowUpClinic ref="followUpClinicRef" layout="vertical" />
        </div>
			</el-main>
		</div>

		<div class="drawer">
			<el-drawer :visible.sync="medicalRecord" :with-header="false" :modal="false" size="45%">
				<div style="display: flex;flex-direction: column;align-items: center;
                            justify-content: center;height: 100%;padding: 20px;">
					<div style="text-align: right; margin-bottom: 10px;">
						<el-button size="small" type="success" @click="printMedicalRecord"
							:disabled="patientForm.patId === ''">
							打印病历
						</el-button>
					</div>

					<div class="preview-container" v-if="medicalRecordHTML" v-html="medicalRecordHTML"
						style="margin-top: 50px; color: #000 !important; background: #fff !important;"></div>
					<div class="no-data-message" v-else>
						<el-empty description="暂无数据,请联系管理员"></el-empty>
					</div>
				</div>
			</el-drawer>

			<el-drawer :visible.sync="outpatientsDiagnosis" :with-header="false" :modal="false" size="45%">
				<div
					style="display: flex;align-items: center;height: 100px;padding: 20px; justify-content: center;margin-top: 50px;">
					<el-button size="small" type="primary" @click="printOutpatientsDiagnosisCombined"
						:disabled="patientForm.patId === ''">
						打印病历
					</el-button>
					<el-button size="small" type="success" @click="printOutpatientsDerive"
						:disabled="patientForm.patId === ''">
						导出Excel
					</el-button>
				</div>


				<!-- 使用 margin-top 让 div 下移 -->
				<div class="preview-container" v-if="outpatientsDiagnosisHTML" v-html="outpatientsDiagnosisHTML"
					style="margin-top: 50px; color: #000 !important; background: #fff !important;"></div>

				<div class="no-data-message" v-else style="margin-top: 20px;">
					<el-empty description="暂无数据,请联系管理员"></el-empty>
				</div>
			</el-drawer>
		</div>


		<div class="dialog">
      <el-dialog title="中药使用信息" :visible.sync="chinaMedicineUsageDialog" :before-close="handleCloseChinaTabel"
                 width="20%" :close-on-click-modal="false">
        <el-form :model="addChinaForm" label-width="100px" size="mini">

          <!-- 付数 -->
          <el-form-item label="付数:" style="margin-bottom: 12px">
            <el-input type="number" v-model.number="addChinaForm.tcmCnt" :min="1" @input="getChinaTotalSum" style="width: 100%"></el-input>
          </el-form-item>

          <!-- 用药频率 -->
          <el-form-item label="用药频率:" style="margin-bottom: 12px">
            <el-select v-model="addChinaForm.usedfrquId" filterable clearable style="width: 100%">
              <el-option v-for="item in medicationFrequencyOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </el-form-item>

          <!-- 给药方式 -->
          <el-form-item label="给药方式:" style="margin-bottom: 12px">
            <el-select v-model="addChinaForm.medcWayId" filterable style="width: 100%">
              <el-option v-for="item in chinaMedicationWayOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </el-form-item>

          <!-- 中药用法 -->
          <el-form-item label="中药用法:" style="margin-bottom: 12px">
            <el-select v-model="addChinaForm.tcmWayId" filterable clearable style="width: 100%">
              <el-option v-for="item in tcmwayOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </el-form-item>

          <!-- 煎药方式 -->
          <el-form-item label="煎药方式:" style="margin-bottom: 12px">
            <el-select v-model="addChinaForm.decoctionType" filterable clearable style="width: 100%">
              <el-option label="人工" :value="0" />
              <el-option label="煎药机" :value="1" />
            </el-select>
          </el-form-item>

          <!-- 煎药量 -->
          <el-form-item label="煎药量:" style="margin-bottom: 12px">
            <el-input type="number" v-model.number="addChinaForm.decoctionVolume" :min="0" @input="validateDecoctionVolume" style="width: 100%">
              <template slot="append">ML</template>
            </el-input>
          </el-form-item>

          <!-- 每次服药量 -->
          <el-form-item label="每次服药量:" style="margin-bottom: 12px">
            <el-input type="number" v-model.number="addChinaForm.doseVolume" :min="0" @input="validateDoseVolume" style="width: 100%">
              <template slot="append">g</template>
            </el-input>
          </el-form-item>

          <!-- 预算金额 -->
          <el-form-item label="预算金额:" style="margin-bottom: 12px">
            <el-input type="text" v-model="addChinaForm.predictMoney" :disabled="true" style="width: 100%">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>

          <!-- 药品总量 -->
          <el-form-item label="药品总量:" style="margin-bottom: 12px">
            <el-input type="text" v-model="addChinaForm.chinaMedicineSum" :disabled="true" style="width: 100%">
              <template slot="append">g</template>
            </el-input>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseChinaTabel" size="mini">取 消</el-button>
          <el-button type="primary" @click="handleConfirmChina" size="mini">确 定</el-button>
        </div>
      </el-dialog>

			<el-dialog title="录音" :visible.sync="showRecordingModal" width="300px">
				<!-- 录制状态显示区域 -->
				<div class="recording-status" style="padding: 10px 0;">
					<div v-if="isRecording" class="wave-animation" style="height: 40px;"></div>
					<p v-if="isRecording" style="margin: 8px 0;">正在录制: {{ recordingTime }}</p>
					<p v-else style="margin: 8px 0;">请点击开始按钮开始录音</p>
					<div class="recording-buttons" style="display: flex; gap: 10px; margin-top: 10px;">
						<el-button size="mini" v-if="!isRecording" type="primary" @click="startRecording">
							开始录音
						</el-button>
						<el-button size="mini" v-else type="danger" @click="stopRecording">
							结束录音
						</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog title="录音记录" :visible.sync="showRecordingModalData" style="margin: 0" width="70%" height="70vh">
				<el-container style="height: 100%; border: 1px solid #eee">
					<el-aside width="200px" style="background-color: rgb(238, 241, 246)">
						<el-menu :default-openeds="['1']" @select="handleMenuSelect" v-model="activeIndex">
							<el-submenu index="1">
								<template slot="title"><i class="el-icon-folder"></i>录音</template>
								<el-menu-item v-for="(item, index) in recordingListOptions" :key="item.index"
									:index="item.index" :data-audio-path="item.audioPath"
									@click="handleAudioItemClick(item.audioPath)">
									{{ item.name }}
								</el-menu-item>
							</el-submenu>
						</el-menu>
					</el-aside>


					<el-container>
						<el-header
							style="text-align: left; font-size: 12px; padding: 0 20px; height: 60px; display: flex; align-items: center; justify-content: flex-start;">
							<div class="audio-player" v-if="currentAudioPath">
								<audio ref="audioPlayer" :src="formattedAudioUrl" controls style="width: 300px;">
									您的浏览器不支持音频播放
								</audio>
							</div>
							<div class="audio-placeholder" v-else style="color: #909399; padding: 0 20px;">
								请选择录音文件播放
							</div>
						</el-header>
						<el-main>
							<el-card shadow="hover" style="height: 100%;">
								<el-table :data="recordingList" size="mini" border>
									<el-table-column v-for="(col, inx) in tableRows15" :key="inx" :type="col.type"
										:prop="col.prop" :label="col.name" :render-header="labelHead"
										:show-overflow-tooltip="false" align="center"
										:min-width="getColumnWidth(col.label,col.prop,recordingList)"
										header-align="center" class-name="compact-cell">
										<template slot-scope="scope">
											<!-- 仅对目标字段添加点击事件 -->
											<span
												v-if="['patientTell', 'nowHistory', 'beforeHistory'].includes(col.prop)"
												@click="handleFieldClick(scope.row[col.prop], col.prop)"
												style="color:#409EFF;cursor:pointer;">
												{{ scope.row[col.prop] }}
											</span>
											<span v-else>
												{{ scope.row[col.prop] }}
											</span>
										</template>
									</el-table-column>
									<el-table-column label="操作" fixed="right" min-width="80" align="center"
										header-align="center">
										<template slot-scope="scope">
											<el-button type="primary" size="mini"
												@click="handleAllFieldClick(scope.row)">
												引用
											</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-card>
						</el-main>
					</el-container>
				</el-container>
			</el-dialog>

			<!-- 新增合约单位 -->
			<el-dialog :title="addUnitForm.id  == null ?'新增合约单位':'修改合约单位'" :before-close="handleCancelAddUnit"
				:visible.sync="addUnitModalVisible" class="addUnitDialog" width="50%" :close-on-click-modal="false"
				:modal="false">
				<div class="aform">
					<!-- 表单 -->
					<el-form :model="addUnitForm" label-width="90px" size="mini" :rules="addUnitRules" ref="addUnitRef">
						<el-row :gutter="20">
							<el-col :span="v.spanRows" type="flex" v-for="(v,i) in addUnitType" :key="i"
								:style="{ marginLeft: v.modelValue === 'uscc' ? '18px' : '0' }">
								<!-- input -->
								<el-form-item v-if="v.type === 'input'"
									:required="['code', 'name'].includes(v.modelValue)" :label="v.label"
									:style="v.modelValue === 'uscc' ? 'white-space: nowrap' : ''">
									<el-input :suffix-icon='v.prefix' v-model="$data.addUnitForm[v.modelValue]"
										@input="handleNameChangeCode(v,i)"
										:disabled="v.modelValue === 'code' ? true : null"
										:style="{ marginLeft: v.modelValue === 'uscc' ? '30px' : '0' }">

									</el-input>
								</el-form-item>
								<!-- select -->
								<el-form-item v-if="v.type === 'select'" :label="v.label">
									<el-select v-model="$data.addUnitForm[v.modelValue]" filterable
										:disabled="v.modelValue === 'untAtte'">
										<el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label"
											:value="item.id">
											<span
												style=" color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 新增的按钮区域 - 并排显示（添加在前，取消在后） -->
						<el-form-item style="margin-top: 20px; text-align: right">
							<el-button type="primary" size="mini" @click="handleAddContractUnit">
								{{ addUnitForm.id == null ? '新增' : '修改' }}
							</el-button>
							<el-button size="mini" @click="handleCancelAddUnit" style="margin-left: 10px">取消</el-button>
						</el-form-item>
					</el-form>
				</div>

			</el-dialog>

			<!-- 新增模板 -->
			<el-dialog :close-on-click-modal="false" :title="templateAddRrEditTtiel"
				:before-close="handleCancelTemplateForm" :visible.sync="tpAddOrEditMedicineDialog"
				class="tpAddOrEditMedicineDialog" width="600px">

				<div class="dialog-form-container">
					<el-form :model="templateForm" :rules="templateRules" label-width="100px" size="mini"
						ref="templateFormRef" label-position="right">

						<!-- 第一行:名称 + 科室 -->
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="名称:" prop="name">
									<el-input v-model="templateForm.name" @input="handleNameChangeCode(1)"
										placeholder="请输入名称" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="科室:" prop="deptId">
									<el-select v-model="templateForm.deptId" placeholder="请选择科室" style="width: 100%">
										<el-option v-for="item in deptOptions" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 第二行:拼音简码 + 适用范围 -->
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="拼音简码:" prop="pinyin">
									<el-input :disabled="true" v-model="templateForm.pinyin" placeholder="自动生成" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="适用范围:" prop="rangeType">
									<el-select v-model="templateForm.rangeType" placeholder="请选择适用范围"
										style="width: 100%">
										<el-option v-for="item in rangeTypeOption" :key="item.id" :label="item.label"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 第三行:状态 -->
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item label="状态:" prop="state">
									<el-select v-model="templateForm.state" placeholder="请选择状态" style="width: 100%">
										<el-option v-for="item in templateStateOption" :key="item.id"
											:label="item.label" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 主诉内容（文本域） -->
						<el-form-item label="内容:" prop="content">
							<el-input type="textarea" v-model="templateForm.content" :rows="3" placeholder="请输入主诉内容"
								style="width: 100%" />
						</el-form-item>

						<!-- 备注（文本域） -->
						<el-form-item label="备注:" prop="remark">
							<el-input type="textarea" v-model="templateForm.remark" :rows="3" placeholder="请输入备注"
								style="width: 100%" />
						</el-form-item>


						<!-- 新增的按钮区域 - 并排显示（添加在前，取消在后） -->
						<el-form-item style="margin-top: 20px; text-align: right">
							<el-button type="primary" size="mini" @click="handleAddTemplate">
								确定
							</el-button>
							<el-button size="mini" @click="handleCancelTemplateForm"
								style="margin-left: 10px">取消</el-button>
						</el-form-item>
					</el-form>
				</div>

			</el-dialog>

			<!-- 快速接诊 -->
			<el-dialog width="60%" height="70vh" title="快速接诊" :close-on-click-modal="false"
				:before-close="handleCancelContract" :visible.sync="receptionModalVisible" class="receptionDialog">
				<div class="aform">
					<el-form ref="patientFormRef" :model="patientForm" label-width="90px" size="mini"
						class="compact-form" :rules="patientFormRules">
						<!-- 第一行 - 基本信息 -->
						<el-row :gutter="15" class="form-row">
							<el-col :span="6">
								<el-form-item label="健康ID:">
									<el-input v-model="patientForm.patId" size="mini" placeholder="输入关键字后按回车键搜索"
										@keyup.enter.native="handleSearch" :disabled="isInputDisabled"
										style="width: 100%" />
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="姓名:" prop="name">
									<el-input v-model="patientForm.name" :disabled="isInputDisabled" size="mini"
										style="width: 100%" />
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="性别:" prop="sex">
									<el-select v-model="patientForm.sex" prop="sex" size="mini" style="width: 100%;">
										<el-option label="男" value="1"></el-option>
										<el-option label="女" value="2"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="出生日期:">
									<el-date-picker v-model="patientForm.brdy" type="date" size="mini"
										style="width: 100%" placeholder="身份证自动计算" :disabled="true" prefix-icon="none"
										value-format="yyyy-MM-dd" />
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 第二行 - 证件信息 -->
						<!-- 第二行 - 证件信息 -->
						<el-row :gutter="22" class="form-row">
							<el-col :span="6">
								<el-form-item prop="certno">
									<div style="display: flex">
										<el-select v-model="patientForm.identityCard" size="mini"
											style="width: 115px; margin-right: 0" filterable clearable>
											<el-option v-for="item in certypeOption" :key="item.id" :label="item.label"
												:value="item.id" />
										</el-select>
										<el-input v-model="patientForm.certno" style="width: 200px"
											@blur="certnoMonitor"
											@clear="patientForm.ageYear = null;patientForm.ageMonth = null;patientForm.brdy = '';"
											clearable maxlength="18" show-word-limit />
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item style="margin-left: 100px;">
									<div class="age-input-group">
										<el-input v-model="patientForm.ageYear" :disabled="true" size="mini"
											style="width: 40px;" />
										<span class="age-unit">岁</span>
										<el-input v-model="patientForm.ageMonth" :disabled="true" size="mini"
											style="width: 40px;" />
										<span class="age-unit">月</span>
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="病员类型:">
									<el-select v-model="patientForm.prhType" size="mini" style="width: 130px">
										<el-option v-for="item in prhTypeOption" :key="item.id" :label="item.label"
											:value="item.id">
											<span style="color: #8492a6; font-size: 12px">{{ item.label }}</span>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="2">
								<el-form-item label="三无:">
									<el-checkbox v-model="patientForm.thrNot" :true-label=1 :false-label=0
										@change="handleThrNotChange" size="mini">
									</el-checkbox>
								</el-form-item>
							</el-col>
							<el-col :span="2">
								<el-form-item label="孕妇:" prop="pregnant">
									<el-checkbox v-model="patientForm.pregnant" :true-label="1" :false-label="0"
										:disabled="patientForm.sex === '1' || patientForm.sex === null">
									</el-checkbox>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 第三行 - 个人信息 -->
						<el-row :gutter="4" class="form-row">
							<el-col :span="6">
								<el-form-item label="民族:">
									<el-select v-model="patientForm.naty" size="mini" style="width: 100%" filterable
										clearable>
										<el-option v-for="item in nationOption" :key="item.id" :label="item.label"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="国籍:">
									<el-select v-model="patientForm.ntlyId" size="mini" style="width: 100%" filterable
										clearable>
										<el-option v-for="item in ntlyOptions" :key="item.id" :label="item.label"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="职业:">
									<el-select v-model="patientForm.jobId" size="mini" style="width: 100%" filterable
										clearable>
										<el-option v-for="item in jobOption" :key="item.id" :label="item.label"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 第四行 - 联系方式 -->
						<el-row :gutter="24" class="form-row">
							<el-col :span="8">
								<el-form-item label="本人电话:" prop="tel">
									<el-input @blur="validateTel('tel')" v-model="patientForm.tel" size="mini"
										style="width: 100%" placeholder="请输入11位手机号" />
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="联系人:">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 1 }"
										v-model="patientForm.conerName" size="mini" style="width: 100%" />
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="联系电话:" prop="conerTel">
									<el-input @blur="validateTel('conerTel')" v-model="patientForm.conerTel" size="mini"
										style="width: 100%" placeholder="请输入11位手机号" />
								</el-form-item>
							</el-col>

						</el-row>

						<!-- 第五行 - 籍贯地址 -->
<!--						<el-row :gutter="15" class="form-row">
							<el-col :span="24">
								<el-form-item label="籍贯地址:" prop="naplAddName" class="address-form-item">
									<div style="display: flex;">
										<el-cascader :key="addressKey" ref="naplAddCodeArrRef"
											v-model="patientForm.naplAddCodeArr" :props="addressProps"
											:options="provinces" @focus="initAddressData('napl')"
											:placeholder="naplPleasett" style="width: 400px;" />
										<el-input v-model="patientForm.naplAddName" clearable placeholder="门牌号"
											style="width: 100%; margin-left: -1px;" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>-->

						<!-- 第六行 - 联系地址 -->
						<el-row :gutter="15" class="form-row">
							<el-col :span="24">
								<el-form-item label="联系地址:" prop="conerAddName">
									<div style="display: flex;">
										<el-cascader size="mini" ref="conerAddCodeArrRef" :key="addressKey"
											v-model="patientForm.conerAddCodeArr" :props="addressProps"
											:options="provinces" @focus="initAddressData" :placeholder="conerPleasett"
											style="width: 400px;"
											:input-style="{ '::placeholder': { color: '#000' } }" />
										<el-input size="mini" v-model="patientForm.conerAddName" clearable
											placeholder="门牌号" style="width: 100%; margin-left: -1px;" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 第七行 - 挂号信息 -->
						<el-row :gutter="15" class="form-row">
							<el-col :span="8">
								<el-form-item label="挂号类别:">
									<el-select v-model="receptionForm.regTypeId" size="mini" style="width: 100%"
										@change="handleRegTypePrice">
										<el-option v-for="item in registerOptions" :key="item.id" :label="item.label"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="挂号金额:">
									<el-input v-model="receptionForm.price" size="mini" style="width: 100%"
										:disabled="true" />
								</el-form-item>
							</el-col>

							<el-col :span="6">
								<el-form-item label="病员费别:">
									<el-select v-model="fastReceptionForm.prhCostType" size="mini" style="width: 100%"
										filterable clearable>
										<el-option v-for="item in prhCostOption" :key="item.id" :label="item.label"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>

					<!-- 操作按钮 -->
					<div class="dialog-footer no-line">
						<el-button size="mini" type="primary" v-if="userInfo?.isInsurance ==='1'"
							@click="handleYB_1191_Upload('01')">
							电子医保读取
						</el-button>
						<el-button size="mini" type="primary" v-if="userInfo?.isInsurance ==='1'"
							@click="handleYB_1191_Upload('03')">
							社保卡读取
						</el-button>
						<el-button size="mini" type="primary" @click="handleReadIdCardData">
							身份证读取
						</el-button>
						<el-button size="mini" type="warning" @click="handleResetContract">
							重置
						</el-button>
						<el-button size="mini" type="primary" @click="handleAddFastReception" :loading="loading">
							确定
						</el-button>
						<el-button size="mini" type="danger" @click="handleCancelContract">
							取消
						</el-button>
					</div>
				</div>
			</el-dialog>

			<el-dialog title="患者选择" :visible.sync="patientDialogVisible" width="60%"
				:before-close="handleCloseChoosePatient" class="patient-dialog">
				<!-- 患者表格 - 固定高度，超出部分滚动 -->
				<el-table size="mini" :data="patientTabelData" border highlight-current-row
					@row-dblclick="handleChoosePatient" @current-change="handleClickRow" style="width: 100%;"
					height="400px">
					<el-table-column v-for="(col, inx) in tableRows14" :key="inx" :type="col.type" :prop="col.prop"
						:label="col.name" :render-header="labelHead" align="center"
						:min-width="getColumnWidth(col.label,col.prop,patientTabelData)">
						<template #default="{ row }">
							{{ safeGetMappedValue(col, row) }}
						</template>
					</el-table-column>
				</el-table>

				<div class="dialog-footer no-line">
					<el-button type="primary" @click="handleChoosePatient" size="mini" :loading="loading">确定</el-button>
					<el-button @click="handleCloseChoosePatient" size="mini">取消</el-button>
				</div>
			</el-dialog>

			<!--一周内就诊数据-->
      <el-dialog :close-on-click-modal="false" title="一周内就诊数据" :visible.sync="sevenDayDialogVisible"
                 :before-close="handleCancelSeedoctorDataList" width="70%" class="patient-dialog">
        <!-- 查询条件区域 -->
        <div class="query-conditions">
          <el-form :inline="true" :model="seedoctorQueryParams" class="query-form" size="mini">
            <el-form-item label="健康ID:">
              <el-input style="width: 150px" v-model="seedoctorQueryParams.patientId"
                        clearable></el-input>
            </el-form-item>

            <el-form-item label="姓名:">
              <el-input style="width: 150px" v-model="seedoctorQueryParams.patientName"
                        clearables></el-input>
            </el-form-item>

            <el-form-item label="就诊时间:">
              <el-date-picker style="width: 150px" v-model="seedoctorQueryParams.startTime" type="date"
                              placeholder="开始日期" value-format="yyyy-MM-dd" @change="handleSavenData"></el-date-picker>
              -
              <el-date-picker style="width: 150px" v-model="seedoctorQueryParams.endTime" type="date"
                              placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleSavenData"></el-date-picker>
            </el-form-item>

            <el-form-item label="就诊医生:">
              <el-select style="width: 100px" v-model="seedoctorQueryParams.doctorId" clearable
                         @change="handleSavenData">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.label"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSavenData" size="mini">查询</el-button>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="mini"
                         @click="batchDeriveExcelSeeDoctorData">导出诊疗信息</el-button>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="mini"
                         @click="exportOfMedicalVisitRecords">导出就诊记录</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格区域 -->
        <div class="table-container">
          <el-table size="mini" :key="queryKey" :data="sevenDayTableData"
                    @row-dblclick="handleQuote" ref="printTable" border style="width: 100%">
            <el-table-column label="操作" width="180" align="center" fixed="right">
              <template #default="{ row }">
                <el-button type="success" size="mini" @click="handleAddReception(row)" title="接诊">接诊
                </el-button>
                <el-button type="success" size="mini" @click="handleQuote(row)" title="返诊"  :disabled="row.cardid !== patientForm.certno">返诊
                </el-button>
              </template>
            </el-table-column>

            <el-table-column v-for="(col, index) in tableRows3" :key="index" :prop="col.prop"
                             :label="col.name" align="center"
                             :min-width="getColumnWidth(col.label, col.prop, sevenDayTableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="totalSize"
                         class="pagination"></el-pagination>
        </div>

        <div slot="footer">
          <el-button @click="handleCancelSeedoctorDataList" size="mini">取消</el-button>
        </div>
      </el-dialog>

      <!--一周内就诊数据-->
      <el-dialog :close-on-click-modal="false" title="订单记录" :visible.sync="chargeDetailDialogVisible"
                 width="90%" class="patient-dialog" @closed="handleChargeDetailDialogClosed">

        <!-- 表格区域 -->
        <div class="table-main-container" ref="tableContainer">
          <!-- 左侧主表格 -->
          <div class="table-left">
            <el-table
                size="mini"
                :key="queryKey"
                :data="chargeTableData"
                @row-click="getChargeDetail"
                border
                highlight-current-row
                style="width: 100%; min-width: 1200px;"
                height="55vh">
              <el-table-column fixed="left" label="行号" type="index" width="50px" align="center"></el-table-column>
              <el-table-column v-for="(col, index) in chargeDetailRows" :key="index" :prop="col.prop"
                               :label="col.name" align="center"
                               :min-width="getColumnWidth(col.label, col.prop, chargeTableData)">
                <template #default="{ row }">
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80" align="center" fixed="right">
                <template #default="{ row }">
                  <el-button type="text" size="mini" @click.stop="getChargeDetail(row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 右侧 el-drawer 抽屉 -->
          <el-drawer
              :visible.sync="showChargeDetail"
              direction="rtl"
              title="订单详情"
              size="68%"
              :with-header="true"
              :append-to-body="false"
              :modal="false"
              :wrapper-closable="true"
              class="charge-detail-drawer"
          >
            <div class="drawer-content" v-if="chargeDetailData">
              <!-- ========== 基本信息 ========== -->
              <!-- 基本信息 -->
              <div class="charge-info-header">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">订单号：</span>
                      <span class="value text-ellipsis" :title="chargeDetailData.orderNo">
          {{ chargeDetailData.orderNo }}
        </span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">患者姓名：</span>
                      <span class="value">{{ chargeDetailData.patientName }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">订单状态：</span>
                      <el-tag :type="getTagTypeByStatus(chargeDetailData.status)" size="mini">
                        {{ getLabelById('orderStatusOptions', chargeDetailData.status) }}
                      </el-tag>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 10px;">
                  <el-col :span="6">
                    <div class="info-item">
                      <span class="label">收费状态：</span>
                      <el-tag :type="getChargeTagType(chargeDetailData.chargeStatus)" size="mini">
                        {{ getLabelById('orderChargeStatusOptions', chargeDetailData.chargeStatus) }}
                      </el-tag>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="info-item">
                      <span class="label">开单时间：</span>
                      <span class="value">{{ chargeDetailData.orderedAt }}</span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="info-item">
                      <span class="label">提交时间：</span>
                      <span class="value">{{ chargeDetailData.submittedAt }}</span>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="info-item">
                      <span class="label">总金额：</span>
                      <span class="value" style="color: #909399;">¥{{ chargeDetailData.totalAmount || 0 }}</span>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 10px;">
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">诊断编码：</span>
                      <span class="value">{{ chargeDetailData.diagnosisCode || '-' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="info-item">
                      <span class="label">诊断名称：</span>
                      <span class="value">{{ chargeDetailData.diagnosisName || '-' }}</span>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 10px;" v-if="chargeDetailData.remark">
                  <el-col :span="24">
                    <div class="info-item">
                      <span class="label">备注：</span>
                      <span class="value">{{ chargeDetailData.remark }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <!-- ========== Tabs ========== -->
              <el-tabs v-model="chargeDetailTab" class="charge-detail-tabs">
                <!-- 订单明细 -->
                <el-tab-pane label="订单明细" name="items">
                  <!-- 引用按钮 -->
                  <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-edit"
                        @click="handleQuotePrescription(chargeDetailData)"
                    >
                      引用处方
                    </el-button>

                    <el-button
                        v-show="chargeDetailData && (chargeDetailData.tcm || (chargeDetailData.items && chargeDetailData.items.some(i => i.itemType === 1 || i.itemType === 2)))"
                        type="primary"
                        size="mini"
                        icon="el-icon-printer"
                        @click="handleGetDataDistributeAndPrint(chargeDetailData)"
                    >
                      打印处方
                    </el-button>
                  </div>

                  <!-- 明细表格 -->
                  <el-table
                      :data="chargeDetailData.items || []"
                      border
                      size="mini"
                      style="width: 100%"
                      max-height="320"
                  >
                    <el-table-column type="index" label="序号" width="50" align="center" />
                    <el-table-column prop="itemCode" label="项目编码" min-width="150" align="center">
                      <template #default="{ row }">{{ row.itemCode || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="itemName" label="项目名称" min-width="150" align="center">
                      <template #default="{ row }">{{ row.itemName || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="specification" label="规格" min-width="120" align="center">
                      <template #default="{ row }">{{ row.specification || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="itemType" label="项目类型" width="90" align="center">
                      <template #default="{ row }">
                        {{ getLabelById('itemTypeOptions', row.itemType) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="数量" width="70" align="center">
                      <template #default="{ row }">{{ row.quantity || 0 }}</template>
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位" width="70" align="center">
                      <template #default="{ row }">{{ row.unitName || '-' }}</template>
                    </el-table-column>
                    <el-table-column prop="unitPrice" label="单价" width="80" align="center">
                      <template #default="{ row }">¥{{ row.unitPrice || 0 }}</template>
                    </el-table-column>
                    <el-table-column prop="totalAmount" label="金额" width="90" align="center">
                      <template #default="{ row }">¥{{ row.totalAmount || 0 }}</template>
                    </el-table-column>
                    <el-table-column prop="status" label="明细状态" width="80" align="center">
                      <template #default="{ row }">
                        <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="mini">
                          {{ row.status === 1 ? '有效' : '已取消' }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>

                <!-- 中药处方（仅当存在时显示） -->
                <el-tab-pane label="中药处方" name="tcm" v-if="chargeDetailData.tcm">
                  <div style="padding: 10px; display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
                    <div><span style="font-weight: bold;">中药用法：</span>{{ chargeDetailData.tcm.tcmWayName || '-' }}</div>
                    <div><span style="font-weight: bold;">中药付数：</span>{{ chargeDetailData.tcm.doseCount || 0 }}</div>
                    <div><span style="font-weight: bold;">煎药方式：</span>{{ chargeDetailData.tcm.decoctionType === 0 ? '人工' : '煎药机' }}</div>
                    <div><span style="font-weight: bold;">煎药量：</span>{{ chargeDetailData.tcm.decoctionVolume || 0 }}</div>
                    <div><span style="font-weight: bold;">每次服药量：</span>{{ chargeDetailData.tcm.doseVolume || 0 }} {{ chargeDetailData.tcm.doseVolumeUnit || '' }}</div>
                    <div><span style="font-weight: bold;">频率ID：</span>{{ chargeDetailData.tcm.frequencyId || '-' }}</div>
                    <div><span style="font-weight: bold;">给药方式ID：</span>{{ chargeDetailData.tcm.routeId || '-' }}</div>
                  </div>
                </el-tab-pane>
              </el-tabs>            </div>
          </el-drawer>        </div>

        <div slot="footer">
          <el-button @click="chargeDetailDialogVisible =  false" size="mini">取消</el-button>
        </div>
      </el-dialog>

      <!--一周内就诊数据医嘱-->
      <el-dialog :close-on-click-modal="false" title="历史医嘱" :visible.sync="historyMedicalDialogVisible"
                 width="70%" class="patient-dialog">
        <div class="table-container">
          <el-table size="mini" :data="historyMedicalData" border style="width: 100%" show-summary
                    :summary-method="getPricSummary">
            <el-table-column v-for="(col, index) in tableRows10" :key="index" :prop="col.prop"
                             :label="col.name" align="center"
                             :min-width="getColumnWidth(col.label, col.prop, historyMedicalData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div slot="footer">
          <el-button @click="historyMedicalDialogVisible = false" size="mini">取消</el-button>
        </div>
      </el-dialog>		<!--一周内就诊数据医嘱-->
			<el-dialog :close-on-click-modal="false" title="历史医嘱" :visible.sync="historyMedicalDialogVisible"
				width="70%" class="patient-dialog">
				<div class="table-container">
					<el-table size="mini" :data="historyMedicalData" border style="width: 100%" show-summary
						:summary-method="getPricSummary">
						<el-table-column v-for="(col, index) in tableRows10" :key="index" :prop="col.prop"
							:label="col.name" align="center"
							:min-width="getColumnWidth(col.label, col.prop, historyMedicalData)">
							<template #default="{ row }">
								{{ safeGetMappedValue(col, row) }}
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div slot="footer">
					<el-button @click="historyMedicalDialogVisible = false" size="mini">取消</el-button>
				</div>
			</el-dialog>

			<!--西医诊断-->
			<el-dialog :close-on-click-modal="false" title="西医诊断" :visible.sync="westernDiagnosisModalVisible"
				:before-close="handleCancelSelDiagnose" width="60%" class="patient-dialog">
				<!-- 搜索框区域 -->
				<div class="search-container" style="display: flex; align-items: center; margin-bottom: 15px;">
					<span style="margin-right: 12px; font-size: 14px; color: #606266; font-weight: 500;">搜索</span>
					<el-input size="small" placeholder="请输入诊断名称搜索" v-model="westernSearchQuery" clearable
						style="width: 320px; " @clear="resetDiagnoseData(1)" @keyup.enter.native="handleWesternSearch">
						<el-button slot="append" icon="el-icon-search" @click="handleWesternSearch"
							style="padding: 9px 12px;"></el-button>
					</el-input>
				</div>

				<!-- 第一个表格（固定高度） -->
				<div style="height:300px; margin-bottom: 15px;">
					<el-table ref="westernTable" sizi="mini" :data="westernDiagnosisTableData" border
						highlight-current-row style="width: 100%;" height="100%" class="compact-mini-table"
						@row-dblclick="addToWesternSelectedTable">
						<el-table-column v-for="(col, inx) in tableRows4" :key="inx" :type="col.type" :prop="col.prop"
							:label="col.name" :render-header="labelHead" align="center"
							:min-width="getColumnWidth(col.label,col.prop,westernDiagnosisTableData)"
							:width="col.prop === 'remarks' ? '700px' : null"></el-table-column>
					</el-table>
				</div>

				<!-- 已选列表（使用el-tabs包装） -->
				<el-tabs type="border-card" style="box-shadow: none; border: 1px solid #ebeef5;">
					<el-tab-pane label="已选诊断列表">
						<el-table size="mini" :data="westernSelectedTable" border style="width: 100%"
							empty-text="请双击上方表格添加诊断" class="compact-mini-table">
							<el-table-column label="操作" width="80" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="text" @click="removeWesternSelected(scope.$index)">移除
									</el-button>
								</template>
							</el-table-column>
							<el-table-column v-for="(col, inx) in tableRows8" :key="inx" :prop="col.prop"
								:label="col.name" :render-header="labelHead" align="center"
								:min-width="getColumnWidth(col.label,col.prop,westernSelectedTable)">
								<template slot-scope="scope">
									<template v-if="col.prop === 'definiteDiagnosis'">
										<el-checkbox v-model="scope.row.definiteDiagnosis" :true-label="1"
											:false-label="0"
											@change="(val) => handleConfirmed(scope.row, val)"></el-checkbox>
									</template>
									<template v-else>
										{{ safeGetMappedValue(col, scope.row) }}
									</template>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs>

				<div slot="footer" class="dialog-footer no-line">
					<el-button type="primary" @click="addReceptionDiagnosis(1)" size="mini"
						:loading="loading">确定</el-button>
					<el-button @click="handleCancelSelDiagnose" size="small">取消</el-button>
				</div>
			</el-dialog>

			<!--中医诊断-->
			<el-dialog :close-on-click-modal="false" title="中医诊断" :visible.sync="chinaDiagnosisModalVisible"
				:before-close="handleCancelSelDiagnose" width="60%" class="patient-dialog">
				<!-- 双表格并排展示 -->
				<el-row :gutter="20">
					<el-col :span="14">
						<!-- 第一个表格的病症列表搜索框 -->
						<div class="search-container" style="margin-bottom: 15px; align-items: center;">
							<span style="margin-right: 10px; font-size: 14px;">搜索:</span>
							<el-input size="mini" placeholder="请输入诊断名称搜索" v-model="chinaSearchQuery1" clearable
								style="width: 300px" @clear="resetDiagnoseData(2)"
								@keyup.enter.native="handleChinaSearch(1)">
								<el-button slot="append" @click="handleChinaSearch(1)">查询</el-button>
							</el-input>
						</div>

						<!-- 第一个表格（固定高度） -->
						<div style="height: 300px;">
							<el-table size="mini" :data="chinaDiagnosisTableData1" border highlight-current-row
								style="width: 100%;" height="100%" @row-click="selChinaDiagnosisRow">
								<el-table-column v-for="(col, inx) in tableRows4" :key="inx" :type="col.type"
									:prop="col.prop" :label="col.name" :render-header="labelHead" align="center"
									:min-width="getColumnWidth(col.label,col.prop,chinaDiagnosisTableData1)"></el-table-column>
							</el-table>
						</div>
					</el-col>

					<el-col :span="10">
						<!-- 第二个表格的筛选搜索框 -->
						<div class="search-container" style="margin-bottom: 15px; align-items: center;">
							<span style="margin-right: 10px; font-size: 14px;">搜索:</span>
							<el-input size="mini" placeholder="请输入筛选条件" v-model="chinaSearchQuery2" clearable
								style="width: 300px" @clear="resetDiagnoseData(3)"
								@keyup.enter.native="handleChinaSearch(2)">
								<el-button slot="append" @click="handleChinaSearch(2)">查询</el-button>
							</el-input>
						</div>

						<!-- 第二个表格（固定高度） -->
						<div style="height: 300px;">
							<el-table size="mini" :data="chinaDiagnosisTableData2" border highlight-current-row
								style="width: 100%;" height="100%" @row-dblclick="addToChinaSelectedTable">
								<el-table-column v-for="(col, inx) in tableRows5" :key="inx" :type="col.type"
									:prop="col.prop" :label="col.name" :render-header="labelHead" align="center"
									:min-width="getColumnWidth(col.label,col.prop,chinaDiagnosisTableData2)"></el-table-column>
							</el-table>
						</div>
					</el-col>
				</el-row>

				<!-- 已选列表（使用el-tabs包装） -->
				<el-tabs type="border-card" style="box-shadow: none; border: 1px solid #ebeef5; margin-top: 15px;">
					<el-tab-pane label="已选诊断列表">
						<el-table size="mini" :data="chinaSelectedTable" border style="width: 100%;"
							empty-text="请双击上方表格添加诊断">
							<el-table-column label="操作" width="80" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="text" @click="removeChinaSelected(scope.$index)">移除
									</el-button>
								</template>
							</el-table-column>
							<el-table-column v-for="(col, inx) in tableRows6" :key="inx" :prop="col.prop"
								:label="col.name" :render-header="labelHead" align="center"
								:min-width="getColumnWidth(col.label,col.prop,chinaSelectedTable)"></el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs>

				<div slot="footer" class="dialog-footer no-line">
					<el-button type="primary" @click="addReceptionDiagnosis(2)" size="mini"
						:loading="loading">确定</el-button>
					<el-button @click="handleCancelSelDiagnose" size="small">取消</el-button>
				</div>
			</el-dialog>

			<!--选择频次-->
			<el-dialog :close-on-click-modal="false" title="选择执行频率" :visible.sync="selExecutionPLDialogVisible"
				width="20%" :before-close="handleExecutionPL">

				<el-form size="mini" label-width="100px">
					<el-row>
						<el-col :span="24">
							<el-form-item :model="searchForm" label="执行科室:">
								<el-select size="mini" :disabled="searchForm.depexecutetype === 0 || isShowPrescription"
									v-model="searchForm.deptName" placeholder="请选择科室" style="width: 70%">
									<el-option v-for="item in deptOptions" :key="item.id" :label="item.label"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item :model="searchForm" label="执行频率:">
								<el-select filterable @change="computeFrequency" v-model="searchForm.usedfrquId"
									style="width: 70%" placeholder="请选择执行频率">
									<el-option v-for="item in medicationFrequencyOptions" :key="item.id"
										:label="item.label" :value="item.id" />
								</el-select>
							</el-form-item>

							<el-form-item label="执行天数:" prop="executionDays">
								<el-input @input="computeFrequencyDay" type="number" min="1" step="1" style="width: 70%"
									v-model.number="searchForm.executionDays" placeholder="请输入执行天数"></el-input>
							</el-form-item>

							<el-form-item label="执行数量:" prop="executionDays">
								<el-input @change="computeFrequencyNum" type="number" min="1" step="1"
									style="width: 70%" v-model.number="searchForm.executionNum"
									placeholder="请输入数量"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>

				<span slot="footer" class="dialog-footer no-line">
					<el-button type="primary" @click="handleDisposeData(true)" size="mini">确定</el-button>
					<el-button @click="handleExecutionPL" size="mini">取消</el-button>
				</span>
			</el-dialog>

      <el-dialog
          :close-on-click-modal="false"
          :title="drugTemplateForm.id === null ? '新增处方模板' : '编辑处方模板'"
          :visible.sync="templateDialogVisible"
          width="90%"
          :before-close="handleCancelTemplate"
      >
        <div class="template-base-info">
          <el-form :model="drugTemplateForm" size="mini" label-width="100px">
            <el-form-item label="模板名称:" required>
              <el-input
                  v-model="drugTemplateForm.name"
                  placeholder="请输入模板名称"
                  style="width: 300px"
                  maxlength="50"
                  show-word-limit
              />
            </el-form-item>

            <!-- 药品搜索区域 -->
            <el-form-item label="药品搜索:" required>
              <div style="display: flex; gap: 10px; align-items: center;">
                <el-select v-model="searchDrugType" size="mini" style="width: 100px;">
                  <el-option label="西药" :value="1" />
                  <el-option label="中药" :value="2" />
                </el-select>
                <el-input
                    clearable
                    v-model="searchKeyword"
                    placeholder="请输入药品名称、规格或生产厂家搜索"
                    size="mini"
                    style="width: 320px"
                    @input="handleSearchDrug"
                    v-popover:searchPopover
                    class="search-input"
                />
              </div>
            </el-form-item>
          </el-form>

          <!-- 搜索弹出表格 -->
          <el-popover
              ref="searchPopover"
              placement="top"
              width="800"
              trigger="click"
              v-model="searchPopoverVisible"
              popper-class="drug-search-popover"
          >
            <el-table
                :data="searchResultData"
                size="mini"
                border
                highlight-current-row
                @row-click="handleSelectSearchResult"
                style="width: 100%"
                max-height="300"
                class="search-result-table"
            >
              <el-table-column
                  v-for="col in searchResultColumns"
                  :key="col.prop"
                  :prop="col.prop"
                  :label="col.name"
                  align="center"
                  :min-width="getColumnWidth(col.label, col.prop, searchResultData)"
              >
                <template #default="{ row }">
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </el-table-column>
            </el-table>
          </el-popover>
        </div>

        <!-- ===== 西药表格 ===== -->
        <div class="medicine-section">
          <div class="section-title">西药</div>
          <el-table
              :data="drugTemplateForm.westDrugs"
              border
              size="mini"
              style="width: 100%"
              max-height="300"
          >
            <!-- 操作列 -->
            <el-table-column label="操作" width="80" align="center">
              <template #default="scope">
                <el-button
                    size="mini"
                    type="text"
                    style="color: #f56c6c;"
                    @click="removeWestDrug(scope.$index)"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>

            <!-- 药品名称（只读） -->
            <el-table-column prop="drugName" label="药品名称" min-width="180" align="center">
              <template #default="scope">
                <span>{{ scope.row.drugName }}</span>
              </template>
            </el-table-column>

            <!-- 单次剂量 -->
            <el-table-column prop="sdoseCnt" label="单次剂量" width="120" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.sdoseCnt"
                    size="mini"
                    placeholder="请输入"
                    @input="handleWestSdoseInput(scope.row)"
                />
              </template>
            </el-table-column>

            <!-- 剂量单位 -->
            <el-table-column prop="dosaUnt" label="剂量单位" width="100" align="center">
              <template #default="scope">
                <el-select v-model="scope.row.dosaUnt" size="mini" placeholder="请选择" filterable>
                  <el-option
                      v-for="item in dosaUntOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  />
                </el-select>
              </template>
            </el-table-column>

            <!-- 用药频率 -->
            <el-table-column prop="usedfrquId" label="用药频率" width="120" align="center">
              <template #default="scope">
                <el-select v-model="scope.row.usedfrquId" size="mini" placeholder="请选择" filterable>
                  <el-option
                      v-for="item in medicationFrequencyOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  />
                </el-select>
              </template>
            </el-table-column>

            <!-- 周期天数 -->
            <el-table-column prop="prdDays" label="周期天数" width="100" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.prdDays"
                    size="mini"
                    placeholder="请输入"
                    @input="handleWestNumberInput(scope.row, 'prdDays')"
                />
              </template>
            </el-table-column>

            <!-- 处方数量 -->
            <el-table-column prop="cnt" label="处方数量" width="100" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.cnt"
                    size="mini"
                    placeholder="请输入"
                    @input="handleWestNumberInput(scope.row, 'cnt')"
                />
              </template>
            </el-table-column>

            <!-- 处方金额 -->
            <el-table-column prop="saleAmt" label="处方金额" width="120" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.saleAmt"
                    size="mini"
                />
              </template>
            </el-table-column>

            <!-- 给药方式 -->
            <el-table-column prop="medcWayId" label="给药方式" width="120" align="center">
              <template #default="scope">
                <el-select v-model="scope.row.medcWayId" size="mini" placeholder="请选择" filterable>
                  <el-option
                      v-for="item in routeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  />
                </el-select>
              </template>
            </el-table-column>

            <!-- 输液速度 -->
            <el-table-column prop="speed" label="输液速度" width="100" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.speed"
                    size="mini"
                    placeholder="请输入"
                    :disabled="![1,2].includes(scope.row.medcWayId)"
                />
              </template>
            </el-table-column>

            <!-- 备注 -->
            <el-table-column prop="remark" label="备注" min-width="100" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.remark"
                    size="mini"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 3 }"
                    placeholder="请输入"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- ===== 中药表格 ===== -->
        <div class="medicine-section" style="margin-top: 20px;">
          <div class="section-title">中药</div>
          <el-table
              :data="drugTemplateForm.chinaDrugs"
              border
              size="mini"
              style="width: 100%"
              max-height="300"
          >
            <el-table-column label="操作" width="80" align="center">
              <template #default="scope">
                <el-button
                    size="mini"
                    type="text"
                    style="color: #f56c6c;"
                    @click="removeChinaDrug(scope.$index)"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>

            <el-table-column prop="drugName" label="药品名称" min-width="180" align="center">
              <template #default="scope">
                <span>{{ scope.row.drugName }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="sdoseCnt" label="单次剂量" width="180" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.sdoseCnt"
                    size="mini"
                    placeholder="请输入剂量"
                    @input="handleChinaSdoseInput(scope.row)"
                />
              </template>
            </el-table-column>

            <el-table-column prop="saleAmt" label="金额" width="180" align="center">
              <template #default="scope">
                <span>{{ scope.row.saleAmt }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="100" align="center">
              <template #default="scope">
                <el-input
                    v-model="scope.row.remark"
                    size="mini"
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 3 }"
                    placeholder="请输入"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <span slot="footer" class="dialog-footer no-line">
    <el-button type="primary" size="mini" @click="handleSaveTemplate">确定</el-button>
    <el-button @click="handleCancelTemplate" size="mini">取消</el-button>
  </span>
      </el-dialog>
      <el-drawer
          title="药品模板"
          :visible.sync="selChinaWestVisible"
          :direction="direction"
          :modal="false"
          wrapper-class-name="chinese-medicine-drawer"
          size="600px"
      >
        <template #title>
          <div class="drawer-custom-title">
            <span class="title-text">药品模板</span>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click.stop="openTemplateDialog(activeTemplateTab)" style="margin-left: 50px">
              创建模板
            </el-button>
          </div>
        </template>

        <div class="prescription-right">
          <el-tabs v-model="activeTemplateTab" class="template-tabs">
            <!-- 西药 Tab -->
            <el-tab-pane label="西药" name="west">
              <el-card class="template-content-card" shadow="never">
                <div v-if="westTemplateList && westTemplateList.length > 0">
                  <div class="template-item" v-for="template in westTemplateList" :key="template.id">
                    <div class="template-header">
                      <div class="template-title">
                        <span class="template-id">{{ template.name }}</span>
                        <el-tag :type="template.state === 1 ? 'success' : 'info'" size="mini">
                          {{ template.state === 1 ? '启用中' : '禁用中' }}
                        </el-tag>
                      </div>
                      <div class="template-actions">
                        <el-button type="text" size="mini" @click="handleEditTemplate(template)">编辑</el-button>
                        <el-button type="text" size="mini" style="color: #F56C6C" @click="handleEditTemplateState(template)">
                          {{ template.state === 1 ? '禁用' : '启用' }}
                        </el-button>
                        <el-button type="text" size="mini" @click="handleQuoteTemplate(template, 1)">引用</el-button>
                      </div>
                    </div>
                    <div class="drugs-list">
                      <div class="drug-item" v-for="(drug, index) in parseContent(template.content)" :key="index">
                        <div class="drug-main">
                    <span class="drug-name">
                      {{ drug.drugName }}{{ drug.sdoseCnt ? ' ' + drug.sdoseCnt + (drug.dosaUnt || 'g') : '' }}
                    </span>
                          <span class="drug-manufacturer">{{ drug.prodentpName || '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-template">
                  <el-empty description="暂无西药模板" :image-size="60">
                    <el-button type="primary" size="small" @click="openTemplateDialog('west')">创建模板</el-button>
                  </el-empty>
                </div>
              </el-card>
            </el-tab-pane>

            <!-- 中药 Tab -->
            <el-tab-pane label="中药" name="china">
              <el-card class="template-content-card" shadow="never">
                <div v-if="chinaTemplateList && chinaTemplateList.length > 0">
                  <div class="template-item" v-for="template in chinaTemplateList" :key="template.id">
                    <div class="template-header">
                      <div class="template-title">
                        <span class="template-id">{{ template.name }}</span>
                        <el-tag :type="template.state === 1 ? 'success' : 'info'" size="mini">
                          {{ template.state === 1 ? '启用中' : '禁用中' }}
                        </el-tag>
                      </div>
                      <div class="template-actions">
                        <el-button type="text" size="mini" @click="handleEditTemplate(template)">编辑</el-button>
                        <el-button type="text" size="mini" style="color: #F56C6C" @click="handleEditTemplateState(template)">
                          {{ template.state === 1 ? '禁用' : '启用' }}
                        </el-button>
                        <el-button type="text" size="mini" @click="handleQuoteTemplate(template, 2)">引用</el-button>
                      </div>
                    </div>
                    <div class="drugs-list">
                      <div class="drug-item" v-for="(drug, index) in parseContent(template.content)" :key="index">
                        <div class="drug-main">
                    <span class="drug-name">
                      {{ drug.drugName }}{{ drug.sdoseCnt ? ' ' + drug.sdoseCnt + 'g' : '' }}
                    </span>
                          <span class="drug-manufacturer">{{ drug.prodentpName || '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-template">
                  <el-empty description="暂无中药模板" :image-size="60">
                    <el-button type="primary" size="small" @click="openTemplateDialog('china')">创建模板</el-button>
                  </el-empty>
                </div>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
      <FollowForm
          :visible.sync="showFollowDialog"
          :default-data="defaultFollowData"
          @success="handleFollowSuccess"></FollowForm>
			<!--      <kzInfo ref="kzInfo" :form="westSonData" v-if="showDrugDialog"></kzInfo>
                                        <useInfo ref="useInfo" :form="westSonData" v-if="showDrugDialog"></useInfo>-->

      <addModel ref="addModel"  />

    </div>

	</div>

</template>
<script>
import {
  addContractUnit,
  addDocphr,
  dict,
  editContractUnit,
  editDocphr,
  getArea,
  getContractUnit,
  getContuntList,
  getDeptList,
  getRegisterType
} from "@/api/reservation/reservation";
import AddType from './reservationAddType.js'
import AddType2 from './reservationSettleType.js'
import addModel from '@/views/systemCatalogue/Western/Western/addDialogVisible.vue';

// 从第4个JS文件中导入字段配置 使用注意
import useInfo from '/src/views/systemCatalogue/xicheng/Western/F4.vue';
import {pinyin} from "pinyin-pro";
import {
  addAise,
  addBeforeHistoryTemplate,
  addComplainTemplate,
  addFastReception,
  addMedicalAudio,
  addMedicineCache,
  addNowHistoryTemplate,
  addOrders,
  addReception,
  aiPrescribeSend,
  batchDeriveExcelSeeDoctorData,
  checkChinaDrug,
  checkClinicRelation,
  checkWestDrug,
  delOneAdvice,
  editAise,
  editBeforeHistoryTemplate,
  editComplainTemplate,
  editDoctoradvice,
  editNowHistoryTemplate,
  editOrders,
  editReception,
  editReceptionDiagnosis,
  exportOfMedicalVisitRecords,
  getAiseList,
  getBeforeHistoryTemplate,
  getChargingPriceById,
  getChinaDiseaseByCondition,
  getChinaDocticdList,
  getChinaDugdpurctable,
  getChinaPrescription,
  getComplainTemplate,
  getDeptInDoctorList,
  getDiagnosisInfo,
  getDocphrAllList,
  getDocphrByCondtion,
  getDocphrList,
  getDocticdList,
  getDoctoradvice,
  getDoctordispose,
  getDoesItExistSFZ,
  getDrugUnt,
  getFinishReception,
  getMedicalAudioList,
  getMedicineCache,
  getNowHistoryTemplate,
  getPatientAllData,
  getReceptionCancel,
  getReceptionDiagnosis,
  getReceptionList,
  getSyndromeByCondition,
  getSyndromeList,
  getDrugByCondition,
  printOutpatientsDerive,
  uploadFile,
} from "@/api/reservation/outpatientPhysician";
import {getChargingPrice} from "@/api/cosrute/Cosrute";
import {getDoctorList} from "@/api/scheduling/scheduling";
import {getDInfos, getDosaUnt, getMedicationWay} from "@/api/MedicenCata";
import {selectDrugDosageForm} from "@/api/systemCatalogue/Pharmacological";
import dayjs from "dayjs";
import printUtil from "@/untils/printUtil";
import {medicalRecordOutpatient} from "@/assets/printTemplateConfig/medicalRecordOutpatient";
import {outpatientsDiagnosis} from "@/assets/printTemplateConfig/outpatientsDiagnosis";
import {outpatientsDiagnosis2} from "@/assets/printTemplateConfig/outpatientsDiagnosis2";
import {readIdCard} from "@/untils/idCardReader";
import {getNationalityId} from "@/untils/outpatientPhysicianUntils";
import {withLoading} from "@/untils/loading";
import {doccliniclist} from "@/api/cinic/cinic";
import {westPrescription} from "@/assets/printTemplateConfig/westPrescription";
import {chinaPrescription} from "@/assets/printTemplateConfig/chinaPrescription";
import {getStaff} from "@/api/user";
import {getSeeDoctorKeywordList} from "@/api/seedoctorKeyword/seedoctorKeyword";
import {addYbResponseData, addYbRquestData, getqdNo} from "@/api/yb";
import {buildYbRequest} from "@/api/yb/ybApi";
import {handleYB_1101_Upload, handleYB_Business_Upload} from "@/api/yb/ocxActiveXApi";
import {getDeptAttribute} from "@/api/addAcc/addAcc";
import {getWestDetail} from "@/api/reservation/outpatientCharge";
import OutpatientCharge from "/src/views/reservation/OutpatientCharge.vue";
import NewGiveMedici from "/src/views/medicenHouse/WesternHouse/giveMedici/newgiveMedici.vue";
import giveMedici from "/src/views/medicenHouse/WesternHouse/giveMedici/giveMedici.vue";
import FollowUpClinic from "/src/views/FollowUpClinic/FollowUpClinic.vue";
import {fySave, selectPatientInfo} from "@/api/MedicenHouse/WesternGive";
import {tcmDisselectPatientInfo, tcmFySave} from "@/api/MedicenHouse/traMediciGive";
import {
  addDrugtemplate,
  editDrugtemplate,
  getDrugTemplateList
} from "@/api/retailPurchaseOfMedicine/retailPurchaseOfMedicine";
import {disposalProject} from "@/assets/printTemplateConfig/disposalProject";
import FollowForm from "@/components/FollowForm.vue";
import {getOrdersByPatientId} from "@/api/reservation/outpatientPhysicianV2";
import {getChargesByChargeId, getChargesQuery} from "@/api/reservation/outpatientChargeV2";

export default {
		components: {
      FollowForm,
      addModel,
			OutpatientCharge,
			giveMedici,
      FollowUpClinic,
      NewGiveMedici
		},
		data() {

			return {
        activeTemplateTab: 'west', // 默认激活西药
        westTemplateList: [],   // 西药模板列表
        chinaTemplateList: [],  // 中药模板列表
        templateDialogVisible: false,
        drugTemplateForm: {
          id: null,
          name: '',
          westDrugs: [],
          chinaDrugs: [],
          state: 1  // 默认启用
        },
        searchDrugType: 1, // 1-西药, 2-中药
        searchKeyword: '',
        searchPopoverVisible: false,
        searchResultData: [],
        searchResultColumns: [],

        // 订单状态选项
        orderStatusOptions: [
          { id: 0, label: '草稿' },
          { id: 1, label: '已提交' },
          { id: 2, label: '已取消' }
        ],

// 收费状态选项
        orderChargeStatusOptions: [
          { id: 0, label: '未收费' },
          { id: 1, label: '已收费' }
        ],

// 项目类型选项（用于 items 展示）
        itemTypeOptions: [
          { id: 1, label: '西药' },
          { id: 2, label: '中药' },
          { id: 4, label: '理疗' },
          { id: 5, label: '卫材' },
          { id: 6, label: '输液/治疗' },
          { id: 7, label: '检查' },
          { id: 8, label: '检验' },
          { id: 9, label: '挂号费' },
          { id: 10, label: '其他' }
        ],
        routeOptions:[{id:3,label:'口服'},{id:1,label:'注射'},{id:2,label:'输液/滴注'}],
        _currentDisposeRow: null,
        disposeSearchTimer: null,

        tableRowsDispose: [
          {
            name: "处置项目",
            prop: "costname",
            align: "center",
            minWidth: "180"
          },
          {
            name: "单价",
            prop: "odcost",
            align: "center",
            width: "80"
          },
          {
            name: "执行频率",
            prop: "exeFrquId",
            align: "center",
            width: "100"
          },
          {
            name: "周期天数",
            prop: "prdDays",
            align: "center",
            width: "80"
          },
          {
            name: "周期次数",
            prop: "periodCount",
            align: "center",
            width: "80"
          },
          {
            name: "执行数量",
            prop: "frquCnt",
            align: "center",
            width: "80"
          },
          {
            name: "金额",
            prop: "executeOdcost",
            align: "center",
            width: "90"
          },
          {
            name: "备注",
            prop: "remark",
            align: "center",
            minWidth: "100"
          }
        ],
        chargeStatusOptions: [
          { id: 0, label: '未收费' },
          { id: 1, label: '已收费' },
          { id: 2, label: '部分退款' },
          { id: 3, label: '全额退款' }
        ],
        fulfillmentStatusOptions: [
          { id: 0, label: '待处理' },
          { id: 1, label: '部分完成' },
          { id: 2, label: '已完成' },
          { id: 3, label: '部分退回' },
          { id: 4, label: '全部退回' },
          { id: 9, label: '无需履约' }
        ],
        skinTestOptions: [
          { id: 0, label: '否' },
          { id: 1, label: '是' }
        ],

        tableRows13: [
          {
            name: "收费状态",
            prop: "chargeStatus",
            align: "center",
            width: "80",
            op: "chargeStatusOptions"
          },
          {
            name: "药品名称",
            prop: "itemName",
            align: "center",
            minWidth: "150"
          },
          /*{
            name: "规格",
            prop: "specification",
            align: "center",
            minWidth: "250"
          },*/
          {
            name: "单次剂量",
            prop: "singleDose",
            align: "center",
            width: "80"
          },
          {
            name: "剂量单位",
            prop: "doseUnit",
            align: "center",
            width: "100"
          },
          {
            name: "频率",
            prop: "frequencyId",
            align: "center",
            width: "80",
            op: "medicationFrequencyOptions"
          },
          {
            name: "天数",
            prop: "periodDays",
            align: "center",
            width: "70"
          },
          {
            name: "总次数",
            prop: "periodCount",
            align: "center",
            width: "80"
          },
          {
            name: "付数",
            prop: "doseCount",
            align: "center",
            width: "80"
          },
          {
            name: "数量",
            prop: "quantity",
            align: "center",
            width: "80"
          },

          {
            name: "单位",
            prop: "unitName",
            align: "center",
            width: "70"
          },
          {
            name: "单价",
            prop: "unitPrice",
            align: "center",
            width: "80"
          },
          {
            name: "金额",
            prop: "totalAmount",
            align: "center",
            width: "90"
          },
          {
            name: "给药方式",
            prop: "routeId",
            align: "center",
            width: "80",
            op: "routeOptions"
          },


          {
            name: "是否皮试",
            prop: "skinTestRequired",
            align: "center",
            width: "100",
            op: "skinTestOptions",
            showCondition: (row) => row.itemType === 1 // 仅西药显示
          },
          {
            name: "输液速度",
            prop: "infusionSpeed",
            align: "center",
            width: "80",
            showCondition: (row) => row.itemType === 6 // 仅输液/治疗显示
          },
          {
            name: "执行状态",
            prop: "fulfillmentStatus",
            align: "center",
            width: "80",
            op: "fulfillmentStatusOptions",
            showCondition: (row) => row.itemType === 1 || row.itemType === 2 || row.itemType === 3 // 仅药品显示
          },
          {
            name: "备注",
            prop: "remark",
            align: "center",
            minWidth: "100"
          }
        ],
        prescriptionList: [],

        isProcessingEnter: false,
        drugSearchTimer: null,

        paymentType: '0',  // 默认自费
        saveTimer: null,
        cachedRequestNo: null, // 缓存当前的幂等号

				leftSidebarCollapsed: false,
				rightSidebarCollapsed: false,
				activeTab: 'outpatient',
				aiDrawerVisible: false,
				direction: 'rtl',
				aiLoading: false,
				aiMessages: [],
				selChinaWestVisible: false,
				currentSessionId: null,
				isGenerating: false,
				currentPartialContent: '',
        showFollowDialog: false,
        defaultFollowData: {},
				provinces: [],
				DropDownedName: '西药医嘱',

				tableMedicineKey: 0,
				activeGroup: null,
				activeField: null,
				keywordsVisible: false,
				keywordGroups: {
					// 主诉分组
					patientTell: [{
							type: 0,
							title: '天数',
							keywords: ['1天', '2天', '3天', '4天', '6天', '1周', '2周', '半个月', '一个月', ]
						},
						{
							type: 1,
							title: '呼吸系统',
							keywords: []
						},
						{
							type: 2,
							title: '消化系统',
							keywords: []
						},
						{
							type: 3,
							title: '心脏血管',
							keywords: []
						},
						{
							type: 4,
							title: '外科症状',
							keywords: []
						},
					],
					// 现病史分组
					nowHistory: [{
							type: 0,
							title: '天数',
							keywords: ['1天', '2天', '3天', '4天', '6天', '1周', '2周', '半个月', '一个月', ]
						},
						{
							type: 1,
							title: '诱因',
							keywords: []
						},
						{
							type: 2,
							title: '特征',
							keywords: []
						},
						{
							type: 3,
							title: '兼症',
							keywords: []
						},
						{
							type: 4,
							title: '精神',
							keywords: []
						},
						{
							type: 5,
							title: '睡眠',
							keywords: []
						},
						{
							type: 6,
							title: '饮食',
							keywords: []
						},
						{
							type: 7,
							title: '二便',
							keywords: []
						},
						{
							type: 8,
							title: '体态',
							keywords: []
						}
					],
					// 既往史分组
					beforeHistory: [{
							type: 0,
							title: '天数',
							keywords: ['1天', '2天', '3天', '4天', '6天', '1周', '2周', '半个月', '一个月', ]
						},
						{
							type: 1,
							title: '默认',
							keywords: []
						},
						{
							type: 2,
							title: '既往有',
							keywords: []
						},
						{
							type: 3,
							title: '个人史',
							keywords: []
						}
					]
				},

				medicalRecord: false,
				outpatientsDiagnosis: false,
				medicalRecordHTML: '',
				outpatientsDiagnosisHTML: '',

				activeCollapse: ['seeDoctorData', 'medical', 'details'],

				westPagination: {
					currentPage: 1,
					pageSize: 20,
					total: 0
				},
				chinaPagination: {
					currentPage: 1,
					pageSize: 20,
					total: 0
				},


				// 防抖相关
				westSearchDebounce: null,
				chinaSearchDebounce: null,
				searchDebounceTime: 500,

				diseaseList: '高血压、动脉硬化性心脏病、冠状动脉粥样硬化性心脏病、脑卒中、糖尿病、慢性阻塞性肺疾病、慢性肾脏病、冠状动脉粥样硬化、冠状动脉狭窄',
				color: [
					'#FF0000', // 红
					'#00FF00', // 绿
					'#0000FF', // 蓝
					'#FF00FF', // 紫
					'#FFA500', // 橙
					'#00FFFF', // 青
					'#FF1493', // 深粉
					'#32CD32', // 酸橙
					'#8A2BE2', // 蓝紫
					'#FFD700', // 金
					'#006400', // 深绿
					'#8B008B', // 深紫
					'#FF6347', // 番茄红
					'#1E90FF', // 道奇蓝
					'#9370DB', // 中紫
					'#3CB371' // 中海绿
				],
				addressKey: null,
				isInitialLoad: true,
				certLengthMap: {
					1: 18, // 居民身份证
					2: 20, // 居民户口簿
					3: 9, // 护照
					4: 10, // 军官证
					5: 12, // 驾驶证
					6: 11, // 港澳居民来往内地通行证
					7: 10, // 台湾居民来往内地通行证
					8: 18, // 中国人民武装警察身份证件
					9: 20 // 其他法定有效证件
				},
				// 证件格式验证规则
				certPatterns: {
					1: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
					2: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/,
					3: /^[A-Za-z]\d{7,8}$/,
					4: /^[A-Za-z0-9\u4e00-\u9fa5]{1,10}$/,
					5: /^\d{12}$/,
					6: /^[HMhm]\d{8,10}$/,
					7: /^\d{8}[A-Za-z]{2}$/,
					8: /^WJ\d{6}\d{11}$/,
					9: /^[A-Za-z0-9\u4e00-\u9fa5]{1,20}$/
				},

				userInfo: null,
				userPermission: {},
				searchForm: {
					deptName: '',
          executId: null,
					odcost: null,
					executeOdcost: null,
					count: 1,
					remark: '',
					chargingPriceId: null,
          eisaiId: null,
					depexecutetype: null,
					usedfrquId: null,
					executionDays: null,
					executionNum: null,
					costmode: null,
				},

				visitStateOption: [{
						id: 1,
						label: '待签到'
					}, {
						id: 2,
						label: '待就诊'
					}, {
						id: 3,
						label: '已接诊'
					},
					{
						id: 4,
						label: '已取消'
					}, {
						id: 5,
						label: '待分诊'
					}, {
						id: 6,
						label: '已失效'
					}
				],

				currentPage: 1, // 当前页码
				pageSize: 10,
				pageNum: 1, //当前页currentPage
				totalSize: 10, //总条数

				patientDialogVisible: false,
				patientTabelData: [],
				sevenDayTableData: [],
        chargeTableData: [],           // 收费记录列表
        chargeDetailData: null,        // 收费详情
        showChargeDetail: false,       // 显示详情抽屉
        chargeDetailTab: 'items',      // 详情tab
        chargeQueryParams: {
          patientName: '',
          patientId: '',
          chargeNo: '',
          status: null,
          chargeType: null,
          startTime: '',
          endTime: '',
        },
        tableRowsCharge: [
          { name: "收费单号", prop: "chargeNo", align: "center" },
          { name: "患者姓名", prop: "patientName", align: "center" },
          { name: "原价总金额", prop: "totalAmount", align: "center" },
          { name: "实付金额", prop: "paidAmount", align: "center" },
          { name: "优惠金额", prop: "discountAmount", align: "center" },
          { name: "退款金额", prop: "refundedAmount", align: "center" },
          { name: "收费状态", prop: "status", align: "center", op: 'chargeStatusOptions' },
          { name: "收费时间", prop: "chargeTime", align: "center" },
          { name: "收费类型", prop: "chargeType", align: "center", op: 'chargeTypeOptions' },
        ],
        showSevenDayDetail: false,
				historyMedicalData: [],
				queryKey: 0,


				chinaDiagnosisTableData1: [],
				chinaDiagnosisTableData2: [],
				chinaSelectedTable: [],
				selChinaDiagnosis: {},

				westernMedicineRules: {
					drugName: [{
						required: true,
						message: '药品名称不能为空',
						trigger: 'blur'
					}],
					isSkinTest: [{
						required: true,
						message: '请选择是否皮试',
						trigger: 'change'
					}]
				},

				westernMedicineSearchQuery: {
					id: '',
					drugName: '',
					isSkinTest: null,
				},

				chinaMedicineSearchQuery: '',
				westMedicineSearchQuery: '',
				chinaChekeCurrentData: {},
				searchTriggered: false,
				showWestTable: false,
				showDrugDialog: false,
				showBasicInfo: false,
				showKzInfo: false,
				showUseInfo: false,
				westernSearchQuery: '',
				chinaSearchQuery1: '',
				chinaSearchQuery2: '',
				westernDiagnosisTableData: [],
				westernSelectedTable: [],

				addWesternForm: {
					id: null,
					age: null,
					ageVar: '',
					agnterAddr: '',
					agnterCertType: null,
					agnterCretno: '',
					agnterName: '',
					agnterRlts: null,
					agnterTel: '',
					bilgDeptId: null,
					bilgDrId: null,
					bilgOptId: null,
					dugDrxDetailsVOS: [],
					icdCode: '',
					icdName: '',
					mainRxId: null,
					name: '',
					opspRx: false,
					phayId: 1,
					pricingType: null,
					purcAmt: null,
					reAmt: null,
					regId: null,
					remark: '',
					rxFrom: null,
					rxType: 1,
					saleAmt: null,
					seeDoctorId: null,
					seeId: null,
					sex: null,
					skintstRx: null,
					state: null,
					patientId: null,
					frquCnt: null,
					isWestPrint: false,
				},
        addChinaForm: {
          // ===== tcm 接口字段 =====
          tcmCnt: 1,                // doseCount - 付数
          decoctionType: 0,         // 煎药方式 0人工 1煎药机
          decoctionVolume: 0,       // 煎药量
          doseVolume: 0,            // 每次服药量
          doseVolumeUnit: 'g',      // 服药量单位 - 写死为 g
          usedfrquId: null,         // frequencyId - 用药频率ID
          medcWayId: null,          // routeId - 给药方式ID
          tcmWayId: null,           // tcmWayId - 中药用法ID

          // ===== 汇总字段 =====
          predictMoney: 0,          // 预算金额
          chinaMedicineSum: 0,      // 药品总量
        },

				//血糖类型1空腹2随机3餐后
				bloodTypeOptions: [{
					id: '1',
					label: '空腹'
				}, {
					id: '2',
					label: '随机'
				}, {
					id: '3',
					label: '餐后'
				}],


				westernMedicineForm: {
					age: null,
					ageVar: '',
					agnterAddr: '',
					agnterCertType: null,
					agnterCretno: '',
					agnterName: '',
					agnterRlts: null,
					agnterTel: '',
					bilgDeptId: null,
					bilgDrId: null,
					bilgOptId: null,
					icdCode: '',
					icdName: '',
					mainRxId: null,
					name: '',
					opspRx: false,
					pricingType: null,
					purcAmt: null,
					reAmt: null,
					regId: null,
					remark: '',
					remarks: '',
					rxFrom: null,
					rxType: null,
					saleAmt: null,
					seeDoctorId: null,
					seeId: null,
					sex: null,
					skintstRx: null,
					state: null,
					dugDrxDetailsVOS: [],
					phayId: null,
					prescriptionAmt: null,
				},
				diagnosisForm: {
					chineseMedicine: '',
					chineseSyndrome: '',
					chineseSyndromeCode: '',
					chineseSyndromeName: '',
					definiteDiagnosis: '',
					diagnosticCategory: '',
					diagnosticName: '',
					diagnosticSequence: '',
					diseaseCode: '',
					diseaseName: '',
					icdCode: '',
					insuranceCode: '',
					insuranceName: '',
					remark: '',
					seeDoctorId: null,
					specialCode: '',
					specialName: '',
					specialNum: '',
					specialRemark: '',
					syndromeCode: '',
					syndromeName: '',
					westernPrefix: '',
					westernSuffix: '',
				},

				active: -1,
				checkedchinaMakeMethod: {},
				checkedchinaPrescriptionId: null,

				showDoseDialog: false,
				editChinaDrugDialog: false,
				isSkinTestDoseDialog: false,
				selExecutionPLDialogVisible: false,
				editDoseValue: 0,
				editChinaDrugPrice: 0,
				currentEditIndex: -1,
				chinaTemplateForm: {
					name: '',
					id: null,
					content: ''
				},
				loading: false,
				addModalVisible: false,
				isInputDisabled: false,
				isFormExpanded: false,
				celerityFilingDialogVisible: false,
				receptionModalVisible: false,
				sevenDayDialogVisible: false,
        chargeDetailDialogVisible: false,
				historyMedicalDialogVisible: false,
				creationMethodDialogVisible: false,

				basMednTypeOptions: [{
					id: 1,
					label: '国家基药'
				}, {
					id: 2,
					label: '省级基药'
				}, {
					id: 3,
					label: '敌方基药'
				}],
				seeDoctorStateOption: [{
					id: 0,
					label: '禁用'
				}, {
					id: 1,
					label: '就诊'
				}, {
					id: 2,
					label: '取消就诊'
				}, {
					id: 3,
					label: '转诊'
				}],
				sexOptions: [{
					id: 1,
					label: '男'
				}, {
					id: 2,
					label: '女'
				}],
				skintstDicmOptions: [{
					id: 0,
					label: '否'
				}, {
					id: 1,
					label: '是'
				}],

				templateStateOption: [{
					id: 1,
					label: '启用'
				}, {
					id: 0,
					label: '禁用'
				}],
				receptionTypeOption: [{
					id: '1',
					label: '正常接诊'
				}, {
					id: '2',
					label: '快速接诊'
				}],
				pregnantOption: [{
					id: 0,
					label: '否'
				}, {
					id: 1,
					label: '是'
				}],
				westPhayOption: [{
					id: 1,
					label: '西药房'
				}],
				chinaPhayOption: [{
					id: 2,
					label: '中药房'
				}],

				conerPleasett: '',
				naplPleasett: '',
				addressProps: {
					lazy: true,
					value: 'areaCode',
					label: 'areaName',
					emitPath: true,
					leaf: node => node.areaLevel >= 5,
					lazyLoad: async (node, resolve) => {
						try {
							const level = node.level + 1;

							// 限制最大层级为5
							if (level > 5) {
								return resolve([]);
							}

							// 请求参数
							const params = {
								areaCode: node.level > 0 ? node.data.areaCode : undefined,
								areaLevel: level,
								condtion: ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code',
									'area_t_code'
								][level - 1]
							};

							const res = await getArea(params);
							const responseData = res?.data || [];

							// 如果没有数据，关闭下拉框
							if (responseData.length === 0 && level > 1) {

							}

							// 格式化数据（关键修改:添加 isLeaf 和 level 属性）
							const formattedData = responseData.map(item => ({
								...item,
								value: item.areaCode, // 严格模式需要 value 字段
								label: item.areaName,
								level: level, // 标记当前层级
								isLeaf: level >= 5 // 第五级强制设为叶子节点
							}));

							resolve(formattedData);

						} catch (error) {
							console.error('加载地区数据失败:', error);
							resolve([]);
						}
					}
				},
				tableRows1: [{
						name: "健康ID",
						prop: "patNo",
						type: ""
					},
					{
						name: "姓名",
						prop: "name",
						type: ""
					}, {
						name: "排",
						prop: "order",
						type: ""
					},
					{
						name: "时间",
						prop: "optTime",
						nz: "nz"
					}, {
						name: "诊室",
						prop: "regDeptName",
						type: ""
					},
				],
				tableRows2: [{
						name: "姓名",
						prop: "patientName",
						type: ""
					},
					{
						name: "就诊医生",
						prop: "doctorId",
						op: 'doctorOptions'
					},
					{
						name: "就诊科室",
						prop: "regDepId",
						op: 'deptOptions'
					},
					{
						name: "挂号序号ID",
						prop: "dregisterTableId",
						type: ""
					},
				],
        chargeDetailRows: [
          { name: "订单号", prop: "orderNo" },
          { name: "患者姓名", prop: "patientName" },
          { name: "订单状态", prop: "status", op: "orderStatusOptions" },
          { name: "收费状态", prop: "chargeStatus", op: "orderChargeStatusOptions" },
          { name: "总金额", prop: "totalAmount", type: "money" },
          { name: "开单时间", prop: "orderedAt", type: "datetime" },
          { name: "提交时间", prop: "submittedAt", type: "datetime" },
          { name: "诊断名称", prop: "diagnosisName" },
          { name: "备注", prop: "remark" }
        ],
        tableRows3: [
            {
          name: "就诊序号",
          prop: "id"
        }, {
          name: "患者序号",
          prop: "patientId",
          type: ""
        },
          {
            name: "姓名",
            prop: "patientName",
            type: ""
          }, {
            name: "性别",
            prop: "gender",
            type: "",
            op: 'sexOptions'
          },
          {
            name: "年龄",
            prop: "age",
            type: ""
          }, {
            name: "联系地址",
            prop: "address",
            type: ""
          },
          {
            name: "身份证",
            prop: "cardid",
            type: ""
          }, {
            name: "挂号类型",
            prop: "dregisterTableId",
            type: ""
          },
          {
            name: "就诊时间",
            prop: "createTime",
            type: ""
          },
          {
            name: "就诊类型",
            prop: "type",
            op: 'receptionTypeOption'
          }, {
            name: "就诊医生",
            prop: "doctorId",
            op: 'doctorOptions'
          },
          {
            name: "是否孕妇",
            prop: "pregnant",
            op: 'pregnantOption'
          },
          {
            name: "西医诊断",
            prop: "westernDiagnos",
            type: ""
          }, {
            name: "中医诊断",
            prop: "chinaDiagnose",
            type: ""
          },
          {
            name: "过敏原",
            prop: "allergen",
            type: "",
            op: 'aiseListOptions'
          },
          {
            name: "舒张压",
            prop: "diapre",
            type: ""
          }, {
            name: "收缩压",
            prop: "syspre",
            type: ""
          },
          {
            name: "血糖类型",
            prop: "bloodType",
            type: "",
            op: 'bloodTypeOptions'
          }, {
            name: "血糖指数",
            prop: "bloodNumber",
            type: ""
          },
          {
            name: "主诉",
            prop: "patientTell",
            op: 'visitStateOption'
          }, {
            name: "现病史",
            prop: "nowHistory",
            type: ""
          },
          {
            name: "既往史",
            prop: "beforeHistory",
            op: 'visitStateOption'
          }
        ],
        chargeTypeOptions: [
          { id: 1, label: '预约挂号收费' },
          { id: 2, label: '处方订单收费' }
        ],
        tableRows4: [{
						name: "临床诊断名称",
						prop: "name",
						type: ""
					},
					{
						name: "医保编码",
						prop: "chsCode",
						type: ""
					}, {
						name: "医保名称",
						prop: "chsName",
						type: ""
					},
					{
						name: "备注",
						prop: "remarks",
						type: ""
					},
				],
				tableRows8: [{
						name: "临床诊断名称",
						prop: "name",
						type: ""
					}, {
						name: "确诊",
						prop: "definiteDiagnosis",
						type: ""
					},
					{
						name: "医保编码",
						prop: "chsCode",
						type: ""
					}, {
						name: "医保名称",
						prop: "chsName",
						type: ""
					},
				],
				tableRows5: [{
						name: "编码",
						prop: "code",
						type: ""
					}, {
						name: "名称",
						prop: "name",
						type: ""
					},
					{
						name: "医保编码",
						prop: "chsCode",
						type: ""
					}, {
						name: "医保名称",
						prop: "chsName",
						type: ""
					},
				],
				tableRows6: [{
						name: "病症名称",
						prop: "diagnosticName",
						type: ""
					}, {
						name: "病症编码",
						prop: "diseaseCode",
						type: ""
					},
					{
						name: "证候名称",
						prop: "chineseSyndromeName",
						type: ""
					},
					{
						name: "证候编码",
						prop: "chineseSyndromeCode",
						type: ""
					}, {
						name: "病症医保名称",
						prop: "insuranceName",
						type: ""
					},
					{
						name: "病症医保代码",
						prop: "insuranceCode",
						type: ""
					}, {
						name: "证候医保名称",
						prop: "syndromeName",
						type: ""
					},
					{
						name: "证候医保代码",
						prop: "syndromeCode",
						type: ""
					},
				],
				// zcw++
				tableRows7: [
					// 批次号列 - 放在第一位，确保在操作列后面显示
					/*{
						prop: 'manuLotnum',
						name: '生产批次号',
						showCondition: () => this.batchSelectionSwitch
					},*/
					//{name: "基本药物", prop: "basMednB", align: "center", op: 'skintstDicmOptions'},
					//{name: "基药类型", prop: "basMednType", align: "center", op: 'basMednTypeOptions'},
          {
            name: "类型",
            prop: "drugType",
            align: "center",
            op:'drugTypeOptions'
          },
					{
						name: "西药名称",
						prop: "drugName",
						align: "center"
					},
					/*{name: "包装规格", prop: "pacSpec", align: "center"},*/
					/*
					        {name: "单位剂量", prop: "unitDose", align: "center"},
					*/
					{
						name: "单次剂量",
						prop: "sdoseCnt",
						align: "center"
					},
					{
						name: "剂量单位",
						prop: "dosUnt",
						align: "center",
						op: 'dosaUntOptions'
					},
					{
						name: "用药频率",
						prop: "usedfrquId",
						align: "center"
					},
					{
						name: "周期次数",
						prop: "prdCnt",
						align: "center"
					}, {
						name: "周期天数",
						prop: "prdDays",
						align: "center"
					},
					{
						name: "处方数量",
						prop: "cnt",
						align: "center"
					},
					/*
					        {name: "销售单位", prop: "saleUntName", align: "center"},
					*/
					{
						name: "销售单位",
						prop: "saleUnt",
						align: "center",
						op: 'saleUntOption'
					},
					{
						name: "处方金额",
						prop: "saleAmt",
						align: "center"
					},
					{
						name: "给药方式",
						prop: "medcWayId",
						align: "center"
					},
					{
						name: "输液速度",
						prop: "speed",
						align: "center"
					},
          {
						name: "备注",
						prop: "remark",
						align: "center"
					},

					/*{name: "药品剂型", prop: "dosform", align: "center", op: 'drugDosageOption'},
							        {name: "药品类型", prop: "drugType", align: "center", op: 'drugTypeOptions'},

							        {name: "药品序号", prop: "drugId", align: "center"},
							        {name: "总剂量", prop: "sdoseSum", align: "center"},


							        {name: "取整方式", prop: "roundUnt", align: "center", op: 'roundUntOption'},*/
					/*        {name: "包装单位", prop: "pacUnt", align: "center", op: 'drugUntOptions'},
					        {name: "最小单位", prop: "minUnt", align: "center", op: 'drugUntOptions'},*/
					/*{name: "是否皮试", prop: "skintstDicm", align: "center", op: 'skintstDicmOptions'},
					{name: "皮试结果", prop: "skintstRslt", align: "center"},*/
					/*{name: "医嘱嘱托", prop: "remarks", align: "center"},*/
					/* {name: "销售单价", prop: "salePric", align: "center"},
					 {name: "销售金额", prop: "saleAmt", align: "center"},
					 {name: "最小单位销售单价", prop: "minSalePric", align: "center"},
					 {name: "最大单位销售单价", prop: "maxSalePric", align: "center"},
					 {name: "成本金额", prop: "purcAmt", align: "center"}, {name: "成本单价", prop: "purcPric", align: "center"},
					 {name: "库存数量", prop: "purcCnt", align: "center"},
					{name: "处方类型", prop: "rxType", align: "center", op: 'rxTypeOptions'}*/
				],
				tableRows9: [
					{
						name: "项目名称",
						prop: "costname"
					},
					{
						name: "执行单价",
						prop: "odcost"
					},
					{
						name: "执行价格",
						prop: "executeOdcost"
					},
					{
						name: "执行频率",
						prop: "exeFrquId",
						op: 'medicationFrequencyOptions'
					},
					{
						name: "开单医生",
						prop: "doctorName",
						op: 'doctorOptions'
					},
					{
						name: "执行科室",
						prop: "deptName",
						op: 'deptOptions'
					},{
						name: "执行人",
						prop: "executId",
						op: 'doctorOptions'
					},
					{
						name: "备注",
						prop: "remark"
					},
				],
				tableRows10: [{
						name: "类型",
						prop: "orderType",
						op: 'orderTypeOptions'
					},
					{
						name: "状态",
						prop: "status",
						op: 'doctorAdviceTypeOptions'
					},
					{
						name: "医嘱内容",
						prop: "content"
					},
					{
						name: "金额",
						prop: "pric"
					},
					{
						name: "开单医生",
						prop: "createName"
					},
					{
						name: "开单时间",
						prop: "createTime"
					},
					/*{name: "打印状态", prop: "print", op: 'printTypeOptions'},*/
					{
						name: "执行科室",
						prop: "deptId",
						op: 'deptOptions'
					},
					//{name: "国家贯标编码", prop: "nationState"},
					//{name: "国家贯标名称", prop: "nationName"},
				],
				// zcw++西药搜索表格列
        drugTypeOptions:[{id:1,label:'西药'},{id:2,label:'中药'},{id:3,label:'卫材'}],
        tableRows11: [
          {
            name: "类型",
            prop: "drugType",
            align: "center",
            op:'drugTypeOptions'
          },
          {
            name: "西药名称",
            prop: "drugName",
            align: "center"
          },
          {
            name: "规格",
            prop: "pacSpec",
            align: "center"
          },
          {
            name: "药品剂型",
            prop: "dosform",
            align: "center",
            op: 'drugDosageOption'
          },
          {
            name: "库存数量",
            prop: "purcCnt",
            align: "center"
          },
          {
            name: "单位剂量",
            prop: "unitDose",
            align: "center",
          },
          {
            name: "剂量单位",
            prop: "dosUnt",
            align: "center",
          },
          {
            name: "最小剂量",
            prop: "minDose",
            align: "center",
            op: 'dosaUntOptions'
          },
          {
            name: "是否皮试",
            prop: "skintstDicm",
            align: "center",
            op: 'skintstDicmOptions'
          },
          {
            name: "冻结数量",
            prop: "freezeCnt",
            align: "center"
          },
          {
            name: "包装数量",
            prop: "pacCnt",
            align: "center"
          },
          {
            name: "包装规格",
            prop: "pacSpec",
            align: "center"
          },
          {
            name: "包装单位",
            prop: "pacUnt",
            align: "center",
            op: 'drugUntOptions'
          },
        ],
        tableRows12: [
          {
            name: "中药名称",
            prop: "drugName",
            align: "center"
          },
          {
            name: "药品剂型",
            prop: "dosform",
            align: "center",
            op: 'drugDosageOption'
          },
          {
            name: "库存数量",
            prop: "purcCnt",
            align: "center"
          },
          {
            name: "单位剂量",
            prop: "unitDose",
            align: "center",
          },
          {
            name: "剂量单位",
            prop: "dosUnt",
            align: "center",
          },
          {
            name: "冻结数量",
            prop: "freezeCnt",
            align: "center"
          },
          {
            name: "包装数量",
            prop: "pacCnt",
            align: "center"
          },
          {
            name: "包装单位",
            prop: "pacUnt",
            align: "center",
            op: 'drugUntOptions'
          },
        ],
        tableRows12China: [
          {
            name: "药品名称",
            prop: "drugName",
            align: "center",
            minWidth: "180"
          },
          {
            name: "单次剂量",
            prop: "sdoseCnt",
            align: "center",
            width: "180"
          },

          {
            name: "金额",
            prop: "saleAmt",
            align: "center",
            width: "180"
          },
          {
            name: "备注",
            prop: "remark",
            align: "center",
            minWidth: "100"
          }
        ],
				tableRows14: [{
						name: "健康ID",
						prop: "id"
					},
					{
						name: "健康卡号",
						prop: "patId"
					},
					{
						name: "姓名",
						prop: "name"
					},
					{
						name: "身份证号",
						prop: "certno"
					},
					{
						name: "联系电话",
						prop: "conerTel"
					},
				],
				tableRows15: [{
						name: "系统序号",
						prop: "id"
					},
					{
						name: "就诊序号",
						prop: "seeDoctorId"
					},
					{
						name: "患者名称",
						prop: "patientName"
					},
					{
						name: "诊所名称",
						prop: "clinicName"
					},
					{
						name: "创建时间",
						prop: "createTime"
					},
					{
						name: "主诉",
						prop: "patientTell"
					},
					{
						name: "现病史",
						prop: "nowHistory"
					},
					{
						name: "既往史",
						prop: "beforeHistory"
					},
				],

				selChineseMedicineDialog: false,
				westernDiagnosisModalVisible: false,
				chinaDiagnosisModalVisible: false,
				selWestMedicineDialog: false,
				selDoctordisposeDialog: false,
				chinaMedicineTableData: [],
				chinaTemplateMedicineTableData: [],
				possessChinaTemplateMedicineTableData: [],
				westMedicineTableData: [],
        currentAdviceId:null,
        updateWestOrChinaForm:{},
				isAutoCalculationInProgress: false, // 标记自动计算状态
				westGroupsTableData: [],
				queryWestMedicineData: [],
				queryChinaMedicineData: [],
				doctordisposeTableData: [],
				medicalAdviceData: [],
				tableData: [],

				prhCostOption: [], //病员费别
				prhTypeOption: [], //病员类别
				rltsEntitiesOption: [], //联系人关系
				contractUnitOption: [], //合约单位
				untAtteOption: [], //往来单位新增---单位属性
				deptOptions: [], //科室下拉框
				doctorOptions: [], //医生下拉框
				registerOptions: [], //挂号类别
				ntlyOptions: [], //国籍
				aiseListOptions: [], //过敏原
				chinaMakeOptions: [], //中药制法
				tcmwayOptions: [], //中药服法
				tableData1: [],
				tableData2: [],
				// 表单数据
				seedoctorQueryParams: {
					patientName: '',
					patientId: '',
					startTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
					endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
					doctorId: null,
					timeFrame: 0,
				},

				showPatientTellSelect: false,
				showNowHistorySelect: false,
				showBeforeHistorySelect: false,

				tpAddOrEditMedicineDialog: false,
				templateAddRrEditTtiel: '',
				aiseAddRrEditTtiel: '',
				aiseAddOrEditMedicineDialog: false,
				templateType: null,


				templateRules: {
					name: [{
							required: true,
							message: '请输入名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在1到50个字符',
							trigger: 'blur'
						}
					],
					deptId: [{
						required: true,
						message: '请选择科室',
						trigger: 'change'
					}],
					rangeType: [{
						required: true,
						message: '请选择适用范围',
						trigger: 'change'
					}],
					state: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}],
					content: [{
							required: true,
							message: '请输入内容',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 500,
							message: '长度在1到500个字符',
							trigger: 'blur'
						}
					],
				},
				aiseRules: {
					name: [{
							required: true,
							message: '请输入名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在1到50个字符',
							trigger: 'blur'
						}
					],
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}],

				},
				aiseForm: {
					id: null,
					code: dayjs().format('YYYYMMDDHHmmss'),
					name: '',
					orderId: null,
					pyCode: '',
					remark: '',
					state: 1,
					type: null,
				},
				templateForm: {
					id: null,
					content: '',
					deptId: null,
					name: '',
					pinyin: '',
					rangeType: null,
					remark: '',
					state: 1,
				},
				fastReceptionForm: {
					patId: '',
					name: '',
					sex: '1',
					identityCard: 1,
					certno: '',
					brdy: '',
					naty: null,
					ageYear: null,
					ageMonth: null,
					jobId: null,
					feeType: null,
					prhType: null,
					contractUnit: null,
					conerName: '',
					conerTel: '',
					conerRltsId: null,
					origoProvince: '', // 省
					origoCity: '', // 市
					origoCounty: '', // 县
					origoTown: '', // 乡
					origoVillage: '', //村
					contactProvince: '', // 省
					contactCity: '', // 市
					contactCounty: '', // 县
					contactTown: '', // 乡
					contactVillage: '', //村
					price: null,
					regTypeId: null,
					naplAddName: null,
					prhCostType: null,
				},
				receptionForm: {
					address: '',
					age: null,
					allergen: '',
					beforeHistory: '',
					bloodNumber: '',
					bloodPressure: '',
					bloodType: '',
					cardid: '',
					chinaDiagnose: '',
					chronicDisease: '',
					diagnosisAdvice: '',
					doctorId: null,
					epidemicDisease: '',
					gatherMorbidity: '',
					gender: '',
					goHigharea: '',
					nowHistory: '',
					patientId: null,
					patientName: '',
					patientTell: '',
					price: null,
					regTypeId: null,
					regTypeName: '',
					westernDiagnos: '',
					status: null,
				},
				addSeedoctorForm: {
					address: '',
					age: null,
					allergen: '',
					beforeHistory: '',
					beforeHistoryRemark: '',
					bloodNumber: null,
					bloodPressure: '',
					bloodType: '',
					cardid: '',
					chinaDiagnose: '',
					chronicDisease: '',
					diagnosisAdvice: '',
					doctorId: null,
					dregisterTableId: null,
					epidemicDisease: '',
					gatherMorbidity: '',
					gender: '',
					goHigharea: '',
					nowHistory: '',
					nowHistoryRemark: '',
					patientId: null,
					patientName: '',
					price: null,
					patientTell: '',
					patientTellRemark: '',
					westernDiagnos: '',
					remark: '',
					chinaPrescription: '',
					westchinaPrescription: '',
					doctordisposePrescription: '',
				},

				recordingList: [],
				showRecordingModal: false,
				showRecordingModalData: false,
				chinaMedicineUsageDialog: false,
				isRecording: false,
				audioBlob: null, // 保留用于上传
				audioChunks: [], // 保留用于生成Blob
				recordingTime: '00:00',
				recordingTimer: null,
				stream: null,
				mediaRecorder: null,

				recordingListOptions: [],
				currentAudioPath: '',
				activeIndex: null,

				contextMenu: {
					visible: false,
					left: 0,
					top: 0,
					field: ''
				},
				areaOption: [{
					id: 1,
					label: '省内'
				}, {
					id: 2,
					label: '省外'
				}, {
					id: 3,
					label: '进口'
				}],
				unitStateOption: [{
					id: 1,
					label: '启用'
				}, {
					id: 0,
					label: '禁用'
				}],
				addUnitForm: {
					id: null,
					code: dayjs().format('YYYYMMDDHHmmss'),
					state: 1,
					area: 1,
					name: '',
					pyCode: '',
					bankName: '',
					bankNo: '',
					splerPmtno: '',
					legalRepe: '',
					mainConer: '',
					conerPhone: '',
					conerTel: '',
					conerQq: '',
					conerFax: '',
					conerPostc: '',
					url: '',
					conerMail: '',
					untAtte: 3,
					uscc: '',
					conerAdd: '',
					remark: ''
				},
				addUnitType: [],
				addType: [],
				nationOption: [], //民族下拉框
				certypeOption: [], //证件下拉框
				profttlOption: [], //职业下拉框
				jobOption: [], //职业下拉框

				chargingPriceOptions: [], //西医模板下拉框
				complainTemplateOptions: [], //主诉模板
				nowHistoryTemplateOptions: [], //现病史模板
				beforeHistoryTemplateOptions: [], //既往史模板
				medicationWayOptions: [], //给药方式
				mrgStateOptions: [], //婚姻状态
				chinaMedicationWayOptions: [], //中药给药方式
				medicationFrequencyOptions: [], //给药频率
				dosaUntOptions: [], //单位剂量、最小单位
				drugUntOptions: [], //包装单位
				drugDosageOption: [], //药品剂型

				currentSelectedRow: null,

				repeatedOptions: [{
					id: 1,
					label: '复诊'
				}, {
					id: 2,
					label: '初诊'
				}],

				takeMedicineWayOptions1: [{
						id: 1,
						label: '频服'
					}, {
						id: 2,
						label: '冷服'
					}, {
						id: 3,
						label: '顿服'
					},
					{
						id: 4,
						label: '温服'
					}, {
						id: 5,
						label: '热服'
					}
				],
				takeMedicineWayOptions2: [{
						id: 1,
						label: '饭后服'
					}, {
						id: 2,
						label: '隔夜服'
					},
					{
						id: 3,
						label: '空腹服'
					}, {
						id: 4,
						label: '睡前服'
					},
					{
						id: 5,
						label: '饭前服'
					}, {
						id: 6,
						label: '餐间服'
					}
				],

				rxTypeOptions: [],
				rangeTypeOption: [{
					id: 1,
					label: '本人'
				}, {
					id: 2,
					label: '本科室'
				}],
				aiseTypeOption: [{
					id: 1,
					label: '药品'
				}, {
					id: 2,
					label: '其他'
				}],
				saleUntOption: [{
					id: 1,
					label: '最小单位'
				}, {
					id: 2,
					label: '包装单位'
				}],


				roundUntOption: [{
						id: 1,
						label: '单次取整'
					}, {
						id: 2,
						label: '总量取整'
					}, {
						id: 3,
						label: '处方取整'
					},
					{
						id: 4,
						label: '不取整'
					}
				],

				// zcw++控制是否显示指定售价列
				showFixedPriceColumns: false,
				// zcw++控制是否显示批次号
				shouldShowBatchNumber: false,
				extgTypeOption: [{
					id: 0,
					label: '人工煎药'
				}, {
					id: 1,
					label: '煎药机煎药'
				}],
				orderTypeOptions: [{
						id: 0,
						label: '西药'
					}, {
						id: 1,
						label: '中药'
					},
					{
						id: 2,
						label: '检查'
					}, {
						id: 3,
						label: '检验'
					}, {
						id: 4,
						label: '处置'
					}, {
						id: 5,
						label: '挂号'
					}, {
						id: 6,
						label: '关联处置'
					}
				],
				printTypeOptions: [{
					id: 0,
					label: '否'
				}, {
					id: 1,
					label: '是'
				}],
				doctorAdviceTypeOptions: [{
					id: 0,
					label: '待发'
				}, {
					id: 1,
					label: '已发送'
				}, {
					id: 2,
					label: '已收款'
				}, {
					id: 3,
					label: '锁定'
				}, {
					id: 4,
					label: '已退费'
				}, {
					id: 5,
					label: '已作废'
				}],
				patientChooseForm: {
					id: null,
					patId: '',
					name: '',
					sex: null,
					certno: null,
					conerTel: null,
					contractUnit: null,
					healthCardNo: null,
					cardType: null,
					seeDoctorId: null,
					repeated: null,
				},
				addForm: {
					discountMoney: null,
					name: '',
					patientId: null,
					payType: null,
					receivableMoney: null,
					receivedMoney: null,
					regDepId: null,
					regDoctorId: null,
					regMode: null,
					regNum: null,
					regTypeId: null,
					regUserId: null,
					remake: '',
					utyTimeDetailsId: null,
					visitId: null,
					rgstId: null,
					/**/
					accountNumber: null,
					currentNumber: null,
					oweNumber: '0/0',
					remark: null,
					feeType: null,
					MoneyPay: null,
					healthCarePay: null,
					fitnessCardpa: null,
					unionPay: null,
					owePay: null,
					phonePay: null,
					discountsNumb: null,
					receivableNum: null,
					receiveNumber: null,
					changeNumber: null,
				},
				addUnitModalVisible: false, // 布尔值，控制模态框显示
				isShowPrescription: false,
				isShowPrescription2: false,

				mobileRegExp: /^1[3-9]\d{9}$/,
				patientFormRules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
					tel: [{
						validator: (rule, value, callback) => {
							// 如果 thrNot 为 1，直接跳过验证
							if (this.patientForm.thrNot === 1) {
								callback();
								return;
							}
							if (!value) {
								callback();
								return;
							}
							if (!this.mobileRegExp.test(value)) {
								callback(new Error('请输入正确的手机号格式'));
							} else {
								callback();
							}
						},
						trigger: 'blur'
					}]
				},
				patientFormDataRules: {
					certno: [{
						validator: async (rule, value, callback) => {
							if (!this.patientForm.thrNot === this.patientForm.ageYear < 18) return callback();
							if (!value) return callback();

							const type = this.patientForm.identityCard;

							// 基础验证
							if (value.length !== this.certLengthMap[type]) {
								return callback(new Error(`请输入${this.certLengthMap[type]}位证件号码`));
							}

							if (this.certPatterns[type] && !this.certPatterns[type].test(value)) {
								return callback(new Error('证件号码格式不正确'));
							}

							// 仅身份证需要查重
							if (type === '1') {
								try {
									const res = await getDoesItExistSFZ({
										certNo: value.toString()
									});

									if (res.data && value !== this.patientChooseForm?.certno) {
										return callback(new Error('该身份证已存在')); // 非阻塞提示
									}
								} catch (error) {
									console.error('身份证校验失败:', error);
									// 接口失败不影响基础验证
								}
							}

							callback();
						},
						trigger: 'blur'
					}],
					bloodPressure: [{
						validator: (rule, value, callback) => {
							// 跳过条件:三无人员或年龄小于18岁
							if (this.patientForm.thrNot === 1 || this.patientForm.ageYear < 18) {
								return callback();
							}

							// 初始加载跳过验证
							if (this.isInitialLoad) {
								this.$nextTick(() => {
									this.isInitialLoad = false;
								});
								return callback();
							}

							// 血压值超长处理（保留基本格式校验）
							if (this.patientForm.syspre && this.patientForm.syspre.toString().length > 3) {
								this.patientForm.syspre = null;
								return callback(new Error('收缩压值过长（最多3位数字）'));
							}
							if (this.patientForm.diapre && this.patientForm.diapre.toString().length > 3) {
								this.patientForm.diapre = null;
								return callback(new Error('舒张压值过长（最多3位数字）'));
							}

							// 宽松的数字格式校验
							const validateNumber = (val, fieldName) => {
								if (val && !/^\d{1,3}$/.test(val.toString())) {
									return callback(new Error(`${fieldName}必须是1-3位数字`));
								}
							};
							callback();
						},
						trigger: 'blur'
					}],
					bloodNumber: [{
						validator: (rule, value, callback) => {
							// 跳过条件:三无人员或年龄<18
							if (this.patientForm.thrNot === 1 || this.patientForm.ageYear < 18) {
								return callback();
							}

							// 初始加载跳过验证
							if (this.isInitialLoad) return callback();

							// 血糖值超长处理
							if (value && String(value).replace('.', '').length > 2) {
								this.patientForm.bloodNumber = null;
								return callback(new Error('请输入合理血糖值'));
							}

							// 格式验证
							if (value && !/^\d+(\.\d{1})?$/.test(value)) {
								return callback(new Error('格式如: 5.6'));
							}

							// 范围提示（非阻塞）
							if (value) {
								const num = parseFloat(value);
								if (num < 3.9 || num > 11.1) {
									this.$message.warning('血糖值超出正常范围（3.9-11.1）');
								}
							}

							callback();
						},
						trigger: 'blur'
					}],
					conerTel: [{
						validator: (rule, value, callback) => {
							if (!this.patientForm.thrNot === 1) return callback();
							if (!value) return callback();
							const mobileReg = /^1[3-9]\d{9}$/;
							const telReg = /^0\d{2,3}-\d{7,8}$/;

							if (!mobileReg.test(value) && !telReg.test(value)) {
								return callback(new Error('请输入正确号码'));
							}
							callback();
						},
						trigger: 'blur'
					}]
				},
				westSonData: {},
				patientForm: {
					id: null,
					patId: '', // 健康ID
					thrNot: null, // 三无（复选框应为布尔值）
					name: '', // 姓名
					sex: null, // 性别
					identityCard: 1,
					certno: '', //证件号码
					brdy: '', // 出生日期
					ageYear: null, // 年龄-岁
					ageMonth: null, // 年龄-月
					naty: 1, // 民族
					ntlyId: 1, // 国籍
					jobId: null, // 职业
					prhCostType: null, // 病员费别
					prhType: null, // 病员类型
					phrUnt: null, // 合约单位
					isSpecial: '否', // 特殊人群
					conerName: '', // 联系人
					conerTel: '', // 联系电话
					conerRltsId: null, // 联系人关系
					province: '', // 省
					city: '', // 市
					county: '', // 县
					town: '', // 乡
					village: '', //村
					registerDate: new Date().toISOString().split('T')[0], // 挂号日期
					timeSlot: '1', // 时段
					department: null, // 科室
					doctor: null, // 医生
					registerType: null, // 挂号类别
					clinicRoom: null, // 诊室
					existNumber: null,
					currentNumber: null,
					caseHistory: null,
					total: null,
					naplAddCode: null,
					number: null,
					aiseId: null,
					aiseName: null,
					seedoctorcCount: null,
					seedoctorcType: null,
					attackTime: new Date().toISOString().split("T")[0],
					bloodType: '1',
					bloodNumber: null,
					systolicPressure: "收缩压",
					diastolicPressure: "舒张压",
					contactProvince: '', // 省
					contactCity: '', // 市
					contactCounty: '', // 县
					contactTown: '', // 乡
					contactVillage: '', //村
					conerAddCode: '',
					naplAddName: '',
					conerAddName: '',
					dregisterTableId: null,
					opspRx: false,
					diapre: null,
					syspre: null,
					conerAddCodeArr: [],
					naplAddCodeArr: [],
					tel: '',
					conerAddJoinName: '',
					pregnant: null,
					repeated: null,
					remark: ''
				},
				celerityFilingForm: {
					name: '', // 姓名
					sex: null, // 性别
					identityCard: 1,
					certno: '', //证件号码d
					brdy: '', // 出生日期
					ageYear: 0, // 年龄-岁
					ageMonth: 0, // 年龄-月
					ageDay: 0, // 年龄-天
					naty: 1, // 民族
					ntlyId: 1, //国籍
					jobId: '', // 职业
					prhType: null, // 病员类型
					contractUnit: null, // 合约单位
					conerName: '', // 联系人
					conerTel: '', // 联系电话
					conerRltsId: null, // 联系人关系
					province: '', // 省
					city: '', // 市
					county: '', // 县
					town: '', // 乡
					village: '', //村
					tel: null,
					restAddCode: null,
					naplAddCode: null,
				},
				addUnitRules: {
					code: [{
						required: true,
						message: '请填写合约单位编码！',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请填写合约单位名称！',
						trigger: 'change'
					}],
				},

				checkChianData: [],
				multipleActiveSelection: [],

				//右键接诊数据
				showReception: false,
				showChinaReception: false,
				showChinaReception2: false,
				showCancelReception: false,
				showAdviceRightClick: false,
				showWestGroupsClick: false,
				adviceRightClickRow: null,
				chinaReceptionRowData: null,
				chinaReceptionRowData2: null,
				ReceptionRowData: null,
				contextMenuLeft: 0,
				contextMenuTop: 0,

				signNo: null,

				outpatientYbRegisterForm: {
					med_type: '11',
					psnSetlway: '01',
					acct_used_flag: '1',
					dise_codg: '不适-R53.x00x005',
					begntime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
					yb_1101_ReturnInfo: {},
					yb_1191_ReturnInfo: {},
					yb_2201A_ReturnInfo: {},
					yb_2203_ReturnInfo: {},
					yb_2204_ReturnInfo: {},
					yb_2206_ReturnInfo: {},
					yb_2207_ReturnInfo: {},
				},
				docphrOptions: [],
				createTemplateQuery: '',
				createTemplateSearchPopoverVisible: false,
				createTemplateTableData: [],
				isRequesting: false,
				systemParameterList: [],

				doctorAdviceRowData: null,
				patientPrescription: [],
				disposalProject: [],
/*
				isWebSocketInitialized: false,
*/
				batchSelectionSwitch: false, // 批次号选择开关，true为启用，false为禁用
				doseUnt: '1'
			};
		},
		computed: {
			// 获取患者信息摘要
			patientInfoSummary() {
				return {
					name: this.patientForm?.name || '',
					gender: this.patientForm?.sex === '1' ? '男' : (this.patientForm?.sex === '2' ? '女' : ''),
					age: (this.patientForm?.ageYear || this.patientForm?.ageMonth) ?
						`${this.patientForm.ageYear || 0}岁${this.patientForm.ageMonth || 0}月` :
						'',
					symptoms: this.addSeedoctorForm?.patientTell || '',
					history: this.addSeedoctorForm?.nowHistory || '',
					pastHistory: this.addSeedoctorForm?.beforeHistory || ''
				}
			},
			medicineSearchQuery: {
				get() {
					return this.DropDownedName === '西药医嘱' ?
						this.westMedicineSearchQuery :
						this.chinaMedicineSearchQuery;
				},
				set(value) {
					if (this.DropDownedName === '西药医嘱') {
						this.westMedicineSearchQuery = value;
					} else {
						this.chinaMedicineSearchQuery = value;
					}
				}
			},

			formattedAudioUrl() {
				if (!this.currentAudioPath) return '';
				// 将反斜杠转换为正斜杠
				let url = this.currentAudioPath.replace(/\\/g, '/');
				// 如果没有协议，添加http协议
				if (!/^https?:\/\//.test(url)) {
					url = `http://${url}`;
				}
				return url;
			},
			isSyspreInvalid() {
				return this.patientForm.syspre && (this.patientForm.syspre < 90 || this.patientForm.syspre > 140);
			},
			isDiapreInvalid() {
				return this.patientForm.diapre && (this.patientForm.diapre < 60 || this.patientForm.diapre > 90);
			},
			isBloodNumberInvalid() {
				if (!this.patientForm.bloodNumber) return false;
				return this.patientForm.bloodNumber < 3 || this.patientForm.bloodNumber > 12;
			}
		},
		watch: {
      'patientForm.patId': {
        handler(newVal) {
          if (newVal) {
            // 选择了患者，初始化空行
            if (this.westMedicineTableData.length === 0) {
              this.westMedicineTableData.push(this.getEmptyWestRowData());
            }
          } else {
            // 没有患者，清空表格
            this.westMedicineTableData = [];
          }
        },
        immediate: true
      },
			activeTab(newTab, oldTab) {
				if (newTab === 'charge') {
					this.$nextTick(() => {
						this.triggerOutpatientChargeMethod()
					})
				}
        if (newTab === 'dispensing') {
          this.$nextTick(() => {
            const child = this.$refs.newGiveMedici;
            if (child) {
              child.searchKeyword = this.patientForm.name;
              child.fetchPatients();
            }
          });
        }
			},
      westMedicineTableData: {
        handler() {
          this.debounceSaveCache();
        },
        deep: true // 暂时保留深监听，但用防抖降低频率
      },
      chinaMedicineTableData: {
        handler() {
          this.debounceSaveCache();
        },
        deep: true
      },
			/*    patientForm: {
			      handler(newVal, oldVal) {
			        if (this.receptionModalVisible) {
			          return;
			        }
			        // 当 patientForm 中任何属性发生变化时触发
			        this.handlePatientFormChange();
			      },
			      deep: true,
			      immediate: false
			    }*/
		},
		beforeDestroy() {
			window.removeEventListener('keydown', this.handleKeyPress);
			/*window.removeEventListener('websocket-ai-complete', this.handleAIComplete);
			window.removeEventListener('websocket-ai-progress', this.handleAIProgress);
			// 关闭WebSocket连接
			this.$websocket.closeWebSocket();*/
		},
		async mounted() {
			await withLoading(this, '正在初始化...')(async () => {
				// 1. 同步操作前置
				this.addUnitType = [...AddType];
				this.addType = [...AddType2];
				this.userInfo = JSON.parse(localStorage.getItem("userInfo") || '{}');

				// 2. 并行优化:将独立请求并行化
				const [userPermission, ...apiResults] = await Promise.all([
					getStaff({
						id: this.userInfo.staffId
					}),
					this.loadData(),
					this.getRegisterType(),
          this.getDrugUnt(),
				]);
				this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
				this.drugUntOptions = this.$store.getters['preload/getDrugUntListOption'];
				this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'];
				this.aiseListOptions = this.$store.getters['preload/getAiseListOptions'];
				this.contractUnitOption = this.$store.getters['preload/getContuntListOptions'];
				this.medicationFrequencyOptions = this.$store.getters[
					'preload/getMedicationWayListOptions'];
				this.chargingPriceOptions = this.$store.getters['preload/getChargingPriceOptions'];
        console.log(this.chargingPriceOptions,'this.chargingPriceOptionsthis.chargingPriceOptions')

        this.docphrOptions = this.$store.getters['preload/getDocphrListOptions'];
				this.drugDosageOption = this.$store.getters['preload/getDrugDosageListOption'];
				this.dosaUntOptions = this.$store.getters['preload/getDosaUntListOption'];
				this.systemParameterList = this.$store.getters['preload/getSystemListOptions'];
        console.log(this.systemParameterList,'this.systemParameterListthis.systemParameterList')
        this.initWestMedicineTable();
				// zcw++新增：判断批次号显示开关
				if (this.systemParameterList) {
					// 初始化批次号开关状态
					this.initBatchSelectionSwitch();
				}

				if (!this.$store.state.dict || Object.keys(this.$store.state.dict).length === 0) {
					await this.$store.dispatch('fetchDictData')
					await this.dict(this.$store.state.dict)
				} else {
					await this.dict(this.$store.state.dict)
				}
				if (this.userInfo?.isInsurance === '1') {
					const res = await getqdNo();
					this.signNo = res.data?.signNo;
				}
				// 3. 避免重复请求（原代码中有重复的 getMedicationFrequency）
				this.userPermission = userPermission?.data;
				// 4. 事件监听优化:使用 passive 事件提高滚动性能
				this.$nextTick(() => {
					window.addEventListener('keydown', this.handleKeyPress, {
						passive: true
					});
					document.addEventListener('click', this.handleClickOutside);
					// zcw => 检查是否有跳转过来的患者信息
					this.handleRouteParams();
				});
/*				if (!this.isWebSocketInitialized) {
					this.$websocket.initWebSocket();
					this.isWebSocketInitialized = true;
					window.addEventListener('websocket-ai-complete', this.handleAIComplete);
					window.addEventListener('websocket-ai-progress', this.handleAIProgress);
				}*/


			});
		},
		methods: {
      /**
       * 订单记录弹窗关闭后重置（覆盖 X / ESC / 取消按钮 所有关闭路径）
       * 避免下次打开时残留上一个患者的抽屉数据
       */
      handleChargeDetailDialogClosed() {
        // 重置抽屉相关变量
        this.showChargeDetail = false;
        this.chargeDetailData = null;
        this.chargeDetailTab = 'items';
        // 重置列表
        this.chargeTableData = [];
      },
      // 判断处方中是否含中药+处置（不可打印）
      isPrescriptionPrintDisabled(prescription) {
        if (!prescription) return true;
        const items = prescription.items || [];
        const hasChina = !!prescription.tcm || items.some(i => i.itemType === 2);
        const hasDispose = items.some(i => i.itemType === 4);
        // 中药+处置一起开→禁用
        if (hasChina && hasDispose) return true;
        // 无任何可打印项→禁用
        const hasWest = items.some(i => i.itemType === 1);
        return !hasChina && !hasWest && !hasDispose;
      },

      getPrintButtonTitle(prescription) {
        if (!prescription) return '';
        const items = prescription.items || [];
        const hasChina = !!prescription.tcm || items.some(i => i.itemType === 2);
        const hasDispose = items.some(i => i.itemType === 4);
        if (hasChina && hasDispose) return '中药处方含处置项目，无法打印';
        return '打印处方';
      },

// 打印处方
      async handlePrintPrescription(prescription) {
        if (!prescription) return;
        const items = prescription.items || [];
        const hasChina = !!prescription.tcm || items.some(i => i.itemType === 2);
        const hasWest = items.some(i => i.itemType === 1);
        const hasDispose = items.some(i => i.itemType === 4);

        // 中药+处置 → 不可打印
        if (hasChina && hasDispose) {
          this.$message.warning('中药处方含处置项目，无法打印');
          return;
        }

        if (!hasChina && !hasWest && !hasDispose) {
          this.$message.warning('该处方无可打印内容');
          return;
        }

        try {
          if (hasChina) {
            // 中药单独打印
            await this.printChinaPrescription(prescription);
          } else if (hasWest) {
            // 西药（若含处置，会随西药一起打）
            await this.printWestPrescription(prescription);
          } else if (hasDispose) {
            // 只有处置
            await this.printDisposeOnly(prescription);
          }
        } catch (error) {
          console.error('打印失败:', error);
          this.$message.error('打印失败，请重试');
        }
      },

// 仅打印处置项目
      async printDisposeOnly(prescription) {
        const disposeItems = (prescription.items || []).filter(i => i.itemType === 4);
        if (disposeItems.length === 0) {
          this.$message.warning('该处方无处置项目');
          return;
        }

        const originalDisposalProject = this.disposalProject;
        const originalPatientPrescription = this.patientPrescription;

        try {
          // 构造处置打印数据
          this.disposalProject = disposeItems.map(item => ({
            costname: item.itemName,
            num: item.quantity,
            executionAmount: item.totalAmount,
            executDeptId: null,
          }));
          this.patientPrescription = [];

          await this.printDisposalProject();
        } finally {
          // 恢复原值
          this.disposalProject = originalDisposalProject;
          this.patientPrescription = originalPatientPrescription;
        }
      },
      // 西药金额计算（参考你原有的 getWestSdoseSum 或类似）
      handleWestSdoseInput(row) {
        if (!row) return;
        // 仅保留数字
        if (typeof row.sdoseCnt === 'string') {
          row.sdoseCnt = row.sdoseCnt.replace(/[^\d.]/g, '');
        }
        const dose = Number(row.sdoseCnt) || 0;
        // 单价从搜索数据来，假设有 unitPrice 或 salePric
        const price = Number(row.unitPrice) || Number(row.salePric) || 0;
        row.saleAmt = (dose * price).toFixed(2);
        // 若有总合计，可调用
        // this.calcWestTotal();
      },

// 中药金额计算
      handleChinaSdoseInput(row) {
        if (!row) return;
        if (typeof row.sdoseCnt === 'string') {
          row.sdoseCnt = row.sdoseCnt.replace(/[^\d.]/g, '');
        }
        const dose = Number(row.sdoseCnt)
        const price = Number(row.fixMinSalePric)
        row.saleAmt = (dose * price).toFixed(2);
        console.log(row.saleAmt,'row.saleAmtrow.saleAmt')
        // 调用总合计（若需要）
        // this.getChinaTotalSum();
      },
      removeWestDrug(index) {
        this.drugTemplateForm.westDrugs.splice(index, 1);
      },
      removeChinaDrug(index) {
        this.drugTemplateForm.chinaDrugs.splice(index, 1);
      },
      async handleSearchDrug(keyword) {
        if (!keyword) {
          this.searchResultData = [];
          this.searchPopoverVisible = false;
          return;
        }
        try {
          const res = await getDrugByCondition({
            condition: keyword,
            drugType: this.searchDrugType
          });
          this.searchResultData = res.data || [];
          // 根据类型设置搜索结果列
          this.searchResultColumns = this.searchDrugType === 1
              ? this.getFilteredTableRows11()   // 西药搜索列（需实现）
              : this.getFilteredTableRows12(); // 中药搜索列（需实现）
          this.searchPopoverVisible = true;
        } catch (e) {
          console.error(e);
        }
      },

// 选择搜索结果行添加到对应表格
      handleSelectSearchResult(row) {
        // 深拷贝原始行
        const newItem = JSON.parse(JSON.stringify(row));

        // ----- 共通默认值 -----
        newItem.sdoseCnt = newItem.minDose || 0;      // 单次剂量默认最小剂量
        newItem.prdDays = 1;                          // 周期天数
        newItem.prdCnt = 1;                           // 周期次数
        newItem.cnt = 1;                              // 处方数量
        newItem.saleAmt = null;                       // 金额待计算或手动输入
        newItem.remark = '';                          // 备注
        newItem.medicineType = this.searchDrugType;   // 1西药2中药

        // 如果是西药 (searchDrugType === 1)
        if (this.searchDrugType === 1) {
          // 参考 handleSelWestTableRowClick 中的字段
          newItem.roundUnt = parseInt(newItem.roundUnt) || 0;
          newItem.purcType = parseInt(newItem.purcType) || 0;
          newItem.rxType = 1; // 默认普通处方，可后续调整
          newItem.prodentpId = newItem.prodentpNameId || null;
          newItem.unt = newItem.dosUnt;               // 剂量单位
          newItem.saleUnt = 1;                        // 默认最小单位（1=最小单位，2=包装单位）
          newItem.saleUntName = newItem.minUnt;
          newItem.saleUntOption = [
            { id: newItem.minUntId, label: newItem.minUnt },
            { id: newItem.pacUntId, label: newItem.pacUnt }
          ];
          newItem.isEdit = newItem.isFixPrice === 1 ? 1 : 0;
          newItem.medcWayType = newItem.medcWayId != null ?
              this.medicationWayOptions.find(item => item.id === newItem.medcWayId)?.type === 2 :
              newItem.medcWayType;

          // 确保这些字段存在
          newItem.usedfrquId = newItem.usedfrquId || null;
          newItem.medcWayId = newItem.medcWayId || null;
          newItem.dosaUnt = newItem.dosUnt;           // 剂量单位（用于模板表格显示）
          newItem.speed = '';                         // 输液速度默认空

          // 添加唯一标识（如果后续需要）
          newItem._tempId = Date.now() + Math.random();

          // 添加到西药数组
          this.drugTemplateForm.westDrugs.push(newItem);
        }
        // 如果是中药 (searchDrugType === 2)
        else {
          // 参考 handleSelChinaTableRowClick
          newItem.saleUnt = 1;
          newItem.unt = newItem.minUnt;
          newItem.sdoseUnt = newItem.dosUnt;
          newItem.isEdit = 0;
          // 中药特有字段（若有）
          newItem.usedfrquId = null;     // 中药可能不需要频率，可留空
          newItem.medcWayId = null;
          newItem.dosaUnt = newItem.dosUnt;
          newItem.speed = '';

          // 添加唯一标识
          newItem._tempId = Date.now() + Math.random();

          // 添加到中药数组
          this.drugTemplateForm.chinaDrugs.push(newItem);
        }

        // 清空搜索
        this.searchKeyword = '';
        this.searchPopoverVisible = false;
        this.searchResultData = [];
      },
      // ===== 专门用于「引用处方」的独立方法 =====
      handleQuotePrescription(prescription) {
        // 1. 清空所有表格
        this.westMedicineTableData = [];
        this.chinaMedicineTableData = [];
        this.doctordisposeTableData = [];

        // 2. 判断类型
        const items = prescription.items || [];
        const hasWest = items.some(item => item.itemType === 1);
        const hasChina = items.some(item => item.itemType === 2);
        const hasDispose = items.some(item => item.itemType === 4);

        if (hasWest) {
          this.DropDownedName = '西药医嘱';
        } else if (hasChina) {
          this.DropDownedName = '中药医嘱';
        }

        const disposeDataRows = [];

        // 3. 循环填充数据（和原来一样）
        items.forEach(item => {
          const itemType = item.itemType;

          // ===== 西药 =====
          if (itemType === 1) {
            const drugData = {
              // ⭐ 注意：这里不传 _orderId、_orderVersion、id、version
              drugId: item.itemId,
              groupNo: item.groupNo,
              drugName: item.itemName,
              pacSpec: item.specification || '',
              minDose: item.singleDose || 0,
              sdoseCnt: item.singleDose || 0,
              usedfrquId: item.frequencyId || null,
              saleUnt: item.unitId || 1,
              prdDays: item.periodDays || 1,
              prdCnt: item.periodCount || 1,
              cnt: item.quantity || 0,
              saleAmt: item.totalAmount || 0,
              unitPrice: item.unitPrice || 0,
              medcWayId: item.routeId || null,
              selfProe: item.selfProvided || 0,
              skintstDicm: item.skinTestRequired || 0,
              remarks: item.remark || '',
              speed: item.infusionSpeed || '',
              roundUnt: 1,
              purcType: 1,
              rxType: this.addWesternForm.rxType || 1,
              prodentpId: null,
              dosUnt: item.doseUnit,
              medicineType: 1,
              saleUntName: '',
              saleUntOption: [],
              isEdit: 0,
              medcWayType: false,
              pacPrice: 0,
              minPrice: 0,
              drugPrice: 0,
              antcLv: null,
              dmCode: null,
              adviceId: 0,
            };

            const newRow = this.getEmptyWestRowData();
            Object.assign(newRow, JSON.parse(JSON.stringify(drugData)));
            newRow.id = Date.now() + Math.random();

            if (item.unitId) {
              newRow.saleUnt = item.unitId;
              newRow.saleUntOption = [{ id: item.unitId, label: item.unitName || '单位' }];
            }
            if (item.routeId) newRow.medcWayId = item.routeId;
            if (item.frequencyId) newRow.usedfrquId = item.frequencyId;

            this.westMedicineTableData.push(newRow);
          }

          // ===== 中药 =====
          if (itemType === 2) {
            const drugData = {
              // ⭐ 同样不传 _orderId、_orderVersion、id、version
              drugId: item.itemId,
              drugName: item.itemName,
              pacSpec: item.specification || '',
              minDose: item.singleDose || 0,
              sdoseCnt: item.singleDose || 0,
              usedfrquId: item.frequencyId || null,
              saleUnt: item.unitId || 1,
              prdDays: item.periodDays || 1,
              prdCnt: item.periodCount || 1,
              cnt: item.quantity || 0,
              saleAmt: item.totalAmount || 0,
              unitPrice: item.unitPrice || 0,
              medcWayId: item.routeId || null,
              selfProe: item.selfProvided || 0,
              skintstDicm: item.skinTestRequired || 0,
              remarks: item.remark || '',
              speed: item.infusionSpeed || '',
              roundUnt: 1,
              purcType: 1,
              rxType: this.addWesternForm.rxType || 1,
              prodentpId: null,
              dosUnt: '',
              medicineType: 2,
              saleUntName: '',
              saleUntOption: [],
              isEdit: 0,
              medcWayType: false,
              pacPrice: 0,
              minPrice: 0,
              drugPrice: 0,
              antcLv: null,
              dmCode: null,
              adviceId: 0,
            };

            const newRow = this.getEmptyChinaRowData();
            Object.assign(newRow, JSON.parse(JSON.stringify(drugData)));
            newRow.id = Date.now() + Math.random();

            if (item.unitId) {
              newRow.saleUnt = item.unitId;
              newRow.saleUntOption = [{ id: item.unitId, label: item.unitName || '单位' }];
            }
            if (item.routeId) newRow.medcWayId = item.routeId;
            if (item.frequencyId) newRow.usedfrquId = item.frequencyId;

            this.chinaMedicineTableData.push(newRow);
          }

          // ===== 处置 =====
          if (itemType === 4) {
            const disposeData = {
              // ⭐ 同样不传 _orderId、_orderVersion、id、version
              costid: item.itemId,
              costname: item.itemName,
              odcost: item.unitPrice || 0,
              deptName: null,
              executId: null,
              exeFrquId: item.frequencyId || null,
              prdDays: item.periodDays || 1,
              frquCnt: item.quantity || 1,
              executeOdcost: (item.quantity || 1) * (item.unitPrice || 0),
              depexecutetype: 0,
              executemode: 0,
              costmode: 0,
              remark: item.remark || '',
              isEdit: 0,
              adviceId: 0,
              doctorName: '',
              _searchResults: [],
              _searchLoading: false,
              _searchKeyword: '',
            };

            const newRow = this.getEmptyDisposeRowData();
            Object.assign(newRow, JSON.parse(JSON.stringify(disposeData)));
            newRow.id = Date.now() + Math.random();

            disposeDataRows.push(newRow);
          }
        });

        // 4. 处置赋值
        if (hasDispose) {
          this.doctordisposeTableData = disposeDataRows;
          if (this.doctordisposeTableData.length > 0) {
            this.addNewDisposeRow();
          }
        }

        // 5. 中药汇总
        if (hasChina) {
          this.getChinaTotalSum();
        }

        // 6. 添加空行
        if (hasWest) {
          this.addNewWestRow();
          this.$nextTick(() => {
            this.renderGroupFlags();
          });
        } else if (hasChina) {
          this.addNewChinaRow();
        }

        // 7. 填充中药扩展
        if (hasChina && prescription.tcm) {
          this.addChinaForm.tcmCnt = prescription.tcm.doseCount || 1;
          this.addChinaForm.decoctionType = prescription.tcm.decoctionType || 0;
          this.addChinaForm.decoctionVolume = prescription.tcm.decoctionVolume || 0;
          this.addChinaForm.doseVolume = prescription.tcm.doseVolume || 0;
          this.addChinaForm.usedfrquId = prescription.tcm.frequencyId || null;
          this.addChinaForm.medcWayId = prescription.tcm.routeId || null;
          this.addChinaForm.tcmWayId = prescription.tcm.tcmWayId || null;
        }

        this.$message.success('已引用处方数据，可修改后提交（将生成新订单）');
      },
      // 通过选项数组 key 和 id 获取 label
      getLabelById(optionsKey, id) {
        const options = this[optionsKey];
        if (!options) return id ?? '-';
        const found = options.find(item => item.id === id);
        return found ? found.label : (id ?? '-');
      },

      // 格式化日期（将 '2026-01-01T10:30:00' 转为 '2026-01-01 10:30'）
      formatDate(dateStr) {
        if (!dateStr) return '-';
        return dateStr.replace('T', ' ').substring(0, 16);
      },

      // 收费状态标签颜色
      getChargeTagType(status) {
        return status === 1 ? 'success' : 'warning';
      },

      // 订单状态标签颜色
      getTagTypeByStatus(status) {
        const map = { 0: 'info', 1: 'success', 2: 'danger' };
        return map[status] || 'info';
      },

      // ---------- 关闭抽屉时清空数据（可选） ----------
      handleCloseDrawer() {
        this.showChargeDetail = false;
        // 清空数据，避免下次打开时残留
        // 若需保留数据可注释掉
        this.chargeDetailData = null;
      },
      // 查询收费记录
      async handleQueryChargeRecords() {
        await withLoading(this, '加载中...')(async () => {
          try {
            const params = {
              patientName: this.chargeQueryParams.patientName || undefined,
              patientId: this.chargeQueryParams.patientId || undefined,
              chargeNo: this.chargeQueryParams.chargeNo || undefined,
              status: this.chargeQueryParams.status || undefined,
              chargeType: this.chargeQueryParams.chargeType || undefined,
              startTime: this.chargeQueryParams.startTime || undefined,
              endTime: this.chargeQueryParams.endTime || undefined,
            };
            const res = await getChargesQuery(params);
            if (res.code === 200) {
              this.chargeTableData = res.data.content || [];
              // 清空右侧详情
              this.chargeDetailData = null;
              this.showChargeDetail = false;
            }
          } catch (error) {
            console.error('查询收费记录失败:', error);
            this.$message.error('查询失败');
          }
        });
      },

// 重置查询
      handleResetChargeQuery() {
        this.chargeQueryParams = {
          patientName: '',
          patientId: '',
          chargeNo: '',
          status: null,
          chargeType: null,
          startTime: '',
          endTime: '',
        };
        this.handleQueryChargeRecords();
      },

// 点击行查看详情
      getChargeDetail(row) {
        // row 是当前点击的订单对象（来自 chargeTableData）
        if (!row) return;
        // 直接使用该对象作为详情数据（也可根据 id 重新请求接口，但直接用已有数据更高效）
        this.chargeDetailData = row;
        this.showChargeDetail = true;
        // 重置 tab 到第一个
        this.chargeDetailTab = 'items';
      },

      // 处置 - 选择频率后自动计算天数和次数
      computeDisposeFrequency(row) {
        if (!row) return;
        const frequency = this.medicationFrequencyOptions.find(item => item.id === row.exeFrquId);
        if (frequency) {
          row.prdDays = frequency.frquPrd || 1;
          row.periodCount = frequency.frquCnt || 1;
          row.frquCnt = (row.periodCount || 1) * (row.prdDays || 1);
          this.updateDisposeRow(row);
        }
      },

// 处置 - 执行天数变化
      computeDisposeDay(row) {
        if (!row) return;
        const frequency = this.medicationFrequencyOptions.find(item => item.id === row.exeFrquId);
        if (frequency) {
          const periodCount = row.periodCount || frequency.frquCnt || 1;
          const days = row.prdDays || 1;
          row.frquCnt = periodCount * days;
          this.updateDisposeRow(row);
        }
      },

// 处置 - 执行次数变化
      computeDisposePeriod(row) {
        if (!row) return;
        const frequency = this.medicationFrequencyOptions.find(item => item.id === row.exeFrquId);
        if (frequency) {
          const periodCount = row.periodCount || 1;
          const days = row.prdDays || frequency.frquPrd || 1;
          row.frquCnt = periodCount * days;
          this.updateDisposeRow(row);
        }
      },
// 获取有数据的处置行数
      getDisposeDataCount() {
        return this.doctordisposeTableData.filter(row => row.costid && row.costid !== null).length;
      },
      getEmptyDisposeRowData() {
        return {
          id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
          costid: null,
          costname: '',
          odcost: 0,
          deptName: null,
          executId: null,
          exeFrquId: null,
          prdDays: 1,
          frquCnt: 1,
          executeOdcost: 0,
          depexecutetype: 0,
          executemode: 0,
          costmode: 0,
          remark: '',
          isEdit: 0,
          adviceId: 0,
          doctorName: '',
          _searchResults: [],
          _searchLoading: false,
          _searchKeyword: '',
        };
      },

// 新增空处置行
      addNewDisposeRow() {
        this.doctordisposeTableData.push(this.getEmptyDisposeRowData());
      },

// 初始化处置表格
      initDisposeTable() {
        if (this.doctordisposeTableData.length === 0) {
          this.doctordisposeTableData.push(this.getEmptyDisposeRowData());
        }
      },

// 清空所有处置项目
      handleClearAllDispose() {
        if (this.isShowPrescription) return;
        this.$confirm('确定要清空所有处置项目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doctordisposeTableData = [this.getEmptyDisposeRowData()];
          this.$message.success('已清空');
        }).catch(() => {});
      },

// 初始化处置行搜索状态
      initDisposeRowSearch(row) {
        if (!row._searchResults) {
          this.$set(row, '_searchResults', []);
          this.$set(row, '_searchLoading', false);
          this.$set(row, '_searchKeyword', '');
        }
      },

// 处置项目搜索
      async searchDisposeItems(row, query) {
        if (!this.preVerificationUserInfo()) {
          return;
        }
        if (!query || query.trim() === '') {
          this.$set(row, '_searchResults', []);
          this.$set(row, '_searchKeyword', '');
          return;
        }

        const keyword = query.trim();
        this.$set(row, '_searchKeyword', keyword);
        this.$set(row, '_searchLoading', true);

        clearTimeout(this.disposeSearchTimer);
        this.disposeSearchTimer = setTimeout(() => {
          try {
            const results = this.chargingPriceOptions.filter(item => {
              const name = (item.label || item.costname || item.name || '').toLowerCase();
              return name.includes(keyword.toLowerCase());
            });
            this.$set(row, '_searchResults', results);
          } catch (error) {
            console.error('搜索处置项目失败:', error);
            this.$set(row, '_searchResults', []);
          } finally {
            this.$set(row, '_searchLoading', false);
          }
        }, 300);
      },

// 处置项目名称回车
      handleDisposeNameEnter(rowIndex) {
        if (this.isProcessingEnter) return;
        this.isProcessingEnter = true;

        const row = this.doctordisposeTableData[rowIndex];
        if (row._searchResults && row._searchResults.length > 0 && !row.costid) {
          const firstItem = row._searchResults[0];
          row.costname = firstItem.label || firstItem.costname || firstItem.name;
          this.handleSelectDisposeItem(row, row.costname);
        } else if (row.costid) {
          this.focusNextDispose(rowIndex, 'costname');
        }

        setTimeout(() => {
          this.isProcessingEnter = false;
        }, 200);
      },


      async handleSelectDisposeItem(row, selectedValue) {
        if (!selectedValue) return;

        const selectedItem = row._searchResults.find(item =>
            (item.label || item.costname || item.name) === selectedValue
        );

        if (!selectedItem) return;

        // 检查是否已存在（排除当前行）
        const exists = this.doctordisposeTableData.some(item =>
            item.costid === selectedItem.id && item !== row
        );
        if (exists) {
          this.$message.warning(`处置项目【${selectedItem.label || selectedItem.costname}】已存在!`);
          row.costname = '';
          return;
        }

        // 处理执行科室
        let deptName = null;
        if (selectedItem.depexecutetype === 1 || selectedItem.depexecutetype === 2) {
          deptName = selectedItem.depexecutetype === 1 ?
              (this.deptOptions.find(item => item.id === this.userInfo.selDept)?.id || null) :
              this.userInfo.selDept;
        } else if (selectedItem.depexecutetype === 0) {
          const executeDept = this.deptOptions.find(item => item.id === selectedItem.executedepid);
          if (executeDept) {
            deptName = executeDept.id;
          }
        }

        // 填充数据到当前行
        row.costid = selectedItem.id;
        row.costname = selectedItem.label || selectedItem.costname || selectedItem.name;
        row.odcost = selectedItem.odcost || 0;
        row.depexecutetype = selectedItem.depexecutetype || 0;
        row.executemode = selectedItem.executemode || 0;
        row.costmode = selectedItem.costmode || 0;
        row.deptName = deptName;
        row.exeFrquId = null;
        row.prdDays = 1;
        row.periodCount = 1;
        row.frquCnt = 1;
        row.remark = '';
        row.id = Date.now() + Math.random();

        this.$set(row, '_searchResults', []);
        this.$set(row, '_searchKeyword', '');

        // ===== 判断是否已有空行，没有才新增 =====
        const hasEmptyRow = this.doctordisposeTableData.some(item =>
            !item.costid || item.costid === null
        );

        if (!hasEmptyRow) {
          this.addNewDisposeRow();
        }

        this.$nextTick(() => {
          const newIndex = this.doctordisposeTableData.indexOf(row);
          if (selectedItem.executemode === 1) {
            this.focusFieldDispose(newIndex, 'exeFrquId');
          } else {
            this.focusFieldDispose(newIndex, 'deptName');
          }
        });
      },

// 更新处置行（频率、天数、数量变化时触发）
      updateDisposeRow(row) {
        if (!row) return;

        // 获取频率对象
        const frequency = this.medicationFrequencyOptions.find(item => item.id === row.exeFrquId);

        if (frequency) {
          if (!row.prdDays || row.prdDays <= 0) {
            row.prdDays = frequency.frquPrd || 1;
          }
          if (!row.frquCnt || row.frquCnt <= 0) {
            row.frquCnt = frequency.frquCnt || 1;
          }
        }

        // 计算执行总金额：数量 × 单价
        const cnt = Number(row.frquCnt) || 0;
        const price = Number(row.odcost) || 0;
        console.log(cnt,'cntcnt')
        console.log(price,'pricepricepriceprice')
        console.log((cnt * price).toFixed(2),'(cnt * price).toFixed(2)')
        row.executeOdcost = (cnt * price).toFixed(2);
      },

// 移除处置行
      removeDoctordisposeSelected(index) {
        if (this.isShowPrescription) return;
        const row = this.doctordisposeTableData[index];
        if (row.adviceId > 0) {
          this.$message.warning('已提交的处置不能删除');
          return;
        }
        this.doctordisposeTableData.splice(index, 1);
        // 如果删除后没有数据行，保留一个空行
        if (this.getDisposeDataCount() === 0) {
          this.doctordisposeTableData = [this.getEmptyDisposeRowData()];
        }
      },

// 处置项目回车跳转
      // 处置项目回车跳转
      focusNextDispose(rowIndex, currentProp) {
        if (this.isProcessingEnter) return;
        this.isProcessingEnter = true;

        const row = this.doctordisposeTableData[rowIndex];
        if (!row) {
          this.isProcessingEnter = false;
          return;
        }

        // 处置可编辑字段顺序
        const editableProps = ['costname', 'deptName', 'exeFrquId', 'prdDays', 'periodCount', 'frquCnt', 'remark'];

        const currentIndex = editableProps.indexOf(currentProp);
        if (currentIndex === -1) {
          this.isProcessingEnter = false;
          return;
        }

        // ===== 不管有没有值，直接跳到下一个字段 =====
        if (currentIndex + 1 < editableProps.length) {
          const nextProp = editableProps[currentIndex + 1];
          this.focusFieldDispose(rowIndex, nextProp);
          this.isProcessingEnter = false;
          return;
        }

        // 当前行是最后一个字段，跳到下一行
        const nextRowIndex = rowIndex + 1;
        if (nextRowIndex >= this.doctordisposeTableData.length) {
          this.addNewDisposeRow();
        }

        this.$nextTick(() => {
          this.focusFieldDispose(nextRowIndex, 'costname');
        });

        setTimeout(() => {
          this.isProcessingEnter = false;
        }, 200);
      },

// 处置项目聚焦字段
      focusFieldDispose(rowIndex, prop) {
        const refMap = {
          'costname': `disposeNameSelect_${rowIndex}`,
          'deptName': `disposeDeptSelect_${rowIndex}`,
          'exeFrquId': `disposeFrquSelect_${rowIndex}`,
          'prdDays': `disposeDaysInput_${rowIndex}`,
          'periodCount': `disposePeriodInput_${rowIndex}`,
          'frquCnt': `disposeCntInput_${rowIndex}`,
          'remark': `disposeRemarkInput_${rowIndex}`,
        };

        const refName = refMap[prop];
        if (!refName) return;

        this.$nextTick(() => {
          const ref = this.$refs[refName];
          if (ref) {
            const el = Array.isArray(ref) ? ref[0] : ref;
            if (el) {
              if (typeof el.focus === 'function') {
                el.focus();
              } else if (el.$el) {
                const input = el.$el.querySelector('input') || el.$el.querySelector('textarea');
                if (input) input.focus();
              }
            }
          }
        });
      },

      async handleConfirmDisposeItem() {
        const validItems = this.doctordisposeTableData.filter(item =>
            item.costid && item.costid !== null && item.costname && item.costname.trim() !== ''
        );

        if (validItems.length === 0) {
          this.$message.warning('请至少添加一个处置项目');
          return;
        }

        for (const item of validItems) {

          if (!item.frquCnt || item.frquCnt < 1) {
            this.$message.warning(`请输入【${item.costname}】的执行数量`);
            return;
          }
        }

        // ===== 构建请求数据 =====
        const requestData = {
          requestNo: this.generateRequestNo(),  // 使用已有的幂等方法
          visitId: this.patientChooseForm.seeDoctorId || '',
          diagnosisCode: this.addSeedoctorForm.westernDiagnos || '',
          diagnosisName: this.addSeedoctorForm.westernDiagnos || '',
          registrationId: this.patientChooseForm.dregisterTableId || null,
          remark: '',
          items: this.buildDisposeItems(validItems),
          tcm: null
        };

        console.log('处置项目提交请求数据:', requestData);

        try {
          const res = await addOrders(requestData);
          if (res.code === 200) {
            this.$message.success('处置项目提交成功');
            // 提交成功，清除缓存的幂等号
            this.clearRequestNo();
            // 清空处置表格
            this.doctordisposeTableData = [this.getEmptyDisposeRowData()];
            // 刷新处方列表
            await this.getOrdersByPatientId();
          } else {
            this.$message.error(`处置项目提交失败: ${res.message || '未知错误'}`);
          }
        } catch (error) {
          console.error('提交处置项目失败:', error);
          this.$message.error('提交失败，请重试');
        }
      },

      buildDisposeItems(items) {
        return items.map(item => ({
          itemId: Number(item.costid),
          itemType: 4,
          quantity: Number(item.frquCnt) || 1,
          doseUnit: null,
          frequencyId: Number(item.exeFrquId) || null,
          groupNo: null,
          infusionSpeed: null,
          periodCount: null,
          periodDays: Number(item.prdDays) || 1,
          remark: item.remark || null,
          routeId: null,
          selfProvided: null,
          singleDose: null,
          skinTestRequired: null,
          unitId: null,
          requestNo: this.generateUUID()
        }));
      },

      handleNumberInput(row, prop) {
        if (row[prop] !== undefined && row[prop] !== null) {
          let value = String(row[prop]);
          // 只保留数字和小数点
          value = value.replace(/[^\d.]/g, '');
          // 防止多个小数点
          const parts = value.split('.');
          if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
          }
          row[prop] = value;
          if (prop === 'cnt') {
            this.calculateSaleAmt(row);
          }
        }
      },
      calculateSaleAmt(row) {
        const quantity = parseFloat(row.cnt);
        if (!quantity || quantity <= 0) {
          row.saleAmt = 0;
          return;
        }

        // 拿到当前行对象的 saleUntOption 中 saleUnt 的下标
        const saleUntIndex = row.saleUntOption?.findIndex(item => item.id === row.saleUnt) ?? -1;

        // 0: 小单位, 1: 大单位
        if (saleUntIndex === 0) {
          // 小单位：数量 × fixMinSalePric
          row.saleAmt = quantity * (row.fixMinSalePric || 0);
        } else if (saleUntIndex === 1) {
          // 大单位：数量 × fixPacSalePric
          row.saleAmt = quantity * (row.fixPacSalePric || 0);
        } else {
          row.saleAmt = 0;
        }
      },
      // 校验煎药量：不能超过总量
      validateDecoctionVolume() {
        const volume = Number(this.addChinaForm.decoctionVolume) || 0;
        const total = Number(this.addChinaForm.chinaMedicineSum) || 0;

        if (volume > total && total > 0) {
          this.$message.warning('煎药量不能超过药品总量');
          this.addChinaForm.decoctionVolume = total;
        }
      },

// 校验每次服药量：不能超过总量
      validateDoseVolume() {
        const dose = Number(this.addChinaForm.doseVolume) || 0;
        const total = Number(this.addChinaForm.chinaMedicineSum) || 0;

        if (dose > total && total > 0) {
          this.$message.warning('每次服药量不能超过药品总量');
          this.addChinaForm.doseVolume = total;
        }
      },
      // 获取中药表格列
      getFilteredTableRows12China() {
        return this.tableRows12China.filter(col => {
          if (col.showCondition) {
            return col.showCondition();
          }
          return true;
        });
      },
      // 修改中药处方
      async handleUpdateChinaPrescription() {
        try {
          const rawItems = this.chinaMedicineTableData;
          const extraData = this.addChinaForm;

          const validItems = rawItems.filter(item => {
            return item.drugId && item.drugId !== '' && item.drugName && item.drugName.trim() !== '';
          });

          if (!validItems || validItems.length === 0) {
            this.$message.warning('请先添加药品');
            return;
          }

          const firstRow = validItems[0];
          const orderId = firstRow._orderId;
          const version = firstRow._orderVersion || 0;

          const items = validItems.map(item => ({
            id: item._orderItemId || 0,
            itemId: Number(item.drugId),
            itemType: 2,  // 中成药
            quantity: Number(extraData.tcmCnt) || 1,  // 付数
            doseUnit: null,
            frequencyId: Number(item.usedfrquId) || null,
            groupNo: null,
            infusionSpeed: null,
            periodCount: null,
            periodDays: null,
            remark: item.remarks || null,
            routeId: Number(item.medcWayId) || null,
            selfProvided: null,
            singleDose: Number(item.sdoseCnt) || null,
            skinTestRequired: null,
            unitId: 1,
          }));

          const requestData = {
            diagnosisCode: firstRow._diagnosisCode || null,
            diagnosisName: firstRow._diagnosisName || null,
            items: items,
            remark: firstRow._orderRemark || null,
            tcm: {
              doseCount: Number(extraData.tcmCnt) || 1,
              decoctionType: Number(extraData.decoctionType) || 0,
              decoctionVolume: Number(extraData.decoctionVolume) || null,
              doseVolume: Number(extraData.doseVolume) || null,
              doseVolumeUnit: 'g',
              frequencyId: Number(extraData.usedfrquId) || null,
              routeId: Number(extraData.medcWayId) || null,
              tcmWayId: Number(extraData.tcmWayId) || null
            },
            version: Number(version) || 0
          };

          console.log('修改中药处方请求数据:', requestData);

          const res = await editOrders(orderId, requestData);

          if (res.code === 200) {
            this.$message.success('中药处方修改成功');
            this.chinaMedicineUsageDialog = false;              // ✅ 关闭弹窗
            this.chinaMedicineTableData = [this.getEmptyChinaRowData()];
            this.addChinaForm = Object.assign({}, this.$options.data.call(this).addChinaForm); // 建议一并重置
            await this.getOrdersByPatientId();
          } else {
            this.$message.error(`中药处方修改失败: ${res.message || '未知错误'}`);
          }
        } catch (error) {
          console.error('修改中药处方异常:', error);
          this.$message.error('修改失败，请重试');
        }
      },
      // 中药搜索 - 每行独立搜索
      async searchChinaDrugsForRow(row, query) {
        if (!query || query.trim() === '') {
          this.$set(row, '_searchResults', []);
          this.$set(row, '_searchKeyword', '');
          this.searchTriggered = false;
          return;
        }

        const keyword = query.trim();
        this.$set(row, '_searchKeyword', keyword);
        this.$set(row, '_searchLoading', true);
        this.searchTriggered = true;

        clearTimeout(this.drugSearchTimer);
        this.drugSearchTimer = setTimeout(async () => {
          try {
            if (!this.preVerificationUserInfo()) {
              this.$set(row, '_searchLoading', false);
              return;
            }
            this.searchTriggered = true;
            this.medicineSearchQuery = keyword;

            const res = await getDrugByCondition({
              condition: keyword,
              drugType:2
            });
            this.queryChinaMedicineData = res.data || [];
            console.log(res.data,'rowrow')
            this.tableMedicineKey++;
            this.$set(row, '_searchResults', [...this.queryChinaMedicineData]);
          } catch (error) {
            console.error('搜索失败:', error);
            this.$set(row, '_searchResults', []);
          } finally {
            this.$set(row, '_searchLoading', false);
          }
        }, this.searchDebounceTime || 300);
      },
// 选择中药 - 从弹窗选择
// 选择中药
// 选择中药 - 从弹窗选择
      async handleSelectChinaDrugFromPopover(row, drugData) {
        this.$set(row, '_popoverVisible', false);

        // 检查是否已存在
        const isExist = this.chinaMedicineTableData.some(
            item => item.drugId === drugData.drugId && item !== row
        );
        if (isExist) {
          this.$message.error(`药品【${drugData.drugName}】已存在!`);
          return;
        }

        // ===== 填充数据 =====
        row.drugId = drugData.drugId;
        row.drugName = drugData.drugName;
        row.pacSpec = drugData.pacUnt || '';  // 包装单位作为规格展示

        row.unitPrice = drugData.fixMinSalePric

        // 设置默认剂量（使用单位剂量）
        row.sdoseCnt = drugData.dosCnt || '';

        // 保存其他信息
        row.minUnt = drugData.minUnt || '';
        row.pacUnt = drugData.pacUnt || '';
        row.manufacturer = drugData.prodentpName || '';
        console.log(drugData,'drugDatadrugData')

        // ===== 计算金额 =====
        this.getChinaSdoseSum(row);

        // 清空搜索状态
        this.$set(row, '_searchResults', []);
        this.$set(row, '_searchKeyword', '');

        // 新增空行
        const tableData = this.chinaMedicineTableData;
        const currentIndex = tableData.indexOf(row);
        if (currentIndex === tableData.length - 1) {
          this.addNewChinaRow();
        }

        this.$nextTick(() => {
          this.focusField(currentIndex, 'sdoseCnt');
        });
      },// 中药剂量变化 → 计算金额
      // 中药剂量变化 → 计算金额
      getChinaSdoseSum(row) {
        if (!row) return;
        console.log(row,'getChinaSdoseSumgetChinaSdoseSumgetChinaSdoseSumgetChinaSdoseSum')
        // 只允许输入数字，过滤非数字字符
        if (row.sdoseCnt !== undefined && row.sdoseCnt !== null) {
          // 如果是字符串，只保留数字和小数点
          if (typeof row.sdoseCnt === 'string') {
            row.sdoseCnt = row.sdoseCnt.replace(/[^\d.]/g, '');
          }
          // 转为数字，如果不是数字则置空
          const num = Number(row.sdoseCnt);
          if (isNaN(num)) {
            row.sdoseCnt = '';
            return;
          }
          row.sdoseCnt = num;
        }

        const dose = Number(row.sdoseCnt) || 0;
        const price = Number(row.unitPrice) || 0;
        row.saleAmt = (dose * price).toFixed(2);

        this.getChinaTotalSum();
      },

// 计算总金额（考虑付数）
      getChinaTotalSum() {
        const tcmCnt = Number(this.addChinaForm.tcmCnt) || 1;

        // 计算总金额 = 每行金额 × 付数
        const total = this.chinaMedicineTableData.reduce((sum, item) => {
          return sum + (Number(item.saleAmt) || 0);
        }, 0) * tcmCnt;

        this.addChinaForm.predictMoney = total.toFixed(2);

        // 计算总药量
        const totalDose = this.chinaMedicineTableData.reduce((sum, item) => {
          return sum + (Number(item.sdoseCnt) || 0);
        }, 0) * tcmCnt;
        this.addChinaForm.chinaMedicineSum = totalDose.toFixed(2);
      },

      getEmptyChinaRowData() {
        return {
          id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
          drugName: '',
          drugId: '',
          pacSpec: '',
          manufacturer: '',
          sdoseCnt: '',        // 单次剂量
          unitPrice: 0,        // 单价
          saleAmt: null,       // 金额 = 单价 × 剂量
          usedfrquId: '',
          medcWayId: '',
          prdDays: 1,
          cnt: null,
          remarks: '',
          minUnt: '',
          pacUnt: '',
          _popoverVisible: false,
          _searchResults: [],
          _searchLoading: false,
          _searchKeyword: '',
        };
      },

// 新增中药空行
      addNewChinaRow() {
        this.chinaMedicineTableData.push(this.getEmptyChinaRowData());
      },

// 初始化中药表格
      initChinaMedicineTable() {
        if (this.chinaMedicineTableData.length === 0) {
          this.chinaMedicineTableData.push(this.getEmptyChinaRowData());
        }
      },

// 移除中药行
      removeChinaMedicineTableData(index) {
        if (this.isShowPrescription) return;
        const row = this.chinaMedicineTableData[index];
        if (row.adviceId > 0) {
          this.$message.warning('已提交的医嘱不能删除');
          return;
        }
        this.chinaMedicineTableData.splice(index, 1);
        const hasData = this.chinaMedicineTableData.some(r => r.drugName);
        if (!hasData) {
          this.chinaMedicineTableData = [this.getEmptyChinaRowData()];
        }
      },

// 中药是否可以移除
      canRemoveChina() {
        const dataRows = this.chinaMedicineTableData.filter(row => row.drugName && row.drugName.trim() !== '').length;
        const totalRows = this.chinaMedicineTableData.length;
        return dataRows > 1 || totalRows >= 2;
      },

      // 修改处方提交
      async handleUpdatePrescription() {
        await withLoading(this, '数据提交中...')(async () => {
          const rawItems = this.westMedicineTableData;

          // 过滤空行（西药）
          const validItems = rawItems.filter(item => {
            return item.drugId && item.drugId !== '' && item.drugName && item.drugName.trim() !== '';
          });

          // 过滤处置
          const disposeItems = this.doctordisposeTableData.filter(item =>
              item.costid && item.costid !== null && item.costname && item.costname.trim() !== ''
          );

          if (!validItems || validItems.length === 0) {
            this.$message.warning('请先添加药品');
            return;
          }


          const groupNo = (validItems.length > 0 || disposeItems.length > 0) ? Math.floor(10000 + Math.random() * 90000) : null;

          // 从行对象取订单信息（取第一条）
          const firstRow = validItems[0];
          const orderId = firstRow._orderId;
          const version = firstRow._orderVersion || 0;

          // 构建 items（西药）
          const items = validItems.map(item => ({
            id: item._orderItemId || null,
            itemId: Number(item.drugId) || 0,
            itemType: 1,
            quantity: Number(item.cnt) || 0,
            doseUnit: item.dosUnt || '',
            frequencyId: Number(item.usedfrquId) || 0,
            groupNo: groupNo,  // 统一分组号
            infusionSpeed: item.speed || '',
            periodCount: Number(item.prdCnt) || 0,
            periodDays: Number(item.prdDays) || 0,
            remark: item.remarks || '',
            routeId: Number(item.medcWayId) || 0,
            selfProvided: Number(item.selfProe) || 0,
            singleDose: Number(item.sdoseCnt) || 0,
            skinTestRequired: Number(item.skintstDicm) || 0,
            unitId: Number(item.saleUnt) || 0,
          }));

          // 处置
          const disposeData = disposeItems.map(item => ({
            itemId: Number(item.costid),
            itemType: 4,
            quantity: Number(item.frquCnt) || 1,
            doseUnit: '次',
            frequencyId: Number(item.exeFrquId) || null,
            groupNo: groupNo,
            infusionSpeed: null,
            periodCount: Number(item.periodCount) || 1,   // 执行次数
            periodDays: Number(item.prdDays) || 1,         // 执行天数
            remark: item.remark || '',
            routeId: null,
            selfProvided: null,
            singleDose: null,
            skinTestRequired: null,
            unitId: null,
            requestNo: this.generateUUID()
          }));

          // ===== 合并西药 + 处置 =====
          const allItems = [...items, ...disposeData];

          const requestData = {
            diagnosisCode: firstRow._diagnosisCode || '',
            diagnosisName: firstRow._diagnosisName || '',
            items: allItems,
            remark: firstRow._orderRemark || '',
            tcm: firstRow._tcm || null,
            version: Number(version) || 0
          };

          console.log('修改处方请求数据:', requestData);

          const res = await editOrders(orderId, requestData);

          if (res.code === 200) {
            this.$message.success('处方修改成功');
            this.westMedicineTableData = [this.getEmptyWestRowData()];
            this.doctordisposeTableData = [this.getEmptyDisposeRowData()];
            await this.getOrdersByPatientId();
          } else {
            this.$message.error(`处方修改失败: ${res.message || '未知错误'}`);
          }
        });
      },      // 修改处方 - 把数据组装成 drugData 格式，复用现有逻辑
      handleEditPrescription(prescription) {

        const items = prescription.items || [];

        // ===== 根据所有 items 判断类型 =====
        const hasWest = items.some(item => item.itemType === 1);
        const hasChina = items.some(item => item.itemType === 2);
        const hasDispose = items.some(item => item.itemType === 4);

        const isWest = hasWest;
        const isChina = hasChina;
        const isDispose = hasDispose;

        // 清空当前表格
        if (isWest) {
          this.westMedicineTableData = [];
          this.DropDownedName = '西药医嘱';
        } else if (isChina) {
          this.chinaMedicineTableData = [];
          this.DropDownedName = '中药医嘱';
        } else if (isDispose) {
          this.doctordisposeTableData = [];
        }

        const disposeDataRows = [];

        items.forEach(item => {
          const itemType = item.itemType;

          // ===== 西药 =====
          if (itemType === 1) {
            const drugData = {
              _orderId: prescription.id,
              _orderVersion: prescription.version,
              _orderItemId: item.id,
              _orderNo: prescription.orderNo,
              _tcm: prescription.tcm,
              _diagnosisCode: prescription.diagnosisCode || '',
              _diagnosisName: prescription.diagnosisName || '',
              _orderRemark: prescription.remark || '',
              drugId: item.itemId,
              groupNo: item.groupNo,
              drugName: item.itemName,
              pacSpec: item.specification || '',
              minDose: item.singleDose || 0,
              sdoseCnt: item.singleDose || 0,
              usedfrquId: item.frequencyId || null,
              saleUnt: item.unitId || 1,
              prdDays: item.periodDays || 1,
              prdCnt: item.periodCount || 1,
              cnt: item.quantity || 0,
              saleAmt: item.totalAmount || 0,
              unitPrice: item.unitPrice || 0,
              medcWayId: item.routeId || null,
              selfProe: item.selfProvided || 0,
              skintstDicm: item.skinTestRequired || 0,
              remarks: item.remark || '',
              speed: item.infusionSpeed || '',
              roundUnt: 1,
              purcType: 1,
              rxType: this.addWesternForm.rxType || 1,
              prodentpId: null,
              dosUnt: item.doseUnit,
              medicineType: 1,
              saleUntName: '',
              saleUntOption: [],
              isEdit: 0,
              medcWayType: false,
              pacPrice: 0,
              minPrice: 0,
              drugPrice: 0,
              antcLv: null,
              dmCode: null,
              adviceId: 0,
            };

            const newRow = this.getEmptyWestRowData();
            Object.assign(newRow, JSON.parse(JSON.stringify(drugData)));
            newRow.id = Date.now() + Math.random();

            if (item.unitId) {
              newRow.saleUnt = item.unitId;
              newRow.saleUntOption = [{ id: item.unitId, label: item.unitName || '单位' }];
            }
            if (item.routeId) newRow.medcWayId = item.routeId;
            if (item.frequencyId) newRow.usedfrquId = item.frequencyId;

            this.westMedicineTableData.push(newRow);
          }

          // ===== 中药 =====
          if (itemType === 2) {
            const drugData = {
              _orderId: prescription.id,
              _orderVersion: prescription.version,
              _orderItemId: item.id,
              _orderNo: prescription.orderNo,
              _tcm: prescription.tcm,
              _diagnosisCode: prescription.diagnosisCode || '',
              _diagnosisName: prescription.diagnosisName || '',
              _orderRemark: prescription.remark || '',
              drugId: item.itemId,
              drugName: item.itemName,
              pacSpec: item.specification || '',
              minDose: item.singleDose || 0,
              sdoseCnt: item.singleDose || 0,
              usedfrquId: item.frequencyId || null,
              saleUnt: item.unitId || 1,
              prdDays: item.periodDays || 1,
              prdCnt: item.periodCount || 1,
              cnt: item.quantity || 0,
              saleAmt: item.totalAmount || 0,
              unitPrice: item.unitPrice || 0,
              medcWayId: item.routeId || null,
              selfProe: item.selfProvided || 0,
              skintstDicm: item.skinTestRequired || 0,
              remarks: item.remark || '',
              speed: item.infusionSpeed || '',
              roundUnt: 1,
              purcType: 1,
              rxType: this.addWesternForm.rxType || 1,
              prodentpId: null,
              dosUnt: '',
              medicineType: 2,
              saleUntName: '',
              saleUntOption: [],
              isEdit: 0,
              medcWayType: false,
              pacPrice: 0,
              minPrice: 0,
              drugPrice: 0,
              antcLv: null,
              dmCode: null,
              adviceId: 0,
            };

            const newRow = this.getEmptyChinaRowData();
            Object.assign(newRow, JSON.parse(JSON.stringify(drugData)));
            newRow.id = Date.now() + Math.random();

            if (item.unitId) {
              newRow.saleUnt = item.unitId;
              newRow.saleUntOption = [{ id: item.unitId, label: item.unitName || '单位' }];
            }
            if (item.routeId) newRow.medcWayId = item.routeId;
            if (item.frequencyId) newRow.usedfrquId = item.frequencyId;

            this.chinaMedicineTableData.push(newRow);
          }

          // ===== 处置 =====
          if (itemType === 4) {
            const disposeData = {
              _orderId: prescription.id,
              _orderVersion: prescription.version,
              _orderItemId: item.id,
              _orderNo: prescription.orderNo,
              _diagnosisCode: prescription.diagnosisCode || '',
              _diagnosisName: prescription.diagnosisName || '',
              _orderRemark: prescription.remark || '',
              costid: item.itemId,
              costname: item.itemName,
              odcost: item.unitPrice || 0,
              deptName: null,
              executId: null,
              exeFrquId: item.frequencyId || null,
              prdDays: item.periodDays || 1,
              frquCnt: item.quantity || 1,
              executeOdcost: (item.quantity || 1) * (item.unitPrice || 0),
              depexecutetype: 0,
              executemode: 0,
              costmode: 0,
              remark: item.remark || '',
              isEdit: 0,
              adviceId: 0,
              doctorName: '',
              _searchResults: [],
              _searchLoading: false,
              _searchKeyword: '',
            };

            const newRow = this.getEmptyDisposeRowData();
            Object.assign(newRow, JSON.parse(JSON.stringify(disposeData)));
            newRow.id = Date.now() + Math.random();

            disposeDataRows.push(newRow);
          }
        });

        // ===== 处置：赋值数据行，再添加空行 =====
        if (isDispose) {
          this.doctordisposeTableData = disposeDataRows;
          if (this.doctordisposeTableData.length > 0) {
            this.addNewDisposeRow();
          }
        }

        // ===== 如果是中药，计算汇总 =====
        if (isChina) {
          this.getChinaTotalSum();
        }

        // ===== 新增空行（西药/中药） =====
        if (isWest) {
          this.addNewWestRow();
          this.$nextTick(() => {
            this.renderGroupFlags();
          });
        } else if (isChina) {
          this.addNewChinaRow();
        }

        // 如果编辑的是中药，同时设置 tcm 扩展数据
        if (isChina && prescription.tcm) {
          this.addChinaForm.tcmCnt = prescription.tcm.doseCount || 1;
          this.addChinaForm.decoctionType = prescription.tcm.decoctionType || 0;
          this.addChinaForm.decoctionVolume = prescription.tcm.decoctionVolume || 0;
          this.addChinaForm.doseVolume = prescription.tcm.doseVolume || 0;
          this.addChinaForm.usedfrquId = prescription.tcm.frequencyId || null;
          this.addChinaForm.medcWayId = prescription.tcm.routeId || null;
          this.addChinaForm.tcmWayId = prescription.tcm.tcmWayId || null;
        }

        this.$message.success('已加载处方数据，可修改后重新提交');
      },      getTotalUnpaidAmount() {
        if (!this.prescriptionList || this.prescriptionList.length === 0) {
          return '0.00';
        }
        // 过滤出未收费的处方（chargeStatus === 0 且状态为已提交）
        const unpaidList = this.prescriptionList.filter(item => {
          return item.status === 1 && item.chargeStatus === 0;
        });
        const total = unpaidList.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
        return total.toFixed(2);
      },
      // 根据 itemType 过滤列
      getFilteredTableRows13(itemType) {
        // ===== 处置项目（itemType === 4） =====
        if (itemType === 4) {
          return this.tableRows13.filter(col => {
            // 处置只展示：药品名称、天数、数量、单位、单价、金额
            const includeProps = ['itemName', 'periodDays', 'quantity', 'unitName', 'unitPrice', 'totalAmount'];
            return includeProps.includes(col.prop);
          });
        }

        // 如果是中药（itemType === 2），过滤掉不需要的列
        if (itemType === 2) {
          return this.tableRows13.filter(col => {
            const excludeProps = ['specification', 'doseUnit', 'frequencyId', 'periodDays', 'periodCount', 'routeId'];
            if (excludeProps.includes(col.prop)) {
              return false;
            }
            if (col.showCondition) {
              return col.showCondition({ itemType: itemType });
            }
            return true;
          });
        }

        // 西药不展示 doseCount
        if (itemType === 1) {
          return this.tableRows13.filter(col => {
            if (col.prop === 'doseCount') {
              return false;
            }
            if (col.showCondition) {
              return col.showCondition({ itemType: itemType });
            }
            return true;
          });
        }

        // 其他类型正常显示
        return this.tableRows13.filter(col => {
          if (col.showCondition) {
            return col.showCondition({ itemType: itemType });
          }
          return true;
        });
      },
      async getOrdersByPatientId() {
        if (!this.patientChooseForm.seeDoctorId || !this.patientChooseForm.id) {
          this.prescriptionList = [];
          return;
        }
        console.log('=== getOrdersByPatientId 被调用 ===');
        console.log('this.patientChooseForm.seeDoctorId:', this.patientChooseForm.seeDoctorId);
        console.log('this.patientChooseForm.patientId:', this.patientChooseForm.patientId);
        console.log('this.patientChooseForm.id:', this.patientChooseForm.id);
        try {
          const res = await getOrdersByPatientId({
            visitId: this.patientChooseForm.seeDoctorId,
            patientId: this.patientChooseForm.patientId
          });
          console.log(res, '处方列表数据');

          if (res.code === 200) {
            this.prescriptionList = (res.data || []).map(order => {
              // 如果是中药（有tcm），把tcm.doseCount赋值给每个item
              if (order.tcm && order.tcm.doseCount) {
                order.items = (order.items || []).map(item => ({
                  ...item,
                  doseCount: order.tcm.doseCount
                }));
              }
              return order;
            });
          } else {
            this.prescriptionList = [];
          }
        } catch (error) {
          console.error('获取处方列表失败:', error);
          this.prescriptionList = [];
        }
      },

// 计算有药品名称的行数
      // 判断是否可以移除：表格总行数大于2 或者 有数据的行数大于1
      canRemove() {
        const dataRows = this.westMedicineTableData.filter(row => row.drugName && row.drugName.trim() !== '').length;
        const totalRows = this.westMedicineTableData.length;
        // 有数据的行大于1 或者 总行数大于等于2（说明有额外的空行可以移除）
        return dataRows > 1 || totalRows >= 2;
      },
      handleSelectEnter(rowIndex, prop, row) {
        // 检查下拉框是否已经展开
        const selectRef = this.$refs[`${this.getFieldRefName(prop)}Select_${rowIndex}`];
        const select = Array.isArray(selectRef) ? selectRef[0] : selectRef;

        if (!select) {
          this.focusNext(rowIndex, prop);
          return;
        }

        // 获取下拉框的 DOM 元素
        const selectDom = select.$el || select;
        const input = selectDom.querySelector('input');

        // 检查下拉框是否已展开（通过 aria-expanded 或类名判断）
        const isExpanded = selectDom.querySelector('.el-select-dropdown')?.style?.display !== 'none';

        // 如果下拉框未展开，正常触发回车（展开下拉）
        if (!isExpanded) {
          // 让 select 自己处理回车（展开下拉）
          return;
        }

        // 如果下拉框已展开，阻止默认行为，执行跳转
        event.preventDefault();
        event.stopPropagation();
        this.focusNext(rowIndex, prop);
      },
      async searchDrugsForRow(row, query) {
        if (!query || query.trim() === '') {
          this.$set(row, '_searchResults', []);
          this.$set(row, '_searchKeyword', '');
          this.$set(row, '_popoverVisible', false);
          this.searchTriggered = false;
          return;
        }

        const keyword = query.trim();
        this.$set(row, '_searchKeyword', keyword);
        this.$set(row, '_searchLoading', true);
        this.searchTriggered = false;

        clearTimeout(this.drugSearchTimer);
        this.drugSearchTimer = setTimeout(async () => {
          try {
            if (!this.preVerificationUserInfo()) {
              this.$set(row, '_searchLoading', false);
              return;
            }
            this.searchTriggered = false;
            this.medicineSearchQuery = keyword;

            if (this.DropDownedName === '西药医嘱') {
              const res = await getDrugByCondition({
                drugType: 1,
                condition: keyword,
              });
              this.queryWestMedicineData = (res.data?.map(item => ({
                ...item,
                dugPurcId: item.id,
                expyDate: item.expyDate ? new Date(item.expyDate).toLocaleString().replace(/\//g, '-') : null,
                manuDate: item.manuDate ? new Date(item.manuDate).toLocaleString().replace(/\//g, '-') : null
              }))?.map(({ id, ...rest }) => rest) || []);
              this.tableMedicineKey++;
              this.$set(row, '_searchResults', [...this.queryWestMedicineData]);

              // ===== 有结果自动打开弹窗 =====
              if (this.queryWestMedicineData.length > 0) {
                this.$set(row, '_popoverVisible', true);
              }
            }
          } catch (error) {
            console.error('搜索失败:', error);
            this.$set(row, '_searchResults', []);
          } finally {
            this.$set(row, '_searchLoading', false);
          }
        }, this.searchDebounceTime || 300);
      },

// 选择药品 - 完全照搬 handleSelWestTableRowClick
      async handleSelectDrugFromPopover(row, drugData) {
        // 关闭弹窗
        this.$set(row, '_popoverVisible', false);

        // ===== 照搬 handleSelWestTableRowClick 的所有校验逻辑 =====
        if (this.westMedicineTableData.some(item => item.drugId === drugData.drugId && item !== row)) {
          try {
            await this.$confirm(`药品序号:${drugData.drugId} 药名:${drugData.drugName} 已存在，是否继续添加？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } catch (error) {
            return;
          }
        }

        if (drugData.antcLv !== null && this.userPermission.antibioticAuthorization < drugData.antcLv) {
          this.$message.warning("员工抗生素权限不足");
          return;
        }

        const permissionMap = {
          2: { field: 'anesthesiaAuthorization', message: "员工麻药类药物权限不足", valid: val => parseInt(val) === 1 },
          3: { field: 'poisonPermission', message: "员工毒麻类药物权限不足", valid: val => parseInt(val) === 1 },
          4: { field: 'spiritPermission', message: "员工精神I类药物权限不足", valid: val => parseInt(val) === 1 },
          5: { field: 'spiritPermission', message: "员工精神II类药物权限不足", valid: val => parseInt(val) === 1 || parseInt(val) === 2 },
        };

        const aiseName = this.aiseListOptions.find(item => item.id === this.patientForm.aiseId)?.label;
        if (aiseName && aiseName.trim() !== '') {
          const keywords = aiseName.split(/[,，、\s]+/).filter(keyword => keyword.trim() !== '');
          let matchedKeyword = '';
          for (const keyword of keywords) {
            if (drugData.drugName.includes(keyword.trim())) {
              matchedKeyword = keyword;
              break;
            }
          }
          if (matchedKeyword) {
            try {
              await this.$confirm(`药品 "${drugData.drugName}" 包含过敏原 "${matchedKeyword}"，请确认是否继续使用？`, '过敏警告', {
                confirmButtonText: '继续使用',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass: 'el-button--warning'
              });
            } catch (error) {
              this.$message({ type: 'info', message: '已取消使用该药品' });
              return;
            }
          }
        }

        const permissionCheck = permissionMap[drugData.dmCode];
        if (permissionCheck && !permissionCheck.valid(this.userPermission[permissionCheck.field])) {
          this.$message.warning(permissionCheck.message);
          return;
        }

        const shouldContinue = await this.checkDiseaseAndConfirm(this.addSeedoctorForm, drugData);
        if (!shouldContinue) return;

        if (drugData.skintstDicm === 1) {
          this.isSkinTestDoseDialog = true;
          this.westernMedicineSearchQuery = JSON.parse(JSON.stringify({
            id: drugData.drugId,
            drugName: drugData.drugName
          }));
          return;
        }

        // ===== 照搬 handleSelWestTableRowClick 的填充逻辑 =====
        drugData.roundUnt = parseInt(drugData.roundUnt);
        drugData.prdDays = 1;
        drugData.prdCnt = 1;
        drugData.sdoseCnt = drugData.minDose;
        drugData.purcType = parseInt(drugData.purcType);
        drugData.rxType = this.addWesternForm.rxType;
        drugData.prodentpId = drugData.prodentpNameId;
        drugData.unt = drugData.dosUnt;
        drugData.medicineType = 1;
        drugData.saleAmt = null;
        drugData.saleUntName = drugData.saleUnt === 1 ? drugData.minUnt : drugData.pacUnt;
        drugData.saleUnt = drugData.saleUnt === 1 ? drugData.minUntId : drugData.pacUntId;
        drugData.saleUntOption = [
          { id: drugData.minUntId, label: drugData.minUnt },
          { id: drugData.pacUntId, label: drugData.pacUnt }
        ];
        drugData.isEdit = drugData.isFixPrice === 1 ? 1 : 0;
        drugData.medcWayType = drugData.medcWayId != null ?
            this.medicationWayOptions.find(item => item.id === drugData.medcWayId)?.type === 2 :
            drugData.medcWayType;

        // ===== 把 drugData 的所有字段复制到 row =====
        Object.assign(row, JSON.parse(JSON.stringify(drugData)));

        // ===== 给 row 补充唯一 id =====
        row.id = Date.now() + Math.random();

        // ===== 清空搜索状态 =====
        this.$set(row, '_searchResults', []);
        this.$set(row, '_searchKeyword', '');

        // ===== 触发计算 =====
        this.getWestSdoseSum(row);

        // ===== 只有当前行是最后一行时才新增空行 =====
        const tableData = this.westMedicineTableData;
        const currentIndex = tableData.indexOf(row);
        if (currentIndex === tableData.length - 1) {
          this.addNewWestRow();
        }

        this.$nextTick(() => {
          this.focusField(currentIndex, 'sdoseCnt');
        });
      },

// 初始化行的搜索状态
      initRowSearch(row) {
        if (!row._popoverVisible) {
          this.$set(row, '_popoverVisible', false);
        }
        if (!row._searchResults) {
          this.$set(row, '_searchResults', []);
        }
        if (!row._searchLoading) {
          this.$set(row, '_searchLoading', false);
        }
        if (!row._searchKeyword) {
          this.$set(row, '_searchKeyword', '');
        }
      },

// 药品名称列回车 - 有结果选第一个，没结果打开弹窗
      handleDrugNameEnter(rowIndex) {
        if (this.isProcessingEnter) return;
        this.isProcessingEnter = true;

        const row = this.westMedicineTableData[rowIndex];
        // 如果有搜索结果且没选药品，选第一个
        if (row._searchResults && row._searchResults.length > 0 && !row.drugName) {
          this.handleSelectDrugFromPopover(row, row._searchResults[0]);
        } else if (row.drugName) {
          // 已有药品，跳到下一个输入框
          this.focusNext(rowIndex, 'drugName');
        } else {
          // 没结果，打开弹窗
          this.$set(row, '_popoverVisible', true);
        }

        setTimeout(() => {
          this.isProcessingEnter = false;
        }, 200);
      },

// 行管理
      getEmptyWestRowData() {
        return {
          id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
          drugName: '',
          drugId: '',
          pacSpec: '',
          manufacturer: '',
          sdoseCnt: '',
          usedfrquId: '',
          saleUnt: '',
          prdDays: 1,
          cnt: '',
          saleAmt: null,
          medcWayId: '',
          dosaUnt: '',
          prdCnt: 1,
          remarks: '',
          speed: '',
          pacPrice: 0,
          minPrice: 0,
          drugPrice: 0,
          manualPric: 0,
          roundUnt: '',
          purcType: '',
          rxType: '',
          prodentpId: '',
          unt: '',
          medicineType: 1,
          saleUntName: '',
          saleUntOption: [],
          isEdit: 0,
          medcWayType: false,
          skintstDicm: 0,
          antcLv: null,
          dmCode: null,
          adviceId: 0,
          _isFrquDisabled: false,
          _isMedcWayDisabled: false,
          _popoverVisible: false,
          _searchResults: [],
          _searchLoading: false,
          _searchKeyword: '',
        };
      },

      addNewWestRow() {
        this.westMedicineTableData.push(this.getEmptyWestRowData());
      },

      initWestMedicineTable() {
        // 只有选择了患者才初始化空行
        if (this.patientForm.patId && this.westMedicineTableData.length === 0) {
          this.westMedicineTableData.push(this.getEmptyWestRowData());
        }
      },

// 移除行
      removeWestMedicineTableData(index) {
        if (this.isShowPrescription) return;
        const row = this.westMedicineTableData[index];
        if (row.adviceId > 0) {
          this.$message.warning('已提交的医嘱不能删除');
          return;
        }
        this.westMedicineTableData.splice(index, 1);
        const hasData = this.westMedicineTableData.some(r => r.drugName);
        if (!hasData) {
          this.westMedicineTableData = [this.getEmptyWestRowData()];
        }
      },

// 回车跳转
      focusNext(rowIndex, currentProp) {
        console.log('===== focusNext 被调用 =====');
        console.log('rowIndex:', rowIndex, 'currentProp:', currentProp);

        if (this.isProcessingEnter) return;
        this.isProcessingEnter = true;

        const tableData = this.westMedicineTableData;
        const row = tableData[rowIndex];
        if (!row) {
          console.log('row 不存在');
          this.isProcessingEnter = false;
          return;
        }

        let editableProps = ['drugName', 'sdoseCnt', 'usedfrquId', 'prdDays', 'saleUnt', 'medcWayId'];

        if (row.medcWayType === 2) {
          const index = editableProps.indexOf('medcWayId');
          if (index !== -1) {
            editableProps.splice(index + 1, 0, 'speed');
          }
        }

        editableProps.push('remark');
        console.log('editableProps:', editableProps);

        const currentIndex = editableProps.indexOf(currentProp);
        console.log('currentIndex:', currentIndex);

        if (currentIndex === -1) {
          this.isProcessingEnter = false;
          return;
        }

        if (currentIndex + 1 < editableProps.length) {
          const nextProp = editableProps[currentIndex + 1];
          console.log('跳到当前行下一个字段:', nextProp);
          this.focusField(rowIndex, nextProp);
          this.isProcessingEnter = false;
          return;
        }

        // ===== 当前行是最后一个字段，跳到下一行 =====
        const nextRowIndex = rowIndex + 1;
        console.log('当前行是最后一个字段，跳到下一行, nextRowIndex:', nextRowIndex);

        if (nextRowIndex >= tableData.length) {
          console.log('下一行不存在，新增一行');
          this.addNewWestRow();
        }

        this.$nextTick(() => {
          const newTableData = this.westMedicineTableData;
          console.log('newTableData.length:', newTableData.length);
          console.log('nextRowIndex:', nextRowIndex);
          if (nextRowIndex < newTableData.length) {
            console.log('聚焦到下一行 drugName');
            this.focusField(nextRowIndex, 'drugName');
          } else {
            console.log('下一行仍然不存在');
          }
        });

        setTimeout(() => {
          this.isProcessingEnter = false;
        }, 200);
      },      // 中药回车跳转
      focusNextChina(rowIndex, currentProp) {
        console.log('>>>>>> focusNextChina 被触发了！', rowIndex, currentProp);
        if (this.isProcessingEnter) return;
        this.isProcessingEnter = true;

        const row = this.chinaMedicineTableData[rowIndex];
        if (!row) {
          this.isProcessingEnter = false;
          return;
        }

        // 中药可编辑字段顺序（只有两个）
        const editableProps = ['sdoseCnt', 'remark'];

        const currentIndex = editableProps.indexOf(currentProp);
        if (currentIndex === -1) {
          this.isProcessingEnter = false;
          return;
        }

        // 找下一个有值的字段
        for (let i = currentIndex + 1; i < editableProps.length; i++) {
          const prop = editableProps[i];
          const value = row[prop];
          const hasValue = value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0);
          if (hasValue) {
            this.focusFieldChina(rowIndex, prop);
            this.isProcessingEnter = false;
            return;
          }
        }

        // 当前行后面没有有值的字段，跳到下一行的药品名称
        const nextRowIndex = rowIndex + 1;
        if (nextRowIndex >= this.chinaMedicineTableData.length) {
          this.addNewChinaRow();
        }

        this.$nextTick(() => {
          this.focusFieldChina(nextRowIndex, 'drugName');
        });

        setTimeout(() => {
          this.isProcessingEnter = false;
        }, 200);
      },

// 中药聚焦字段
      focusFieldChina(rowIndex, prop) {
        const refMap = {
          'sdoseCnt': `sdoseCntInput_${rowIndex}`,
          'remark': `remarksInput_${rowIndex}`,
          'drugName': `drugNameInput_${rowIndex}`,
        };

        const refName = refMap[prop];
        if (!refName) return;

        this.$nextTick(() => {
          const ref = this.$refs[refName];
          if (ref) {
            const el = Array.isArray(ref) ? ref[0] : ref;
            if (el) {
              if (typeof el.focus === 'function') {
                el.focus();
              } else if (el.$el) {
                const input = el.$el.querySelector('input') || el.$el.querySelector('textarea');
                if (input) input.focus();
              }
            }
          }
        });
      },
      focusField(rowIndex, prop) {
        console.log('focusField 被调用, prop:', prop, 'rowIndex:', rowIndex);

        this.$nextTick(() => {
          // 根据 prop 直接构造 ref 名称
          let refName = '';
          if (prop === 'drugName') {
            refName = `drugNameInput_${rowIndex}`;
          } else if (prop === 'sdoseCnt') {
            refName = `sdoseCntInput_${rowIndex}`;
          } else if (prop === 'usedfrquId') {
            refName = `usedfrquIdSelect_${rowIndex}`;
          } else if (prop === 'prdDays') {
            refName = `prdDaysInput_${rowIndex}`;
          } else if (prop === 'saleUnt') {
            refName = `saleUntSelect_${rowIndex}`;
          } else if (prop === 'medcWayId') {
            refName = `medcWayIdSelect_${rowIndex}`;
          } else if (prop === 'speed') {
            refName = `speedInput_${rowIndex}`;
          } else if (prop === 'remark') {
            refName = `remarksInput_${rowIndex}`;
          }

          if (!refName) {
            console.log('未找到对应的 ref, prop:', prop);
            return;
          }

          console.log('查找 ref:', refName);
          const ref = this.$refs[refName];
          console.log('找到的 ref:', ref);

          if (ref) {
            const el = Array.isArray(ref) ? ref[0] : ref;
            if (el) {
              if (typeof el.focus === 'function') {
                el.focus();
              } else if (el.$el) {
                const input = el.$el.querySelector('input') || el.$el.querySelector('textarea');
                if (input) input.focus();
              }
            }
          } else {
            console.log('未找到 ref:', refName);
            console.log('当前 this.$refs 所有 keys:', Object.keys(this.$refs));
          }
        });
      },

      doFocus(el) {
        try {
          if (typeof el.focus === 'function') {
            el.focus();
            if (el.select && typeof el.select === 'function') {
              el.select();
            }
          } else if (el.$el) {
            const input = el.$el.querySelector('input') || el.$el.querySelector('textarea');
            if (input) {
              input.focus();
              if (input.select) input.select();
            }
          }
        } catch (e) {}
      },

      getFieldRefName(prop) {
        const map = {
          'drugName': 'drugName',      // 药品名称（触发输入框）
          'sdoseCnt': 'sdoseCnt',      // 剂量
          'usedfrquId': 'usedfrquId',  // 频率
          'prdDays': 'prdDays',        // 天数
          'saleUnt': 'saleUnt',        // 单位
          'medcWayId': 'medcWayId',    // 用法
        };
        return map[prop] || null;
      },
        // ============================================
        // 生命周期
        // ===========================================
      debounceSaveCache() {
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => {
          if (this.patientChooseForm?.seeDoctorId) {
            const data = {
              west: JSON.stringify(this.westMedicineTableData),
              china: JSON.stringify(this.chinaMedicineTableData)
            };
            addMedicineCache({
              seeDoctorId: this.patientChooseForm.seeDoctorId,
              data: JSON.stringify(data)
            }).catch(err => console.warn('缓存保存失败', err));
          }
        }, 1000);
      },
      openFollowDialog() {
        // 打开前设置要填充的数据
        this.defaultFollowData = {
          patientId: this.patientForm.id,      // 当前患者ID
          patientName: this.patientForm.name,  // 患者名称（如果需要显示）
          seeId: this.patientChooseForm.seeDoctorId,               // 当前就诊ID
          exeId: this.userInfo.staffId,       // 当前登录用户ID作为执行人
          type: 1,                                 // 默认随访类型
          num: 3,                                  // 默认执行次数
          intervalDay: 7                           // 默认间隔天数
        };
        this.showFollowDialog = true;
      },
      handleFollowSuccess() {
        // 如果需要刷新列表，在这里调用
        // this.loadData();
        this.showFollowDialog = false;
      },
			handleSaveIfValid() {
				// 只有患者ID不为null时才保存
				if (this.patientForm.id != null) {
					this.handlePatientFormChange();
				}
			},
			async printDisposalProject() {
				const DisposalProjectData = await this.planDisposalProjectData();
				printUtil.init(disposalProject);
				printUtil.print(DisposalProjectData);
			},

			async planDisposalProjectData(data) {
				const clinicData = await doccliniclist();
				const clinic = clinicData.data.map(item => ({
					id: item.id,
					label: item.name
				}));

				// 格式化处置项目数据
				const formatDisposalProjects = (projects) => {
					if (!projects || !Array.isArray(projects)) {
						return [];
					}

					return projects.map(project => {
						return {
							costname: project.costName || project.costname || '', // 项目名称
							unit: '次', // 固定单位"次"
							num: project.num || project.cnt || 1, // 数量
							executDeptName: this.deptOptions.find(item => item.id === project.executDeptId)
								?.label || '默认科室', // 写死为"默认科室"
							executionAmount: (project.executionAmount || project.amount || 0).toFixed(
								2) // 金额，保留两位小数
						};
					});
				};

				// 生成处置项目HTML - 根据图片调整位置和样式
				const generateDisposalHtml = (projects) => {
					if (!projects || projects.length === 0) {
						// 返回一个空表格
						return `
							                <div style="position: absolute; left: 28.5px; top: 238px; width: 110px; font-size: 14px; font-family: '仿宋'; color: #999; text-align: center;">
							                  暂无处置项目
							                </div>
							              `;
					}

					// 根据模板的列宽度和位置进行调整
					// 模板中的列位置（根据坐标计算）：
					// 检查项目列：left=28.5px, width≈110px
					// 单位列：left=145.5px, width=45px
					// 数量列：left=204px, width=40.5px
					// 执行科室列：left=259.5px, width=78px
					// 金额列：left=355.5px, width=55.5px

					let html = '';

					projects.forEach((project, index) => {
						// 增加行间距，每行30px（原22px），让行之间更有空隙
						const top = (index * 50); // 行间距增加到30px

						// 生成每一行的HTML - 调整样式确保自动换行
						html += `
							            <!-- 检查项目 - 增加自动换行，设置最大高度 -->
							            <div style="position: absolute; left: -10px; top: ${top}px; width: 200px; min-height: 20px; font-size: 14px; font-family: '仿宋'; line-height: 1.4; word-wrap: break-word; word-break: break-all; white-space: normal; overflow-wrap: break-word;">
							              ${project.costname}
							            </div>

							            <!-- 单位 - 垂直居中对齐 -->
							            <div style="position: absolute; left: 145.5px; top: ${top}px; width: 45px; height: 20px; font-size: 14px; font-family: '仿宋'; line-height: 20px; text-align: center; display: flex; align-items: center; justify-content: center;">
							              ${project.unit}
							            </div>

							            <!-- 数量 - 垂直居中对齐 -->
							            <div style="position: absolute; left: 230px; top: ${top}px; width: 40.5px; height: 20px; font-size: 14px; font-family: '仿宋'; line-height: 20px; text-align: center; display: flex; align-items: center; justify-content: center;">
							              ${project.num}
							            </div>

							            <!-- 执行科室 - 增加自动换行 -->
							            <div style="position: absolute; left: 300px; top: ${top}px; width: 78px; min-height: 20px; font-size: 14px; font-family: '仿宋'; line-height: 1.4; text-align: center; word-wrap: break-word; word-break: break-all; white-space: normal; display: flex; align-items: center; justify-content: center; flex-direction: column;">
							              ${project.executDeptName}
							            </div>

							            <!-- 金额 - 垂直居中右对齐 -->
							            <div style="position: absolute; left: 420px; top: ${top}px; width: 55.5px; height: 20px; font-size: 14px; font-family: '仿宋'; line-height: 20px; text-align: right; padding-right: 4px; display: flex; align-items: center; justify-content: flex-end;">
							              ${project.executionAmount}
							            </div>
							          `;
					});

					return html;
				};

				// 处理数据
				const disposalProjects = formatDisposalProjects(this.disposalProject || []);
				const disposalHtml = generateDisposalHtml(disposalProjects);

				// 计算处置项目总金额
				const disposalTotalAmount = disposalProjects.reduce((sum, project) => {
					return sum + (parseFloat(project.executionAmount) || 0);
				}, 0);

				// 计算处方总金额
				const prescriptionAmount = (this.patientPrescription || []).reduce((sum, item) => {
					return sum + (item.saleAmt || 0);
				}, 0);

				// 计算总金额
				const totalAmount = prescriptionAmount + disposalTotalAmount;

				// 返回数据，确保字段名与打印模板中的field完全匹配
				return {
					// 基础信息
					clinicPrescriptionName: (clinic.find(item => item.id === this.userInfo.clinicId)?.label || '') +
						'处方笺',
					isGrowUp: this.patientForm.ageYear >= 18 ? '成人' : '未成年',
					patId: this.patientForm.patId || '00000101',
					prhCostType: this.prhCostOption.find(item => item.id === this.patientForm.prhCostType)?.label ||
						'',
					code: '', // 编号
					seedoctorId: this.patientChooseForm.seeDoctorId || '334',
					name: this.patientForm.name,
					age: this.patientForm.ageYear,
					sex: this.sexOptions.find(item => item.id === parseInt(this.patientForm.sex))?.label || '男',
					dept: this.deptOptions.find(item => item.id === this.userInfo.selDept)?.label,
					date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
					address: (this.conerPleasett || '') + (this.patientForm.conerAddName || ''),
					westernDiagnos: this.addSeedoctorForm.westernDiagnos || '(胃肠炎和结肠炎)',
					remake: this.westernMedicineForm.remark || '',

					// 关键：处置项目HTML
					disposalProjects: disposalHtml,

					// 底部信息
					doctor: this.userInfo.staffName || '张来福',
					prescriptionAmount: totalAmount.toFixed(2),
					phayId: this.westPhayOption[0]?.label || '西药房',

					// 调试信息
					_disposalCount: disposalProjects.length,
					_disposalTotal: disposalTotalAmount.toFixed(2)
				};
			},


			async handleGetDisposalProject(row = null) {
				if (row.orderType !== undefined) {
					this.doctorAdviceRowData = JSON.parse(JSON.stringify(row));
				}
				// 检查 doctorAdviceRowData 是否为 null
				if (this.doctorAdviceRowData === null && this.multipleActiveSelection.length <= 0) {
					this.$message.warning("请在下方医嘱勾选或单击医嘱进行选中打印");
					return;
				}
				console.log(row, 'rowrowrow')
				const res = await getPatientAllData({
					id: row.seeDoctor
				});

				if (res.code === 200) {
					this.disposalProject = res.data.cncDoctorDisposeRespVOList.filter(item => item.chargeStatus === 1);
					console.log(this.disposalProject, 'this.disposalProjectthis.disposalProject')
					if (this.disposalProject.length === 0) {
						this.$message.warning("当前医嘱内的处理项目都未缴费无法打印");
						return;
					}
					await this.printDisposalProject();
				} else {
					this.$message.error(res.message);
				}
			},
			toggleLeftSidebar() {
				this.leftSidebarCollapsed = !this.leftSidebarCollapsed
			},

      async handleSaveTemplate() {
        if (!this.drugTemplateForm.name) {
          this.$message.warning('请输入模板名称');
          return;
        }
        const { westDrugs, chinaDrugs, name, id, state } = this.drugTemplateForm;
        if (westDrugs.length === 0 && chinaDrugs.length === 0) {
          this.$message.warning('请至少添加一种药品');
          return;
        }
        // 不允许同时包含西药和中药（保持单类型）
        if (westDrugs.length > 0 && chinaDrugs.length > 0) {
          this.$message.warning('当前仅支持分别保存西药或中药模板，请分别创建');
          return;
        }

        const type = westDrugs.length > 0 ? 1 : 2;
        const content = westDrugs.length > 0 ? westDrugs : chinaDrugs;

        try {
          let res;
          // 判断是否为编辑模式（有 id）
          if (id) {
            // 编辑模式：保留原 state
            const params = {
              id: id,
              name: name,
              content: JSON.stringify(content),
              type: type,
              state: state  // 保持原状态不变
            };
            res = await editDrugtemplate(params);
          } else {
            // 新增模式：默认 state=1（启用）
            const params = {
              name: name,
              content: JSON.stringify(content),
              type: type,
              state: 1  // 新增默认启用
            };
            res = await addDrugtemplate(params);
          }

          if (res.code === 200) {
            this.$message.success(id ? '修改成功' : '创建成功');
            this.templateDialogVisible = false;
            await this.handleOpenSelChinaWestTemplate(); // 刷新列表
          } else {
            this.$message.error(res.message || '操作失败');
          }
        } catch (error) {
          this.$message.error('操作异常');
        }
      },
      async handleOpenSelChinaWestTemplate() {
        if (this.patientForm.name === '') {
          this.$message.warning("请先选择患者进行操作!");
          return;
        }
        try {
          // 同时获取西药和中药模板
          const [westRes, chinaRes] = await Promise.all([
            getDrugTemplateList({ state: 1, type: 1 }),
            getDrugTemplateList({ state: 1, type: 2 })
          ]);
          if (westRes.code === 200) {
            this.westTemplateList = westRes.data || [];
          } else {
            this.$message.error(`获取西药模板失败: ${westRes.message}`);
          }
          if (chinaRes.code === 200) {
            this.chinaTemplateList = chinaRes.data || [];
          } else {
            this.$message.error(`获取中药模板失败: ${chinaRes.message}`);
          }
          this.selChinaWestVisible = true;
        } catch (error) {
          this.$message.error('获取模板列表异常');
        }
      },
      parseContent(content) {
				try {
					if (typeof content === 'string') {
						return JSON.parse(content);
					} else if (Array.isArray(content)) {
						return content;
					}
					return [];
				} catch (error) {
					console.error('解析药品内容失败:', error);
					return [];
				}
			},
      handleEditTemplate(template) {
        const type = template.type;
        this.drugTemplateForm = {
          id: template.id,
          name: template.name,
          state: template.state,  // 保存原始状态
          westDrugs: type === 1 ? JSON.parse(template.content) : [],
          chinaDrugs: type === 2 ? JSON.parse(template.content) : []
        };
        this.currentTemplateType = type;
        this.templateDialogVisible = true;
      },

      // 引用模板，type 1西药 2中药
      handleQuoteTemplate(template, type) {
        // 解析 content
        const drugList = this.parseContent(template.content);
        if (!drugList || drugList.length === 0) {
          this.$message.warning('模板内容为空');
          return;
        }
        // 根据类型赋值
        if (type === 1) {
          this.westMedicineTableData = drugList.map(item => ({ ...item, _popoverVisible: false, _searchResults: [], _searchLoading: false }));
          this.$message.success('西药模板引用成功');
        } else {
          this.chinaMedicineTableData = drugList.map(item => ({ ...item, _popoverVisible: false, _searchResults: [], _searchLoading: false }));
          this.$message.success('中药模板引用成功');
        }
        this.selChinaWestVisible = false;
      },
			async handleEditTemplateState(data) {
				try {
					const action = data.state === 1 ? '禁用' : '启用';
					const confirmMessage = `确定要${action}「${data.name}」这个模板吗？`;

					await this.$confirm(confirmMessage, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					this.templateForm = {
						...data
					};
					this.templateForm.state = this.templateForm.state === 1 ? 0 : 1;
					const res = await editDrugtemplate(this.templateForm);

					if (res.code === 200) {
						await this.handleOpenSelChinaWestTemplate();
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				} catch (error) {
					if (error !== 'cancel') {
						console.error('操作失败:', error);
					}
				}
			},

      // 打开模板弹窗（新增/编辑）
      openTemplateDialog(type = null, templateData = null) {
        if (templateData) {
          // 编辑模式
          this.drugTemplateForm = {
            id: templateData.id,          // 必须确保 templateData.id 存在且不为 null
            name: templateData.name,
            westDrugs: templateData.type === 1 ? JSON.parse(JSON.stringify(templateData.content || [])) : [],
            chinaDrugs: templateData.type === 2 ? JSON.parse(JSON.stringify(templateData.content || [])) : []
          };
          this.editingTemplateType = templateData.type;
          // 打印日志确认
          console.log('编辑模板 ID:', this.drugTemplateForm.id);
        } else {
          // 新增模式
          this.drugTemplateForm = {
            id: null,
            name: '',
            westDrugs: [],
            chinaDrugs: [],
            state: 1
          };
        }
        // ...
      },
      // zcw 检查并处理跳转过来的患者信息
			async handleRouteParams() {
				try {
					// 获取路由参数
					const routeParams = this.$route.query;

					if (Object.keys(routeParams).length === 0) {
						return; // 没有路由参数，直接返回
					}

					// 根据不同的参数类型进行处理
					let targetPatient = null;

					if (routeParams.seeDoctorId) {
						// 通过就诊ID查找
						targetPatient = this.tableData2.find(item =>
							item.id === parseInt(routeParams.seeDoctorId) ||
							item.seeDoctorId === parseInt(routeParams.seeDoctorId)
						);
					} else if (routeParams.patientId) {
						// 通过患者ID查找
						targetPatient = this.tableData2.find(item =>
							item.patientId == routeParams.patientId
						);
					} else if (routeParams.healthId) {
						// 通过健康ID查找
						targetPatient = this.tableData2.find(item =>
							item.patId === routeParams.healthId
						);
					}

					if (targetPatient) {
						console.log('找到目标患者:', targetPatient);

						// 延迟执行选择操作，确保DOM已渲染
						setTimeout(async () => {
							await this.handleClickReceptionRow(targetPatient, 1);

							// 滚动到选中的行（可选）
							this.scrollToSelectedPatient(targetPatient);

							this.$message.success(`已自动选择患者: ${targetPatient.patientName}`);
						}, 500);
					} else {
						this.$message.warning('未找到对应的患者信息，请手动选择');
					}
				} catch (error) {
					this.$message.error('自动选择患者失败，请手动操作');
				}
			},


			// 滚动到选中的患者行
			scrollToSelectedPatient(patient) {
				this.$nextTick(() => {
					const table = this.$refs.receptionTable; // 假设接诊表格的ref为receptionTable
					if (table && patient) {
						// 查找行的索引
						const index = this.tableData2.findIndex(item => item.id === patient.id);
						if (index !== -1) {
							// 滚动到对应行
							const rowElement = table.$el.querySelector(`.el-table__row:nth-child(${index + 1})`);
							if (rowElement) {
								rowElement.scrollIntoView({
									behavior: 'smooth',
									block: 'center'
								});
							}
						}
					}
				});
			},

			async handlePatientFormChange() {
				// 在这里处理 patientForm 的变化
				this.patientForm.conerAddCode =
					this.patientForm.conerAddCodeArr?.length > 0 ?
					this.patientForm.conerAddCodeArr[this.patientForm.conerAddCodeArr.length - 1] :
					'';

				await editDocphr(this.patientForm);
				const newItem = {
					id: this.patientChooseForm.seeDoctorId,
					address: this.patientForm.conerAddName,
					sex: this.patientForm.sex,
					age: this.patientForm.ageYear,
					allergen: this.patientForm.aiseId,
					bloodType: this.patientForm.bloodType,
					bloodNumber: parseInt(this.patientForm.bloodNumber),
					cardid: this.patientForm.certno,
					doctorId: this.userInfo.staffId,
					patientId: this.patientForm.id,
					patientName: this.patientForm.name,
					patientTell: this.addSeedoctorForm.patientTell,
					nowHistory: this.addSeedoctorForm.nowHistory,
					beforeHistory: this.addSeedoctorForm.beforeHistory,
					diapre: this.patientForm.diapre,
					syspre: this.patientForm.syspre,
					prhCostType: this.patientForm.prhCostType,
					pregnant: this.patientForm.pregnant ? 1 : 0
				};

				editReception(newItem);
			},

			// 关闭所有打开的下拉框
			closeAllDropdowns() {
				// 遍历所有可能的下拉框字段
				const dropdownFields = ['usedfrquId', 'medcWayId'];

				dropdownFields.forEach(field => {
					// 查找所有该字段的下拉框 ref
					const refKeys = Object.keys(this.$refs).filter(key =>
						key.startsWith(`${field}Select_`)
					);

					refKeys.forEach(refKey => {
						const dropdown = this.$refs[refKey];
						if (dropdown) {
							const target = Array.isArray(dropdown) ? dropdown[0] : dropdown;
							if (target && target.blur) {
								target.blur(); // 调用 blur 方法关闭下拉框
							}
						}
					});
				});
			},

			// 递归查找可聚焦的字段
			recursiveFocus(rowIndex, fieldName) {
				const fieldOrder = ['sdoseCnt', 'usedfrquId', 'prdDays', 'cnt', 'saleAmt', 'medcWayId'];
				const currentIndex = fieldOrder.indexOf(fieldName);

				if (currentIndex === -1) return;

				let nextRowIndex = rowIndex;
				let nextFieldIndex = currentIndex + 1;

				// 如果当前是最后一个字段，尝试下一行
				if (nextFieldIndex >= fieldOrder.length) {
					nextRowIndex++;
					nextFieldIndex = 0;

					// 检查是否超出数组范围
					if (nextRowIndex >= this.westMedicineTableData.length) {
						console.log('已经是最后一条数据了');
						return;
					}
				}

				const nextField = fieldOrder[nextFieldIndex];
				const nextRefName =
					`${nextField}${['sdoseCnt', 'prdDays', 'cnt', 'saleAmt'].includes(nextField) ? 'Input' : 'Select'}_${nextRowIndex}`;

				this.$nextTick(() => {
					const element = this.$refs[nextRefName];
					if (element) {
						const target = Array.isArray(element) ? element[0] : element;
						if (target && target.focus) {
							target.focus();
						}
					} else {
						// 继续递归查找
						this.recursiveFocus(nextRowIndex, nextField);
					}
				});
			},
			handleNoAllergies(selectedId) {
				const aise = this.aiseListOptions.find(item => item.id === selectedId)
				console.log(aise, 'aiseaiseaise')
				if (aise?.orderId === 299) {
					this.$confirm('请确认是否无过敏史？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 用户点击确定，继续执行
						this.patientForm.aiseId = selectedId;
						// 关闭下拉框
						this.$nextTick(() => {
							this.$refs.allergenSelect.blur();
						});
					}).catch(() => {
						// 用户点击取消，清空选择并停止操作
						this.patientForm.aiseId = null;
						this.$message({
							type: 'info',
							message: '已取消选择'
						});
						// 取消时也关闭下拉框
						this.$nextTick(() => {
							this.$refs.allergenSelect.blur();
						});
					});
				}
			},
			async handlePaymentComplete() {
        try {
          await this.getOrdersByPatientId();
        } catch (e) {
          console.warn('刷新处方列表失败:', e);
        }
        // 检查是否存在mzzdfy参数且值为0，或者参数不存在，都返回
        const mafxParam = this.systemParameterList.find(item => item.param === 'mafx_swich');
        if (mafxParam?.value === '1') return;
        const mzzdfyParam = this.systemParameterList.find(item => item.param === 'mzzdfy');
        if (!mzzdfyParam || mzzdfyParam.value === '0') return;

				console.log('收到支付完成通知，开始排队发药操作')
				const chinaRes = await tcmDisselectPatientInfo({
					name: this.patientForm.name,
					patientId: this.patientForm.id
				});
				if (chinaRes.data.content.length > 0) {
						console.log('=====================================')
						for (let i = 0; i < chinaRes.data.content.length; i++) {
							const item = chinaRes.data.content[i];
							item.purcAmt = Number(item.purcAmt) || 0;
							item.cnt = Number(item.cnt) || 0;

							let res = await tcmFySave({
								id: chinaRes.data.content[i].id
							});
							if (res.code === 200) {
								this.$message.success(`中药处方${i + 1}发药完成`);
							} else {
								this.$message.error(res.message + ':中药处方发药异常');
							}
						}

				}

				let westRes = await selectPatientInfo({
					name: this.patientForm.name,
					patientId: this.patientForm.id,
				});
				if (westRes.data.content.length > 0) {
					if (this.$refs.giveMediciRef && this.$refs.giveMediciRef.startQueueDispensing) {
						try {
							if (westRes.code === 200) {
								if (this.systemParameterList.find(item => item.param === 'mzzdfy')?.value === '1') {
									// 分别处理每个处方对象
									const autoDispensePromises = []; // 自动发药的处方
									const manualDispensePrescriptions = []; // 需要人工发药的处方

									westRes.data.content.forEach(item => {
										if (!item.voList || !Array.isArray(item.voList)) return;

										// 检查这个处方的 voList 中是否有需要扫追溯码的药品
										const hasRetrospect = item.voList.some(subItem => subItem.drugTracB ===
											1);

										if (hasRetrospect) {
											// 这个处方需要人工发药
											item.voList.forEach(prescription => {
												manualDispensePrescriptions.push({
													patientData: {
														id: item.id,
														patientId: this.patientForm.patientId,
														name: this.patientForm.name,
														icdName: this.patientForm.diagnosis
													},
													medicineData: [prescription]
												});
											});
										} else {
											// 这个处方可以自动发药
											const sendData = {
												id: item.id, // 外层ID
												voList: item.voList.map(prescription => ({
													id: prescription.id || prescription
														.rdDetailsId,
													drgTracCnt: Number(prescription
														.drgTracCnt) || 0,
													drgTracCode: prescription.drgTracCode ||
														'',
													drugTracB: Number(prescription
														.drugTracB) || 0,
													drugTracMaxCnt: Number(prescription
														.drugTracMaxCnt) || 0,
													drugTracMaxId: Number(prescription
														.drugTracMaxId) || 0,
													drugTracMinId: Number(prescription
														.drugTracMinId) || 0,
													cnt: Number(prescription.cnt) || 0,
													purcPric: Number(prescription.purcPric) ||
														0,
													saleAmt: Number(prescription.saleAmt) || 0,
													drugId: prescription.drugId,
													drugName: prescription.drugName,
													drugSpec: prescription.drugSpec,
													drugUnit: prescription.drugUnit
												}))
											};

											autoDispensePromises.push(fySave(sendData));
										}
									});

									// 执行自动发药
									if (autoDispensePromises.length > 0) {
										const autoResults = await Promise.allSettled(autoDispensePromises);
										autoResults.forEach((result, index) => {
											if (result.status === 'fulfilled' && result.value.code === 200) {
												this.$message.success(`自动发药成功!`);
											} else {
												const errorMsg = result.status === 'fulfilled' ? result.value
													.message : result.reason;
												this.$message.error(`自动发药失败: ${errorMsg}`);
											}
										});
									}

									// 执行人工发药
									if (manualDispensePrescriptions.length > 0) {
										await this.$refs.giveMediciRef.startQueueDispensing(
											manualDispensePrescriptions);
									}

								} else {
									// 非自动发药模式：处理所有药品
									const allPrescriptions = westRes.data.content.flatMap(item => {
										if (!item.voList || !Array.isArray(item.voList)) {
											return [];
										}
										return item.voList.map(prescription => ({
											patientData: {
												id: item.id,
												patientId: this.patientForm.patientId,
												name: this.patientForm.name,
												icdName: this.patientForm.diagnosis
											},
											medicineData: [prescription]
										}));
									});

									if (allPrescriptions.length > 0) {
										await this.$refs.giveMediciRef.startQueueDispensing(allPrescriptions);
									} else {
										this.$message.warning('没有找到需要发药的处方');
									}
								}
							} else {
								console.error('获取患者信息失败:', westRes.message)
								this.$message.error('获取患者信息失败: ' + westRes.message)
							}

						} catch (error) {
							console.error('发药流程异常:', error)
							this.$message.error('发药流程异常，请重试')
						}
					} else {
						console.log('发药组件未加载或方法不存在')
					}
				}

			},

			async triggerOutpatientChargeMethod() {
				// 通过ref调用OutpatientCharge组件的方法
				if (this.$refs.outpatientChargeRef && this.$refs.outpatientChargeRef.handleSearch) {
					try {
						await this.$refs.outpatientChargeRef.initData();
						await this.$refs.outpatientChargeRef.handleExternalSearch(this.patientForm)
					} catch (error) {
						console.error('调用门诊收费方法失败:', error)
					}
				} else {
					console.log('门诊收费组件未加载或方法不存在')
				}
			},
			async initLoad() {
				await withLoading(this, '正在初始化...')(async () => {
					// 1. 同步操作前置
					this.addUnitType = [...AddType];
					this.addType = [...AddType2];
					this.userInfo = JSON.parse(localStorage.getItem("userInfo") || '{}');

					// 2. 并行优化:将独立请求并行化
					const [userPermission, ...apiResults] = await Promise.all([
						getStaff({
							id: this.userInfo.staffId
						}),
						this.loadData(),
						this.getRegisterType()
					]);
					this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
					this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'];
					this.aiseListOptions = this.$store.getters['preload/getAiseListOptions'];
					this.contractUnitOption = this.$store.getters['preload/getContuntListOptions'];
					this.medicationFrequencyOptions = this.$store.getters[
						'preload/getMedicationWayListOptions'];
					this.chargingPriceOptions = this.$store.getters['preload/getChargingPriceOptions'];
					this.docphrOptions = this.$store.getters['preload/getDocphrListOptions'];
					this.drugDosageOption = this.$store.getters['preload/getDrugDosageListOption'];
					this.dosaUntOptions = this.$store.getters['preload/getDosaUntListOption'];
					this.systemParameterList = this.$store.getters['preload/getSystemListOptions'];

					if (!this.$store.state.dict || Object.keys(this.$store.state.dict).length === 0) {
						await this.$store.dispatch('fetchDictData')
						await this.dict(this.$store.state.dict)
					} else {
						await this.dict(this.$store.state.dict)
					}
					if (this.userInfo?.isInsurance === '1') {
						const res = await getqdNo();
						this.signNo = res.data?.signNo;
					}
					// 3. 避免重复请求（原代码中有重复的 getMedicationFrequency）
					this.userPermission = userPermission?.data;
					// 4. 事件监听优化:使用 passive 事件提高滚动性能
					this.$nextTick(() => {
						window.addEventListener('keydown', this.handleKeyPress, {
							passive: true
						});
						document.addEventListener('click', this.handleClickOutside);
					});
/*
					this.$websocket.initWebSocket();
*/
					window.addEventListener('websocket-ai-complete', this.handleAIComplete);
					window.addEventListener('websocket-ai-progress', this.handleAIProgress);
				});
			},
			async onCntChange(row, value) {
				// 设置 isEdit 标识
				if (!row.isEdit) {
					this.$set(row, 'isEdit', 1);
				}

				this.$set(row, 'cnt', value);
				let checkRes;
				let requiredCount; // 需要的小单位数量
				let minPurcCountSum; // 总库存（小单位）

				console.log('=== 开始处理药品数量变更 ===');
				console.log('药品信息:', {
					drugId: row.drugId,
					drugName: row.drugName,
					saleUnt: row.saleUnt,
					pacCnt: row.pacCnt,
					isFixPrice: row.isFixPrice,
					fixMinSalePric: row.fixMinSalePric,
					fixPacSalePric: row.fixPacSalePric,
					cnt: value
				});

				if (row.isEdit === 1) {
					checkRes = await checkWestDrug({
						drugId: row.drugId
					});
					console.log('库存查询结果:', checkRes);

					if (checkRes.code === 200) {
						// 根据销售单位计算需要的小单位数量
						if (row.saleUnt === 1) {
							// 小单位：直接使用value
							requiredCount = value;
							console.log(`销售单位: 小单位, 需要的小单位数量: ${requiredCount}`);
						} else {
							// 包装单位：需要转换为小单位
							requiredCount = value * row.pacCnt;
							console.log(`销售单位: 包装单位, 需要的小单位数量: ${requiredCount} (${value} * ${row.pacCnt})`);
						}

						minPurcCountSum = checkRes.data.reduce((sum, item) => sum + item.purcCnt, 0);
						console.log('库存批次详情:');
						checkRes.data.forEach((batch, index) => {
							console.log(`批次${index + 1}:`, {
								批次ID: batch.batchId,
								库存数量: batch.purcCnt,
								小单位价格: batch.minSalePric,
								包装单位价格: batch.maxSalePric
							});
						});
						console.log(`总库存数量: ${minPurcCountSum}, 需要数量: ${requiredCount}`);

						if (requiredCount > minPurcCountSum) {
							console.log(`库存不足! 需要: ${requiredCount}, 实际库存: ${minPurcCountSum}`);
							this.$set(row, 'saleAmt', null);
							this.$set(row, 'cnt', null);
							this.$message.warning("手动修改当前药品数量:" + row.drugName + '库存不足');
							return;
						}

						// 计算批次金额
						let remainingCount = requiredCount; // 还需要取的小单位数量
						let totalAmount = 0; // 总金额
						console.log(`开始计算批次金额, 初始剩余需取数量: ${remainingCount}`);

						// 按批次顺序取库存
						for (let i = 0; i < checkRes.data.length && remainingCount > 0; i++) {
							const batch = checkRes.data[i];
							const takeCount = Math.min(batch.purcCnt, remainingCount); // 从这个批次取的小单位数量
							console.log(`\n--- 处理批次 ${i + 1} ---`);
							console.log('批次信息:', {
								批次库存: batch.purcCnt,
								剩余需取: remainingCount,
								本次实际取: takeCount
							});

							// 计算这个批次的金额
							let batchAmount;
							if (row.saleUnt === 1) {
								// 单品价格：直接按小单位计算
								const unitPrice = row.isFixPrice === 1 ? row.fixMinSalePric : batch.minSalePric;
								batchAmount = takeCount * unitPrice;
								console.log(`小单位计算: ${takeCount} × ${unitPrice} = ${batchAmount}`);
							} else {
								// 包装价格：需要转换为包装单位计算
								const takePackCount = Math.ceil(takeCount / row.pacCnt); // 向上取整，取的包装单位数量
								const unitPrice = row.isFixPrice === 1 ? row.fixPacSalePric : batch.maxSalePric;
								batchAmount = takePackCount * unitPrice;
								console.log(
									`包装单位计算: ${takeCount}个小单位 = ${takePackCount}个包装, ${takePackCount} × ${unitPrice} = ${batchAmount}`
									);
								console.log(
									`包装转换: ${takeCount} / ${row.pacCnt} = ${takeCount / row.pacCnt}, 向上取整: ${takePackCount}`
									);
							}

							totalAmount += batchAmount;
							remainingCount -= takeCount;

							console.log(`批次${i + 1}计算结果:`, {
								本次取货数量: takeCount,
								批次金额: batchAmount,
								累计总金额: totalAmount,
								剩余需取数量: remainingCount
							});
						}

						// 设置最终金额
						console.log('\n=== 最终结果 ===');
						console.log(`总金额: ${totalAmount}, 格式化后: ${parseFloat(totalAmount.toFixed(2))}`);
						this.$set(row, 'saleAmt', parseFloat(totalAmount.toFixed(2)));
						console.log('药品更新后信息:', {
							cnt: row.cnt,
							saleAmt: row.saleAmt,
							isEdit: row.isEdit
						});

					} else {
						console.log('库存查询失败:', checkRes.message);
						this.$message.warning(checkRes.message);
					}
				}

				console.log('=== 处理完成 ===\n');
			},

			// 手动修改 saleAmt 时调用
			onSaleAmtChange(row, value) {
				console.log(row, 'onSaleAmtChangeonSaleAmtChangeonSaleAmtChangeonSaleAmtChangeonSaleAmtChange')
				// 设置 isEdit 标识
				if (!row.isEdit) {
					this.$set(row, 'isEdit', 1);
				}

				// 更新 saleAmt 值
				this.$set(row, 'saleAmt', value);
			},
			async handleClickDoctorAdviceRow(row) {
				this.doctorAdviceRowData = JSON.parse(JSON.stringify(row))
			},
			async handleGetWestPrescription(row = null) {
        await this.printWestPrescription(row);
      },

			async printMultipleWestPrescriptionsSimple() {
				for (let i = 0; i < this.multipleActiveSelection.length; i++) {
					const prescription = this.multipleActiveSelection[i];

					try {
						const res = await getWestDetail(prescription.orderTypeId);
						if (res.code === 200) {
							this.patientPrescription = res.data.drxDetails;
							await this.printWestPrescription(res.data.rxNo);

							// 添加延迟，避免请求过于频繁
							if (i < this.multipleActiveSelection.length - 1) {
								await new Promise(resolve => setTimeout(resolve, 500));
							}
						} else {
							this.$message.error(`第 ${i + 1} 条医嘱打印失败: ${res.message}`);
						}
					} catch (error) {
						console.error(`第 ${i + 1} 条医嘱打印出错:`, error);
						this.$message.error(`第 ${i + 1} 条医嘱打印出错: ${error.message}`);
					}
				}

				this.$message.success(`已完成 ${this.multipleActiveSelection.length} 条西药处方打印`);
			},

			async getDocphrList() {
				const res = await getDocphrAllList();
				this.docphrOptions = res.data.map(item => {
					return {
						id: item.id,
						certno: item.certno,
						label: item.name,
					}
				})
			},

			async handleYB_1191_Upload(mdtrtCretType) {
				// 添加请求锁
				if (this.isRequesting) {
					return false;
				}

				this.isRequesting = true;

				try {
					console.log(this.signNo, 'this.signNothis.signNo')
					const ybTemplate = buildYbRequest(this.signNo, '1191', this.userInfo.mdtrtareaAdmvs);
					ybTemplate.body = {
						...ybTemplate.body,
						input: {
							data: {
								mdtrt_cert_type: mdtrtCretType,
								cardtype: '0',
								businesstype: '01101',
								operatorid: this.userInfo.staffId.toString(),
								operatorname: this.userInfo.staffName,
								officeid: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept)
									?.specialtyCode || '',
								officename: this.userInfo.deptDepts.find(item => item.id === this.userInfo.selDept)
									?.specialtyName || '',
							}
						},
						transType: "ec.query",
						orgId: this.userInfo.clinicCode,
					};

					const res = await addYbRquestData({
						infno: '1191',
						mdtrtareaAdmvs: this.userInfo.mdtrtareaAdmvs,
						data: JSON.stringify(ybTemplate),
						patientId: this.userInfo.staffId,
						patientName: this.userInfo.staffName
					});

					if (res.code !== 200) {
						this.$message.error('交易编号:【1191】请求备份失败: ' + (res.message || '未知错误'));
						return false;
					}

					const initResult = await handleYB_1101_Upload({
						fixmedins_code: this.userInfo.clinicCode,
						infosyscode: res.data.infosyscode,
						infosyssign: res.data.infoSysSign,
						service_url: 'http://10.114.177.55:8080/eapdomain/callService'
					});

					if (!initResult.success) {
						this.$message.error('COM服务初始化失败: ' + initResult.error);
						return false;
					}

					let initData;
					try {
						initData = typeof initResult.data === 'string' ? JSON.parse(initResult.data) : initResult.data;
					} catch (e) {
						initData = initResult.data;
					}

					if (initData && initData.infcode !== 0) {
						this.$message.warning(initData.err_msg || 'ocx服务初始化异常');
						return false;
					}

					// 2. 调用 BusinessHandleW 方法
					const businessParams = {
						fixmedins_code: this.userInfo.clinicCode,
						infosyscode: res.data.infosyscode,
						infosyssign: res.data.infoSysSign, // 确认使用正确的签名字段
						input_data: ybTemplate.body
					};

					const businessResult = await handleYB_Business_Upload(businessParams);
					if (!businessResult.success) {
						this.$message.error('业务处理失败: ' + businessResult.error);
						return false;
					}

					let businessResponse = JSON.parse(businessResult.data);
					if (businessResponse.infcode !== 0) {
						this.$message.warning(businessResult.data.err_msg);
						return false;
					}

					// 备份响应数据
					addYbResponseData({
						id: res.data.id,
						infno: '1191',
						data: JSON.stringify(businessResult)
					});
					let patientData;
					if (mdtrtCretType === '01') {
						patientData = this.docphrOptions.findIndex(item => item.certno === businessResponse.output
							.ecinfo.idno);
						if (patientData > 0) {
							this.patientForm.patId = businessResponse.output.ecinfo.idno;
							await this.handleSearch();
							this.$message.success("已自动匹配患者存在信息")
						} else {
							this.$message.warning("健康档案不存在该患者信息,请进行快速建档");
							this.patientForm.name = businessResponse.output.ecinfo.username;
							this.patientForm.certno = businessResponse.output.ecinfo.idno;
							await this.certnoMonitor();
						}
					} else if (mdtrtCretType === '03') {
						patientData = this.docphrOptions.findIndex(item => item.certno === businessResponse.output
							.cardinfo.certno);
						if (patientData > 0) {
							this.patientForm.patId = businessResponse.output.cardinfo.certno;
							await this.handleSearch();
							this.$message.success("已自动匹配患者存在信息")
						} else {
							this.$message.warning("健康档案不存在该患者信息,请进行快速建档");
							this.patientForm.name = businessResponse.output.cardinfo.psn_name;
							this.patientForm.certno = businessResponse.output.cardinfo.certno;
							await this.certnoMonitor();
						}
					}
					this.outpatientYbRegisterForm.yb_1191_ReturnInfo = businessResponse;
					return true;

				} catch (error) {
					this.$message.error('交易编号:【1191】系统异常: ' + (error.message || '未知错误'));
					return false;
				} finally {
					this.isRequesting = false;
				}
			},


			async handleAiPrescribeSend() {
				try {
					if (!this.preVerificationUserInfo()) return;
					if (!this.preVerificationUserMedical()) return;

					this.aiLoading = true;
					this.isGenerating = true;
					this.currentPartialContent = '';
					this.aiDrawerVisible = true;

					// 重置之前的AI消息缓冲区
					if (this.$websocket && typeof this.$websocket.resetType5Buffer === 'function') {
						this.$websocket.resetType5Buffer();
					}

					// 添加系统消息
					this.aiMessages.push({
						role: 'system',
						content: '正在请求AI分析患者信息...',
						timestamp: new Date()
					});

					// 构建请求文本
					const text = this.buildRequestText();

					// 添加用户消息
					this.aiMessages.push({
						role: 'user',
						content: this.getUserMessageSummary(),
						timestamp: new Date()
					});

					// 发送请求到后端
					await aiPrescribeSend({
						text: text
					});

					// 滚动到底部
					this.scrollToBottom();

				} catch (error) {
					this.$message.error('AI请求失败，请重试');
					this.isGenerating = false;
					this.aiLoading = false;
					this.addSystemMessage('AI请求失败:' + error.message);
				}
			},

			handleAIProgress(event) {
				const progressData = event.detail;

				if (progressData.chunk === '-1') {
					console.log('检测到空字符串，AI生成完成');
					this.handleAICompleteManually('AI分析生成完毕');
					return;
				}

				this.processSegmentedData(progressData.buffer);
				this.isGenerating = true;
				this.scrollToBottom();
			},

			handleAICompleteManually(completionMessage = '') {
				this.aiLoading = false;
				this.isGenerating = false;

				const systemMessageIndex = this.aiMessages.findIndex(msg =>
					msg.role === 'system' && msg.content.includes('正在请求AI分析患者信息')
				);

				if (systemMessageIndex !== -1) {
					this.aiMessages[systemMessageIndex].content = completionMessage;
					this.aiMessages[systemMessageIndex].timestamp = new Date();
				}

				if (this.currentPartialContent && this.currentPartialContent.trim() !== '') {
					this.aiMessages.push({
						role: 'ai',
						content: this.currentPartialContent,
						timestamp: new Date()
					});
				}

				this.currentPartialContent = '';
				this.scrollToBottom();
			},

			handleAIComplete(event) {
				const completeMessage = event.detail;

				this.aiLoading = false;
				this.isGenerating = false;
				this.currentPartialContent = '';

				const systemMessageIndex = this.aiMessages.findIndex(msg =>
					msg.role === 'system' && msg.content.includes('正在请求AI分析患者信息')
				);

				if (systemMessageIndex !== -1) {
					this.aiMessages[systemMessageIndex].content = 'AI分析生成完毕';
					this.aiMessages[systemMessageIndex].timestamp = new Date();
				}

				// 检查完整消息是否是原始格式，如果是则跳过（因为分段处理已经美化了）
				const isOriginalFormat = completeMessage.data && (
					completeMessage.data.includes('诊断建议:') ||
					completeMessage.data.includes('治疗方案:') ||
					completeMessage.data.includes('处方:')
				);

				if (!isOriginalFormat) {
					// 只有非原始格式的数据才添加
					this.aiMessages.push({
						role: 'ai',
						content: completeMessage.data,
						timestamp: new Date()
					});
				}

				this.scrollToBottom();
			},

			// 处理分段数据
			processSegmentedData(buffer) {
				if (!buffer) return;

				console.log('收到数据:', buffer.substring(0, 100)); // 调试用

				// 检查是否是原始格式数据（包含诊断建议:、治疗方案:等标识）
				const isOriginalFormat = buffer.includes('诊断建议:') || buffer.includes('治疗方案:') || buffer.includes('处方:');

				if (isOriginalFormat) {
					// 这是原始格式数据，进行美化处理
					if (buffer.includes('诊断建议:')) {
						this.handleDiagnosisData(buffer);
					} else if (buffer.includes('治疗方案:') || buffer.includes('处方:')) {
						this.handleTreatmentData(buffer);
					}
				} else {
					// 这是已经美化过的数据，直接显示
					const isAlreadyDisplayed = this.aiMessages.some(msg =>
						msg.role === 'ai' && msg.content && msg.content.includes(buffer.substring(0, 50))
					);

					if (!isAlreadyDisplayed) {
						const normalMessage = {
							role: 'ai',
							content: buffer,
							timestamp: new Date()
						};
						this.addUniqueMessage(normalMessage);
					}
				}
			},

			// 处理诊断建议
			handleDiagnosisData(data) {
				const content = data.replace('诊断建议:', '').trim();
				const diagnosisMessage = {
					role: 'ai',
					content: this.formatDiagnosisContent(content),
					timestamp: new Date(),
					type: 'diagnosis' // 确保设置了类型
				};
				this.addUniqueMessage(diagnosisMessage);
			},

			// 处理治疗方案
			// 处理治疗方案
			// 修改 handleTreatmentData 方法，添加更详细的调试
			// 修改 handleTreatmentData 方法中的处方匹配
			handleTreatmentData(data) {
				console.log('=== 开始处理治疗方案数据 ===');

				let html = '';

				// 处理治疗方案
				if (data.includes('治疗方案:')) {
					const treatmentMatch = data.match(/治疗方案:\s*(\[.*?\])(?=处方:|$)/s);
					if (treatmentMatch) {
						console.log('✅ 找到治疗方案');
						html += this.formatTreatmentPlan(treatmentMatch[1]);
					}
				}

				// 处理处方 - 支持数组格式
				if (data.includes('处方:')) {
					console.log('📋 数据中包含"处方:"关键字');

					// 匹配处方数据（支持数组格式）
					const prescriptionMatch = data.match(/处方:\s*(\[.*?\])(?=治疗方案:|$)/s);
					if (prescriptionMatch) {
						console.log('✅ 找到处方数据（数组格式）');
						html += this.formatPrescription(prescriptionMatch[1]);
					} else {
						console.log('❌ 未匹配到处方数据');
						// 显示无处方提示
						html += `
							                    <div class="prescription-section">
							                      <div class="section-title">💊 处方建议</div>
							                      <div class="no-prescription">
							                        <div class="no-prescription-icon">💊</div>
							                        <div class="no-prescription-text">
							                          <div>暂无具体处方建议</div>
							                          <div class="no-prescription-desc">请根据诊断建议和治疗方案进行相应处理</div>
							                        </div>
							                      </div>
							                    </div>
							                  `;
					}
				}

				if (html) {
					const treatmentMessage = {
						role: 'ai',
						content: html,
						timestamp: new Date(),
						type: 'treatment'
					};
					this.addUniqueMessage(treatmentMessage);
				}
			},


			// 格式化诊断建议
			formatDiagnosisContent(content) {
				if (!content) return '';

				let formattedContent = this.escapeHtml(content);

				// 简单处理:句号后换行
				formattedContent = formattedContent.replace(/。/g, '。<br>');

				return `<div class="diagnosis-content">${formattedContent}</div>`;
			},

			formatTreatmentPlan(treatmentStr) {
				let html = '<div class="treatment-section">';
				html += '<div class="section-title">💡 治疗方案</div>';

				try {
					const treatments = JSON.parse(treatmentStr);
					if (Array.isArray(treatments)) {
						treatments.forEach((item, index) => {
							// 移除原始内容中的数字编号
							const cleanContent = this.cleanTreatmentContent(item);
							html += `<div class="treatment-item">
							                      <div class="treatment-content">
							                        <span class="treatment-number">${index + 1}.</span>
							                        <span class="treatment-text">${this.escapeHtml(cleanContent)}</span>
							                      </div>
							                    </div>`;
						});
					}
				} catch (e) {
					console.log('治疗方案解析失败:', e);
					html += '<div class="error-text">治疗方案解析失败</div>';
				}

				html += '</div>';
				return html;
			},

			// 新增:清理治疗方案内容，移除开头的数字编号
			cleanTreatmentContent(content) {
				if (typeof content !== 'string') return content;
				// 移除开头的 "1. "、"2. " 等数字编号和空格
				return content.replace(/^\d+\.\s*/, '').trim();
			},

			formatPrescription(prescriptionStr) {
				console.log('🔄 开始格式化处方:', prescriptionStr);

				let html = '<div class="prescription-section">';
				html += '<div class="section-title">💊 处方建议</div>';

				try {
					const prescription = JSON.parse(prescriptionStr);

					// 判断是数组格式还是对象格式
					if (Array.isArray(prescription)) {
						// 数组格式:直接显示药品列表
						html += this.formatMedicationList(prescription, '药品');
					} else if (typeof prescription === 'object') {
						// 对象格式:按类别显示
						Object.keys(prescription).forEach(category => {
							const meds = prescription[category];
							if (Array.isArray(meds)) {
								html += this.formatMedicationList(meds, category);
							}
						});
					} else {
						html += '<div class="no-prescription">无处方数据</div>';
					}

				} catch (e) {
					console.log('❌ 处方JSON解析失败:', e.message);
					html += '<div class="no-prescription">处方数据格式异常</div>';
				}

				html += '</div>';
				return html;
			},

			// 修改药品列表格式化方法，支持新字段
			formatMedicationList(meds, category) {
				let html = `<div class="med-category">
							                <div class="category-title">${this.getCategoryIcon(category)} ${category}</div>`;

				meds.forEach((med, index) => {
					html += `<div class="med-card">
							                  <div class="med-header">
							                    <span class="med-name">${this.escapeHtml(med.药品名称 || med.药物名称 || '未知药品')}</span>
							                    <span class="med-index">#${index + 1}</span>
							                  </div>
							                  <div class="med-details">
							                    <div class="med-row">
							                      <span class="med-label">用法:</span>
							                      <span class="med-value">${this.escapeHtml(med.用法 || '')}</span>
							                    </div>
							                    <div class="med-row">
							                      <span class="med-label">剂量:</span>
							                      <span class="med-value">${this.escapeHtml(med.剂量 || '')}</span>
							                    </div>
							                    <div class="med-row">
							                      <span class="med-label">频次:</span>
							                      <span class="med-value">${this.escapeHtml(med.频次 || '')}</span>
							                    </div>
							                    <div class="med-row">
							                      <span class="med-label">注意事项:</span>
							                      <span class="med-value">${this.escapeHtml(med.注意事项 || med.备注)}</span>
							                    </div>

							                    <div class="med-row">
							                      <span class="med-label">用药时间:</span>
							                      <span class="med-value">${this.escapeHtml(med.用药时间 || '')}</span>
							                    </div>
							                  </div>
							                </div>`;
				});

				html += '</div>';
				return html;
			},

			// 获取药品类别图标
			getCategoryIcon(category) {
				const icons = {
					'药品': '💊',
					'西药': '💊',
					'中药': '🌿',
					'中成药': '🌿',
					'局部缓解': '🎯',
					'其他': '💡'
				};
				return icons[category] || '💊';
			},


			// 添加唯一消息
			addUniqueMessage(newMessage) {
				const existingIndex = this.aiMessages.findIndex(msg =>
					msg.role === newMessage.role && msg.type === newMessage.type
				);

				if (existingIndex !== -1) {
					this.aiMessages[existingIndex] = newMessage;
				} else {
					this.aiMessages.push(newMessage);
				}
			},

			// HTML转义
			escapeHtml(text) {
				if (text === null || text === undefined) return '';
				const div = document.createElement('div');
				div.textContent = text;
				return div.innerHTML;
			},

			// 原有的其他方法保持不变
			buildRequestText() {
				const info = this.patientInfoSummary;
				const parts = [];

				if (info.symptoms) parts.push(`主诉:${info.symptoms}`);
				if (info.history) parts.push(`现病史:${info.history}`);
				if (info.pastHistory) parts.push(`既往史:${info.pastHistory}`);

				if (parts.length === 0) {
					return '请提供患者信息以进行AI诊断。';
				}

				return parts.join(',');
			},

			getUserMessageSummary() {
				const info = this.patientInfoSummary;
				const parts = [];

				if (info.name) parts.push(`患者:${info.name}`);
				if (info.gender) parts.push(`性别:${info.gender}`);
				if (info.age) parts.push(`年龄:${info.age}`);

				if (this.patientForm?.syspre && this.patientForm?.diapre) {
					parts.push(`血压 ${this.patientForm.syspre}/${this.patientForm.diapre} mmHg`);
				}

				if (this.patientForm?.bloodNumber) {
					const typeLabel = this.getBloodTypeLabel(this.patientForm.bloodType);
					parts.push(`血糖 ${this.patientForm.bloodNumber} mmol/L${typeLabel ? `（${typeLabel}）` : ''}`);
				}

				if (info.symptoms) parts.push(`主诉:${info.symptoms}`);
				if (info.history) parts.push(`现病史:${info.history}`);
				if (info.pastHistory) parts.push(`既往史:${info.pastHistory}`);

				return parts.join('，') + '。请分析诊断并提供处方建议。';
			},
			// 获取血压类型标签
			getBloodTypeLabel(typeId) {
				const bloodType = this.bloodTypeOptions?.find(item => item.id === typeId);
				return bloodType ? bloodType.label : '';
			},

			// 获取过敏原标签
			getAiseLabel(aiseId) {
				const allergy = this.aiseListOptions?.find(item => item.id === aiseId);
				return allergy ? allergy.label : '';
			},

			formatMessage(content, isTimeout = false) {
				if (!content) return '';

				let formattedContent = this.escapeHtml(content);

				formattedContent = formattedContent
					.replace(/\*\*(.*?)\*\*/g, '<strong class="ai-highlight">$1</strong>')
					.replace(/\n/g, '<br>');

				if (isTimeout) {
					formattedContent = `<div class="timeout-content">${formattedContent}</div>`;
				}

				return formattedContent;
			},

			formatTime(timestamp) {
				return new Date(timestamp).toLocaleTimeString('zh-CN', {
					hour: '2-digit',
					minute: '2-digit'
				});
			},

			handleDrawerClose(done) {
				this.$confirm('确定要关闭AI助手吗？未保存的内容将会丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.resetAIConversation();
					done();
				}).catch(() => {});
			},

			addSystemMessage(content) {
				this.aiMessages.push({
					role: 'system',
					content: content,
					timestamp: new Date()
				});
				this.scrollToBottom();
			},

			resetAIConversation() {
				this.aiMessages = [];
				this.aiLoading = false;
				this.isGenerating = false;
				this.currentPartialContent = '';
				this.currentSessionId = null;
			},

			scrollToBottom() {
				this.$nextTick(() => {
					const container = this.$refs.aiMessages;
					if (container) {
						container.scrollTop = container.scrollHeight;
					}
				});
			},
			validateBloodNumber() {
				const value = this.patientForm.bloodNumber;

				// 如果输入值为空，不进行验证
				if (value === '' || value === null || value === undefined) {
					this.isBloodNumberInvalid = false;
					return;
				}

				// 验证只能输入数字和小数点
				const validPattern = /^-?\d*\.?\d*$/;
				if (!validPattern.test(value)) {
					// 如果输入不合法，清空并提示
					this.patientForm.bloodNumber = '';
					this.$message.warning('只能输入数字和小数点');
					this.isBloodNumberInvalid = false;
					return;
				}

				// 转换为数字进行范围验证
				const numValue = parseFloat(value);
				if (isNaN(numValue)) {
					this.patientForm.bloodNumber = '';
					this.isBloodNumberInvalid = false;
					return;
				}

				// 验证血糖范围
				this.isBloodNumberInvalid = numValue < 3 || numValue > 12;

				if (this.isBloodNumberInvalid) {
					this.$message.warning(`血糖值 ${numValue} mmol/L 超出正常范围(3-12)`);
				}
				if (this.patientForm.id != null) {
					this.handlePatientFormChange();
				}
			},

			validateBloodPressure() {
				if (this.isSyspreInvalid) {
					this.$message.warning(`收缩压值 ${this.patientForm.syspre} 超出正常范围(90-140)`);
				}
				if (this.isDiapreInvalid) {
					this.$message.warning(`舒张压值 ${this.patientForm.diapre} 超出正常范围(60-90)`);
				}

				// 如果两个都超出范围，只显示一条合并提示
				if (this.isSyspreInvalid && this.isDiapreInvalid) {
					this.$message.warning(`血压值超出正常范围(收缩压:90-140, 舒张压:60-90)`);
				}
				if (this.patientForm.id != null) {
					this.handlePatientFormChange();
				}
			},
      // 血压输入过滤（只允许数字和小数点）
      handleBloodPressureInput(field, value) {
        // 只保留数字和小数点
        let filtered = value.replace(/[^\d.]/g, '');
        // 防止多个小数点
        const parts = filtered.split('.');
        if (parts.length > 2) {
          filtered = parts[0] + '.' + parts.slice(1).join('');
        }
        this.patientForm[field] = filtered;
      },

// 血糖输入过滤（只允许数字和小数点）
      handleBloodNumberInput(value) {
        let filtered = value.replace(/[^\d.]/g, '');
        const parts = filtered.split('.');
        if (parts.length > 2) {
          filtered = parts[0] + '.' + parts.slice(1).join('');
        }
        this.patientForm.bloodNumber = filtered;
      },

			validateTel(fieldName) {
				const phoneNumber = this.patientForm[fieldName];

				// 如果为空则不验证（根据需求可以调整为必填）
				if (!phoneNumber) return true;

				// 中国大陆手机号正则
				const phoneRegex = /^1[3-9]\d{9}$/;

				if (!phoneRegex.test(phoneNumber)) {
					const fieldLabel = fieldName === 'tel' ? '联系电话' : '联系人电话';
					this.$message.warning(`${fieldLabel}格式不正确，请输入11位中国大陆手机号`);
					return false;
				}
				if (this.patientForm.id != null) {
					this.handlePatientFormChange();
				}
				return true;
			},

      /**
       * 患者就诊前验证（血压/血糖）
       * 验证逻辑：
       * 1. 开关关闭 → 跳过所有验证（无论年龄）
       * 2. 开关开启 && 年龄 >= 35 → 验证对应字段（必填）
       * 3. 开关开启 && 年龄 < 35 → 跳过验证（不强制）
       */
      preVerificationUserInfo(val) {
        // 1. 检查是否已选择患者
        if (this.patientForm.id === null) {
          this.$message.warning("请选择患者后进行操作");
          return false;
        }

        const AGE_THRESHOLD = 35;
        const age = this.patientForm.ageYear;

        // 2. 获取开关配置
        const bloodPressureEnabled = this.systemParameterList?.find(
            item => item.param === 'is_blood_pressure'
        )?.value == 1;

        const bloodNumberEnabled = this.systemParameterList?.find(
            item => item.param === 'is_blood_number'
        )?.value == 1;

        // 3. 开关全部关闭 → 跳过所有验证
        if (!bloodPressureEnabled && !bloodNumberEnabled) {
          return true;
        }

        // 4. 年龄 < 35 → 跳过验证（即使开关开启也不强制）
        if (age < AGE_THRESHOLD) {
          return true;
        }

        // ====== 以下为：开关开启 && 年龄 >= 35 ======

        // 5. 血压验证（仅当血压开关开启）
        if (bloodPressureEnabled) {
          if (!this.patientForm.syspre) {
            this.$refs.syspreRef?.focus();
            this.$message.warning("请填写收缩压信息");
            return false;
          }
          if (!this.patientForm.diapre) {
            this.$refs.diapreRef?.focus();
            this.$message.warning("请填写舒张压信息");
            return false;
          }
        }

        // 6. 血糖验证（仅当血糖开关开启）
        if (bloodNumberEnabled) {
          if (!this.patientForm.bloodNumber) {
            this.$refs.bloodNumberRef?.focus();
            this.$message.warning("请填写血糖值");
            return false;
          }
        }

        return true;
      },
      preVerificationUserMedical() {
				if (!this.addSeedoctorForm.patientTell) {
					this.$message.warning("请填写主诉")
					return false;
				}
				if (!this.addSeedoctorForm.beforeHistory) {
					this.$message.warning("请填写既往史")
					return false;
				}
				return true;
			},

			async handleRecordingModalData() {
				await this.getMedicalAudioList();
				this.showRecordingModalData = true;
			},

      // ========== 入口方法 ==========
      async handleConfirmMedicalAdvice() {
        if (this.DropDownedName === '西药医嘱') {
          // 判断是否在编辑模式
          const hasOrderId = this.westMedicineTableData.some(item => item._orderId);
          if (hasOrderId) {
            await this.handleUpdatePrescription();
          } else {
            if (this.westMedicineTableData.length > 0) {
              this.preProcessWestData();
              await this.handleConfirmPrescription('west');
            } else {
              this.$message.warning('西药医嘱数据为空，请先添加药品');
            }
          }
        } else if (this.DropDownedName === '中药医嘱') {
          // 判断是否在编辑模式
          const hasOrderId = this.chinaMedicineTableData.some(item => item._orderId);
          if (hasOrderId) {
            // ===== 中药修改：先弹窗填写拓展数据 =====
            const validItems = this.chinaMedicineTableData.filter(item => {
              return item.drugId && item.drugId !== '' && item.drugName && item.drugName.trim() !== '';
            });
            if (validItems.length === 0) {
              this.$message.warning('请先添加中药');
              return;
            }
            // ===== 弹窗前先计算汇总 =====
            this.getChinaTotalSum();
            // 弹窗让用户填写拓展数据
            this.chinaMedicineUsageDialog = true;
          } else {
            if (this.chinaMedicineTableData.length > 0) {
              // ===== 新增中药：弹窗前先计算汇总 =====
              this.filterChinaMedicationWay();
              this.getChinaTotalSum();
              this.chinaMedicineUsageDialog = true;
            } else {
              this.$message.warning('中药医嘱数据为空，请先添加药品');
            }
          }
        } else {
          this.$message.warning('请先选择医嘱类型');
        }
      },// ========== 西药数据预处理 ==========
      preProcessWestData() {
        this.addWesternForm.adviceId = this.westMedicineTableData[0]?.adviceId || '';
        this.addWesternForm.id = this.westMedicineTableData[0]?.westPrescriptionId || '';
        this.addWesternForm.agnterCertType = this.patientForm.identityCard || '';
        this.addWesternForm.bilgDeptId = this.userInfo.selDept;
        this.addWesternForm.bilgDrId = this.userInfo.staffId;
        this.addWesternForm.bilgOptId = this.userInfo.staffId;
        this.addWesternForm.name = this.patientForm.name || '';
        this.addWesternForm.brdy = this.patientForm.brdy || '';
        this.addWesternForm.patientId = this.patientForm.id || '';
        this.addWesternForm.seeId = this.patientChooseForm.seeDoctorId || '';
        this.addWesternForm.pricingType = 1;
        this.addWesternForm.state = 0;
        this.addWesternForm.age = this.patientForm.ageYear || 0;
        this.addWesternForm.ageVar = `${this.patientForm.ageYear || 0}岁${this.patientForm.ageMonth || 0}月`;
        this.addWesternForm.opspRx = this.addWesternForm.opspRx === false ? 0 : 1;
        this.addWesternForm.regId = this.patientChooseForm.dregisterTableId || '';
        this.addWesternForm.remark = this.westernMedicineForm.remark || '';
        this.addWesternForm.status = 1;
        this.addWesternForm.sex = this.patientForm.sex || '';
        this.addWesternForm.saleAmt = this.westMedicineTableData
            .reduce((total, item) => total + (Number(item.saleAmt) || 0), 0)
            .toFixed(2);

        // 设置诊断信息
        this.addWesternForm.icdCode = this.westernSelectedTable.map(item => item.code).join(',');
        this.addWesternForm.icdName = this.westernSelectedTable.map(item => item.name).join(', ');

        // 深拷贝数据
        this.addWesternForm.dugDrxDetailsVOS = JSON.parse(JSON.stringify(this.westMedicineTableData));

        console.log('西药提交数据:', this.addWesternForm);
      },

// ========== 统一的处方新增方法 ==========
      async handleConfirmPrescription(type) {
        try {
          const isWest = type === 'west';

          // 获取基础数据
          const items = isWest ? this.westMedicineTableData : this.chinaMedicineTableData;
          const extraData = isWest ? this.addWesternForm : this.addChinaForm;
          const selectedTable = isWest ? this.westernSelectedTable : this.chinaSelectedTable;

          // 验证数据
          if (!items || items.length === 0) {
            this.$message.warning('请先添加药品');
            return;
          }

          // ===== 构建 items：中西药 + 处置合并 =====
          const mergedItems = [];

          // 1. 中西药
          const drugItems = this.buildPrescriptionItems(type, items, extraData);
          mergedItems.push(...drugItems);

          // 2. 处置（不管西药还是中药，都合并处置）
          const disposeItems = this.doctordisposeTableData.filter(item =>
              item.costid && item.costid !== null && item.costname && item.costname.trim() !== ''
          );
          if (disposeItems.length > 0) {
            const disposeData = disposeItems.map(item => ({
              itemId: item.costid,
              itemType: 4,
              quantity: Number(item.frquCnt) || 1,
              doseUnit: '次',
              frequencyId: Number(item.exeFrquId) || null,
              groupNo: item.groupNo,
              infusionSpeed: null,
              periodCount: Number(item.frquCnt),
              periodDays: Number(item.prdDays) || 1,
              remark: item.remark || '',
              routeId: null,
              selfProvided: null,
              singleDose: 1,
              skinTestRequired: null,
              unitId: null,
              requestNo: this.generateUUID()
            }));
            mergedItems.push(...disposeData);
          }

          // ===== 构建请求数据 =====
          const requestData = {
            requestNo: this.generateRequestNo(),
            visitId: this.patientChooseForm.seeDoctorId || '',
            diagnosisCode: this.getDiagnosisCode(selectedTable, isWest),
            diagnosisName: this.getDiagnosisName(selectedTable, isWest),
            pharmacyId: extraData.phayId || null,
            registrationId: this.patientChooseForm.dregisterTableId || null,
            remark: extraData.remark || '',
            items: mergedItems,
            tcm: isWest ? null : this.buildTcmData(extraData)
          };

          console.log('新增处方请求数据:', requestData);

          const res = await addOrders(requestData);
          console.log('接口返回:', res);

          if (res && res.code === 200) {
            this.$message.success('处方新增成功');
            this.updateWestOrChinaForm = {};

            this.clearRequestNo();

            if (isWest) {
              this.westMedicineTableData = [this.getEmptyWestRowData()];
              this.westMedicineSearchQuery = '';
              this.queryWestMedicineData = [];
              this.showWestTable = false;
            } else {
              this.chinaMedicineTableData = [this.getEmptyChinaRowData()];
              this.chinaMedicineUsageDialog = false;
              this.selChineseMedicineDialog = false;
              this.showWestTable = false;
            }

            // 清空处置表格
            this.doctordisposeTableData = [this.getEmptyDisposeRowData()];

            this.showWestTable = false;
            this.isSkinTestDoseDialog = false;
            this.medicineSearchQuery = '';

            await this.getOrdersByPatientId();
            await this.handleEditDocphr();
            await this.resetMedicineData(type);

          } else {
            this.$message.error(`处方新增失败: ${res?.message || '未知错误'}`);
          }
        } catch (error) {
          console.error('提交处方异常:', error);
          this.$message.error(`提交失败: ${error.message || '请检查网络或接口地址'}`);
        }
      },
      // ========== 构建处方项目 ==========
      buildPrescriptionItems(type, items, extraData) {
        const isWest = type === 'west';
        const validItems = items.filter(item => {
          return item.drugId && item.drugId !== '' && item.drugName && item.drugName.trim() !== '';
        });
        // ===== 只处理中西药，不处理处置 =====
        let result = [];
        console.log(validItems,'itemsitemsitems')

        if (isWest) {
          result = validItems.map(item => ({
            itemId: item.drugId,
            itemType: item.drugType ===  1 ? 1 : item.drugType ===  3 ? 5 : 1 ,
            quantity: Number(item.cnt) || 1,
            doseUnit: item.dosUnt || '',
            frequencyId: Number(item.usedfrquId) || null,
            groupNo: item.groupNo,
            infusionSpeed: item.speed || '',
            periodCount: Number(item.prdCnt) || null,
            periodDays: Number(item.prdDays) || 1,
            remark: item.remarks || '',
            routeId: Number(item.medcWayId) || null,
            selfProvided: Number(item.selfProe) || 0,
            singleDose: Number(item.sdoseCnt) || null,
            skinTestRequired: Number(item.skintstDicm) || 0,
            unitId: Number(item.saleUnt) || null,
            requestNo: this.generateUUID()
          }));
        } else {
          result = validItems.map(item => ({
            itemId: item.drugId,
            itemType: 2,
            quantity: Number(item.sdoseCnt),
            doseUnit: 'g',
            frequencyId: Number(item.usedfrquId) || null,
            groupNo: null,
            infusionSpeed: '',
            periodCount: null,
            periodDays: null,
            remark: item.remarks || '',
            routeId: Number(item.medcWayId) || null,
            selfProvided: null,
            singleDose: Number(item.sdoseCnt) || null,
            skinTestRequired: null,
            unitId: 1,
            requestNo: this.generateUUID()
          }));
        }
        console.log(result,'resultresultresult')

        return result;
      },
      buildTcmData() {
        return {
          doseCount: Number(this.addChinaForm.tcmCnt) || null,
          decoctionType: Number(this.addChinaForm.decoctionType) || null,
          decoctionVolume: Number(this.addChinaForm.decoctionVolume) || null,
          doseVolume: Number(this.addChinaForm.doseVolume) || null,
          doseVolumeUnit: 'g',
          frequencyId: Number(this.addChinaForm.usedfrquId) || null,
          routeId: Number(this.addChinaForm.medcWayId) || null,
          tcmWayId: Number(this.addChinaForm.tcmWayId) || null
        };
      },

// ========== 生成幂等号（带缓存，用于主请求） ==========
      generateRequestNo() {
        // 如果已有缓存的幂等号，直接返回（用于重试场景）
        if (this.cachedRequestNo) {
          return this.cachedRequestNo;
        }
        // 否则生成新的UUID
        this.cachedRequestNo = this.generateUUID();
        return this.cachedRequestNo;
      },

// ========== 生成UUID（不缓存，用于子项目） ==========
      generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },

// ========== 清除缓存的幂等号（提交成功后调用） ==========
      clearRequestNo() {
        this.cachedRequestNo = null;
      },

// ========== 获取诊断编码 ==========
      getDiagnosisCode(selectedTable, isWest) {
        if (!selectedTable || selectedTable.length === 0) return '';
        if (isWest) {
          return selectedTable.map(item => item.code).join(',');
        } else {
          return selectedTable.map(item => item.icdCode).join(', ');
        }
      },

// ========== 获取诊断名称 ==========
      getDiagnosisName(selectedTable, isWest) {
        if (!selectedTable || selectedTable.length === 0) return '';
        if (isWest) {
          return selectedTable.map(item => item.name).join(', ');
        } else {
          return selectedTable[0]?.diagnosticName || '';
        }
      },

// ========== 重置药品数据 ==========
      async resetMedicineData(type) {
        if (type === 'west') {
          this.westMedicineTableData = [];
          this.westernSelectedTable = [];
          this.addWesternForm = Object.assign({}, this.$options.data.call(this).addWesternForm);
          this.westernMedicineForm = Object.assign({}, this.$options.data.call(this).westernMedicineForm);
        } else {
          this.chinaMedicineTableData = [];
          this.chinaSelectedTable = [];
          this.addChinaForm = Object.assign({}, this.$options.data.call(this).addChinaForm);
        }
      },

// ========== 刷新处方列表 ==========
      async refreshPrescriptionList() {
        try {
          const [res2, res5] = await Promise.all([
            getReceptionDiagnosis({
              category: 2,
              seeDoctorId: this.patientChooseForm.seeDoctorId
            }),
            getDoctoradvice({
              seeDoctorId: this.patientChooseForm.seeDoctorId
            }),
          ]);

          if (res5 && res5.data) {
            this.medicalAdviceData = res5.data;
            this.addSeedoctorForm = {
              ...this.addSeedoctorForm,
              chinaDiagnose: res2?.map(item => `(${item.diagnosticName})`).join('') || '',
              chinaPrescription: res5.data
                  .filter(item => item.orderType === 1)
                  .map(item => item.content?.split(',').join('\n') || '')
                  .join('\n') || '',
            };
          }
        } catch (error) {
          console.error('刷新处方列表失败:', error);
        }
      },

// ========== 西药确认（保留兼容） ==========
      async handleConfirmWest() {
        // 数据预处理
        this.preProcessWestData();
        // 调用统一新增
        await this.handleConfirmPrescription('west');
      },

// 确认中药
      async handleConfirmChina() {
        // 验证必填字段
        if (!this.addChinaForm.tcmCnt || this.addChinaForm.tcmCnt < 1) {
          this.$message.warning('请输入付数');
          return;
        }

        const hasOrderId = this.chinaMedicineTableData.some(item => item._orderId);

        if (hasOrderId) {
          await this.handleUpdateChinaPrescription();
        } else {
          await this.handleConfirmPrescription('china');
        }
      },

// ========== 中药数据预处理 ==========
      preProcessChinaData() {
        this.addChinaForm.bilgDeptId = this.userInfo.selDept;
        this.addChinaForm.bilgDrId = this.userInfo.userId;
        this.addChinaForm.name = this.patientForm.name || '';
        this.addChinaForm.regId = this.patientChooseForm.dregisterTableId || '';
        this.addChinaForm.seeId = this.patientChooseForm.seeDoctorId || '';
        this.addChinaForm.brdy = this.patientForm.brdy || '';
        this.addChinaForm.patientId = this.patientForm.id || '';
        this.addChinaForm.pricingType = 1;
        this.addChinaForm.state = 0;
        this.addChinaForm.sex = this.patientForm.sex || '';
        this.addChinaForm.age = this.patientForm.ageYear || 0;
        this.addChinaForm.ageVar = `${this.patientForm.ageYear || 0}岁${this.patientForm.ageMonth || 0}月`;
        this.addChinaForm.opspRx = this.addChinaForm.opspRx ? 1 : 0;
        this.addChinaForm.rxType = 1;

        // 设置诊断信息
        this.addChinaForm.icdCode = this.chinaSelectedTable
            .map(item => item.icdCode)
            .join(', ');
        this.addChinaForm.icdName = this.chinaSelectedTable[0]?.diagnosticName || '';

        // 设置用法信息
        this.addChinaForm.tcmWayName = this.tcmwayOptions?.find(item => item.id === this.addChinaForm.tcmWayId)?.label || '';
        this.addChinaForm.useMethod = [
          this.addChinaForm.takeMedicineWay1,
          this.addChinaForm.takeMedicineWay2
        ].filter(Boolean).join(',');

        // 构建中药详情
        this.addChinaForm.tcmDetailsVOS = JSON.parse(JSON.stringify(this.chinaMedicineTableData));
        this.addChinaForm.tcmDetailsVOS = this.addChinaForm.tcmDetailsVOS.map(item => {
          const sdoseCnt = Number(item.sdoseCnt) || 0;
          const tcmCnt = Number(this.addChinaForm.tcmCnt) || 1;
          const price = item.isFixPrice === 1 ? (item.fixMinSalePric || 0) : (item.minSalePric || 0);
          const sumPrice = price * sdoseCnt;

          return {
            ...item,
            roundUnt: 2,
            cnt: sdoseCnt * tcmCnt,
            sumPrice: sumPrice,
            saleAmt: sumPrice * tcmCnt,
            purcAmt: item.purcAmt || 0,
            tcmCnt: tcmCnt,
            medcWayId: this.addChinaForm.medcWayId || '',
            usedfrquId: this.addChinaForm.usedfrquId || '',
            sdoseSum: sdoseCnt * tcmCnt
          };
        });

        // 计算总金额
        this.addChinaForm.saleAmt = parseFloat(
            (
                this.chinaMedicineTableData.reduce(
                    (sum, item) => sum + (Number(item.sumPrice) || 0),
                    0
                ) * (Number(this.addChinaForm.tcmCnt) || 1)
            ).toFixed(2)
        );

        this.addChinaForm.purcAmt = this.chinaMedicineTableData.reduce(
            (sum, item) => sum + (Number(item.purcPric) || 0),
            0
        );

        console.log('中药提交数据:', this.addChinaForm);
      },

			handleTableRowClick(row, column, event) {
				if (this.DropDownedName === '西药医嘱') {
					this.handleSelWestTableRowClick(row, column, event);
				} else {
					this.handleSelChinaTableRowClick(row, column, event);
				}
			},

      handleCommand(type) {
        if (type === 'a') {
          this.DropDownedName = '西药医嘱';
          this.initWestMedicineTable();
        } else if (type === 'b') {
          this.DropDownedName = '中药医嘱';
          this.initChinaMedicineTable();
        }
      },

/*
			async handleClearDisposeToTag(tag) {
				await this.$confirm(
					`确认删除:【${tag.costname}】处置项目吗?`,
					'删除', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning'
					}
				);
				try {
					const res = await delOneAdvice({
						id: this.medicalAdviceData.find(item => item.orderTypeId === tag.id)?.id
					})
					if (res.code === 200) {
						const res2 = await getDoctordispose({
							seeDoctorId: this.patientChooseForm.seeDoctorId
						});
						this.doctordisposeTableData = res2.data.map(item => ({
							...item,
							odcost: item.executionPrice,
							executeOdcost: item.executionAmount,
							doctorName: item.staffId,
							deptName: item.executDeptId,
							count: item.num
						}));
						await this.resetWestMedicineData();
					} else {
						this.$message.warning(res.message)
					}
				} catch (error) {
					this.$message.error("系统异常:请联系管理员!!!")
				} finally {

				}
			},
*/

			async handleGetMedicalKeywordList(type) {
				if (!this.preVerificationUserInfo()) return;
				try {
					// 设置当前活动字段
					this.activeField = type === 1 ? 'patientTell' :
						type === 2 ? 'nowHistory' : 'beforeHistory';

					// 获取API数据
					const res = await getSeeDoctorKeywordList({
						type,
						state: 1
					});

					// 清空原有关键词
					this.keywordGroups[this.activeField].forEach((group, index) => {
						if (index > 0) {
							group.keywords = [];
						}
					});

					// 将API数据分配到对应分组
					if (res.data && Array.isArray(res.data)) {
						res.data.forEach(item => {
							let groupType;
							if (type === 1) groupType = item.mainGroup;
							else if (type === 2) groupType = item.nowHistoryGroup;
							else groupType = item.beforeHistoryGroup;

							if (groupType !== 0) {
								const targetGroup = this.keywordGroups[this.activeField]
									.find(g => g.type === groupType);

								if (targetGroup) {
									targetGroup.keywords.push(item.name);
								}
							}
						});
					}

					// 默认选中第一个分组
					if (this.keywordGroups[this.activeField].length > 0) {
						this.activeGroup = this.keywordGroups[this.activeField][0].type;
					}

					// 修复：安全地判断是否显示关键词
					const hasApiData = res.data && res.data.length > 0;
					const hasDefaultKeywords = this.keywordGroups[this.activeField] &&
						this.keywordGroups[this.activeField][0] &&
						this.keywordGroups[this.activeField][0].keywords &&
						this.keywordGroups[this.activeField][0].keywords.length > 0;

					this.keywordsVisible = hasApiData || hasDefaultKeywords;

				} catch (error) {
					console.error('获取关键词失败:', error);
					this.keywordsVisible = false;
				}
			},

			addKeyword(word) {
				if (!this.activeField) return;

				const inputEl = document.querySelector(`[data-field="${this.activeField}"]`);
				if (!inputEl) return;

				const value = this.addSeedoctorForm[this.activeField] || '';

				const shouldAddComma = value && value.trim() !== '' && this.activeGroup !== 0;

				this.addSeedoctorForm[this.activeField] = shouldAddComma ? value + ',' + word : value + word;

				// 保持关键词面板可见
				this.keywordsVisible = true;

				// 重置光标位置到末尾
				this.$nextTick(() => {
					inputEl.focus();
					const newValue = this.addSeedoctorForm[this.activeField];
					inputEl.setSelectionRange(newValue.length, newValue.length);
				});
			},

			handleClickOutside(e) {
				if (e.target.closest('.keywords-panel')) {
					return;
				}
				const isTargetInput = e.target.closest(`
							                [data-field="patientTell"],
							                [data-field="nowHistory"],
							                [data-field="beforeHistory"]
							              `);
				if (!isTargetInput) {
					setTimeout(() => this.keywordsVisible = false, 200);
				}
			},

			handleAllFieldClick({
				patientTell,
				nowHistory,
				beforeHistory
			}) {
				Object.assign(this.addSeedoctorForm, {
					patientTell,
					nowHistory,
					beforeHistory
				});
				this.showRecordingModalData = false;
				this.$message.success('引用成功');
			},

			handleFieldClick(text, field) {
				const fieldMessages = {
					patientTell: '主诉内容已更新',
					nowHistory: '现病史内容已更新',
					beforeHistory: '既往史内容已更新'
				};

				if (field in this.addSeedoctorForm) {
					this.addSeedoctorForm[field] = text;
					this.$message.success(fieldMessages[field]);
				}
			},

			handleMenuSelect(index) {
				this.activeIndex = index;
			},

			handleAudioItemClick(audioPath) {
				this.currentAudioPath = audioPath;
				// 自动播放选中的音频
				this.$nextTick(() => {
					const audioElement = this.$refs.audioPlayer;
					if (audioElement) {
						audioElement.play().catch(error => {
							this.$message.warning('音频播放失败:' + error.message);
							console.error('播放错误:', error);
						});
					}
				});
			},

			async getMedicalAudioList() {
				const ctx = this;
				try {
					const res = await getMedicalAudioList({
						seeDoctorId: ctx.patientChooseForm.seeDoctorId
					});
					if (res?.code !== 200 || !Array.isArray(res.data)) throw new Error(res?.message || 'Invalid data');

					const options = [],
						list = [];
					const {
						clinicName
					} = ctx.userInfo, {
						name: patientName
					} = ctx.patientForm;

					res.data.forEach((item, i) => {
						options.push({
							index: String(i),
							name: `系统序号:${item.id}`,
							audioPath: item.audioPath
						});
						list.push({
							...item,
							clinicName,
							patientName
						});
					});

					ctx.recordingListOptions = options;
					ctx.recordingList = list;
				} catch (e) {
					ctx.recordingListOptions = [];
					console.error('Recording load failed:', e);
					ctx.$message.error(`获取失败: ${e.message}`);
				}
			},
			// 开始录音
			startRecording() {
				this.isRecording = true;
				this.audioUrl = '';
				this.audioBlob = null;
				this.audioChunks = [];
				this.startRecordingTimer();

				navigator.mediaDevices.getUserMedia({
						audio: true
					})
					.then(stream => {
						this.stream = stream;
						this.mediaRecorder = new MediaRecorder(stream);

						this.mediaRecorder.ondataavailable = (e) => {
							this.audioChunks.push(e.data);
						};

						this.mediaRecorder.onstop = () => {
							this.audioBlob = new Blob(this.audioChunks, {
								type: 'audio/wav'
							});
							this.audioUrl = URL.createObjectURL(this.audioBlob);
						};

						this.mediaRecorder.start();
					})
					.catch(error => {
						this.isRecording = false;
						this.stopRecordingTimer();
						this.$message.error(`录音初始化失败: ${error.message || '无法访问麦克风'}`);
					});
			},

			// 停止录音
			stopRecording() {
				if (this.isRecording) {
					this.isRecording = false;
					this.stopRecordingTimer();

					if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
						this.mediaRecorder.stop();
					}
					if (this.stream) {
						this.stream.getTracks().forEach(track => track.stop());
						this.stream = null;
					}

					// 无预览时直接保存（添加此行）
					setTimeout(() => this.saveRecording(), 500);
				}
			},

			// 保存录音并上传
			saveRecording() {
				if (this.audioBlob) {
					this.uploadRecording(this.audioBlob);
					this.showRecordingModal = false;
				} else {
					this.$message.warning('没有可保存的录音数据');
				}
			},

			// 上传录音到后端
			async uploadRecording(blob) {
				await withLoading(this, '录音处理中...')(async () => {
					const formData = new FormData();
					formData.append('file', blob, `recording_${new Date().getTime()}.wav`);

					try {
						const res = await uploadFile(formData);

						if (res && res.code === 200) {
							this.$message.success('录音上传成功');
							const newItem = {
								audioPath: res.data.path,
								patientId: this.patientChooseForm.id,
								seeDoctorId: this.patientChooseForm.seeDoctorId,
							}
							await addMedicalAudio(newItem);
						} else {
							this.$message.error(`录音保存失败: ${res?.message || '未知错误'}`);
						}
					} catch (error) {
						this.$message.error(`上传失败: ${error.message || '网络错误'}`);
					}
				});
			},

			// 录音计时器
			startRecordingTimer() {
				let seconds = 0;
				this.recordingTimer = setInterval(() => {
					seconds++;
					const minutes = Math.floor(seconds / 60);
					this.recordingTime =
						`${minutes.toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
				}, 1000);
			},

			// 停止计时器
			stopRecordingTimer() {
				clearInterval(this.recordingTimer);
				this.recordingTimer = null;
				this.recordingTime = '00:00';
			},

			// 组件销毁时清理资源
      beforeDestroy() {
        // 1. 原有录音清理（保留）
        if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
          this.mediaRecorder.stop();
        }
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
        }
        if (this.recordingTimer) {
          clearInterval(this.recordingTimer);
        }
        if (this.audioUrl) {
          URL.revokeObjectURL(this.audioUrl);
        }

        // 2. 移除全局事件监听（原有 + 新增）
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('keydown', this.handleKeyPress); // 你代码中有 addEventListener，必须移除

        // 3. 清除防抖定时器（如果你已经按建议加了 saveTimer）
        if (this.saveTimer) {
          clearTimeout(this.saveTimer);
          this.saveTimer = null;
        }

        // 4. 清理所有大数组（核心！）
        this.westMedicineTableData = null;
        this.chinaMedicineTableData = null;
        this.medicalAdviceData = null;
        this.doctordisposeTableData = null;
        this.queryWestMedicineData = null;
        this.queryChinaMedicineData = null;
        this.patientPrescription = null;
        this.disposalProject = null;
        this.westernSelectedTable = null;
        this.chinaSelectedTable = null;

        // 5. 清理大对象中的子数组（避免额外引用）
        if (this.addChinaForm) {
          this.addChinaForm.tcmDetailsVOS = null;
        }
        if (this.addWesternForm) {
          this.addWesternForm.dugDrxDetailsVOS = null;
        }
        if (this.updateWestOrChinaForm) {
          // 如果其中包含大数组，也清空
          if (this.updateWestOrChinaForm.drxDetails) this.updateWestOrChinaForm.drxDetails = null;
          if (this.updateWestOrChinaForm.tcmDetailsRespVOS) this.updateWestOrChinaForm.tcmDetailsRespVOS = null;
        }

        // 6. 如果有 ECharts 或图表实例，调用 dispose
        // if (this.chart) { this.chart.dispose(); this.chart = null; }
      },

      async handleShowDataDetail(row) {
        // 直接调用 addModel 的 openAddModel 方法
        this.$refs.addModel.openAddModel({
          id: row.drugId,                     // 药品ID（必须）
          mode: 'view',                       // 查看模式
          label: `查看西药(${row.drugName})的档案信息`  // 对话框标题
        });
      },
			async exportOfMedicalVisitRecords() {
				await withLoading(this, '数据导出中...')(async () => {
					try {
						// 1. 获取二进制数据（与原有逻辑完全一致)
						const result = await exportOfMedicalVisitRecords({
							startTime: this.seedoctorQueryParams.startTime,
							endTime: this.seedoctorQueryParams.endTime,
							patientName: this.seedoctorQueryParams.patientName,
							patientId: this.seedoctorQueryParams.patientId,
							doctorId: this.seedoctorQueryParams.doctorId,
						});

						// 2. 创建Blob（保持相同MIME类型）
						const blob = new Blob([result], {
							type: 'application/vnd.ms-excel' // 与您原代码完全一致
						});

						// 3. 优先尝试原生保存对话框
						if ('showSaveFilePicker' in window) {
							const fileHandle = await window.showSaveFilePicker({
								types: [{
									description: 'Excel文件',
									accept: {
										'application/vnd.ms-excel': ['.xlsx'], // 与原下载相同格式
										'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
											'.xlsx'
										]
									}
								}],
								suggestedName: `就诊记录_${new Date().toLocaleDateString('zh-CN')}.xlsx` // 相同文件名规则
							});

							const writable = await fileHandle.createWritable();
							await writable.write(blob);
							await writable.close();

							this.$message.success('文件已保存至选择的位置！');
						}
						// 4. 浏览器不支持时自动降级为原下载逻辑
						else {
							const url = URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.download = `就诊记录_${new Date().toLocaleDateString('zh-CN')}.xlsx`; // 相同文件名
							link.click();

							setTimeout(() => {
								URL.revokeObjectURL(url);
							}, 100);
						}

					} catch (error) {
						if (error.name === 'AbortError') return;

						console.error('导出失败:', error);
						if (error.response?.data instanceof Blob) {
							const errorText = await error.response.data.text();
							try {
								const errData = JSON.parse(errorText);
								this.$message.error(errData.message || '导出失败');
							} catch {
								this.$message.error('服务器返回异常数据');
							}
						} else {
							this.$message.error(error.message || '导出失败');
						}
					}
				});
			},
			async batchDeriveExcelSeeDoctorData() {
				await withLoading(this, '数据导出中...')(async () => {
					try {
						// 1. 获取二进制数据（与原有逻辑完全一致)
						const result = await batchDeriveExcelSeeDoctorData({
							startTime: this.seedoctorQueryParams.startTime,
							endTime: this.seedoctorQueryParams.endTime,
						});

						// 2. 创建Blob（保持相同MIME类型）
						const blob = new Blob([result], {
							type: 'application/vnd.ms-excel' // 与您原代码完全一致
						});

						// 3. 优先尝试原生保存对话框
						if ('showSaveFilePicker' in window) {
							const fileHandle = await window.showSaveFilePicker({
								types: [{
									description: 'Excel文件',
									accept: {
										'application/vnd.ms-excel': ['.xlsx'], // 与原下载相同格式
										'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
											'.xlsx'
										]
									}
								}],
								suggestedName: `诊疗信息_${new Date().toLocaleDateString('zh-CN')}.xlsx` // 相同文件名规则
							});

							const writable = await fileHandle.createWritable();
							await writable.write(blob);
							await writable.close();

							this.$message.success('文件已保存至选择的位置！');
						}
						// 4. 浏览器不支持时自动降级为原下载逻辑
						else {
							const url = URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.download = `诊疗信息_${new Date().toLocaleDateString('zh-CN')}.xlsx`; // 相同文件名
							link.click();

							setTimeout(() => {
								URL.revokeObjectURL(url);
							}, 100);
						}

					} catch (error) {
						if (error.name === 'AbortError') return;

						console.error('导出失败:', error);
						if (error.response?.data instanceof Blob) {
							const errorText = await error.response.data.text();
							try {
								const errData = JSON.parse(errorText);
								this.$message.error(errData.message || '导出失败');
							} catch {
								this.$message.error('服务器返回异常数据');
							}
						} else {
							this.$message.error(error.message || '导出失败');
						}
					}
				});
			},

			setRowClassName({
				row
			}) {
				if (row.skintstDicm === 1) {
					console.log(row, 'rowrowrowrowrowrowrowrowrowrow')
					if (row.skintstDicmResult === 2) {
						return 'row-positive';
					} else if (row.skintstDicmResult === 1) {
						return 'row-negative';
					}
				}
				return '';
			},

			async getHistoryMedicalData(row) {
				await withLoading(this, '数据加载中...')(async () => {
					const res = await getDoctoradvice({
						seeDoctorId: row.id
					});
					if (res.code === 200) {
						this.historyMedicalData = res.data;
						this.historyMedicalDialogVisible = true;
					} else {
						this.$message.error(res.message)
					}
				});
			},

			handleCancelSeedoctorDataList() {
				this.sevenDayDialogVisible = false;
			},
      handleSizeChange(val) {
        this.pageNum = val;
        this.handleSavenData();
      },
      //当前条数改变触发
      handleCurrentChange(val) {
        this.pageNum = val;
        this.handleSavenData();
      },
			handleGroupInfusionSync(currentRow) {
				if (currentRow.groupNo == null) return;
				const newSpeed = currentRow.speed;
				// 使用缓存避免重复过滤
				const groupNo = currentRow.groupNo;
				for (let i = 0; i < this.westMedicineTableData.length; i++) {
					const item = this.westMedicineTableData[i];
					if (item.groupNo === groupNo) {
						this.$set(item, 'speed', newSpeed);
					}
				}
			},

			handleCancelAiseForm() {
				this.$refs.aiseFormRef.resetFields();
				this.aiseForm = Object.assign({}, this.$options.data.call(this).aiseForm)
				this.aiseAddOrEditMedicineDialog = false;
			},

			handleKeyPress(event) {
				// 检查是否为 F9 键（兼容 key 和 keyCode）
				if (event.key === 'F9' || event.keyCode === 120) {
					event.preventDefault(); // 阻止默认行为
					this.handleReadIdCardData(); // 调用你的业务方法
				}
			},

			checkHasDisease(inputString) {
				if (!inputString || typeof inputString !== 'string') {
					return {
						hasDisease: false,
						matchedKeywords: []
					};
				}

				// 缓存疾病列表，避免重复拆分
				if (!this._diseasesArray) {
					this._diseasesArray = this.diseaseList.split('、');
				}

				// 使用Set提高查找效率
				const matchedKeywords = [];
				for (let i = 0; i < this._diseasesArray.length; i++) {
					const disease = this._diseasesArray[i];
					if (inputString.includes(disease)) {
						matchedKeywords.push(disease);
					}
				}

				return {
					hasDisease: matchedKeywords.length > 0,
					matchedKeywords: matchedKeywords
				};
			},

			async checkDiseaseAndConfirm(formData, row) {
				// 快速路径:如果药品没有限制使用标记，直接返回true
				if (row.lmtusedB !== 1) {
					return true;
				}

				// 1. 检查药品名称是否包含禁忌症名称
				const aiseId = this.patientForm.aiseId;
				let aiseName = null;
				let isDrugContraindicated = false;

				if (aiseId) {
					// 使用缓存避免重复查找
					if (!this._aiseNameCache) {
						this._aiseNameCache = {};
					}

					if (this._aiseNameCache[aiseId] === undefined) {
						const aiseItem = this.aiseListOptions.find(item => item.id === aiseId);
						this._aiseNameCache[aiseId] = aiseItem?.label || null;
					}

					aiseName = this._aiseNameCache[aiseId];
					isDrugContraindicated = aiseName && row.drugName.includes(aiseName);
				}

				// 2. 拼接所有病史字段 - 只在需要时执行
				const isPregnantOrMinorWithLimit = (this.patientForm.pregnant || this.patientForm.ageYear <= 14);

				// 如果已经有禁忌症或者是孕妇/未成年人，就不需要检查疾病了
				let diseaseResult = {
					hasDisease: false,
					matchedKeywords: []
				};

				if (!isDrugContraindicated && !isPregnantOrMinorWithLimit) {
					const combinedString = [
						formData.patientTell,
						formData.nowHistory,
						formData.beforeHistory,
						formData.westernDiagnos
					].filter(Boolean).join(' '); // 过滤掉空值再拼接

					// 3. 检查病史中是否包含慢性病关键词
					diseaseResult = this.checkHasDisease(combinedString);
				}

				const hasDiseaseWithLimit = diseaseResult.hasDisease;

				// 4. 构建风险提示消息 - 只在有风险因素时构建
				const riskFactors = [];

				if (isDrugContraindicated) {
					riskFactors.push(`药品名称包含禁忌症: ${aiseName}`);
				}
				if (hasDiseaseWithLimit) {
					riskFactors.push(`慢性疾病: ${diseaseResult.matchedKeywords.join('、')}`);
				}
				if (isPregnantOrMinorWithLimit) {
					riskFactors.push(`患者为${this.patientForm.pregnant ? '孕妇' : '未成年人'}`);
				}

				// 5. 如果有风险因素，弹出确认框
				if (riskFactors.length > 0) {
					const message = `
							                  <strong>检测到以下风险因素:</strong><br>
							                  ${riskFactors.join('<br>')}<br>
							                  ${row.lmtusedRemark ? `限定备注: ${row.lmtusedRemark}<br>` : ''}
							                  请确认是否继续操作?
							                `;

					try {
						await this.$confirm(
							message,
							'风险提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
								dangerouslyUseHTMLString: true
							}
						);
						return true; // 用户确认继续
					} catch {
						return false; // 用户取消操作
					}
				}

				return true; // 无风险，默认继续
			},

			tableRowClassName({
				row
			}) {
				if (row.lmtusedB === 1) {
					return 'warning-row';
				}
				return '';
			},

			async handleReadIdCardData() {
				await withLoading(this, '读取身份证中...')(async () => {
					try {
						if (!this.receptionModalVisible) return;
						if (this.patientForm.certno && this.patientForm.certno.trim() !== '') return;
						const res = await readIdCard();
						this.patientForm.certno = res.cardno;
						this.patientForm.naplAddName = res.address;
						this.patientForm.name = res.name;
						this.patientForm.naty = getNationalityId(this.ntlyOptions, res.nation) ?? 1;
						this.naplPleasett = res.address;
						const isExist = await this.certnoMonitor(this.celerityFilingForm);
						if (isExist === 1) {
							this.patientForm.patId = res.cardno;
							await this.handleSearch();
							this.$message.warning("已自动匹配存在患者信息")
						}
					} catch (error) {
						this.$message.error(error)
					}
				});
			},

			async printOutpatientsDerive() {
				await withLoading(this, '数据导出中...')(async () => {
					try {
						// 1. 获取二进制数据
						const result = await printOutpatientsDerive({
							seeDoctorId: this.patientChooseForm.seeDoctorId
						});

						// 2. 创建Blob
						const blob = new Blob([result], {
							type: 'application/vnd.ms-excel'
						});

						// 3. 提取导出逻辑到复用函数
						await this._saveExcelFile(blob,
							`诊疗数据_${new Date().toLocaleDateString('zh-CN')}.xlsx`);
					} catch (error) {
						if (error.name === 'AbortError') return; // 用户取消保存不报错

						console.error('导出失败:', error);
						this._handleExportError(error);
					}
				});
			},

			// 提取共用的Excel文件保存逻辑
			async _saveExcelFile(blob, filename) {
				// 优先尝试原生保存对话框
				if ('showSaveFilePicker' in window) {
					try {
						const fileHandle = await window.showSaveFilePicker({
							types: [{
								description: 'Excel文件',
								accept: {
									'application/vnd.ms-excel': ['.xlsx'],
									'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
										'.xlsx'
									]
								}
							}],
							suggestedName: filename
						});

						const writable = await fileHandle.createWritable();
						await writable.write(blob);
						await writable.close();

						this.$message.success('文件已保存至选择的位置！');
					} catch (error) {
						if (error.name !== 'AbortError') {
							// 如果不是用户取消，则降级到传统下载
							this._fallbackDownload(blob, filename);
						}
					}
				} else {
					// 浏览器不支持时使用传统下载
					this._fallbackDownload(blob, filename);
				}
			},

			// 传统下载方法
			_fallbackDownload(blob, filename) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.click();

				// 及时释放URL对象
				setTimeout(() => URL.revokeObjectURL(url), 100);
			},

			// 处理导出错误
			async _handleExportError(error) {
				if (error.response?.data instanceof Blob) {
					try {
						const errorText = await error.response.data.text();
						const errData = JSON.parse(errorText);
						this.$message.error(errData.message || '导出失败');
					} catch {
						this.$message.error('服务器返回异常数据');
					}
				} else {
					this.$message.error(error.message || '导出失败');
				}
			},

			getPricSummary(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '合计';
						return;
					}

					// 只计算 pric 列（注意列名是否正确）
					if (column.property === 'pric') {
						const values = data
							.map(item => {
								const val = item[column.property];
								// 处理可能的 null、undefined 或空字符串
								return val === null || val === undefined || val === '' ? 0 : Number(val);
							})
							.filter(value => !isNaN(value)); // 确保都是有效数字

						const sum = values.reduce((prev, curr) => prev + curr, 0);
						sums[index] = sum.toFixed(2); // 保留2位小数
					} else {
						sums[index] = ''; // 其他列不显示汇总
					}
				});

				return sums;
			},

			handleCancelAddUnit() {
				this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
				this.addUnitModalVisible = false;
			},

			checkSelectable(row, index) {
				// 示例:只允许未删除的行被选中
				return row.orderType !== 5;
			},

			handleSelectionActiveChange(val) {
				this.multipleActiveSelection = val;
				console.log('当前选中:', val);
			},

			// zcw++过滤西药搜索表格列
			getFilteredTableRows11() {
			        return this.tableRows11.filter(col => {
			            // 如果有显示条件，根据条件判断
			            if (col.showCondition) {
			                return col.showCondition();
			            }
			            return true;
			        });
			    },

			    // zcw++过滤中药搜索表格列
			    getFilteredTableRows12() {
			        return this.tableRows12.filter(col => {
			            // 如果有显示条件，根据条件判断
			            if (col.showCondition) {
			                return col.showCondition();
			            }
			            return true;
			        });
			    },

			    // zcw++过滤一体化表格列
			   getFilteredTableRows7() {
			           return this.tableRows7.filter(col => {
			               // 如果有显示条件，根据条件判断
			               if (col.showCondition) {
			                   return col.showCondition();
			               }
			               return true;
			           });
			       },
			// zcw++初始化批次号开关状态
			initBatchSelectionSwitch() {
			    console.log('开始初始化批次号开关状态');

			    // 从systemParameterList中查找参数
			    if (this.systemParameterList && this.systemParameterList.length > 0) {
			        console.log('systemParameterList:', this.systemParameterList);

			        // 查找param为"dug_purc_batch_select"且name为"药品库存批次选择开关"的参数
			        const batchSwitchParam = this.systemParameterList.find(item =>
			            item.param === 'dug_purc_batch_select' &&
			            item.name === '药品库存批次选择开关'
			        );

			        if (batchSwitchParam) {
			            console.log('找到批次号开关参数:', batchSwitchParam);

			            // 判断state是否为1，为1代表启用
			            this.batchSelectionSwitch = batchSwitchParam.state === 1;

			            console.log('批次号开关状态:', {
			                参数名称: batchSwitchParam.name,
			                参数编码: batchSwitchParam.param,
			                参数值: batchSwitchParam.value,
			                状态: batchSwitchParam.state,
			                是否启用: this.batchSelectionSwitch
			            });
			        } else {
			            console.warn('未找到批次号开关参数，使用默认值: false');
			            this.batchSelectionSwitch = false;
			        }
			    } else {
			        console.warn('systemParameterList为空，无法初始化批次号开关');
			        this.batchSelectionSwitch = false;
			    }

			    console.log('最终批次号开关状态:', this.batchSelectionSwitch);
			},
			debouncedChinaSearch() {
				clearTimeout(this.chinaSearchDebounce);
				this.chinaSearchDebounce = setTimeout(() => {
					this.handleSearchChinaMedicine()
				}, this.searchDebounceTime);
			},

			// 分页处理
			handleWestPageChange(page) {
				this.westPagination.currentPage = page
			},

			handleChinaPageChange(page) {
				this.chinaPagination.currentPage = page
			},

			formatPrescriptionContent(content) {
				if (!content) return '';

				// 1. 按括号分割内容（保留括号）
				const items = content.split(/($[^)]+$)/g)
					.filter(item => item.trim());

				// 2. 重新组合为换行字符串
				return items.join('\n');
			},

			async handleOpenDrawer(val) {
				try {
					switch (val) {
						case 'outpatientsDiagnosis':
							await this.previewOutpatientsDiagnosisCombined();
							this.outpatientsDiagnosis = true;
							break;

						case 'medicalRecord':
							await this.previewMedicalRecord();
							this.medicalRecord = true;
							break;
					}
				} catch (error) {
					console.error('打开抽屉出错:', error);
					this.$message.error('加载数据失败，请重试');
				}
			},

      async planWestPrescriptionData(data) {
        // 1. 诊所数据（data 里没有，仍走接口）
        const clinicData = await doccliniclist();
        const clinic = clinicData.data.map(item => ({
          id: item.id,
          label: item.name
        }));

        // 2. 生成药品 HTML（无分组，逐条渲染）
        const generatePrescriptionHtml = (items) => {
          const renderDrugItem = (item) => {
            // 用法 / 频次 通过字典映射
            const medcWay = this.routeOptions.find(opt => opt.id === item.routeId)?.label || '';
            const usedfrqu = this.medicationFrequencyOptions.find(opt => opt.id === item.frequencyId)?.label || '';

            // Sig 行：单次剂量 + 剂量单位 + 用法 + 频次 + 天数
            const sigParts = [
              item.singleDose && item.doseUnit ? `${item.singleDose}${item.doseUnit}` : '',
              medcWay,
              usedfrqu
            ].filter(Boolean).join(' ');

            const sigText = `${sigParts}${item.periodDays ? ` ${item.periodDays}天` : ''}`;

            return `
      <div style="margin: 4px 0; line-height: 1.3; font-family: '仿宋'; font-size: 15px;">
          <div style="display: flex; align-items: flex-start; width: 100%;">
              <span style="color: #333; font-weight: bold; width: 130px; text-align: right; margin-right: 12px; flex-shrink: 0; word-break: keep-all;">${item.itemName || ''}</span>
              <span style="color: #000; flex: 1; min-width: 0; margin-right: 12px; word-break: break-all;">${item.specification || ''}</span>
              <span style="color: #000; width: 110px; flex-shrink: 0; white-space: nowrap;">共${item.quantity ?? ''}${item.unitName || ''}</span>
          </div>
          <div style="margin-left: 142px; color: #000; margin-top: 1px;">
              Sig: ${sigText}
          </div>
      </div>
    `;
          };

          const itemsHtml = (items || []).map(renderDrugItem).join('');

          return `
    <div style="font-weight: bold; font-size: 12px; margin-bottom: 8px; font-family: '仿宋';">Rp:</div>
    <div style="padding-left: 8px;">${itemsHtml}</div>
  `;
        };

        // 3. 取 items
        const items = (Array.isArray(data) ? data[0]?.items : data?.items) || [];

        // 4. 取当前订单（用于患者、诊断、备注、金额等）
        const order = Array.isArray(data) ? data[0] : data;
        console.log('items:', items);
        console.log('medicineGroupsHtml:', generatePrescriptionHtml(items));

        // 5. 组装打印数据
        return {
          // 诊所名称
          clinicPrescriptionName: (clinic.find(item => item.id === this.userInfo.clinicId)?.label || '') + '处方笺',
          isGrowUp: this.patientForm.ageYear >= 18 ? '成人' : '未成年',
          rxType: this.rxTypeOptions.find(item => item.id === this.addWesternForm.rxType)?.label,

          // 以下尽量从 order 取，取不到再回退到 this
          patId: order?.patientId || this.patientForm.patId,
          prhCostType: this.prhCostOption.find(item => item.id === this.patientForm.prhCostType)?.label,
          name: order?.patientName || this.patientForm.name,
          sex: this.sexOptions.find(item => item.id === parseInt(this.patientForm.sex))?.label,
          age: this.patientForm.ageYear,
          dept: this.deptOptions.find(item => item.id === order?.orderingDeptId)?.label
              || this.deptOptions.find(item => item.id === this.userInfo.selDept)?.label,
          seedoctorId: order?.orderingDoctorId || this.patientChooseForm.seeDoctorId,
          date: order?.orderedAt || order?.submittedAt || dayjs().format('YYYY-MM-DD HH:mm:ss'),
          address: this.conerPleasett + this.patientForm.conerAddName,
          westernDiagnos: order?.diagnosisName || this.addSeedoctorForm.westernDiagnos,
          remake: order?.remark ?? this.westernMedicineForm.remark,
          doctor: this.userInfo.staffName,

          prescriptionAmount: order?.totalAmount != null
              ? Number(order.totalAmount).toFixed(2)
              : this.patientPrescription.reduce((sum, item) => sum + (item.saleAmt || 0), 0).toFixed(2),

          phayId: this.westPhayOption[0].label,
          medicineGroups: generatePrescriptionHtml(items)
        };
      },
      async planChinaPrescriptionData(row) {
        const clinicData = await doccliniclist();
        const clinic = clinicData.data.map(item => ({
          id: item.id,
          label: item.name
        }));

        // 患者基础信息：优先 row，其次 this
        const chinaData = {
          clinicPrescriptionName: (clinic.find(item => item.id === this.userInfo.clinicId)?.label || '') + '处方笺',
          isGrowUp: this.patientForm.ageYear >= 18 ? '成人' : '未成年',
          patId: row.patientId || this.patientForm.patId,
          prhCostType: this.prhCostOption.find(item => item.id === this.patientForm.prhCostType)?.label,
          name: row.patientName || this.patientForm.name,
          sex: this.sexOptions.find(item => item.id === parseInt(this.patientForm.sex))?.label,
          age: this.patientForm.ageYear,
          dept: this.deptOptions.find(item => item.id === row.orderingDeptId)?.label
              || this.deptOptions.find(item => item.id === this.userInfo.selDept)?.label,
          seedoctorId: row.orderingDoctorId || this.patientChooseForm.seeDoctorId,
          date: row.orderedAt || dayjs().format('YYYY-MM-DD HH:mm:ss'),
          address: this.conerPleasett + this.patientForm.conerAddName,
          chinaDiagnose: row.diagnosisName || this.addSeedoctorForm.chinaDiagnose,
          westernDiagnos: row.diagnosisName || this.addSeedoctorForm.westernDiagnos,
          doctor: this.userInfo.staffName,
          phayId: this.chinaPhayOption[0].label,
        };

        // 取中药明细（itemType === 2），有 tcm 本身就是中药
        const tcmItems = (row.items || []).filter(item => item.itemType === 2);

        // 付数：来自 row.tcm.doseCount
        const doseCount = row.tcm?.doseCount ?? 1;
        chinaData.zyfs = doseCount;

        // 逐味药生成 HTML
        tcmItems.forEach((item, index) => {
          // 单付金额 = 每付数量 * 单价
          const singleAmt = ((item.quantity || 0) * (item.unitPrice || 0)).toFixed(2);
          // 剂量单位：优先 doseUnit，否则 unitName，默认 g
          const doseUnit = item.doseUnit || item.unitName || 'g';
          // 单次剂量：中药里 singleDose 就是每付用量
          const singleDose = item.singleDose ?? item.quantity ?? '';

          const line1 = `${item.itemName}${singleDose}${doseUnit}-${singleAmt}元`;
          // 方法名：中药特殊煎法/备注，来自 remark
          const line2 = item.remark?.trim() ? `(${item.remark})` : '';

          chinaData[`chineseMedicine${index + 1}`] =
              `<div style="font-family: monospace; position: relative;">${line1}
                <div style="margin-left: 20px">${line2}</div>
            </div>`;
        });

        // 处方号 & 金额
        chinaData.code = row.orderNo;
        chinaData.prescriptionAmount = Number(row.totalAmount || 0).toFixed(2);

        return chinaData;
      },
			async printWestPrescription(row) {
				const westPrescriptionData = await this.planWestPrescriptionData(row);
				/*console.log(westPrescriptionData, 'westPrescriptionDatawestPrescriptionDatawestPrescriptionData')*/
				westPrescriptionData.code = row.orderNo;
				printUtil.init(westPrescription);
				printUtil.print(westPrescriptionData);
			},

			async printChinaPrescription(row) {
				console.log(row, 'rowrowrow')
				const chinaPrescriptionData = await this.planChinaPrescriptionData(row);
				printUtil.init(chinaPrescription);
				printUtil.print(chinaPrescriptionData);
				await new Promise(resolve => setTimeout(resolve, 1000));
				await Promise.all(
					this.medicalAdviceData.map(item =>
						editDoctoradvice({
							id: item.id,
							print: 1
						})
					)
				);
			},

			async planOutpatientsDiagnosis() {
				const res = await getDiagnosisInfo({
					seeDoctorId: this.patientChooseForm.seeDoctorId
				});
				const result = {};
				const allergen = this.aiseListOptions.find(item => item.id === this.patientForm.aiseId)?.label ?? null;
				result.sex = this.sexOptions.find(item => item.id === res.data.sex).label;
				result.ntlyId = this.ntlyOptions.find(item => item.id === res.data.ntlyId)?.label;
				result.naty = this.nationOption.find(item => item.id === res.data.naty)?.label;
				result.professionalTitle = this.profttlOption.find(item => item.id === parseInt(res.data
					.professionalTitle))?.label;
				result.conerAddName = this.patientForm.conerAddJoinName + this.patientForm.conerAddName;
				result.regTime = res.data.regTime === null ? res.data.seeDoctorTime : res.data.regTime;
				result.phrAlgsDrugAiseId = res.data.phrAlgsDrugAiseId === null ? allergen : res.data.phrAlgsDrugAiseId;
				result.seeDoctorId = this.patientChooseForm.seeDoctorId;
				result.mrgState = this.mrgStateOptions.find(item => item.id === res.data.mrgState)?.label;
				const west = res.data.diagnosisList.filter(item => item.diagnosticCategory === '1'); // 西药
				const china = res.data.diagnosisList.filter(item => item.diagnosticCategory === '2'); // 中药
				west.slice(0, 3).forEach((item, index) => {
					const num = index + 1;
					result[`diagnosticName${num}`] = item.diagnosticName;
					result[`icdCode${num}`] = item.icdCode;
				});
				china.slice(0, 3).forEach((item, index) => {
					const num = index + 4;
					result[`diagnosticName${num}`] = item.diagnosticName;
					result[`icdCode${num}`] = item.icdCode;
				});
				const mergedRes = {
					...res.data,
					...result
				};
				console.log(mergedRes, 'mergedResmergedResmergedResmergedResmergedResmergedResmergedRes')
				return mergedRes;
			},

			planMedicalRecord() {
				// 1. 处理需要查找的字段
				const department = this.deptOptions.find(item => item.id === this.userInfo.selDept)?.label ?? null;
				const allergen = this.aiseListOptions.find(item => item.id === this.patientForm.aiseId)?.label ?? null;
				const bloodPressure = this.patientForm.syspre && this.patientForm.diapre ?
					`${this.patientForm.syspre}-${this.patientForm.diapre}mmoL` :
					null;
				const therapyOpinion = this.medicalAdviceData
					.filter(item => item.orderType !== 5)
					.map(item => `(${item.content})`);
				if (therapyOpinion.length > 0) {
					therapyOpinion.unshift('');
				}
				console.log(this.patientForm, 'this.patientFormthis.patientFormthis.patientForm')
				return {
					patId: this.patientForm.patId,
					name: this.patientForm.name,
					sex: this.patientForm.sex === '1' ? '男' : '女',
					ageYear: this.patientForm.ageYear,
					seedoctorcType: this.patientForm.repeated === 1 ? '复诊' : '初诊',
					seeDoctorDate: dayjs().format('YYYY-MM-DD'),
					selDept: department,
					syspre: bloodPressure,
					westernDiagnos: this.addSeedoctorForm.westernDiagnos,
					patientTell: this.addSeedoctorForm.patientTell,
					nowHistory: this.addSeedoctorForm.nowHistory,
					beforeHistory: this.addSeedoctorForm.beforeHistory,
					aiseId: allergen,
					conerTel: this.patientForm.conerTel,
					conerAddName: this.patientForm.conerAddJoinName + this.patientForm.conerAddName,
					userId: this.userInfo.staffName,
					currentDate: dayjs().format('YYYY-MM-DD'),
					therapyOpinion: therapyOpinion.join('&nbsp;')
				};
			},

			async printMedicalRecord() {
				try {
					// 1. 先执行打印
					printUtil.init(medicalRecordOutpatient);
					printUtil.print(this.planMedicalRecord());
					await new Promise(resolve => setTimeout(resolve, 1000));
					await Promise.all(
						this.medicalAdviceData.map(item =>
							editDoctoradvice({
								id: item.id,
								print: 1
							})
						)
					);

					await this.resetDisposeAndAdviceData();
				} catch (error) {
					this.$message.error('操作失败');
				}
			},

			async previewMedicalRecord() {
				try {
					// 获取预览内容
					const data = this.planMedicalRecord();

					// 初始化模板
					const template = new hiprint.PrintTemplate({
						template: medicalRecordOutpatient,
            paperSize: { width: 148, height: 'auto' },
					});

					// 获取HTML内容并转换为字符串
					const htmlObj = template.getHtml(data);
					this.medicalRecordHTML = this.extractHtmlString(htmlObj);
				} catch (error) {
					console.error('预览病历文书失败:', error);
					this.$message.error('预览病历文书失败');
				}
			},

			async previewOutpatientsDiagnosisCombined() {
				const res = await this.planOutpatientsDiagnosis()
				// 初始化第一个模板
				const template1 = new hiprint.PrintTemplate({
					template: outpatientsDiagnosis,
          paperSize: { width: 148, height: 'auto' },
				});

				// 获取第一个模板的HTML并转换为字符串

				const htmlObj1 = template1.getHtml(res);
				const html1 = this.extractHtmlString(htmlObj1);

				// 初始化第二个模板
				const template2 = new hiprint.PrintTemplate({
					template: outpatientsDiagnosis2,
          paperSize: { width: 148, height: 'auto' },
				});

				// 获取第二个模板的HTML并转换为字符串
				const htmlObj2 = template2.getHtml(res);
				const html2 = this.extractHtmlString(htmlObj2);

				// 合并两个HTML
				this.outpatientsDiagnosisHTML = `${html1}<hr style="margin: 20px 0; border: 1px dashed #ccc;">${html2}`
			},

			async printOutpatientsDiagnosisCombined() {
				const res = await this.planOutpatientsDiagnosis()
				// 打印第一个模板
				printUtil.init(outpatientsDiagnosis);
				printUtil.print(res);

				// 延迟一会儿（避免浏览器拦截连续打印）
				await new Promise(resolve => setTimeout(resolve, 500));

				// 打印第二个模板
				printUtil.init(outpatientsDiagnosis2);
				printUtil.print(res);
			},

			extractHtmlString(htmlObj) {
				// 如果是jQuery对象
				if (htmlObj && htmlObj.jquery) {
					return htmlObj.html();
				}
				// 如果是DOM元素
				else if (htmlObj && htmlObj.outerHTML) {
					return htmlObj.outerHTML;
				}
				// 如果已经是字符串
				else if (typeof htmlObj === 'string') {
					return htmlObj;
				}
				// 其他情况尝试转换为字符串
				else {
					console.warn('无法识别的HTML对象类型:', htmlObj);
					return String(htmlObj);
				}
			},

      clearWestGroupsCode() {
        const selectedRows = this.$refs.westMedicineTableData.selection;

        // 1. 如果没有选中任何行，提示用户
        if (!selectedRows || selectedRows.length === 0) {
          this.$message.warning('请先选中要取消分组的药品行');
          return;
        }

        // 2. 获取所有选中行所属的分组ID（去重）
        const groupIdsToClear = [...new Set(selectedRows.map(row => row.groupNo).filter(id => id != null))];

        if (groupIdsToClear.length === 0) {
          this.$message.warning('选中的行不属于任何分组，无需取消');
          return;
        }

        // 3. 清除整个分组：遍历所有行，清除匹配 groupNo 的所有行
        this.westMedicineTableData.forEach(row => {
          if (groupIdsToClear.includes(row.groupNo)) {
            row.groupNo = null;
            row.grpColor = null;
            row._isFrquDisabled = false;
            row._isMedcWayDisabled = false;
          }
        });

        // 4. 重新渲染分组旗帜和禁用状态（关键！）
        this.$nextTick(() => {
          this.renderGroupFlags();       // 根据更新后的数据重新生成旗帜
          this.sortGroupedRows();        // 重新排序（如果有必要）
          this.$refs.westMedicineTableData.clearSelection();
        });
      },

			async createWestGroupsCode() {

				// 1. 获取当前选中行
				const selectedRows = this.$refs.westMedicineTableData.selection;
				if (selectedRows.length === 0) return;

				// 2. 检查给药频率是否一致
				const firstFrquId = selectedRows[0].usedfrquId;
				const medcWayId = selectedRows[0].medcWayId;
				const isFrquSame = selectedRows.every(row => row.usedfrquId === firstFrquId);
				const medicationFrequency = this.medicationFrequencyOptions.find(item => item.id === firstFrquId)
					?.label;
				if (!medicationFrequency) {
					this.$message.warning("请选择用药频率再进行分组");
					return;
				}
				if (!isFrquSame) {
					// 使用Element UI弹窗替换原生confirm
					try {
						await this.$confirm(
							`所选药品给药方式不一致（存在${selectedRows.length}种），是否强制分组？\n分组后将统一使用第一种【用药频率】:${medicationFrequency}`,
							'提示', {
								confirmButtonText: '强制分组',
								cancelButtonText: '取消',
								type: 'warning'
							}
						);
						// 用户点击确认，继续执行后续代码
					} catch {
						this.$message.warning('已取消分组操作');
						return; // 用户点击取消则终止
					}
				}

				// 4. 生成分组ID和颜色（保持你的原有逻辑）
				const newGroupId = parseInt(String(Date.now()).slice(-5));
				const usedColors = new Set(this.westMedicineTableData.filter(item => item.grpColor).map(item => item
					.grpColor));
				const newColor = this.color.find(c => !usedColors.has(c)) || this.color[0];

				// 5. 更新选中行数据（统一给药频率）
				selectedRows.forEach((row, index) => {
					row.groupNo = newGroupId;
					row.grpColor = newColor;
					row._isFrquDisabled = index > 0; // 第一条不禁用，其他行禁用
					row._isMedcWayDisabled = index > 0; // 第一条不禁用，其他行禁用
					row.usedfrquId = index > 0 ? firstFrquId : row.usedfrquId;
					row.medcWayId = index > 0 ? medcWayId : row.medcWayId;
				});

				// 6. 排序和渲染（保持你的原有逻辑）
				this.sortGroupedRows();
				this.$nextTick(() => {

					this.renderGroupFlags();
					this.$refs.westMedicineTableData.clearSelection();
				});
			},

			sortGroupedRows() {
				this.westMedicineTableData.sort((a, b) => {
					if (a.groupNo && !b.groupNo) return -1; // 有分组的排前面
					if (!a.groupNo && b.groupNo) return 1;
					if (a.groupNo === b.groupNo) return 0; // 相同分组保持原序
					return (a.groupNo || 0) - (b.groupNo || 0); // 不同分组按ID排序
				});
			},

			renderGroupFlags() {
				const table = this.$refs.westMedicineTableData.$el;

				// 1. 清除所有旧旗帜和禁用状态
				table.querySelectorAll('.group-flag, .disabled-frqu').forEach(el => el.remove());

				// 2. 颜色生成器（不同grpStat分配不同颜色）
				const colorMap = {}; // 记录每个grpStat对应的颜色
				const colorPalette = [
					'#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A',
					'#98D8C8', '#F06292', '#7986CB', '#9575CD'
				];
				let colorIndex = 0;

				// 3. 统计分组信息 {groupNo: [行索引]}
				const groupMap = {};
				this.westMedicineTableData.forEach((item, index) => {
					if (item.groupNo) {
						if (!groupMap[item.groupNo]) {
							groupMap[item.groupNo] = [];
							// 为新的grpStat分配颜色（循环使用调色板）
							colorMap[item.groupNo] = colorPalette[colorIndex % colorPalette.length];
							colorIndex++;
						}
						groupMap[item.groupNo].push(index);
					}
				});

				// 4. 处理每个分组
				Object.entries(groupMap).forEach(([groupNo, rowIndexes]) => {
					if (rowIndexes.length <= 1) return; // 忽略孤立分组

					const groupColor = colorMap[groupNo]; // 获取该分组的颜色

					// 4.1 添加旗帜（所有分组行使用相同颜色）
					rowIndexes.forEach(index => {
						const row = table.querySelectorAll('.el-table__row')[index];
						if (!row) return;

						const firstCell = row.querySelector('.el-table__cell:first-child');
						if (!firstCell) return;

						const flag = document.createElement('div');
						flag.className = 'group-flag';
						flag.innerHTML = `
							                        <svg width="16" height="16" viewBox="0 0 24 24">
							                          <path fill="${groupColor}" d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/>
							                        </svg>
							                      `;
						firstCell.appendChild(flag);
					});

					// 4.2 禁用非首行的用药频率选择器（保持不变）
					rowIndexes.slice(1).forEach(index => {
						const row = table.querySelectorAll('.el-table__row')[index];
						if (!row) return;

						const select = row.querySelector('.usedfrquId-cell .el-select');
						if (select) {
							select.classList.add('disabled-frqu');
							select.querySelector('input').disabled = true;
							select.style.opacity = '0.6';
							select.style.cursor = 'not-allowed';
						}
					});
				});
			},

			handleWestGroups(selectedRows) {
				this.westGroupsTableData = selectedRows;
			},

			async handleAddReception(row) {
				await withLoading(this, '数据加载中...')(async () => {
					this.patientForm = Object.assign({}, this.$options.data.call(this).patientForm)
					this.patientForm.patId = row.cardid;
					await this.handleSearch();
					await this.getRegisterType();
					const mainRegType = this.registerOptions.find(item => item.mainType = 1);
					if (this.registerOptions.length < 1) return this.$message.warning("请去添加挂号类别")
					this.receptionForm.regTypeId = mainRegType.id;
					this.receptionForm.price = mainRegType.odcost;
					await this.handleAddFastReception({
						skipValidation: true
					});
					this.sevenDayDialogVisible = false;
					this.historyMedicalDialogVisible = false;
				});
			},
      async handleQuote(row) {
        try {
          // ===== 1. 检查当前是否有已填写的病历信息 =====
          const hasContent = this.addSeedoctorForm.patientTell ||
              this.addSeedoctorForm.nowHistory ||
              this.addSeedoctorForm.beforeHistory ||
              this.addSeedoctorForm.westernDiagnos ||
              this.addSeedoctorForm.chinaDiagnose;

          if (hasContent) {
            // ===== 有内容 → 弹窗让用户确认是否覆盖 =====
            try {
              await this.$confirm('当前已有病历信息，是否覆盖？', '提示', {
                confirmButtonText: '覆盖',
                cancelButtonText: '取消',
                type: 'warning'
              });
              // 用户点击「覆盖」→ 执行反向赋值
              this.assignMedicalHistory(row);
            } catch {
              // 用户点击「取消」→ 不赋值，继续执行（但当前病历保留不变）
              this.$message.info('保留当前病历信息');
            }
          } else {
            // ===== 没有内容 → 直接赋值 =====
            this.assignMedicalHistory(row);
          }

          // ===== 2. 返诊天数校验 =====
          const res = await getDeptAttribute({ deptId: this.userInfo.selDept });
          if (res.code !== 200) {
            this.$message.error('获取当前科室返诊天数失败');
            return;
          }
          const returnVisitNum = res.data.returnVisitNum ?? 0;
          if (returnVisitNum !== 0) {
            const createTime = dayjs(row.createTime);
            const currentTime = dayjs();
            const hoursDiff = currentTime.diff(createTime, 'hour');
            if (hoursDiff > returnVisitNum * 24) {
              const daysPassed = (hoursDiff / 24).toFixed(1);
              this.$message.warning(`返诊期限已过（允许 ${returnVisitNum} 天，当前已过 ${daysPassed} 天）`);
              return;
            }
          }

          // ===== 3. 获取订单列表 =====
          const orders = await getOrdersByPatientId({
            patientId: row.patientId,
            visitId: row.id,
            unpaidOnly: false
          });

          if (orders.code === 200) {
            // ===== 打开前重置抽屉状态（防止上一个患者残留）=====
            this.showChargeDetail = false;
            this.chargeDetailData = null;
            this.chargeDetailTab = 'items';

            this.chargeTableData = orders.data || [];
            this.chargeDetailDialogVisible = true;
          } else {
            this.$message.error(orders.message || '获取订单列表失败');
          }
        } catch (error) {
          console.error('返诊失败:', error);
          this.$message.error('返诊失败，请重试');
        }
      },

// ===== 抽取赋值方法 =====
      assignMedicalHistory(row) {
        this.addSeedoctorForm.patientTell = row.patientTell || '';
        this.addSeedoctorForm.nowHistory = row.nowHistory || '';
        this.addSeedoctorForm.beforeHistory = row.beforeHistory || '';
        this.addSeedoctorForm.westernDiagnos = row.westernDiagnos || '';
        this.addSeedoctorForm.chinaDiagnose = row.chinaDiagnose || '';

        // 生命体征
        this.patientForm.syspre = row.syspre || '';
        this.patientForm.diapre = row.diapre || '';
        this.patientForm.bloodType = row.bloodType || '';
        this.patientForm.bloodNumber = row.bloodNumber || '';

        this.$message.success('已加载就诊记录信息');
      },
      handleCloseChoosePatient() {
        this.isInputDisabled = false;
        this.patientForm = Object.assign({}, this.$options.data.call(this).patientForm);
        this.patientDialogVisible = false;
			},

			async loadAndDisplayAddress(type = 'coner') {
				try {
					// 1. 确保省级数据已加载
					if (this.provinces.length === 0) {
						await this.loadProvincial();
					}

					// 2. 根据地址类型获取对应数据
					const codeKey = `${type}AddCodeArr`;
					const nameKey = `${type}AddName`;
					const codes = this.patientForm[codeKey] || [];

					let currentNodes = this.provinces;
					const loadedCodes = [];
					const addressNames = [];
					const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code',
					'area_t_code'];

					// 3. 按层级逐级加载
					for (let i = 0; i < codes.length; i++) {
						const code = codes[i];
						const level = i + 1; // 1:省, 2:市, 3:县, 4:镇, 5:乡

						// 尝试从当前层级查找节点
						let targetNode = currentNodes.find(node => node.areaCode === code);

						// 如果未找到，尝试动态加载该级数据
						if (!targetNode) {
							const parentCode = i > 0 ? codes[i - 1] : undefined;
							const params = {
								areaCode: parentCode,
								areaLevel: level,
								condtion: levelConditions[i]
							};

							const res = await getArea(params);
							currentNodes = res.data || [];
							targetNode = currentNodes.find(node => node.areaCode === code);

							// 如果是省级数据，更新this.provinces
							if (level === 1) {
								this.provinces = currentNodes;
							}
						}

						if (!targetNode) {
							break;
						}

						loadedCodes.push(code);
						addressNames.push(targetNode.areaName);
						// 动态加载子级数据（如果未到末级）
						if (!targetNode.leaf && level < 5) {
							const res = await getArea({
								areaCode: code,
								areaLevel: level + 1,
								condtion: levelConditions[level]
							});
							targetNode.children = res.data || [];
							currentNodes = targetNode.children;
						}
					}
					if (type === 'coner') {
						this.patientForm.conerAddJoinName = addressNames.join('');
					}
					this.$nextTick(() => {
						// 先强制清空以触发响应式更新
						this.patientForm[codeKey] = [];

						// 立即重新赋值（不再使用setTimeout）
						this.$nextTick(() => {
							this.patientForm[codeKey] = [...loadedCodes];
							console.log(this.patientForm,
								'this.patientFormthis.patientFormthis.patientForm')
							// 调用内部方法强制更新显示文本
							if (type === "coner") {
								this.conerPleasett = addressNames.join('/');
							} else {
								this.naplPleasett = addressNames.join('/');
							}
							this.addressKey = Date.now(); // 通过key强制刷新组件
						});
					});
				} catch (error) {
					console.error(`加载${type}地址数据失败:`, error);
					this.$message.error('地址加载失败，请重试');
				}
			},

			async loadProvincial() {
				try {
					const res = await getArea({
						areaLevel: 1,
						condtion: 'area_p_code'
					});
					this.provinces = res.data.map(item => ({
						areaCode: item.areaCode,
						areaName: item.areaName,
						areaLevel: 1,
						leaf: false,
					}));
				} catch (error) {
					console.error('加载省级数据失败:', error);
				}
			},

			async loadSelectedPath(type = 'coner') {
				try {
					// 1. 确保省级数据已加载
					if (this.provinces.length === 0) {
						await this.loadProvincial();
					}

					// 2. 根据类型获取对应字段
					const codeKey = `${type}AddCodeArr`;
					const codes = this.patientForm[codeKey] || [];

					// 3. 定义各级请求条件
					const levelConditions = ['area_p_code', 'area_p_code', 'area_c_code', 'area_d_code',
					'area_t_code'];
					let currentNodes = this.provinces;
					const loadedCodes = [];
					const addressNames = [];

					// 4. 按层级逐级加载
					for (let i = 0; i < codes.length; i++) {
						const code = codes[i];
						const level = i + 1; // 1:省, 2:市, 3:区, 4:镇, 5:社区

						// 尝试从当前层级查找节点
						let targetNode = currentNodes.find(node => node.areaCode === code);

						// 如果未找到，动态加载该级数据
						if (!targetNode) {
							const parentCode = i > 0 ? codes[i - 1] : undefined;
							const params = {
								areaCode: parentCode,
								areaLevel: level,
								condtion: levelConditions[i]
							};
							const res = await getArea(params);
							currentNodes = res.data || [];
							targetNode = currentNodes.find(node => node.areaCode === code);

							// 更新省级数据缓存
							if (level === 1) {
								this.provinces = currentNodes;
							}
						}

						if (!targetNode) {
							break;
						}

						loadedCodes.push(code);
						addressNames.push(targetNode.areaName);

						// 动态加载下一级数据（如果未到末级）
						if (level < 5 && (!targetNode.children || targetNode.children.length === 0)) {
							const nextLevelParams = {
								areaCode: code,
								areaLevel: level + 1,
								condtion: levelConditions[level]
							};
							const res = await getArea(nextLevelParams);
							targetNode.children = res.data || [];

							// 如果是第四级，设置其子节点为叶子节点
							if (level === 5) {
								targetNode.children.forEach(item => {
									item.isLeaf = true; // 标记为叶子节点，不显示下拉箭头
								});
							}
						}

						currentNodes = targetNode.children || [];
					}

					this.$nextTick(() => {
						// 强制刷新级联选择器
						this.patientForm[codeKey] = [];
						this.$nextTick(() => {
							setTimeout(() => {
								this.patientForm[codeKey] = [...loadedCodes];
								if (type === 'coner') {
									this.conerPleasett = addressNames.join("/")
								} else {
									this.naplPleasett = addressNames.join("/")
								}
							}, 200);
						});

					});

				} catch (error) {
					console.error(`加载${type}地址路径失败:`, error);
					this.$message.error(`${type === 'coner' ? '联系' : '籍贯'}地址加载失败，请重试`);
				}
			},

			async initAddressData() {
				try {
					// 确保省级数据已加载
					if (this.provinces.length === 0) {
						await this.loadProvincial();
					}

					// 确保naplAddCodeArr不是null
					this.patientForm.naplAddCodeArr = this.patientForm.naplAddCodeArr || [];

					// 如果存在有效编码才加载路径
					if (this.patientForm.naplAddCodeArr.length > 0) {
						await this.loadSelectedPath('napl');
					}
				} catch (error) {
					console.error('地址初始化失败:', error);
				}
			},

			filterChinaMedicationWay() {
				this.chinaMedicationWayOptions = this.medicationWayOptions.filter(
					item => item.lmtSpc === 2
				);
			},

			async handleThrNotChange() {
				if (this.patientForm.thrNot === 0) {
					this.patientForm.name = '';
					return;
				}
				const today = dayjs().format('YYYYMMDD');
				// 生成4个随机大写字母
				const randomChars = Array.from({
						length: 5
					}, () =>
					String.fromCharCode(65 + Math.floor(Math.random() * 26))
				).join('');

				this.patientForm.name = `三无人员${today}_${randomChars}`;
			},

			handleExecutionPL() {
				this.searchForm = Object.assign({}, this.$options.data.call(this).searchForm);

				this.selExecutionPLDialogVisible = false;
			},

			handleCancelTemplate() {
				this.templateDialogVisible = false;
			},

			computeFrequencyNum(val) {
				const frequency = JSON.parse(JSON.stringify(
					this.medicationFrequencyOptions.find(item => item.id === this.searchForm.usedfrquId)
				));

				if (!frequency || frequency.frquCnt === 0) return; // 避免除零错误

				if (!frequency || frequency.frquPrd <= 0) return; // 避免无效值

				// 计算 executionDays
				if (frequency.frquPrd > frequency.frquCnt) {
					const day = Math.ceil(Math.ceil(val / frequency.frquCnt) * frequency.frquPrd);
					this.$set(this.searchForm, 'executionDays', day);
				} else {
					this.$set(this.searchForm, 'executionDays', Math.ceil(val / frequency.frquCnt));
				}
			},

			computeFrequencyDay(val) {
				const frequency = JSON.parse(JSON.stringify(this.medicationFrequencyOptions.find(item => item.id === this
					.searchForm.usedfrquId)));
				this.$set(this.searchForm, 'executionNum', frequency.frquCnt * val);
			},

			computeFrequency() {
				const frequency = JSON.parse(JSON.stringify(this.medicationFrequencyOptions.find(item => item.id === this
					.searchForm.usedfrquId)));
				console.log(frequency, 'frequencyfrequencyfrequencyfrequency')
				this.$set(this.searchForm, 'executionDays', frequency.frquPrd);
				this.$set(this.searchForm, 'executionNum', frequency.frquCnt);
			},

			validateDose() {
				if (this.editDoseValue <= 0) {
					this.$message.warning('用量必须大于0');
					this.editDoseValue = 1; // 重置为最小值
				}
			},
			validateChinaDrugPrice() {
				if (this.editChinaDrugPrice <= 0) {
					this.$message.warning('用量必须大于0');
					this.editChinaDrugPrice = 1; // 重置为最小值
				}
			},

			async resetDisposeAndAdviceData() {
				const res = await getDoctoradvice({
					seeDoctorId: this.patientChooseForm.seeDoctorId
				});
				const res2 = await getDoctordispose({
					seeDoctorId: this.patientChooseForm.seeDoctorId
				});
				this.doctordisposeTableData = res2.data.map(item => ({
					...item,
					odcost: item.executionPrice,
					executeOdcost: item.executionAmount,
					doctorName: item.staffId,
					deptName: item.executDeptId,
					count: item.num
				}));
				this.$set(this, 'medicalAdviceData', [...res.data]);
			},

			async resetWestMedicineData() {
				this.westMedicineTableData = [];
				const [res2, res5] = await Promise.all([
					getReceptionDiagnosis({
						category: 1,
						seeDoctorId: this.patientChooseForm.seeDoctorId
					}),
					getDoctoradvice({
						seeDoctorId: this.patientChooseForm.seeDoctorId
					}),
				]);
				this.medicalAdviceData = res5.data;
				this.addSeedoctorForm = {
					...this.addSeedoctorForm,
					westernDiagnos: res2.map(item => `(${item.diagnosticName})`).join('') || '',
					doctordisposePrescription: res5.data.filter(item => item.orderType === 4).map(item =>
						`${item.content}`).join('') || '',
				};
				this.medicalAdviceData = res5.data.map(item => {
					// 处理 orderType === 0 的数据
					if (item.orderType === 0) {
						let processedContent = item.content
							.replace(/\/n/g, '\n') // 统一换行符格式
							.split('\n')
							.map(line => line.trim()) // 去除首尾空格
							.filter(line => line.length > 0) // 过滤空行
							.map(line => line.startsWith('(') && line.endsWith(')') ? line :
							`(${line})`) // 智能加括号
							.join('\n');
						return {
							...item,
							content: processedContent
						};
					}
					if (item.skintstDicm === 1) {
						if (item.skintstDicmResult === 2) {
							item.content += '\n（皮试结果:阳性）';
						} else if (item.skintstDicmResult === 1) {
							item.content += '\n（皮试结果:阴性）';
						} else if (item.skintstDicmResult === 0) {
							item.content += '\n（皮试结果:未知）';
						}
					}
					// 其他 orderType 的数据原样返回
					return item;
				});
				this.selWestMedicineDialog = false;
				this.addWesternForm = Object.assign({}, this.$options.data.call(this).addWesternForm)
				this.westernMedicineForm = Object.assign({}, this.$options.data.call(this).westernMedicineForm)
			},

			async batchDelOneAdvice() {
				if (this.multipleActiveSelection.length < 1) return this.$message.warning("请勾选数据后再进行操作")
				this.multipleActiveSelection.forEach(item => {
					this.delOneAdvice({
						id: item.id
					})
				})
			},

			async delOneAdvice(row) {
				try {
					const res = await delOneAdvice({
						id: row.id
					});
					if (res.code === 200) {
						const res2 = await getDoctoradvice({
							seeDoctorId: this.patientChooseForm.seeDoctorId
						});
						this.medicalAdviceData = res2.data;
						await this.resetWestMedicineData();
						await this.resetDisposeAndAdviceData();
					} else {
						this.$message.warning(res.message)
					}
				} catch (error) {
					this.$message.error("系统异常:请联系管理员")
				} finally {

				}

			},

			handleCancelSkinTest() {
				this.$refs.skinTestForm.clearValidate();
				this.isSkinTestDoseDialog = false;
				this.westernMedicineSearchQuery = Object.assign({},
					this.$options.data.call(this).westernMedicineSearchQuery
				);
			},

			handleConfirmSkinTest() {
				this.$refs.skinTestForm.validate((valid) => {
					if (valid) {
						// 表单验证通过，执行原有逻辑
						const index = this.westMedicineTableData.findIndex(
							item => item.drugId === this.westernMedicineSearchQuery.id
						);
						if (index !== -1) {
							this.$set(
								this.westMedicineTableData[index],
								'skintstDicm',
								this.westernMedicineSearchQuery.isSkinTest
							);
						}
						// 重置表单数据
						this.westernMedicineSearchQuery = Object.assign({},
							this.$options.data.call(this).westernMedicineSearchQuery
						);
						this.isSkinTestDoseDialog = false;
					} else {
						// 验证失败，不执行任何操作
						return false;
					}
				});
			},

			isTransfusion(id, row) {
				const res = this.medicationWayOptions.find(item => item.id === id);
				if (!res) return;
				row.medcWayType = res.type === 2;
				if (res.type !== 2) {
					this.$set(row, 'speed', '');
				}
				if (row.groupNo != null) {
					this.westMedicineTableData.forEach(item => {
						if (item.groupNo === row.groupNo) {
							this.$set(item, 'medcWayId', id);
							this.$set(item, 'medcWayType', res.type === 2);
							if (res.type !== 2) {
								this.$set(item, 'speed', '');
							}
						}
					});
				}
			},

			handleAddChinaMakeMethod() {
				const index = this.chinaMedicineTableData.findIndex(item =>
					item.drugId === this.checkedchinaPrescriptionId
				)
				if (index !== -1) {
					this.$set(this.chinaMedicineTableData, index, {
						...this.chinaMedicineTableData[index],
						methodId: this.checkedchinaMakeMethod.id,
						methodName: this.checkedchinaMakeMethod.label
					})
				}
				this.creationMethodDialogVisible = false;
			},

			handleCheckedChinaMakeMethod(row, index) {
				this.active = index;
				this.checkedchinaMakeMethod = row;
			},

			handleMedicineContextMenu(row, column, event) {
				event.preventDefault();
				this.showChinaReception = true;
				this.contextMenuLeft = event.clientX;
				this.contextMenuTop = event.clientY;
				this.chinaReceptionRowData = row;
				document.addEventListener('click', this.closeMedicineMenu);
			},

			handleMedicineContextMenu2(row, column, event) {
				event.preventDefault();
				this.showChinaReception2 = true;
				this.contextMenuLeft = event.clientX;
				this.contextMenuTop = event.clientY;
				this.chinaReceptionRowData2 = row;
				document.addEventListener('click', this.closeMedicineMenu2);
			},

			closeMedicineMenu() {
				this.showChinaReception = false;
				document.removeEventListener('click', this.closeMedicineMenu);
			},

			closeMedicineMenu2() {
				this.showChinaReception2 = false;
				document.removeEventListener('click', this.closeMedicineMenu);
			},

			handleMethodNote(row, e) {
				console.log(row, e, 'handleMethodNotehandleMethodNote')
				this.creationMethodDialogVisible = true;
				this.checkedchinaPrescriptionId = row.drugId;
			},

			handleClearMethod(row, e) {
				delete row.methodId;
				delete row.methodName;
			},

			openDoseDialog(row, index) {
				this.currentEditIndex = index;
				this.editDoseValue = row.sdoseCnt;
				this.showDoseDialog = true;
			},

			openChinaPriceDialog(row, index) {
				this.currentEditIndex = index;
				this.editDoseValue = row.sdoseCnt;
				this.editChinaDrugPrice = row.sumPrice;
				this.editChinaDrugDialog = true;
			},

			confirmEditDose() {
				if (this.currentEditIndex >= 0) {
					const item = this.chinaMedicineTableData[this.currentEditIndex];
					this.chinaMedicineTableData[this.currentEditIndex].sdoseCnt = this.editDoseValue;
					this.chinaMedicineTableData[this.currentEditIndex].sumPrice = item.isFixPrice === 1 ? item
						.fixMinSalePric * item.sdoseCnt : item.sdoseCnt * item.minSalePric;
					this.chinaMedicineTableData[this.currentEditIndex].isEdit = 1;
					this.showDoseDialog = false;
				}
			},

			confirmEditChinaPrice() {
				if (this.currentEditIndex >= 0) {
					this.chinaMedicineTableData[this.currentEditIndex].sumPrice = this.editChinaDrugPrice;
					this.chinaMedicineTableData[this.currentEditIndex].isEdit = 1;
					this.editChinaDrugDialog = false;
				}
			},

			handleClose(done) {
				done();
			},

			handleModifyDosage(row) {
				const findIndex = this.chinaMedicineTableData.findIndex(item => item.drugId === row.drugId)
				this.openDoseDialog(row, findIndex);
			},

			handleModifyMoney(row) {
				const findIndex = this.chinaMedicineTableData.findIndex(item => item.drugId === row.drugId)
				this.openChinaPriceDialog(row, findIndex);
			},

			handleDeleteMedicine(row, e) {
				const index = this.chinaMedicineTableData.findIndex(item => item.drugId === row.drugId);
				if (index !== -1) {
					// 创建新数组赋值
					this.chinaMedicineTableData = [
						...this.chinaMedicineTableData.slice(0, index),
						...this.chinaMedicineTableData.slice(index + 1)
					];
					this.getChinaDosageSum();
				}
			},

			handleDeleteMedicine2(row, e) {
				const index = this.chinaTemplateMedicineTableData.findIndex(item => item.drugId === row.drugId);
				if (index !== -1) {
					// 创建新数组赋值
					this.chinaTemplateMedicineTableData = [
						...this.chinaTemplateMedicineTableData.slice(0, index),
						...this.chinaTemplateMedicineTableData.slice(index + 1)
					];
				}
			},

			handleNumericInput() {
				let value = this.addChinaForm.sdoseCnt;

				// 1. 移除非数字和小数点
				value = value.replace(/[^\d.]/g, '');

				// 2. 不能以小数点开头
				value = value.replace(/^\./g, '');

				// 3. 只保留第一个小数点（简化的正确写法）
				// 将字符串按小数点分割，只保留第一部分和第二部分（如果存在）
				const parts = value.split('.');
				if (parts.length > 1) {
					value = parts[0] + '.' + parts.slice(1).join('');
				}

				// 4. 再次确保只有一个小数点
				// 找到第一个小数点的位置，去掉后面的所有小数点
				const dotIndex = value.indexOf('.');
				if (dotIndex !== -1) {
					value = value.substring(0, dotIndex + 1) + value.substring(dotIndex + 1).replace(/\./g, '');
				}

				// 5. 限制小数点后最多2位
				if (value.includes('.')) {
					const decimalParts = value.split('.');
					value = decimalParts[0] + '.' + (decimalParts[1] || '').slice(0, 2);
				}

				// 6. 验证
				if (value && parseFloat(value) <= 0) {
					value = '';
					this.$message.warning("请规范填写用量!!!");
				}

				this.addChinaForm.sdoseCnt = value;
			},

			async handleDosageEnter() {
				if (JSON.stringify(this.chinaChekeCurrentData) === '{}') {
					this.$message.warning("请选择药品!");
					return;
				}
				if (!this.addChinaForm.sdoseCnt) return this.$message.warning("请输入剂量!")
				const isExist = this.chinaMedicineTableData.some(
					item => item.drugId === this.chinaChekeCurrentData.drugId
				);
				if (isExist) {
					this.$message.error(`药品【${this.chinaChekeCurrentData.drugName}】已存在处方中!`);
					return;
				}
				const newItem = JSON.parse(JSON.stringify(this.chinaChekeCurrentData));
/*
				this.chinaChekeCurrentData.sumPrice = await this.checkChinaDrug(newItem);
*/
				this.chinaChekeCurrentData.medicineType = 2;
				newItem.sdoseCnt = parseInt(this.addChinaForm.sdoseCnt);
				newItem.sumPrice = newItem.isFixPrice === 1 ? this.chinaChekeCurrentData.fixMinSalePric * newItem
					.sdoseCnt : this.chinaChekeCurrentData.minSalePric * newItem.sdoseCnt;
				newItem.isEdit = newItem.isFixPrice === 1 ? 1 : 0;
				this.chinaMedicineTableData.push(newItem)
				this.chinaMedicineSearchQuery = '';
				this.chinaChekeCurrentData = {};
				this.getChinaDosageSum();
			},


			async checkChinaDrug(row) {
				const res = await checkChinaDrug({
					drugId: row.drugId
				});
				if (res.code === 200) {
					const requiredCount = this.addChinaForm.sdoseCnt;
					const minPurcCountSum = res.data.reduce((sum, item) => sum + item.purcCnt, 0)

					if (requiredCount > minPurcCountSum) {
						this.$message.warning("中药库存不足");
						this.$set(this.addChinaForm, 'saleAmt', null)
						return;
					}
					let remainingCount = requiredCount;
					let totalAmount = 0;

					for (let i = 0; i < res.data.length; i++) {
						const batch = res.data[i];
						const batchStock = Number(batch.purcCnt) || 0;
						if (batchStock <= 0) continue;
						const takeFromThisBatch = Math.min(batchStock, remainingCount)

						totalAmount += takeFromThisBatch * batch.minSalePric;
						remainingCount -= takeFromThisBatch;
					}

					console.log(totalAmount, 'totalAmounttotalAmount')
					return parseFloat(totalAmount.toFixed(2));
				}
			},
			handleConfirmed(row, newValue) {
				if (!row.hasOwnProperty('originalName')) {
					this.$set(row, 'originalName', row.name.replace('?', ''))
				}

				// 2. 根据复选框状态处理名称
				if (newValue === 1) {
					// 勾选状态:移除问号
					this.$set(row, 'name', row.originalName)
				} else {
					// 取消勾选:添加问号
					this.$set(row, 'name', row.originalName + '?')
				}
			},

			getChinaDosageSum() {
				// 计算总药量（保留2位小数）
				this.addChinaForm.chinaMedicineSum = parseFloat(
					(this.chinaMedicineTableData.reduce(
						(sum, item) => sum + (Number(item.sdoseCnt) || 0),
						0
					) * (Number(this.addChinaForm.tcmCnt) || 1)).toFixed(2)
				);

				this.addChinaForm.predictMoney = parseFloat(
					(this.chinaMedicineTableData.reduce(
						(sum, item) => sum + (Number(item.sumPrice) || 0),
						0
					) * (Number(this.addChinaForm.tcmCnt) || 1)).toFixed(2)
				);

				const tcmCnt = Math.max(1, Number(this.addChinaForm.tcmCnt) || 1);

				this.chinaMedicineTableData.forEach(item => {
					item.tcmCnt = tcmCnt;
					item.sdoseSum = parseFloat(
						((Number(item.sdoseCnt) || 0) * tcmCnt).toFixed(2)
					);
				});
			},

			getWestSdoseSum(row) {
				// 标记开始自动计算
				this.isAutoCalculationInProgress = true;
        console.log(row,'rowrowrowrow')

				const sdoseCnt = parseFloat(row.sdoseCnt);
				const prdDays = parseFloat(row.prdDays);
				const prdCnt = parseFloat(row.prdCnt);
				const usedfrquData = this.medicationFrequencyOptions.find(item => item.id === row.usedfrquId);
        console.log(sdoseCnt,'usedfrquDatausedfrquData')
        console.log(prdDays,'usedfrquData')
        console.log(usedfrquData,'usedfrquDatausedfrquData')
				if (!usedfrquData) {
					this.isAutoCalculationInProgress = false;
					return;
				}

				const unitDose = parseFloat(row.unitDose);

				if (row.sdoseSum === undefined || row.sdoseSum === null || isNaN(row.sdoseSum)) {
					this.$set(row, 'sdoseSum', '待计算');
				}

				if (isNaN(sdoseCnt) || isNaN(prdDays) || isNaN(unitDose)) {
					this.$set(row, 'sdoseSum', '待计算');
					this.$set(this.westernMedicineForm, 'prescriptionAmt', '待计算');
					this.isAutoCalculationInProgress = false;
					return;
				}

				// 检查是否 > 0
				if (sdoseCnt <= 0 || prdDays <= 0 || unitDose <= 0) {
					this.$message.warning("单次剂量、周期次数、周期天数必须大于 0！");
					this.$set(row, 'sdoseSum', '待计算');
					this.$set(this.westernMedicineForm, 'prescriptionAmt', '待计算');
					this.isAutoCalculationInProgress = false;
					return;
				}

				// 保存原始 isEdit 状态
				const originalIsEdit = row.isEdit;
        const saleUntIndex = row.saleUntOption.findIndex(item => item.id === row.saleUnt);
				// 最小单位-单次取整（saleUnt=1且roundUnt=1）
				if (saleUntIndex === 0 && row.roundUnt === 1) {
					const cnt = Math.ceil(sdoseCnt / row.unitDose) * prdDays * usedfrquData.frquCnt;
					this.$set(row, 'sdoseSum', parseFloat((sdoseCnt * usedfrquData.frquCnt * prdDays).toFixed(2)));
					this.$set(row, 'cnt', cnt);
					this.$set(row, 'saleAmt', parseFloat((cnt * row.fixMinSalePric).toFixed(2)));
				}

				// 最小单位-处方取整（saleUnt=1且roundUnt=2/3）
				else if (saleUntIndex === 0 && (row.roundUnt === 2 || row.roundUnt === 3)) {
					const cnt = Math.ceil((sdoseCnt / row.unitDose) * usedfrquData.frquCnt * prdDays);
					this.$set(row, 'sdoseSum', parseFloat((row.unitDose * cnt).toFixed(2)));
					this.$set(row, 'cnt', cnt);
          this.$set(row, 'saleAmt', parseFloat((cnt * row.fixMinSalePric).toFixed(2)));
				}

				// 包装单位-处方取整（saleUnt=2且roundUnt=2/3）
				else if (saleUntIndex === 1 && (row.roundUnt === 2 || row.roundUnt === 3)) {
					const pacUnitDose = row.pacCnt * parseFloat(row.unitDose);
					const cnt = Math.ceil((usedfrquData.frquCnt * sdoseCnt * prdDays) / pacUnitDose);
					this.$set(row, 'sdoseSum', parseFloat((sdoseCnt * usedfrquData.frquCnt * prdDays).toFixed(2)));
					this.$set(row, 'cnt', cnt);
          this.$set(row, 'saleAmt', parseFloat((cnt * row.fixPacSalePric).toFixed(2)));

        }

				// 包装单位-单次取整（saleUnt=2且roundUnt=1）
				else if (saleUntIndex === 1 && row.roundUnt === 1) {
					const cnt = Math.ceil((usedfrquData.frquCnt * sdoseCnt * prdDays) / row.pacCnt);
					this.$set(row, 'sdoseSum', parseFloat((usedfrquData.frquCnt * sdoseCnt * prdDays).toFixed(2)));
					this.$set(row, 'cnt', cnt);
          this.$set(row, 'saleAmt', parseFloat((cnt * row.fixPacSalePric).toFixed(2)));

        }

				row.prdCnt = row.prdDays * usedfrquData.frquCnt;

				// 计算总金额
				this.westernMedicineForm.prescriptionAmt = parseFloat(
					this.westMedicineTableData
					.reduce((sum, item) => sum + (item.amount || 0), 0)
					.toFixed(2)
				);

				// 恢复原始 isEdit 状态（如果是自动计算触发的）
				if (originalIsEdit !== undefined && originalIsEdit !== row.isEdit) {
					this.$set(row, 'isEdit', originalIsEdit);
				}

				// 标记自动计算结束
				this.isAutoCalculationInProgress = false;
			},

			async selectDrugDosageForm() {
				if (this.drugDosageOption.length > 0) return;
				const res = await selectDrugDosageForm();
				this.drugDosageOption = res.data.map(item => {
					return {
						id: item.id,
						label: item.dosageName
					}
				})
			},

			async getDosaUnt() {
				if (this.dosaUntOptions.length > 0) return;
				const res = await getDosaUnt();
				this.dosaUntOptions = res.data.map(item => {
					return {
						id: item.id,
						label: item.name
					}
				})
			},

			async getDrugUnt() {
				if (this.drugUntOptions.length > 0) return;
				const res = await getDrugUnt();
				this.drugUntOptions = res.data.map(item => {
					return {
						id: item.id,
						label: item.name
					}
				})
        console.log(this.drugUntOptions,'this.drugUntOptionsthis.drugUntOptions')
			},

			async getMedicationFrequency() {
				if (this.medicationFrequencyOptions.length > 0) return;
				const res = await getMedicationWay();
				this.medicationFrequencyOptions = res.data.map(item => {
					return {
						id: item.id,
						label: item.name,
						frquCnt: item.frquCnt,
						frquPrd: item.frquPrd
					}
				})
			},

			async handleSearchChinaMedicine() {
				// zcw++新增：检查输入框的值，如果为空则直接返回，不执行搜索逻辑
				    if (!this.medicineSearchQuery || this.medicineSearchQuery.trim() === '') {
				        this.searchTriggered = false;
				        this.queryChinaMedicineData = [];
				        // 重点：即使点击了输入框，如果值为空，也不显示表格
				        this.showWestTable = false; // 注意：这里控制的是同一个弹窗变量
				        return;
				    }
				if (!this.preVerificationUserInfo()) return
				this.searchTriggered = true
				try {
					const res = await getChinaDugdpurctable({
						condition: this.chinaMedicineSearchQuery
					});
					this.queryChinaMedicineData = res.data;
					this.tableMedicineKey++;
				} catch (error) {
					console.error('搜索失败:', error)
					this.queryChinaMedicineData = []
				}
			},

			async handleSearchWestMedicine() {
				// zcw++新增：检查输入框的值，如果为空则直接返回，不执行搜索逻辑
				    if (!this.medicineSearchQuery || this.medicineSearchQuery.trim() === '') {
				        this.searchTriggered = false;
				        this.queryWestMedicineData = [];
				        // 重点：即使点击了输入框，如果值为空，也不显示表格
				        this.showWestTable = false;
				        return;
				    }
				if (!this.preVerificationUserInfo()) return
				this.searchTriggered = false;
				try {
          const res = await getDrugByCondition({
            drugType: 1,
            condition: keyword,
          });
					/*const res = await getDrugByCondition({
					  condition: this.westMedicineSearchQuery,
					  rxType:this.addWesternForm.rxType
					});*/

					this.queryWestMedicineData = (res.data?.map(item => ({
						...item,
						dugPurcId: item.id,
						expyDate: item.expyDate ? new Date(item.expyDate).toLocaleString().replace(
							/\//g, '-') : null,
						manuDate: item.manuDate ? new Date(item.manuDate).toLocaleString().replace(
							/\//g, '-') : null
					}))?.map(({
						id,
						...rest
					}) => rest) || [])
					this.tableMedicineKey++;
				} catch (error) {
					console.error('搜索失败:', error);
					this.queryWestMedicineData = [];
				} finally {}
			},

			async handleSelWestTableRowClick(row) {
				if (this.westMedicineTableData.some(item => item.drugId === row.drugId)) {
					try {
						// 弹窗确认是否继续添加
						await this.$confirm(`药品序号:${row.drugId} 药名:${row.drugName} 已存在，是否继续添加？`, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						});
						// 用户点击确定，继续执行
					} catch (error) {
						return;
					}
				}
				if (row.antcLv !== null && this.userPermission.antibioticAuthorization < row.antcLv) {
					this.$message.warning("员工抗生素权限不足");
					return;
				}

				const permissionMap = {
					2: {
						field: 'anesthesiaAuthorization',
						message: "员工麻药类药物权限不足",
						valid: val => parseInt(val) === 1
					},
					3: {
						field: 'poisonPermission',
						message: "员工毒麻类药物权限不足",
						valid: val => parseInt(val) === 1
					},
					4: {
						field: 'spiritPermission',
						message: "员工精神I类药物权限不足",
						valid: val => parseInt(val) === 1
					},
					5: {
						field: 'spiritPermission',
						message: "员工精神II类药物权限不足",
						valid: val => parseInt(val) === 1 || parseInt(val) === 2
					},
				};

				// 过敏原检查 - 添加弹框提示
				const aiseName = this.aiseListOptions.find(item => item.id === this.patientForm.aiseId)?.label;
				if (aiseName && aiseName.trim() !== '') {
					// 分割过敏原关键字（支持逗号、顿号、空格等分隔符）
					const keywords = aiseName.split(/[,，、\s]+/).filter(keyword => keyword.trim() !== '');

					let matchedKeyword = '';

					// 检查是否匹配任何一个关键字
					for (const keyword of keywords) {
						if (row.drugName.includes(keyword.trim())) {
							matchedKeyword = keyword;
							break;
						}
					}

					if (matchedKeyword) {
						console.log(`药品 "${row.drugName}" 包含过敏原关键字 "${matchedKeyword}"`);

						try {
							await this.$confirm(`药品 "${row.drugName}" 包含过敏原 "${matchedKeyword}"，请确认是否继续使用？`, '过敏警告', {
								confirmButtonText: '继续使用',
								cancelButtonText: '取消',
								type: 'warning',
								confirmButtonClass: 'el-button--warning'
							});
							// 用户确认继续使用
						} catch (error) {
							// 用户取消使用
							this.$message({
								type: 'info',
								message: '已取消使用该药品'
							});
							return;
						}
					} else {
						console.log(`药品 "${row.drugName}" 不包含任何过敏原关键字`);
					}
				}

				const permissionCheck = permissionMap[row.dmCode];
				if (permissionCheck && !permissionCheck.valid(this.userPermission[permissionCheck.field])) {
					this.$message.warning(permissionCheck.message);
					return;
				}

				const shouldContinue = await this.checkDiseaseAndConfirm(this.addSeedoctorForm, row);
				if (!shouldContinue) return;

				if (row.skintstDicm === 1) {
					this.isSkinTestDoseDialog = true;
					this.westernMedicineSearchQuery = JSON.parse(JSON.stringify({
						id: row.drugId,
						drugName: row.drugName
					}));
				} else {
					row.skintstDicm = 0;
				}
				row.roundUnt = parseInt(row.roundUnt);
				row.prdDays = 1;
				row.prdCnt = 1;
				row.sdoseCnt = row.minDose;
				row.purcType = parseInt(row.purcType);
				row.rxType = this.addWesternForm.rxType;
				row.prodentpId = row.prodentpNameId;
				row.unt = row.dosUnt;
				row.medicineType = 1;
				row.saleAmt = null;
				row.saleUntName = row.saleUnt === 1 ? row.minUnt : row.pacUnt;
				row.saleUnt = row.saleUnt === 1 ? row.minUnt : row.pacUnt;
				row.saleUntOption = [{
					id: row.minUntId,
					label: row.minUnt
				}, {
					id: row.pacUntId,
					label: row.pacUnt
				}];
        console.log(row.saleUntOption,'row.saleUntOptionrow.saleUntOption')
				row.isEdit = row.isFixPrice === 1 ? 1 : 0;
				row.medcWayType = row.medcWayId != null ?
					this.medicationWayOptions.find(item => item.id === row.medcWayId)?.type === 2 :
					row.medcWayType;
				this.westMedicineSearchQuery = row.drugName;
				this.westMedicineTableData.push(JSON.parse(JSON.stringify(row)));
				this.westMedicineSearchQuery = '';
				this.showWestTable = false;
				console.log(this.westMedicineTableData, 'westMedicineTableDatawestMedicineTableData')
			},

      async handleSelChinaTableRowClick(row) {
        // 深拷贝原始 row 对象
        const newRow = JSON.parse(JSON.stringify(row));

        newRow.dugPurcId = newRow.id;
        delete newRow.id;
        newRow.saleUnt = 1;
        newRow.unt = newRow.minUnt;
        newRow.sdoseUnt = newRow.dosUnt;
        newRow.isEdit = 0;

        this.chinaChekeCurrentData = { ...newRow };
        console.log(this.chinaMedicineTableData, '1233this.chinaMedicineTableData...');
        this.chinaMedicineSearchQuery = newRow.drugName;

        this.$nextTick(() => {
          this.$refs.dosageInput && this.$refs.dosageInput.focus();
        });
      },

			handleCancelSelDiagnose() {
				this.westernSelectedTable = [];
				this.westernDiagnosisModalVisible = false;
				this.chinaSelectedTable = [];
				this.chinaDiagnosisModalVisible = false;
				this.selChinaDiagnosis = {};
				this.westernSearchQuery = '';
				this.chinaSearchQuery1 = '';
				this.chinaSearchQuery2 = '';
			},

			async addReceptionDiagnosis(val) {
				await withLoading(this, '数据提交中...')(async () => {
					switch (val) {
						case 1: // 西药诊断
							if (this.westernSelectedTable.length <= 0) {
								this.$message.warning("请至少选择一项西药诊断!");
								return;
							}

							this.westernSelectedTable = this.westernSelectedTable.map(item => ({
								...item,
								name: item.name.replace(/\?/g, ''),
								diagnosticCategory: '1',
								seeDoctorId: this.patientChooseForm.seeDoctorId,
								insuranceCode: item.chsCode,
								insuranceName: item.chsName,
								diagnosticName: item.name,
								icdCode: item.code,
								remark: item.remarks,
							}));

							const res = await editReceptionDiagnosis(this.westernSelectedTable);
							if (res.code === 200) {
								this.westernDiagnosisModalVisible = false;
								this.addSeedoctorForm.westernDiagnos = '';
								const diagnosticNames = this.westernSelectedTable.map(item =>
									`(${item.diagnosticName})`).join(' ');

								this.addSeedoctorForm = {
									...this.addSeedoctorForm,
									westernDiagnos: diagnosticNames
								};

								const res2 = await editReception({
									id: this.patientChooseForm.seeDoctorId,
									westernDiagnos: diagnosticNames,
								});

								if (res2.code !== 200) {
									this.$message.error(res2.message);
								}

								this.westernSelectedTable = [];
								this.$message.success('西药诊断保存成功');
							} else {
								throw new Error(res.message || '西药诊断保存失败');
							}
							break;

						case 2: // 中药诊断
							if (this.chinaSelectedTable.length <= 0) {
								this.$message.warning("请至少选择一项中药诊断!");
								return;
							}

							this.chinaSelectedTable = this.chinaSelectedTable.map(item => ({
								...item,
								diagnosticName: item.insuranceName + '-' + item
									.chineseSyndromeName,
								diagnosticCategory: '2',
								seeDoctorId: this.patientChooseForm.seeDoctorId,
							}));
							console.log(this.chinaSelectedTable,
								'this.chinaSelectedTablethis.chinaSelectedTablethis.chinaSelectedTable'
								)

							const chinaRes = await editReceptionDiagnosis(this.chinaSelectedTable);
							if (chinaRes.code === 200) {
								this.selChinaDiagnosis = {};
								this.chinaDiagnosisModalVisible = false;
								this.addSeedoctorForm.chinaDiagnose = '';
								const diagnosticNames = this.chinaSelectedTable.map(item =>
									`(${item.diagnosticName})`).join(' ');

								this.addSeedoctorForm = {
									...this.addSeedoctorForm,
									chinaDiagnose: diagnosticNames
								};

								const chinaRes2 = await editReception({
									id: this.patientChooseForm.seeDoctorId,
									chinaDiagnose: diagnosticNames,
								});

								if (chinaRes2.code !== 200) {
									this.$message.error(chinaRes2.message);
								}

								this.chinaSelectedTable = [];
								this.$message.success('中药诊断保存成功');
							} else {
								throw new Error(chinaRes.message || '中药诊断保存失败');
							}
							break;
					}
				});
			},

			resetDiagnoseData(val) {
				switch (val) {
					case 1:
						this.westernSearchQuery = '';
						this.getWesternDiagnosisData();
						break;
					case 2:
						this.chinaSearchQuery1 = '';
						this.getChinaDiagnosisOptions();
						break;
					case 3:
						this.chinaSearchQuery2 = '';
						this.getChinaDiagnosisOptions();
						break;
				}

			},

			removeWesternSelected(index) {
				this.westernSelectedTable.splice(index, 1)
			},

			removeChinaSelected(index) {
				this.chinaSelectedTable.splice(index, 1)
			},

			/*removeDoctordisposeSelected(index) {
				this.doctordisposeTableData.splice(index, 1)
			},*/

			removeWestMedicineTableData(index) {
				console.log(index, 'indexindexindexindex');

				const hasAdviceId = this.medicalAdviceData.some(item => item.adviceId !== null);
				console.log(hasAdviceId, 'indexindexindexindex');
				if (hasAdviceId) {
					const currentItem = this.westMedicineTableData[index];
					console.log(currentItem, 'currentItemcurrentItemcurrentItem');
					if (!currentItem.adviceId) {
						this.westMedicineTableData.splice(index, 1); // 直接 splice 会触发 watch
					} else {
						this.$message.warning("已开处方请在医嘱列表删除!");
					}
				} else {
					this.westMedicineTableData.splice(index, 1); // 直接 splice 会触发 watch
				}

				// 不再需要 this.$forceUpdate();
			},

			async handleWesternSearch() {
				const res = await getDocticdList({
					pageSize: 100,
					condition: this.westernSearchQuery
				});
				this.westernDiagnosisTableData = res.data.map(item => {
					return {
						...item,
						definiteDiagnosis: 0,
					}
				})
			},

			async handleChinaSearch(val) {
				if (val === 1) {
					const res = await getChinaDiseaseByCondition({
						pageSize: 100,
						condition: this.chinaSearchQuery1
					});
					this.chinaDiagnosisTableData1 = res.data;
					return;
				}

				const res = await getSyndromeByCondition({
					pageSize: 100,
					condition: this.chinaSearchQuery2
				});
				this.chinaDiagnosisTableData2 = res.data;
			},

			async addToWesternSelectedTable(row) {
				// 创建新对象以避免修改原始数据
				const newRow = {
					...row,
					name: row.name, // 添加问号标记
					originalName: row.name, // 保存原始名称
					definiteDiagnosis: 1
				};

				const res = this.westernSelectedTable.findIndex(item => item.id === newRow.id);
				if (res === -1) {
					this.westernSelectedTable.push(newRow);
					return;
				}

				console.log(this.westernSelectedTable, 'westernSelectedTable');
				this.$message.error(`(${newRow.name}) 已存在,请勿重复添加!`);
			},

			async addToChinaSelectedTable(row) {
				if (!this.selChinaDiagnosis || Object.keys(this.selChinaDiagnosis).length === 0) return this.$message
					.error(`请添加新的数据!`);
				const isExist = this.chinaSelectedTable.some(item =>
					item.diseaseCode === this.selChinaDiagnosis.code &&
					item.chineseSyndromeCode === row.code
				);
				if (!isExist) {
					const newItem = {
						id: this.selChinaDiagnosis.id,
						syndromeId: row.id,
						diagnosticName: this.selChinaDiagnosis.name,
						diseaseCode: this.selChinaDiagnosis.code,
						chineseSyndromeCode: row.code,
						chineseSyndromeName: row.name,
						icdCode: this.selChinaDiagnosis.code,
						insuranceName: this.selChinaDiagnosis.chsName,
						insuranceCode: this.selChinaDiagnosis.chsCode,
						syndromeName: row.chsName,
						syndromeCode: row.chsCode,
					};
					this.chinaSelectedTable.push(newItem);
					return;
				}

				console.log(this.chinaSelectedTable, 'chinaSelectedTablechinaSelectedTable')
				this.$message.error(`"${this.selChinaDiagnosis.name} + ${row.name}" 组合已存在，请勿重复添加！`);
			},

			async selChinaDiagnosisRow(row) {
				this.selChinaDiagnosis = row;
				console.log(this.selChinaDiagnosis,
					'this.selChinaDiagnosisthis.selChinaDiagnosisthis.selChinaDiagnosis')
				console.log(this.chinaSelectedTable,
					'this.selChinaDiagnosisthis.selChinaDiagnosisthis.selChinaDiagnosis')
			},

			handleRefreshTable() {
				this.loadData();
				setTimeout(() => {
					this.$message.success(`已成功刷新待诊病人${this.tableData1.length}人,接诊病人${this.tableData2.length}人`)
				}, 500);
			},

			async handleAddFastReception(options = {}) {
				await withLoading(this, '数据处理中...')(async () => {
					try {
						const {
							patientForm,
							receptionForm,
							tableData2,
							registerOptions,
							userInfo,
							$refs: {
								patientFormRef
							},
							$message,
							$options
						} = this;
						const patientId = patientForm.id;

						// 前置验证
						if (tableData2.some(({
								patientId: cardid
							}) => cardid === patientId)) {
							return $message.warning("该患者已在就诊列表,请选择直接进行操作!");
						}
						if (!receptionForm.regTypeId) {
							return $message.warning("请选择挂号类别!");
						}
						if (!options.skipValidation && !(await patientFormRef.validate())) {
							return;
						}

						// 优化数据处理
						const lastCode = arr => arr?.slice(-1)[0] || '';
						patientForm.naplAddCode = lastCode(patientForm.naplAddCodeArr);
						patientForm.conerAddCode = lastCode(patientForm.conerAddCodeArr);
						patientForm.thrNot = patientForm.thrNot ? 1 : 0;
						patientForm.age = patientForm.ageYear;
            // 确保 conerAddName 是字符串，避免 null/undefined
            const conerAddNameVal = patientForm.conerAddName || '';
            if (!conerAddNameVal.includes(patientForm.conerAddJoinName || '')) {
              patientForm.conerAddName = (patientForm.conerAddJoinName || '') + conerAddNameVal;
            }

						// 优化对象合并
						const regType = registerOptions.find(item => item.id === receptionForm.regTypeId);
						Object.assign(receptionForm, {
							address: `${patientForm.conerAddJoinName}${patientForm.conerAddName}`,
							age: patientForm.ageYear,
							gender: patientForm.sex,
							doctorId: userInfo.staffId,
							deptId: userInfo.selDept,
							patientId,
							patientName: patientForm.name,
							cardid: patientForm.certno,
							pregnant: patientForm.pregnant ? 1 : 0,
							regTypeName: regType?.label
						});

						// 优化API调用
						const isNewPatient = patientId == null;
						const [apiMethod, action] = isNewPatient
							?
							[addDocphr, '新增'] :
							[editDocphr, '更新'];

						const res2 = await apiMethod(patientForm);
						if (!isNewPatient) {
							checkClinicRelation({
								phrId: patientForm.id
							});
						}

						if (res2.code !== 200) {
							return $message.error(`${action}健康档案失败!` + res2.message);
						} else {
							const docphr = await getDocticdList();
							this.docphrOptions = docphr.data.map(item => {
								return {
									id: item.id,
									label: item.costname,
									odcost: item.odcost,
									executedepid: item.executedepid,
									depexecutetype: item.depexecutetype,
									executemode: item.executemode,
									costmode: item.costmode
								}
							})
							this.$store.commit('preload/updatePreloadData', {
								key: 'getDocphrListOptions',
								data: this.docphrOptions,
							});
						}

						if (isNewPatient) {
							receptionForm.patientId = res2.data;
						}

						const res1 = await addFastReception(receptionForm);
						if (res1.code !== 200) {
							return $message.error("快速接诊失败!");
						}

						// 并行加载数据和处理结果
						await Promise.all([
							this.loadData(),
							this.handleClickReceptionRow({
								...patientForm,
								...receptionForm,
								id: res1.data
							}, 1)
						]);

						// 重置表单
						this.receptionForm = Object.assign({}, $options.data.call(this).receptionForm);
						this.receptionModalVisible = false;

					} catch (error) {
						console.error('快速接诊系统异常:', error);
						this.$message.error("系统异常:请联系管理员");
					}
				});
			},

			async handleSearch() {
				const res = await getDocphrByCondtion({
					condtion: this.patientForm.patId,
					type: 1
				});
				if (res.data.length > 1) {
					this.patientDialogVisible = true;
					this.patientTabelData = res.data;
					this.isInputDisabled = this.patientForm.patId != null;
					return;
				} else if (res.data.length <= 0) {
					this.$message.warning("没有搜索到相关患者!请在健康档案新增或挂号菜单快速建档!")
					return;
				}
				this.patientChooseForm = res.data[0];
				await this.handleChoosePatient();
				this.isInputDisabled = this.patientForm.patId != null;
			},

			handleRegTypePrice(val) {
				this.receptionForm.price = this.registerOptions.find(item => item.id === val).odcost;
			},

			async handleFastReceptionClick() {
				this.conerPleasett = '';
				this.naplPleasett = '';
				this.patientForm = Object.assign({}, this.$options.data.call(this).patientForm)
				const mainRegType = this.registerOptions.find(item => item.mainType = 1);
				if (this.registerOptions.length < 1) return this.$message.warning("请去添加挂号类别")
				this.receptionForm.regTypeId = mainRegType.id;
				this.receptionForm.price = mainRegType.odcost;
				let addressArr = [];
				if (this.systemParameterList.find(item => item.type === 5)?.value !== undefined) {
					addressArr = JSON.parse(this.systemParameterList.find(item => item.type === 5)?.value);
				}
				this.isInputDisabled = false;
				this.receptionModalVisible = true;
				if (addressArr.length > 0) {
					this.patientForm.conerAddCodeArr = addressArr;
					this.patientForm.naplAddCodeArr = addressArr;
					await this.loadAndDisplayAddress('coner');
					await this.loadAndDisplayAddress('napl');
					await this.loadSelectedPath('coner');
					await this.loadSelectedPath('napl');
				}
			},

			handleReceptionClick(row, column, event) {
				event.preventDefault();
				this.showReception = true;
				this.contextMenuLeft = event.clientX;
				this.contextMenuTop = event.clientY;
				this.ReceptionRowData = row;
				document.addEventListener('click', this.closeContextMenu);
			},

			handleWestGroupsFixed(row, column, event) {
				event.preventDefault();
				const selectedRows = this.$refs.westMedicineTableData.selection;
				const isSelected = selectedRows.some(selectedRow => selectedRow.id === row.id);

				if (!isSelected) {
					// 如果未选中，阻止右键菜单显示
					event.preventDefault();
					return;
				}

				// 如果选中，显示右键菜单
				this.showWestGroupsClick = true;
				this.contextMenuLeft = event.clientX;
				this.contextMenuTop = event.clientY;
				document.addEventListener('click', this.closeContextMenu);
			},

			handleCancelReceptionClick(row, column, event) {
				event.preventDefault();
				this.showCancelReception = true;
				this.contextMenuLeft = event.clientX;
				this.contextMenuTop = event.clientY;
				this.ReceptionRowData = row;
				document.addEventListener('click', this.closeContextMenu);
			},

			closeContextMenu() {
				this.showReception = false;
				this.showCancelReception = false;
				this.showAdviceRightClick = false;
				this.showWestGroupsClick = false;
				// 移除事件监听
				document.removeEventListener('click', this.closeContextMenu);
			},

      handleAdviceRightClick(row, column, event) {
        if (row.orderType === 5) return;
        event.preventDefault();

        // 获取视口尺寸
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // 预估菜单尺寸（根据你的菜单项数量调整）
        const menuWidth = 120;  // 菜单宽度
        const menuHeight = 120; // 菜单高度（3个菜单项 * 40px）

        // 计算菜单位置
        let left = event.clientX;
        let top = event.clientY;

        // 检查右侧空间
        if (left + menuWidth > viewportWidth) {
          left = viewportWidth - menuWidth - 10; // 留10px边距
        }

        // 检查底部空间
        if (top + menuHeight > viewportHeight) {
          top = viewportHeight - menuHeight - 10; // 留10px边距
        }

        // 确保不超出左侧和顶部
        if (left < 0) left = 10;
        if (top < 0) top = 10;

        // 设置菜单位置
        this.contextMenuLeft = left;
        this.contextMenuTop = top;
        this.showAdviceRightClick = true;
        this.adviceRightClickRow = row;

        document.addEventListener('click', this.closeContextMenu);
      },

			handleMenuClick(action) {
				this.closeContextMenu();
				switch (action) {
					case 1:
						this.handleSitIn(this.ReceptionRowData);
						this.loadData();
						break;
					case 2:
						this.handlieCancelReception(this.ReceptionRowData)
						this.loadData();
						break;
					case 3:
						this.handlieSucceedReception(this.ReceptionRowData);
						break;
					case 4:
						this.delOneAdvice(this.adviceRightClickRow);
						break;
					case 5:
						this.createWestGroupsCode();
						break;
					case 6:
						this.clearWestGroupsCode();
						break;
					case 7:
						this.batchDelOneAdvice();
						break;
					case 8:
						this.handleGetDataDistributeAndPrint(this.adviceRightClickRow);
						break;

            case 9:
						this.handleUpdateWestOrChina(this.adviceRightClickRow);
						break;
				}

			},
      async handleUpdateWestOrChina(row){
        let res ;
        if(row.orderType === 0){
          this.handleCommand('a');
          res = await getWestDetail(row.orderTypeId);
          this.updateWestOrChinaForm = res.data;
          // 获取原始数据
          this.westMedicineTableData = res.data.drxDetails;

// 处理每个对象，根据minUnt和pacCnt去drugUntOptions中查找
          this.westMedicineTableData = res.data.drxDetails.map(item => {
            // 深拷贝原对象，避免修改原数据
            const newItem = { ...item };
            newItem.isEdit = 1;
            if (newItem.saleUnt === 2) {
              newItem.cnt = Math.ceil(newItem.pacCnt / newItem.cnt);
            }
            // 根据minUnt和pacCnt去drugUntOptions中查找对应的单位信息
            const minUntOption = this.drugUntOptions.find(opt => opt.id === item.minUnt);
            const pacUntOption = this.drugUntOptions.find(opt => opt.id === item.pacUnt);
            // 组装saleUntOption数组
            newItem.saleUntOption = [
              {
                id: 1,  // 如果找到就用找到的id，否则用默认值1
                label: minUntOption.label
              },
              {
                id:  2,  // 如果找到就用找到的id，否则用默认值2
                label: pacUntOption.label
              }
            ];

            return newItem;
          });
          this.currentAdviceId = row.id;
          this.sortGroupedRows();
          this.$nextTick(() => {
            this.renderGroupFlags();
            this.$refs.westMedicineTableData.clearSelection();
          });
        }
        if(row.orderType === 1){
          this.handleCommand('b');
          res = await getChinaPrescription({id: row.orderTypeId})
          this.updateWestOrChinaForm = res.data;
          // 获取原始数据
          this.chinaMedicineTableData = res.data.tcmDetailsRespVOS.map(item => {return{
            ...item,
            sumPrice: item.isFixPrice ===  1 ? item.fixMinSalePric * item.sdoseCnt * item.tcmCnt :  item.minSalePric * item.sdoseCnt,
            isEdit : item.isFixPrice === 1 ? 1 : 0
          }});
          this.addChinaForm.tcmCnt = res.data.tcmDetailsRespVOS[0]?.tcmCnt;
          this.currentAdviceId = row.id;
          this.filterChinaMedicationWay();
          this.getChinaDosageSum();
        }
      },
      handleGetDataDistributeAndPrint(row) {
        const type = row.items?.[0]?.itemType;
        if (row.tcm || type === 2) {
          this.printChinaPrescription(row);
        } else if (type === 1) {
          this.handleGetWestPrescription(row);
        } else if (type === 4) {
          // 理疗
        }
      },
			async handlieSucceedReception(row) {
				try {
					// 1. 添加确认对话框
					const confirmResult = await this.$confirm(
						`患者(${row.patientName}):是否确认完成就诊该患者`,
						'操作确认', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					).catch(() => {
						return false;
					});

					if (!confirmResult) return;
					const newItem = {
						id: row.id,
						status: 4,
					};
					const res = await editReception(newItem);
					if (res.code === 200) {
						this.handleCancelContract();
						await this.loadData();
					} else {
						this.$message.error(res.message);
					}
				} catch (error) {
					this.$message.error("系统异常:请联系管理员");
				}
			},

			async handlieCancelReception(row) {
				try {
					// 1. 添加确认对话框
					await this.$confirm(`患者(${row.patientName}):是否确认取消就诊该患者`, '取消就诊确认', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						closeOnClickModal: false // 防止误触
					});
					console.log(this.medicalAdviceData,
						'this.medicalAdviceDatathis.medicalAdviceDatathis.medicalAdviceData')
					if (this.medicalAdviceData.some(item => item.status === 2)) {
						this.$message.warning("该患者已缴费,无法取消接诊")
						return;
					}

					// 2. 用户确认后执行原逻辑
					let params = {};
					if (row.type === '1') {
						params = {
							dregisterTableId: row.dregisterTableId,
							id: row.id
						};
					} else {
						params = {
							id: row.id
						};
					}

					const res = await getReceptionCancel(params);

					// 3. 处理结果
					if (res.code === 200) {
						Object.assign(this.$data, this.$options.data.call(this))
						await this.initLoad()
					} else {
						this.$message.error(res.message);
					}
				} catch (error) {
					// 用户点击取消或请求失败
					if (error !== 'cancel') { // 排除用户主动取消的情况
						console.error('取消就诊失败:', error);
						this.$message.error("操作过程中发生错误");
					}
				}
			},

			async handleSitIn(row) {
				this.receptionForm.doctorId = row.regDoctorId;
				this.receptionForm.dregisterTableId = row.id;
				this.receptionForm.patientId = row.patientId;
				this.receptionForm.patientName = row.name;
				this.receptionForm.age = row.age;
				this.receptionForm.deptId = this.userInfo.selDept;
				const res = await addReception(this.receptionForm)
				if (res.code === 200) {
					this.showReception = false;
					await this.loadData();
				} else {
					this.$message.error(res.message)
				}
			},

			handleBlur() {
				setTimeout(() => {
					this.showPatientTellSelect = false;
					this.showNowHistorySelect = false;
					this.showBeforeHistorySelect = false;
				}, 500);
			},

			async handleAiseAddOrEdit() {
				try {
					const valid = await this.$refs.aiseFormRef.validate();
					if (!valid) {
						this.$message.warning('请填写完整表单');
						return;
					}
					await withLoading(this, '数据提交中...')(async () => {
						let res;
						if (!this.aiseForm.id) {
							res = await addAise(this.aiseForm);
						} else {
							res = await editAise(this.aiseForm);
						}
						if (res.code === 200) {
							await this.getAiseList();
							this.aiseAddOrEditMedicineDialog = false;
						} else {
							this.$message.error(res.message)
						}
					});
				} catch (error) {} finally {

				}
			},

			async handleAddTemplate() {
				await withLoading(this, '数据提交中...')(async () => {
					// 1. 表单验证
					const valid = await this.$refs.templateFormRef.validate();
					if (!valid) {
						this.$message.warning('请填写完整表单');
						return;
					}

					// 2. 根据模板类型处理
					switch (this.templateType) {
						case 1:
							const apiCall = this.templateForm.id ?
								editComplainTemplate :
								addComplainTemplate;

							const res1 = await apiCall(this.templateForm);

							if (res1.code === 200) {
								this.tpAddOrEditMedicineDialog = false;
								this.templateForm = Object.assign({}, this.$options.data.call(this)
									.templateForm)
								const options1 = await getComplainTemplate({
									pageSize: 100,
									pageNum: 1,
									state: 1,
									condition: '',
									deptId: this.userInfo.selDept
								});
								this.complainTemplateOptions = options1.data.content.map(item => ({
									label: item.content,
									id: item.id,
									data: item
								}));
							} else {
								this.$message.error(res1.message)
							}
							break;

						case 2: // 现病史模板
							const apiCall2 = this.templateForm.id ?
								editNowHistoryTemplate :
								addNowHistoryTemplate;

							const res2 = await apiCall2(this.templateForm);
							if (res2.code === 200) {
								this.tpAddOrEditMedicineDialog = false;
								this.templateForm = Object.assign({}, this.$options.data().templateForm);
								const options2 = await getNowHistoryTemplate({
									pageSize: 100,
									pageNum: 1,
									state: 1,
									condition: '',
									deptId: this.userInfo.selDept
								});
								this.nowHistoryTemplateOptions = options2.data.content.map(item => ({
									label: item.content,
									id: item.id,
									data: item,
								}));
							} else {
								this.$message.error(res2.message)
							}
							break;

						case 3: // 既往史模板
							const apiCall3 = this.templateForm.id ?
								editBeforeHistoryTemplate :
								addBeforeHistoryTemplate;

							const res3 = await apiCall3(this.templateForm);
							if (res3.code === 200) {
								this.tpAddOrEditMedicineDialog = false;
								this.templateForm = Object.assign({}, this.$options.data().templateForm);
								const options3 = await getBeforeHistoryTemplate({
									pageSize: 100,
									pageNum: 1,
									state: 1,
									condition: '',
									deptId: this.userInfo.selDept
								});
								this.beforeHistoryTemplateOptions = options3.data.content.map(item => ({
									label: item.content,
									id: item.id,
									data: item,
								}));
							} else {
								this.$message.error(res3.message)
							}
							break;
					}
				});
			},

			handleEditAllTemplate(val, data) {
				this.templateForm = data.data;
				this.templateForm.state = parseInt(this.templateForm.state)
				console.log(this.templateForm, 'this.templateFormthis.templateForm')
				switch (val) {
					case 1:
						this.templateAddRrEditTtiel = "编辑主诉模板";
						this.templateType = 1;
						break;

					case 2:
						this.templateAddRrEditTtiel = "编辑现病史模板";
						this.templateType = 2;
						break;

					case 3:
						this.templateAddRrEditTtiel = "编辑既往史模板";
						this.templateType = 3;
						break;
				}
				this.tpAddOrEditMedicineDialog = true;
			},

			handleAddAllTemplate(val) {
				this.tpAddOrEditMedicineDialog = true;
				switch (val) {
					case 1:
						this.templateAddRrEditTtiel = "新增主诉模板";
						this.templateType = 1;
						break;

					case 2:
						this.templateAddRrEditTtiel = "新增现病史模板";
						this.templateType = 2;
						break;

					case 3:
						this.templateAddRrEditTtiel = "新增既往史模板";
						this.templateType = 3;
						break;
				}
			},

			async choosePatientTell(data) {
				const newItem = {
					...this.patientForm,
					pregnant: this.patientForm.pregnant ? 1 : 0,
					id: this.patientChooseForm.seeDoctorId,
					patientTell: this.addSeedoctorForm.patientTell,
				}
				if (this.addSeedoctorForm.patientTell?.trim()) {
					const res = await editReception(newItem);
					if (res.code !== 200) {
						this.$message.error(res.message);
					}
				}
			},

			async chooseNowHistory(data) {
				const newItem = {
					...this.patientForm,
					pregnant: this.patientForm.pregnant ? 1 : 0,
					id: this.patientChooseForm.seeDoctorId,
					nowHistory: this.addSeedoctorForm.nowHistory,
				}
				if (this.addSeedoctorForm.nowHistory?.trim()) {
					const res = await editReception(newItem);
					if (res.code !== 200) {
						this.$message.error(res.message);
					}
				}
			},

			async chooseBeforeHistory(data) {
				const newItem = {
					...this.patientForm,
					pregnant: this.patientForm.pregnant ? 1 : 0,
					id: this.patientChooseForm.seeDoctorId,
					beforeHistory: this.addSeedoctorForm.beforeHistory,
				}
				if (this.addSeedoctorForm.beforeHistory?.trim()) {
					const res = await editReception(newItem);
					if (res.code !== 200) {
						this.$message.error(res.message);
					}
				}
			},

			async switchToSelect(value) {
				if (!this.preVerificationUserInfo(1)) return;
				switch (value) {
					case 1:
						this.showPatientTellSelect = true
						this.$nextTick(() => {
							this.$refs.showPatientTellSelect.focus()
						})
						if (this.complainTemplateOptions.length > 0) return;
						const res1 = await getComplainTemplate({
							pageSize: 500,
							pageNum: 1,
							state: 1,
						});
						this.complainTemplateOptions = res1.data.content.map(item => {
							return {
								label: item.content,
								id: item.id,
								data: item
							}
						})
						break;

					case 2:
						this.showNowHistorySelect = true
						this.$nextTick(() => {
							this.$refs.showNowHistorySelect.focus()
						})
						if (this.nowHistoryTemplateOptions.length > 0) return;
						const res2 = await getNowHistoryTemplate({
							pageSize: 500,
							pageNum: 1,
							state: 1,
						});
						this.nowHistoryTemplateOptions = res2.data.content.map(item => {
							return {
								label: item.content,
								id: item.id,
								data: item
							}
						})
						break;

					case 3:
						this.showBeforeHistorySelect = true
						this.$nextTick(() => {
							this.$refs.showBeforeHistorySelect.focus()
						})
						if (this.beforeHistoryTemplateOptions.length > 0) return;
						const res3 = await getBeforeHistoryTemplate({
							pageSize: 500,
							pageNum: 1,
							state: 1,
						});
						this.beforeHistoryTemplateOptions = res3.data.content.map(item => {
							return {
								label: item.content,
								id: item.id,
								data: item
							}
						})
						break;
				}


			},

			/*handleDelItemPrice(){
			  this.doctordisposeTableData.filter(item => item.id !== this.currentSelectedRow.id);
			  console.log(this.currentSelectedRow)
			  this.medicalAdviceData = this.medicalAdviceData.filter(
			      item => !(item.id === this.currentSelectedRow.id && item.type === "处置项目")
			  );
			},*/

/*
			async handleConfirmDisposeItem() {
				await withLoading(this, '数据提交中...')(async () => {
					const requestData = this.doctordisposeTableData.map(item => ({
						...item,
						costnameId: item.id,
            executId: item.executId,
						dregisterId: this.patientChooseForm.dregisterTableId,
						name: this.patientForm.name,
						num: item.count,
						openDeptId: this.userInfo.selDept,
						seeDoctorId: this.patientChooseForm.seeDoctorId,
						staffId: this.userInfo.staffId, //this.userInfo.userId;
						bsSource: 4,
						chargeStatus: item.chargeStatus ? item.chargeStatus : 0,
						dataSource: 1,
						executionAmount: item.executeOdcost,
						executionPrice: item.odcost,
						remark: item.remarks,
						standardPrice: item.odcost,
						patientId: this.patientForm.id,
						age: this.patientForm.ageYear,
						brdy: this.patientForm.brdy,
						careateId: this.userInfo.staffId, //this.userInfo.userId;
					}))
					const res = await addDoctordispose(requestData);
					if (res.code === 200) {
						this.doctordisposeTableData = [];
						this.selDoctordisposeDialog = false;
						await this.resetDisposeAndAdviceData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
*/




			handleCloseChinaTabel() {
				this.chinaMedicineSearchQuery = '';
				this.addChinaForm = Object.assign({}, this.$options.data.call(this).addChinaForm);
				this.chinaMedicineUsageDialog = false;
				/*if (this.$refs.chinaMedicineTable) {
				  this.$refs.chinaMedicineTable.clearSelection();
				}*/
			},

			async handleDisposeData(isFrequency = false) {
				try {
					const res = await getChargingPriceById(this.searchForm.chargingPriceId);
					const res2 = await getDoctordispose({
						seeDoctorId: this.patientChooseForm.seeDoctorId
					});

					// 检查是否存在重复医嘱
					if (res2.data.some(item => item.costnameId === res.data.id) && !isFrequency) {
						// 使用确认对话框替代原来的简单提示
						try {
							await this.$confirm(
								`处置医嘱:【${res.data.costname}】已存在医嘱列表，是否继续生成？`,
								'重复医嘱提示', {
									confirmButtonText: '继续生成',
									cancelButtonText: '取消',
									type: 'warning'
								}
							);
							// 用户点击"继续生成"，继续执行后面的代码
						} catch (cancel) {
							// 用户点击"取消"或关闭对话框
							this.$message.info('已取消生成重复医嘱');
							return;
						}
					}

          if (this.searchForm.executId===null){
            this.$message.error("请选择执行人");
            return;
          }
					// 如果是执行频次模式且需要选择频次
					if (res.data.executemode === 1 && !isFrequency) {
						this.selExecutionPLDialogVisible = true;
						return;
					}

					if (this.searchForm.executionDays < 1 || this.searchForm.executionDays === null) {
						this.$message.warning("请填写正确的频率天数!");
						return;
					}

					console.log(this.searchForm.deptName, 'searchForm.deptNamesearchForm.deptName');

					const itemData = {
						...res.data,
						odcost: this.searchForm.odcost,
						remark: this.searchForm.remark,
						deptName: this.searchForm.deptName,
            executId: this.searchForm.executId,
						doctorName: this.userInfo.staffName,
						frquCnt: this.searchForm.executionNum,
						prdDays: this.searchForm.executionDays,
						executDeptId: this.searchForm.depexecutetype,
						sex: this.patientForm.sex,
						executeOdcost: this.searchForm.executionNum * this.searchForm.odcost,
						count: this.searchForm.count,
						...(isFrequency && {
							exeFrquId: this.searchForm.usedfrquId
						})
					};

					console.log(itemData, 'itemData.itemData.itemDataitemDataitemDataitemDataitemData');

					// 添加到表格
					this.doctordisposeTableData.push(itemData);

					// 重置表单
					this.searchForm = Object.assign({}, this.$options.data.call(this).searchForm);

					// 关闭弹窗（如果是频次模式）
					if (isFrequency) {
						this.selExecutionPLDialogVisible = false;
					}

					console.log('当前处置表数据:', this.doctordisposeTableData);
				} catch (error) {
					console.error('处理数据出错:', error);
					// 这里要区分是确认框的取消还是其他错误
					if (error !== 'cancel') {
						this.$message.error('操作失败，请重试');
					}
				}
			},



			async getChinaDiagnosisOptions(type) {
				// 前置条件验证
				if (!this.preVerificationUserMedical()) return;


				await withLoading(this, '数据加载中...')(async () => {
					const [icdList, syndromeList, diagnoses] = await Promise.all([
						getChinaDocticdList(),
						getSyndromeList(),
						getReceptionDiagnosis({
							category: 2,
							seeDoctorId: this.patientChooseForm.seeDoctorId
						})
					]);

					// 处理返回数据
					this.chinaSelectedTable = diagnoses.map(({
						diagnosticName,
						diseaseCode,
						chineseSyndromeCode,
						chineseSyndromeName,
						insuranceName,
						insuranceCode,
						syndromeName,
						syndromeCode
					}) => ({
						diagnosticName,
						diseaseCode,
						chineseSyndromeCode,
						chineseSyndromeName,
						insuranceName,
						insuranceCode,
						syndromeName,
						syndromeCode
					}));

					this.chinaDiagnosisTableData1 = icdList.data;
					this.chinaDiagnosisTableData2 = syndromeList.data;

					// 条件性显示弹窗
					if (type !== 1) {
						this.chinaDiagnosisModalVisible = true;
					}

				});
			},

			async getWesternDiagnosisData(type) {
				if (!this.preVerificationUserMedical()) return;

				await withLoading(this, '数据加载中...')(async () => {
					this.westernDiagnosisTableData = []
					const [icdList, diagnoses] = await Promise.all([
						getDocticdList({
							pageSize: 100
						}),
						getReceptionDiagnosis({
							category: 1,
							seeDoctorId: this.patientChooseForm.seeDoctorId
						})
					]);

					// 3. 处理数据
					this.westernSelectedTable = diagnoses.map(item => ({
						...item,
						id: item.id,
						chsName: item.insuranceName,
						chsCode: item.insuranceCode,
						code: item.icdCode,
						name: item.diagnosticName,
						remarks: item.remark,
						definiteDiagnosis: parseInt(item.definiteDiagnosis)
					}));

					this.westernDiagnosisTableData = icdList.data;

					// 4. 条件性显示弹窗
					if (type !== 2) {
						this.$nextTick(() => {
							if (this.$refs.westernTable) {
								this.$refs.westernTable.doLayout();
							}
							this.$forceUpdate();
						});
						this.westernDiagnosisModalVisible = true;
					}

				});
			},


			/*过敏原下拉框*/
			async getAiseList() {
				const res = await getAiseList();
				this.aiseListOptions = res.data.map(item => {
					return {
						label: item.name,
						id: item.id
					}
				})
				this.$store.commit('preload/updatePreloadData', {
					key: 'getAiseListOptions',
					data: this.aiseListOptions
				});
			},

			/*判断身份证重复和正则验证*/
			async certnoMonitor() {
				if (!this.patientForm.certno) return;

				const certType = this.patientForm.identityCard; // 当前选择的证件类型
				const certLength = this.certLengthMap[certType]; // 获取对应长度要求
				const certPattern = this.certPatterns[certType]; // 获取对应正则规则

				// 长度验证
				if (this.patientForm.certno.length !== certLength) {
					this.$message.error(`请输入${certLength}位证件号码`);
					return;
				}

				// 格式验证
				if (certPattern && !certPattern.test(this.patientForm.certno)) {
					this.$message.error('证件号码格式不正确');
					return;
				}

				// 特殊证件处理（仅身份证需要解析信息）
				if (certType === 1) { // 居民身份证
					console.log(this.patientForm.certno, 'this.patientForm.certnothis.patientForm.certno')
					const res = await getDoesItExistSFZ({
						certNo: this.patientForm.certno.toString()
					});
					if (res.data && this.patientForm.certno !== this.patientChooseForm.certno) {
						this.$message.warning("该身份证在信息库中已经存在!")
						return 1;
					}
					const genderDigit = parseInt(this.patientForm.certno.charAt(16), 10);
					this.patientForm.sex = genderDigit % 2 === 1 ? '1' : '2';

					// 计算年龄和出生日期
					const data = this.getAgeAndMonthsFromIdCard(this.patientForm.certno);
					this.patientForm.ageYear = data.years;
					this.patientForm.ageMonth = data.months;
					this.patientForm.brdy =
						this.patientForm.certno.slice(6, 10) + '-' +
						this.patientForm.certno.slice(10, 12) + '-' +
						this.patientForm.certno.slice(12, 14);
				} else if (certType === '8') { // 武警身份证件
					// 可选:添加武警证件特殊处理逻辑
					this.patientForm.sex = ''; // 清除非身份证的性别信息
				} else {
					// 其他证件类型清空自动计算字段
					this.patientForm.sex = '';
					this.patientForm.ageYear = '';
					this.patientForm.ageMonth = '';
					this.patientForm.brdy = '';
				}
				if (this.patientForm.id != null) {
					this.handlePatientFormChange();
				}
			},

			/*计算年龄和出生日期*/
			getAgeAndMonthsFromIdCard(idCard) {
				if (!idCard || idCard.length !== 18) return {
					years: 0,
					months: 0,
					birthday: ''
				};

				const birthStr = idCard.slice(6, 14); // 格式:YYYYMMDD
				const birthday = `${birthStr.slice(0, 4)}-${birthStr.slice(4, 6)}-${birthStr.slice(6, 8)}`;

				const birthDate = new Date(birthday);
				if (isNaN(birthDate.getTime())) return {
					years: 0,
					months: 0,
					birthday: ''
				};

				// 2. 获取当前日期
				const today = new Date();

				// 3. 计算周岁
				let years = today.getFullYear() - birthDate.getFullYear();

				// 4. 计算月龄（总月数差）
				let months = (today.getFullYear() - birthDate.getFullYear()) * 12 +
					(today.getMonth() - birthDate.getMonth());

				// 5. 调整年龄和月龄（如果生日未到）
				if (
					today.getMonth() < birthDate.getMonth() ||
					(today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
				) {
					years--;
					months--;
				}

				// 6. 确保月龄为正数
				months = Math.max(0, months % 12); // 超过12个月的部分已计入周岁

				return {
					years,
					months,
					birthday
				};
			},
			/*一周内就诊数据*/
      async handleSavenData() {
        await withLoading(this, '数据处理中...')(async () => {
          const res = await getFinishReception({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            startTime: this.seedoctorQueryParams.startTime,
            endTime: this.seedoctorQueryParams.endTime,
            doctorId: this.seedoctorQueryParams.doctorId ?? null,
            patientId: this.seedoctorQueryParams.patientId,
            patientName: this.seedoctorQueryParams.patientName
          });
          this.sevenDayTableData = res.data.content
          this.totalSize = res.data.totalSize;
          this.sevenDayDialogVisible = true;
        });
      },


      /*外层保存患者信息及就诊信息*/
			async handleEditDocphr() {
        await withLoading(this, '数据提交中...')(async () => {
          // ================= 2. 数据处理 =================
          this.patientForm.conerAddCode =
              this.patientForm.conerAddCodeArr?.length > 0 ?
                  this.patientForm.conerAddCodeArr[this.patientForm.conerAddCodeArr
                      .length - 1] :
                  '';
          // ================= 3. 提交第一组数据 =================
          const res = await editDocphr(this.patientForm);
          if (res.code !== 200) {
            this.$message.error(res.message);
            this.loading = false;
            return;
          }
          console.log(this.patientForm.pregnant,
              'this.patientForm.pregnantthis.patientForm.pregnant')
          // ================= 4. 准备第二组数据 =================
          const newItem = {
            id: this.patientChooseForm.seeDoctorId,
            address: this.patientForm.conerAddName,
            sex: this.patientForm.sex,
            age: this.patientForm.ageYear,
            allergen: this.patientForm.aiseId,
            bloodType: this.patientForm.bloodType,
            bloodNumber: parseInt(this.patientForm.bloodNumber),
            cardid: this.patientForm.certno,
            doctorId: this.userInfo.staffId,
            patientId: this.patientForm.id,
            patientName: this.patientForm.name,
            patientTell: this.addSeedoctorForm.patientTell,
            nowHistory: this.addSeedoctorForm.nowHistory,
            beforeHistory: this.addSeedoctorForm.beforeHistory,
            diapre: this.patientForm.diapre,
            syspre: this.patientForm.syspre,
            prhCostType: this.patientForm.prhCostType,
            pregnant: this.patientForm.pregnant ? 1 : 0
          };

          console.log(newItem, '就诊信息数据');

          // ================= 5. 提交第二组数据 =================
          const res2 = await editReception(newItem);
          if (res2.code !== 200) {
            this.$message.error(res2.message);
            this.loading = false;
            return;
          }

          // ================= 6. 成功处理 =================
          setTimeout(async () => {
            this.patientChooseForm = {
              ...this.addSeedoctorForm,
              ...this.patientChooseForm,
              ...this.patientForm,
              id: this.patientChooseForm.seeDoctorId,
              allergen: this.patientForm.aiseId,
            };
            this.patientForm = Object.assign({}, this.$options.data
                .call(this).patientForm);
            await this.handleClickReceptionRow(this
                .patientChooseForm, 1);
            await this.loadAndDisplayAddress();
          });
        }, 1000);

      },
			/*挂号类别下拉框*/
			async getRegisterType() {
				const res = await getRegisterType({
					doctorId: this.userInfo.staffId
				});
				this.registerOptions = res.data.map(item => {
					return {
						label: item.designation,
						id: item.id,
						odcost: item.odcost,
						mainType: item.mainType
					}
				})
				console.log(this.registerOptions,
					'this.registerOptionsthis.registerOptionsthis.registerOptionsthis.registerOptionsthis.registerOptions'
					)
			},
			/*医生下拉框*/
			async getDoctorList() {
				if (this.doctorOptions.length > 0) return;
				const res = await getDoctorList()
				this.doctorOptions = res.data.map(item => {
					return {
						id: item.id,
						label: item.fullName
					}
				})
			},
			/*科室下拉框*/
			async getDeptList() {
				if (this.deptOptions.length > 0) return;
				const res = await getDeptList();
				this.deptOptions = res?.data.map(item => {
					return {
						id: item.id,
						label: item.deptName
					}
				})
			},
			/*模板新增修改名称转拼音*/
			handleNameChangeCode(v, i) {
				switch (i) {
					case 1:
						this.templateForm.pinyin =
							pinyin(this.templateForm.name, {
								pattern: 'first',
								toneType: 'none',
								separator: ''
							}).toLocaleUpperCase();
						this.addUnitForm.pyCode =
							pinyin(this.addUnitForm.name, {
								pattern: 'first',
								toneType: 'none',
								separator: ''
							}).toLocaleUpperCase();
						break;
					case 2:
						this.aiseForm.pyCode =
							pinyin(this.aiseForm.name, {
								pattern: 'first',
								toneType: 'none',
								separator: ''
							}).toLocaleUpperCase();
						break;
				}
			},
			/*新增修改合约单位*/
			async handleAddContractUnit() {
				await withLoading(this, '数据提交中...')(async () => {
					if (this.addUnitForm.id) {
						const res = await editContractUnit(this.addUnitForm);
						if (res.code === 200) {
							await this.getContuntList();
							this.addUnitModalVisible = false;
						} else {

							this.$message.error(res.message)
						}
					} else {
						const res = await addContractUnit(this.addUnitForm);
						if (res.code === 200) {
							await this.getContuntList();
							this.addUnitModalVisible = false;
						} else {
							this.$message.error(res.message)
						}
					}
					this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)

				});
			},
			/*关闭快速就诊模态框*/
			handleCancelContract() {
				const initialData = this.$options.data.call(this);
				this.patientForm = Object.assign({}, initialData.patientForm);
				this.conerPleasett = '';
				this.receptionForm = Object.assign({}, initialData.receptionForm || {});
				this.templateForm = Object.assign({}, initialData.templateForm || {});
				this.addSeedoctorForm = Object.assign({}, initialData.addSeedoctorForm || {});
				this.patientChooseForm = Object.assign({}, initialData.patientChooseForm || {});
				this.templateFormRef = Object.assign({}, initialData.templateFormRef || {});
				this.medicalAdviceData = [];
        this.westMedicineTableData = [];
        this.chinaMedicineTableData = [];
        this.doctordisposeTableData = [];
        this.prescriptionList = [];
				if (this.$refs.templateFormRef) this.$refs.templateFormRef.clearValidate();
				this.isInputDisabled = false;
				this.receptionModalVisible = false;
				this.tpAddOrEditMedicineDialog = false;
			},
			/*关闭新增修改模板模态框*/
			handleCancelTemplateForm() {
				this.templateForm = Object.assign({}, this.$options.data.call(this).templateForm)
				this.tpAddOrEditMedicineDialog = false;
			},
			/*重置表单*/
			handleResetContract() {
				const initialData = this.$options.data.call(this);
				this.patientForm = Object.assign({}, initialData.patientForm);
				this.templateForm = Object.assign({}, initialData.templateForm || {});
				this.addSeedoctorForm = Object.assign({}, initialData.addSeedoctorForm || {});
				this.fastReceptionForm = Object.assign({}, initialData.fastReceptionForm || {});
				this.patientChooseForm = Object.assign({}, initialData.patientChooseForm || {});
				this.conerPleasett = '';
				this.naplPleasett = '';
				this.medicalAdviceData = [];
				this.isInputDisabled = false;
			},
			/*修改合约单位*/
			async handleEditContractUnit(item) {
				const res = await getContractUnit(item.id.toString())
				this.addUnitForm = res.data
				this.addUnitModalVisible = true;
			},
			/*新增合约单位*/
			handleSaveContractUnit() {
				this.$closeAllSelects();
				this.addUnitForm = Object.assign({}, this.$options.data.call(this).addUnitForm)
				this.addUnitModalVisible = true;
			},

			handleAddOrEditAise() {
				if (!this.aiseForm.id) {
					this.aiseAddRrEditTtiel = '新增过敏原'
				} else {
					this.aiseAddRrEditTtiel = '编辑过敏原'
				}
				this.$closeAllSelects();
				this.aiseForm = Object.assign({}, this.$options.data.call(this).aiseForm)
				this.aiseAddOrEditMedicineDialog = true;
			},
			/*就诊列表但单击行事件*/
			async handleClickRow(row) {
				this.patientChooseForm = JSON.parse(JSON.stringify(row));
			},
      /*选择患者或切换患者组装数据*/
      async handleClickReceptionRow(row, skip) {
        // 1. Check for unsaved changes
        if (skip !== 1 && this.patientForm.name &&
            !await this.$confirm('患者信息可能未保存，确认切换患者吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).catch(() => false)) return;

        this.patientForm = Object.assign({}, this.$options.data.call(this).patientForm)
        this.patientChooseForm = Object.assign({}, this.$options.data.call(this).patientChooseForm)
        await this.getOrdersByPatientId();
        await withLoading(this, '加载患者信息中...')(async () => {
          // 2. Parallel data fetching with optimized requests
          this.medicineSearchQuery = '';
          const [patientInfo, patientData] = await Promise.all([
            getDocphrList(row.patientId),
            getPatientAllData({
              id: row.id
            }),
          ]);
// 重置中药表格
          this.westMedicineTableData = [this.getEmptyWestRowData()];
          this.chinaMedicineTableData = [this.getEmptyChinaRowData()];
          this.doctordisposeTableData = [this.getEmptyDisposeRowData()];
          this.medicalAdviceData = [];
          this.queryWestMedicineData = [];
          this.queryChinaMedicineData = [];

          // 3. Pre-process data for better performance
          const seeDoctorDataObj = patientData.data.cncSeeDoctorRespVO;
          const advicesData = patientData.data.dugDoctorAdviceRespVOList;


          const diagnosisList = patientData.data.cncDiagnosisRespVOList || [];

// ===== 提取西医诊断（diagnosticCategory === '1'） =====
          const westernDiagnos = diagnosisList
              .filter(item => item.diagnosticCategory === '1')
              .map(item => item.diagnosticName)
              .join('；');

// ===== 提取中医诊断（diagnosticCategory === '2'） =====
          const chinaDiagnose = diagnosisList
              .filter(item => item.diagnosticCategory === '2')
              .map(item => item.diagnosticName)
              .join('；');

// ===== 赋值给 patientChooseForm =====
          this.patientChooseForm = {
            ...patientInfo.data,
            seeDoctorId: row.id,
            patientId: row.patientId,
            dregisterTableId: row.dregisterTableId,
            repeated: row.seeCount,
            bloodNumber: seeDoctorDataObj.bloodNumber,
            bloodType: seeDoctorDataObj.bloodType,
            syspre: seeDoctorDataObj.syspre,
            diapre: seeDoctorDataObj.diapre,
            aiseId: seeDoctorDataObj.allergen ? parseInt(row.allergen) : null,
            pregnant: row.pregnant,
            type: row.type,
            patientTell: seeDoctorDataObj.patientTell || '',
            nowHistory: seeDoctorDataObj.nowHistory || '',
            beforeHistory: seeDoctorDataObj.beforeHistory || '',
            westernDiagnos: westernDiagnos,
            chinaDiagnose: chinaDiagnose,
          };

// ===== ⭐ 同时赋值给 addSeedoctorForm（页面实际绑定的对象） =====
          this.addSeedoctorForm.patientTell = seeDoctorDataObj.patientTell || '';
          this.addSeedoctorForm.nowHistory = seeDoctorDataObj.nowHistory || '';
          this.addSeedoctorForm.beforeHistory = seeDoctorDataObj.beforeHistory || '';
          this.addSeedoctorForm.westernDiagnos = westernDiagnos;
          this.addSeedoctorForm.chinaDiagnose = chinaDiagnose;
          console.log(this.patientChooseForm, 'this.patientChooseFormthis.patientChooseForm')
          await this.handleChoosePatient();
          const res = await getMedicineCache({
            seeDoctorId: row.id
          });
          await this.getOrdersByPatientId();

          const parsedData = JSON.parse(res.data);

          // ===== 修复：处理west数据 =====
          if (parsedData?.west && skip !== 1) {
            const westArray = JSON.parse(parsedData.west);
            if (Array.isArray(westArray) && westArray.length > 0) {
              this.westMedicineTableData = [];
              this.westMedicineTableData.push(...westArray);
            } else {
              // 缓存为空，初始化一行空数据
              this.westMedicineTableData = [this.getEmptyWestRowData()];
            }
          } else {
            // 没有缓存数据或 skip === 1，初始化一行空数据
            this.westMedicineTableData = [this.getEmptyWestRowData()];
          }

          // ===== 修复：处理china数据 =====
          if (parsedData?.china && skip !== 1) {
            const chinaArray = JSON.parse(parsedData.china);
            if (Array.isArray(chinaArray) && chinaArray.length > 0) {
              this.chinaMedicineTableData = [];
              this.chinaMedicineTableData.push(...chinaArray);
            }
          }

          // ===== 修复：确保中药也有空状态 =====
          if (this.chinaMedicineTableData.length === 0) {
            this.chinaMedicineTableData = [];
          }

          this.addressKey++;
          this.activeTab = 'outpatient';
        });
      },
			/*组装患者数据*/
			async handleChoosePatient() {
				await withLoading(this, '数据处理中...')(async () => {
					// 1. 预处理身份证信息
					const ageData = (() => {
						const certno = this.patientChooseForm.certno?.trim();
						if (!certno) return {
							ageYear: null,
							ageMonth: null,
							brdy: null
						};
						try {
							const ageInfo = this.getAgeAndMonthsFromIdCard(certno);
							return {
								ageYear: ageInfo.years,
								ageMonth: ageInfo.months,
								brdy: ageInfo.birthday
							};
						} catch (error) {
							console.error('身份证解析错误:', error);
							return {
								ageYear: null,
								ageMonth: null,
								brdy: null
							};
						}
					})();
					// 2. 直接赋值基础信息，减少中间对象创建
					const form = this.patientForm;
					const chooseForm = this.patientChooseForm;
					const matchedUnit = this.contractUnitOption.find(item => item.id === chooseForm
					.phrUnt);
					console.log(chooseForm.sex, 'chooseForm.sex')

					form.id = chooseForm.id || null;
					form.patId = chooseForm.patId || null;
					form.thrNot = chooseForm.thrNot || null;
					form.patientId = chooseForm.patientId || null;
					form.dregisterTableId = chooseForm.dregisterTableId || null;
					form.repeated = chooseForm.repeated || null;
					form.name = chooseForm.name || null;
					form.sex = chooseForm.sex === 1 ? '1' : '2';
					form.certno = chooseForm.certno || null;
					form.identityCard = chooseForm.identityCard || 1;
					form.naty = chooseForm.naty || 3;
					form.jobId = chooseForm.jobId || null;
					form.ntlyId = parseInt(chooseForm.ntlyId) || null;
					form.phrUnt = matchedUnit ? chooseForm.phrUnt : null;
					form.mrgState = chooseForm.mrgState || null;
					form.tel = chooseForm.tel || null;
					form.conerName = chooseForm.conerName || null;
					form.conerTel = chooseForm.conerTel || null;
					form.conerRltsId = chooseForm.conerRltsId || null;
					form.prhCostType = chooseForm.prhCostType || null;
					form.prhType = chooseForm.prhType || null;
					form.aiseId = chooseForm.aiseId || null;
					form.bloodNumber = chooseForm.bloodNumber || null;
					form.bloodType = chooseForm.bloodType || '1';
					form.syspre = chooseForm.syspre || null;
					form.diapre = chooseForm.diapre || null;
					form.pregnant = chooseForm.pregnant === 1;
					form.seedoctorcCount = null;
					form.seedoctorcType = null;
					form.naplAddName = chooseForm.naplAddName || null;
					form.conerAddName = chooseForm.conerAddName || null;
					form.ageYear = ageData.ageYear || null;
					form.ageMonth = ageData.ageMonth || null;
					form.brdy = ageData.brdy || null;

					// 3. 优化行政区划处理
					const processRegion = (code, arrName) => {
						const codeStr = code?.toString().trim();
						if (!codeStr) return;

						form[arrName] = [
							this.formatRegionCode(codeStr, 2, 10),
							this.formatRegionCode(codeStr, 4, 8),
							this.formatRegionCode(codeStr, 6, 6),
							this.formatRegionCode(codeStr, 9, 3),
							codeStr
						];
					};

					form.naplAddCodeArr = [];
					form.conerAddCodeArr = [];
					processRegion(chooseForm.naplAddCode, 'naplAddCodeArr');
					processRegion(chooseForm.conerAddCode, 'conerAddCodeArr');

					// 4. 并行加载地址信息
					await Promise.all([
						form.conerAddCodeArr.length > 0 ? this.loadAndDisplayAddress('coner') :
						Promise.resolve(),
						form.naplAddCodeArr.length > 0 ? this.loadAndDisplayAddress('napl') :
						Promise.resolve()
					]);

					this.isFormExpanded = !!this.isFormExpanded;
					this.patientDialogVisible = false;
				});
			},
			/*数据字典*/
			async dict() {
				try {
					// 重命名API调用避免函数名冲突
					const res = await dict();
					const {
						data
					} = res;

					// 映射配置:统一管理所有选项的转换规则
					const optionMappings = [{
							key: 'nationOption',
							path: 'natyEntities'
						},
						{
							key: 'certypeOption',
							path: 'certypeEntities'
						},
						{
							key: 'jobOption',
							path: 'jobEntities'
						},
						{
							key: 'profttlOption',
							path: 'profttlEntities'
						},
						{
							key: 'prhCostOption',
							path: 'prhCostType'
						},
						{
							key: 'prhTypeOption',
							path: 'prhType'
						},
						{
							key: 'rltsEntitiesOption',
							path: 'rltsEntities'
						},
						{
							key: 'untAtteOption',
							path: 'unatteVo'
						},
						{
							key: 'ntlyOptions',
							path: 'country'
						},
						{
							key: 'chinaMakeOptions',
							path: 'methodTypeVO'
						},
						{
							key: 'tcmwayOptions',
							path: 'tcmway'
						},
						{
							key: 'mrgStateOptions',
							path: 'mrgStateEntities'
						},
						{
							key: 'rxTypeOptions',
							path: 'rxTypeVOS'
						}
					];

					// 批量处理标准映射（id + label）
					optionMappings.forEach(({
						key,
						path
					}) => {
						this[key] = (data[path] || []).map(item => ({
							id: item.id,
							label: item.name
						}));
					});

					// 特殊处理:包含额外字段的映射
					this.medicationWayOptions = (data.ruteVo || []).map(item => ({
						id: item.id,
						label: item.name,
						type: item.type,
						exeB: item.exeB,
						lmtSpc: item.lmtSpc
					}));
				} catch (error) {
					console.error('字典数据加载失败:', error);
					this.$message.error('系统字典初始化失败，请刷新页面重试');
				}
			},
			/*往来单位列表*/
			async getContuntList() {
				if (this.contractUnitOption.length > 0) return;
				const res = await getContuntList({
					state: 1
				});
				this.contractUnitOption = res.data.map(item => {
					return {
						id: item.id,
						label: item.name,
						code: item.code
					}
				})
			},
			/*数据源*/
			async loadData() {
				const today = new Date();
				const formattedDate = today.toISOString().split('T')[0];
				const res1 = await getDeptInDoctorList({
					date: formattedDate,
					depId: this.userInfo.selDept,
					doctorId: this.userInfo.staffId,
					visitState: 2
				});
				const res2 = await getReceptionList({
					doctorId: this.userInfo.staffId,
					status: 1
				});
				this.tableData1 = res1.data;
				this.tableData2 = res2.data;
				const sortedData = [...this.tableData1]?.sort((a, b) => {
					return new Date(a.regTime) - new Date(b.regTime);
				});
				sortedData?.map((item, index) => {
					item.optTime = item.optTime.substring(5);
					item.regDeptName = this.deptOptions?.find(dept => dept.id === item.regDepId)?.label ?? '';
					item.order = index + 1;
				})

			},
			/*魔法数字对应数组回显*/
			safeGetMappedValue(col, row, type) {

				// 1. 检查数据有效性
				const rawValue = row[col.prop];
				if (rawValue === null || rawValue === undefined) return ' ';

				// 2. 检查映射数组
				const mapArray = this[col.op];
				if (!col.op || !Array.isArray(mapArray)) return rawValue;

				// 3. 执行映射
				const matched = mapArray.find(item => item.id == rawValue);
				return matched?.label || rawValue;
			},
             safeGetMappedValue2(col, row, type) {
        const hiddenProps = new Set([
          'usedfrquId', 'sdoseCnt', 'prdCnt', 'prdDays', 'medcWayId', 'tcmCnt',
          'selfProe', 'skintstRslt', 'remark', 'remarks', 'rxDosCnt', 'cnt', 'saleAmt', 'saleUnt','drugName'
        ]);

        if (hiddenProps.has(col.prop)) {
          return ''; // 直接返回空字符串，不显示
        }
        // 1. 检查数据有效性
        const rawValue = row[col.prop];
        if (rawValue === null || rawValue === undefined) return ' ';

        // 2. 检查映射数组
        const mapArray = this[col.op];
        if (!col.op || !Array.isArray(mapArray)) return rawValue;

        // 3. 执行映射
        const matched = mapArray.find(item => item.id == rawValue);
        return matched?.label || rawValue;
      },
			/*行政划分码补0辅助方法*/
			formatRegionCode(code, prefixLength, zeroPadding) {
				if (!code || code.length < prefixLength) {
					return code || '';
				}
				return code.substring(0, prefixLength) + '0'.repeat(zeroPadding);
			},
			/*自动计算列宽*/
			getColumnWidth(label, prop, tableData) {
				const minWidth = 100;
				const padding = 30;
				const contentList = tableData.map(item => item?.[prop] ?? '');
				const widths = [...contentList, label].map(text => {
					const str = String(text || '');
					return this.getTextWidth(str) + padding;
				});

				return Math.max(minWidth, ...widths);
			},
			/*自动计算列宽辅助方法*/
			getTextWidth(text, fontSize = 14) {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				ctx.font = `${fontSize}px Microsoft YaHei`;
				return ctx.measureText(text).width;
			},
			/*列头剧中*/
			labelHead(h, {
				column,
				$index
			}) {
				let l = column.label.length;
				let f = 12;
				column.minWidth = f * (l + 5); //加上一个文字长度
				return h("div", {
					class: "table-head",
					style: {
						width: "100%"
					}
				}, [
					column.label,
				]);
			},
		}
	}
</script>

<style lang="less" scoped>

.patient-dialog {
  /deep/ .el-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 16px 64px rgba(0, 0, 0, 0.16);
    margin-top: 4vh !important;
  }

  /deep/ .el-dialog__headerbtn {
    top: 18px;
    right: 20px;
    font-size: 18px;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    overflow: hidden;
    max-height: 76vh;
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-dialog__footer {
    padding: 12px 24px;
    border-top: 1px solid #e8ecf1;
    background: #fafbfc;
    border-radius: 0 0 12px 12px;
  }
}

/* ===== 查询条件 ===== */
.query-conditions {
  padding: 16px 20px 4px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #e8ecf1;
  flex-shrink: 0;

  .el-form-item {
    margin-bottom: 10px;
    margin-right: 12px;
    &:last-child {
      margin-right: 0;
    }
  }
}

/* ===== 表格容器 ===== */
.table-main-container {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  height: 55vh;
  min-height: 380px;
  overflow: hidden;
  background: #ffffff;
  flex: 1;
}

/* ===== 左侧表格 ===== */
.table-left {
  flex: 1;
  overflow: hidden;
  min-width: 0;
  padding: 12px 16px 16px 16px;

  /deep/ .el-table {
    border-radius: 6px;
    border: 1px solid #e8ecf1;
    font-size: 13px;

    th.el-table__cell {
      background-color: #f5f7fa !important;
      color: #4a4f5a;
      font-weight: 600;
    }

    .el-table__body-wrapper {
      overflow-y: auto;
    }

    .el-button--text {
      color: #409EFF;
      &:hover {
        color: #66b1ff;
        text-decoration: underline;
      }
    }

    .current-row td {
      background-color: #ecf5ff !important;
    }
  }
}

/* ===== 抽屉 - 关键：限制在弹窗内 ===== */
.charge-detail-drawer {
  position: absolute !important; /* 相对于父容器定位 */
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
  width: 100% !important;
  overflow: hidden;
  pointer-events: none; /* 让点击穿透，但内部可交互 */

  /deep/ .el-drawer {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    height: 100% !important;
    width: 68% !important;
    pointer-events: auto; /* 抽屉本身可交互 */
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.10);
    border-left: 1px solid #e4e7ed;
    border-radius: 0 !important;
    transform: none !important;
  }

  /deep/ .el-drawer__body {
    padding: 0;
    overflow: hidden;
    height: 100%;
  }

  /* 隐藏默认遮罩 */
  /deep/ .el-drawer__wrapper {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    pointer-events: none;
  }

  /deep/ .v-modal {
    display: none !important; /* 隐藏黑色遮罩 */
  }
}

/* ===== 抽屉内容 ===== */
.drawer-content {
  height: 100%;
  padding: 16px 20px 20px 20px;
  overflow-y: auto;
  background: #ffffff;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cfd5df;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f2f4f8;
  }
}

/* ===== 基本信息卡片 ===== */
.charge-info-header {
  background: #f8f9fc;
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 16px;
  border: 1px solid #e9edf4;
  flex-shrink: 0;

  .el-row + .el-row {
    margin-top: 8px;
  }

  .info-item {
    display: flex;
    align-items: center;
    padding: 3px 0;
    min-height: 28px;
  }

  .label {
    color: #7a7f8a;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: 72px;
  }

  .value {
    color: #303133;
    font-weight: 500;
    font-size: 13px;
    word-break: break-all;
    flex: 1;
    min-width: 0;
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
}

/* ===== Tabs ===== */
.charge-detail-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;

  /deep/ .el-tabs__header {
    margin-bottom: 12px;
    border-bottom: 1px solid #e8ecf1;
    flex-shrink: 0;
  }

  /deep/ .el-tabs__item {
    font-size: 14px;
    font-weight: 500;
    color: #5a5f6b;
    padding: 0 16px;
    height: 36px;
    line-height: 36px;

    &.is-active {
      color: #409EFF;
    }
  }

  /deep/ .el-tabs__active-bar {
    background-color: #409EFF;
    height: 3px;
  }

  /deep/ .el-tabs__content {
    flex: 1;
    overflow: hidden;
  }

  /deep/ .el-tab-pane {
    height: 100%;
    overflow: hidden;
  }

  /deep/ .el-table {
    border-radius: 6px;
    border: 1px solid #e8ecf1;

    th.el-table__cell {
      background-color: #f5f7fa !important;
      color: #4a4f5a;
      font-weight: 600;
      font-size: 13px;
    }

    .cell {
      font-size: 13px;
      color: #2c3e50;
    }
  }
}
.patient-info-card {
  background: #ffffff;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  padding: 6px 18px;
  margin: 8px 0 10px 0;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.3s;
}

.patient-info-card:hover {
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.06);
}

.info-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 2;
  padding: 2px 0;
}

.info-value {
  color: #303133;
  font-weight: 500;
  font-size: 13px;
}

.name-value {
  font-weight: 700;
  color: #1a2a3a;
}

/* 分隔线 */
.info-item:not(:last-child)::after {
  content: '';
  display: inline-block;
  width: 1px;
  height: 18px;
  background: #e8ecf1;
  margin-left: 12px;
}

/* 生命体征项 - 分隔线特殊处理 */
.vital-item:not(:last-child)::after {
  margin-left: 10px;
}

.vital-slash {
  margin: 0 2px;
  font-size: 12px;
  color: #c0c4cc;
}

.vital-unit {
  font-size: 11px;
  color: #b0bcc8;
  margin-left: 3px;
  white-space: nowrap;
}

/* 无边框下拉框 */
.borderless-select {
  ::v-deep .el-input__inner {
    border: none !important;
    background: transparent !important;
    padding: 0 18px 0 4px !important;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    color: #303133;
    border-radius: 4px !important;
    transition: all 0.25s ease;

    &:hover {
      background: #f5f7fa !important;
    }

    &:focus {
      background: #f0f5ff !important;
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12) !important;
    }
  }

  ::v-deep .el-input__suffix {
    right: 2px;
  }
}

/* 输入框统一样式 - 无边框 */
.vital-item .el-input {
  ::v-deep .el-input__inner {
    border: none !important;
    background: transparent !important;
    padding: 0 4px !important;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    color: #303133;
    border-radius: 4px !important;
    text-align: center;
    transition: all 0.25s ease;

    &:hover {
      background: #f5f7fa !important;
    }

    &:focus {
      background: #f0f5ff !important;
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12) !important;
    }

    &::placeholder {
      color: #c0c4cc;
      font-size: 11px;
    }
  }
}

/* 血糖输入框错误样式 */
.blood-error ::v-deep .el-input__inner {
  color: #F56C6C !important;
  background: #fef0f0 !important;
}

/* ===== 空状态 ===== */
.empty-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  color: #909399;
  font-size: 14px;
}

/* ===== 响应式 ===== */
@media screen and (max-width: 768px) {
  .info-grid {
    gap: 2px 10px;
  }
  .info-item:not(:last-child)::after {
    margin-left: 8px;
  }
}

@media screen and (max-width: 576px) {
  .patient-info-card {
    padding: 4px 12px;
    margin: 4px 0 6px 0;
  }
  .info-grid {
    gap: 2px 8px;
  }
  .info-item {
    font-size: 12px;
  }
  .info-value {
    font-size: 12px;
  }
  .info-item:not(:last-child)::after {
    margin-left: 6px;
    height: 14px;
  }
  .vital-item .el-input {
    ::v-deep .el-input__inner {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
  }
  .vital-item .el-select {
    ::v-deep .el-input__inner {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
  }
  .vital-unit {
    font-size: 10px;
  }
}
/* 处方列表标题高度调整 */
.prescription-module .medical-header {
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 处方列表标题右侧 - 待收费合计 */
.total-unpaid-header {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.total-unpaid-header .amount-red {
  color: #F56C6C;
  font-size: 18px;
  font-weight: 700;
  margin-left: 4px;
}
/* 处方盒子圆角 */
.prescription-box {
  border-radius: 10px;
  margin-bottom: 16px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #f0f2f5;
}

.prescription-box:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 盒子头部圆角跟随 */
.prescription-box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #f0f2f5;
  flex-wrap: wrap;
  gap: 8px;
}

/* 盒子内容圆角 */
.prescription-box-body {
  overflow-x: auto;
  scrollbar-width: thin;
  border-radius: 0 0 10px 10px;
}

.prescription-box-body .el-table {
  border-radius: 6px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.order-type-tag {
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.order-type-tag i {
  font-size: 14px;
}

/* 处方类型标签 */
.tag-west {
  background: #ecf5ff;
  color: #409EFF;
}

.tag-tcm {
  background: #fdf6ec;
  color: #E6A23C;
}

.tag-dispose {
  background: #f0f9eb;
  color: #67C23A;
}

.tag-other {
  background: #f4f4f5;
  color: #909399;
}
.order-no {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
}
.order-status {
  display: flex;
  align-items: center;
}

.order-time {
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 4px;
}

.total-amount {
  font-size: 14px;
  color: #409EFF;
}

.total-amount span {
  font-size: 18px;
  font-weight: 700;
}

.order-count {
  font-size: 12px;
  color: #909399;
  background: #f5f7fa;
  padding: 2px 10px;
  border-radius: 12px;
}



.prescription-box-body .el-table .cell {
  font-size: 12px;
  padding: 0 6px;
}

/* 空状态 */
.empty-prescription {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  background: #fafbfc;
  border: 1px solid #e8ecf1;
}

.empty-prescription i {
  font-size: 48px;
  color: #c0c4cc;
}

.empty-prescription p {
  color: #909399;
  margin-top: 12px;
  font-size: 14px;
}

/* 药品选择下拉框样式 - 与顶部气泡风格一致 */
.drug-select-popper {
  .el-select-dropdown__item {
    height: auto !important;
    padding: 8px 12px !important;

    &:hover {
      background-color: #ecf5ff;
    }
  }
}
/* 方案一：无边框悬浮输入框 */
/* 临时标签 */
.temp-tag {
  display: inline-block;
  background: #fdf6ec;
  color: #e6a23c;
  font-size: 11px;
  padding: 0 6px;
  border-radius: 3px;
  margin-right: 4px;
  font-weight: 500;
  line-height: 20px;
  border: 1px solid #faecd8;
}
.patient-info-card {
  background: #ffffff;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  padding: 6px 18px;
  margin: 8px 0 10px 0;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

/* 空状态占位 - 居中 */
.empty-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  color: #909399;
  font-size: 14px;
}

.info-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 20px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 2;
}

.info-value {
  color: #303133;
  font-weight: 400;
  font-size: 13px;
}

/* 姓名加粗 */
.name-value {
  font-weight: 700;
  color: #303133;
}

/* 无边框下拉框 */
.borderless-select {
  ::v-deep .el-input__inner {
    border: none !important;
    background: transparent !important;
    padding: 0 20px 0 4px !important;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    color: #303133;
    border-radius: 4px !important;
    transition: all 0.25s ease;

    &:hover {
      background: #f5f7fa !important;
    }

    &:focus {
      background: #f0f5ff !important;
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12) !important;
    }
  }

  ::v-deep .el-input__suffix {
    right: 2px;
  }
}

/* 分隔线 */
.info-item:not(:last-child)::after {
  content: '';
  display: inline-block;
  width: 1px;
  height: 18px;
  background: #e8ecf1;
  margin-left: 14px;
}

/* 响应式 */
@media screen and (max-width: 576px) {
  .patient-info-card {
    padding: 4px 12px;
    margin: 4px 0 6px 0;
  }
  .info-grid {
    gap: 2px 12px;
  }
  .info-item {
    font-size: 12px;
  }
  .info-value {
    font-size: 12px;
  }
  .empty-placeholder {
    font-size: 12px;
    height: 32px;
  }
  .borderless-select {
    ::v-deep .el-input__inner {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      padding: 0 16px 0 4px !important;
    }
  }
  .info-item:not(:last-child)::after {
    margin-left: 8px;
    height: 14px;
  }
}
	/* 医嘱区域（包含西药/中药）设置为可滚动 */
	.seedoctorMedical:nth-child(3) {
		display: flex;
		flex-direction: column;
		max-height: 300px;
		/* 设置最大高度 */
	}

	.seedoctorMedical:nth-child(3)>div:last-child {
		flex: 1;
		overflow-y: auto;
		min-height: 0;
	}

	.medicine-whiteboard {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	/* 医嘱列表区域占满剩余空间 */
	.seedoctorMedical:last-child {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-height: 200px;
	}

	/* 使用 ::v-deep 或 /deep/ 穿透 scoped 样式 */
	.compact-collapse ::v-deep .el-collapse-item {
		margin-bottom: 2px;
	}

	.compact-collapse ::v-deep .el-collapse-item__wrap {
		margin-bottom: 2px;
		border-bottom: none;
	}

	.compact-collapse ::v-deep .el-collapse-item__content {
		padding-bottom: 2px !important;
		padding-top: 0;
	}

	/* 主容器样式调整 */
	.main-container {
		display: flex;
		position: relative;
		height: 100vh;
		transition: all 0.3s ease;
	}

	.sidebar-collapse-btn {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 10px;
		height: 48px;
		background-color: #ecf5ff;
		/* 淡蓝色背景 */
		border: 1px solid #b3d8ff;
		/* 淡蓝色边框 */
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		z-index: 500;
		color: #409EFF;
		/* Element UI 主蓝色 */
		transition: all 0.3s ease;
		border-radius: 0 4px 4px 0;
		opacity: 0.8;
	}

	.sidebar-collapse-btn:hover {
		background-color: #d9ecff;
		/* 悬停时稍深的淡蓝色 */
		color: #66b1ff;
		/* 稍亮的蓝色 */
		opacity: 1;
		box-shadow: 0 0 4px rgba(64, 158, 255, 0.3);
	}

	.sidebar-collapse-btn.left {
		left: calc(16% - 1px);
		border-radius: 0 4px 4px 0;
	}

	.sidebar-collapse-btn.right {
		right: calc(17% - 1px);
		border-radius: 4px 0 0 4px;
	}

	.sidebar-collapse-btn i {
		font-size: 14px;
		font-weight: bold;
	}

	/* 左侧边栏样式调整 */
	.el-aside.modern-sidebar {
		position: relative;
		transition: all 0.3s ease;
		background: #f8f9fa;
		box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}

	/* 右侧边栏样式调整 */
	.el-aside.right-sidebar {
		position: relative;
		transition: all 0.3s ease;
		background: #f8f9fa;
		box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}

	/* 主内容区样式调整 */
	.el-main.content {
		transition: all 0.3s ease;
		padding: 16px;
		background: #fff;
		overflow-y: auto;
	}

	/* 表格样式调整 - 适应宽度变化 */
	.sticky-header-table {
		width: 100% !important;
	}

	/* 响应式设计 */
	@media screen and (max-width: 1200px) {
		.el-aside.modern-sidebar {
			width: 20% !important;
		}

		.el-aside.right-sidebar {
			width: 20% !important;
		}

		.sidebar-collapse-btn.left {
			left: calc(20% - 1px);
		}

		.sidebar-collapse-btn.right {
			right: calc(20% - 1px);
		}

		.el-main.content {
			margin-left: var(--left-sidebar-width) !important;
			margin-right: var(--right-sidebar-width) !important;
			width: calc(100% - var(--left-sidebar-width) - var(--right-sidebar-width)) !important;
		}
	}

	@media screen and (max-width: 992px) {
		.el-aside.modern-sidebar {
			width: 240px !important;
			position: fixed;
			left: 0;
			top: 0;
			height: 100vh;
			z-index: 1001;
		}

		.el-aside.right-sidebar {
			width: 240px !important;
			position: fixed;
			right: 0;
			top: 0;
			height: 100vh;
			z-index: 1001;
		}

		.sidebar-collapse-btn.left {
			position: fixed;
			left: 240px;
			z-index: 1002;
		}

		.sidebar-collapse-btn.right {
			position: fixed;
			right: 240px;
			z-index: 1002;
		}
	}

	/* 添加侧边栏折叠动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s, transform 0.3s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
		transform: translateX(-10px);
	}

	/* 内容区域平滑过渡 */
	.content-expand-enter-active,
	.content-expand-leave-active {
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.content-expand-enter,
	.content-expand-leave-to {
		margin-left: 0 !important;
		margin-right: 0 !important;
		width: 100% !important;
	}

	.medicine-block {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
		padding: 8px;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		position: relative;
	}

	.medicine-name {
		flex: 1;
		margin-right: 10px;
	}

	.medicine-dose-input {
		width: 100%;
		margin-right: 10px;
	}

	.delete-btn-circle {
		cursor: pointer;
		color: #f56c6c;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: #fef0f0;
	}

	.drug-item {
		padding: 8px 10px;
		background: #f8f9fa;
		border-radius: 4px;
		border-left: 3px solid #409EFF;
	}

	.drug-main {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 6px;
	}

	.drug-name {
		font-weight: 500;
		color: #303133;
		font-size: 13px;
		flex: 1;
	}

	.drug-manufacturer {
		color: #909399;
		font-size: 11px;
		flex-shrink: 0;
		margin-left: 8px;
	}

	.drug-specs {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin-bottom: 4px;
	}

	.spec-item {
		display: flex;
		align-items: center;
		gap: 3px;
		color: #606266;
		font-size: 11px;
	}

	.drugs-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin-bottom: 10px;
	}

	.template-actions {
		display: flex;
		gap: 4px;
	}

	.template-id {
		font-weight: 600;
		color: #303133;
		font-size: 13px;
	}

	.template-title {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.template-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		padding-bottom: 8px;
		border-bottom: 1px solid #f0f0f0;
	}

	.template-disabled {
		opacity: 0.6;
		background: #fafafa;
	}

.template-item {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 12px 16px;
  background: #fff;
  transition: all 0.2s ease;
  width: 100%; /* 改为 100% 占满容器 */
  box-sizing: border-box;
  margin-bottom: 12px;
}
.template-item:hover {
  border-color: #409EFF;
  box-shadow: 0 1px 6px rgba(64, 158, 255, 0.1);
}

	.template-list {
		height: 100%;
		flex: 1;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	/* 紧凑的滚动条 */
	.template-list::-webkit-scrollbar {
		width: 4px;
	}

	.template-list::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	.template-list::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 2px;
	}

	.template-list::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}

	.template-content-card {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-height: 0;
		/* 重要：允许内容收缩 */
	}

	.template-content-card {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding: 12px;
		min-height: 0;
	}

	.template-content-card {
		flex: 1;
		border: none;
		border-radius: 0;

		/deep/ .el-card__body {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.prescription-right {
		width: 100%;
		height: 100%;
	}

	.prescription-right {
		.template-section {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;

			.template-header-custom {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px 20px;
				background: linear-gradient(135deg, #1890ff 0%, #36cbcb 100%);
				color: white;

				.header-main {
					display: flex;
					align-items: center;
					font-size: 16px;
					font-weight: 600;

					i {
						margin-right: 8px;
						font-size: 18px;
					}
				}

				.header-badge {
					.badge {
						/deep/ .el-badge__content {
							background: #ff4d4f;
						}
					}

					.el-button {
						color: white;
						padding: 4px 8px;

						&:hover {
							background: rgba(255, 255, 255, 0.2);
							border-radius: 4px;
						}
					}
				}
			}

			.template-content-card {
				flex: 1;
				border: none;
				border-radius: 0;

				/deep/ .el-card__body {
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}

	.medical-type-buttons {
		display: flex;
		align-items: center;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
	}

	.medical-type-btn {
		border: none !important;
		border-radius: 0 !important;
		margin: 0 !important;
		padding: 7px 20px !important;
		background: white !important;
		color: #606266 !important;
		font-size: 13px !important;
		border-right: 1px solid #dcdfe6 !important;
	}

	/* 最后一个按钮去掉右边框 */
	.medical-type-btn:last-child {
		border-right: none !important;
	}

	/* 鼠标悬停效果 */
	.medical-type-btn:hover {
		background: #f5f7fa !important;
		color: #409EFF !important;
	}

	/* 选中状态 - 主要效果 */
	.medical-type-btn.active {
		background: #409EFF !important;
		color: white !important;
		font-weight: 500;
	}

	@page {
		size: auto !important;
	}

	.modern-table-wrapper .el-table {
		/* 固定布局，防止列宽自动调整 */
		table-layout: fixed !important;
	}

	.modern-table-wrapper .el-table .el-table__header-wrapper {
		position: sticky;
		top: 0;
		z-index: 10;
		background: white;
	}

	.modern-table-wrapper .el-table th {
		background: #f5f7fa;
		font-weight: bold;
		height: 40px;
		/* 固定表头高度 */
	}

	.modern-table-wrapper .el-table .el-table__body {
		overflow-y: auto;
	}

.tab-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

	.custom-tabs {
		display: flex;
		background: white;
		border-bottom: none;
	}

	.custom-tab-item {
		display: flex;
		align-items: center;
		padding: 8px 16px;
		cursor: pointer;
		transition: all 0.3s ease;
		background-color: #f0f7ff;
		font-weight: 600;
		color: #1890ff;
    /* 保持原有样式不变 */
    position: relative;

    /* 激活状态 - 底部下划线 */
    &.active {
      color: #409EFF !important;
      font-weight: 900;
      text-shadow: 0 0 0.5px currentColor;  /* 模拟更粗 */
      -webkit-text-stroke: 0.3px currentColor;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 3px;
        background: #409EFF;
        border-radius: 3px 3px 0 0;
      }
    }
	}

	.custom-tab-item:last-child {
		border-right: none;
	}

	.custom-tab-item i {
		margin-right: 6px;
		font-size: 14px;
	}

	.header-actions {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.tab-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #f0f7ff;
		color: #1890ff;
		border-radius: 4px;
	}

	.tab-buttons {
		display: flex;
		gap: 5px;
	}

	.tab-buttons .el-button {
		border-radius: 4px;
		padding: 8px 16px;
		font-weight: 500;
	}

	.charge-content {
		padding: 0;
	}

	.charge-header {
		margin-bottom: 20px;
	}

	.charge-header h3 {
		margin-bottom: 15px;
		color: #303133;
		font-weight: 600;
	}

	.charge-info {
		margin-bottom: 20px;
	}

	.charge-details {
		margin-bottom: 20px;
	}

	.charge-summary {
		margin-bottom: 20px;
	}

	.summary-card,
	.payment-card {
		background: #f8f9fa;
		padding: 15px;
		border-radius: 4px;
		border: 1px solid #e6e6e6;
	}

	.summary-card h4,
	.payment-card h4 {
		margin-bottom: 15px;
		color: #303133;
		font-weight: 600;
	}

	.summary-item {
		display: flex;
		justify-content: space-between;
		padding: 8px 0;
		border-bottom: 1px solid #e6e6e6;
	}

	.summary-item.total {
		font-weight: bold;
		color: #409EFF;
		border-bottom: none;
		margin-top: 10px;
		padding-top: 12px;
		border-top: 2px solid #e6e6e6;
	}

	.charge-actions {
		text-align: center;
		padding: 20px 0;
		border-top: 1px solid #e6e6e6;
		margin-top: 20px;
	}

	.charge-actions .el-button {
		margin: 0 10px;
		min-width: 100px;
	}

	.context-menu {
		position: fixed;
		background: #fff;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		min-width: 100px;
		/* 建议增加最小宽度 */
		max-width: 300px;
		padding: 5px 0;
		z-index: 9999;
		/* 确保在最上层 */
	}

	/* 添加菜单项样式 */
	.context-menu .menu-item {
		padding: 8px 15px;
		cursor: pointer;
		color: #606266;
		/* 关键：设置文字颜色 */
		font-size: 14px;
		line-height: 1.5;
		white-space: nowrap;
		/* 防止文字换行 */
	}

	.context-menu .menu-item:hover {
		background-color: #f5f7fa;
		color: #409EFF;
	}

	/* 确保标题内容居中 */
	:deep(.el-collapse-item__header)>div {
		text-align: center !important;
		width: 100% !important;
	}

	:deep(.el-collapse-item__header) {
		padding-left: 30px !important;
		/* 增加左边内边距 */
		justify-content: flex-start !important;
		/* 左对齐 */
		background-color: #e8f4ff !important;
		/* 浅蓝色背景 */
		color: #1890ff !important;
		font-weight: 600;
	}

	.blood-sugar-container {
		display: flex;
		align-items: center;
		width: 100%;
		gap: 4px;
	}

	.blood-sugar-select {
		flex: 1;
		/* 占一半 */
		min-width: 0;
	}

	.blood-sugar-input {
		flex: 1;
		/* 占一半 */
		min-width: 0;
	}

	.blood-sugar-unit {
		flex: 0 0 auto;
		font-size: 11px;
		margin-left: 4px;
		white-space: nowrap;
	}

	:deep(.el-descriptions-item__content) {
		width: 100%;
	}

	/* 输入框宽度100% */
	:deep(.el-descriptions-item__content .el-input) {
		width: 100% !important;
	}

	/* 下拉框宽度100% */
	:deep(.el-descriptions-item__content .el-select) {
		width: 100% !important;
	}

	/* 日期选择器宽度100% */
	:deep(.el-descriptions-item__content .el-date-editor) {
		width: 100% !important;
	}

	/* 级联选择器宽度100% */
	:deep(.el-descriptions-item__content .el-cascader) {
		width: 100% !important;
	}

	/* 确保下拉框的输入框也是100% */
	:deep(.el-select .el-input) {
		width: 100% !important;
	}

	/* 下拉菜单宽度自适应 */
	:deep(.el-select-dropdown) {
		min-width: auto !important;
		width: auto !important;
	}

	/* 确保下拉选项宽度与触发器一致 */
	:deep(.el-select-dropdown.el-popper) {
		min-width: 0 !important;
	}

	:deep(.el-descriptions-item__label) {
		text-align: center;
	}

	:deep(.label-text) {
		display: block;
		width: 100%;
		text-align: center;
	}

	/* 确保标签单元格内容居中 */
	:deep(.el-descriptions-item__label.is-bordered-label) {
		text-align: center;
	}

	:deep(.el-descriptions-item__label .label-text) {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	:deep(.el-descriptions__table) {
		border-spacing: 0 !important;
		border-collapse: collapse !important;
	}

	:deep(.el-descriptions-item__cell) {
		padding: 2px !important;
	}

	:deep(.el-descriptions-item__label),
	:deep(.el-descriptions-item__content) {
		padding: 2px !important;
	}

	:deep(.el-descriptions-row) {
		padding: 2px !important;
	}

	/* 确保表单元素也没有外边距 */
	:deep(.el-descriptions-item__content .el-input),
	:deep(.el-descriptions-item__content .el-select),
	:deep(.el-descriptions-item__content .el-date-editor) {
		margin: 2px !important;
	}

	/* 如果需要更紧凑的布局，可以设置单元格高度 */
	:deep(.el-descriptions-item__cell) {
		height: auto !important;
		line-height: 1 !important;
	}

	/* 药品卡片样式优化 */
	.med-card {
		background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
		border: 1px solid #e8e8e8;
		border-left: 4px solid #1890ff;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 16px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		transition: all 0.3s ease;
	}

	.med-card:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
		border-color: #1890ff;
	}

	.med-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;
		padding-bottom: 8px;
		border-bottom: 1px solid #f0f0f0;
	}

	.med-name {
		font-weight: 600;
		color: #1890ff;
		font-size: 15px;
		line-height: 1.4;
	}

	.med-index {
		background: #1890ff;
		color: white;
		padding: 4px 8px;
		border-radius: 12px;
		font-size: 12px;
		font-weight: bold;
		min-width: 24px;
		text-align: center;
	}

	.med-details {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.med-row {
		display: flex;
		align-items: flex-start;
		padding: 4px 0;
	}

	.med-label {
		min-width: 50px;
		font-size: 13px;
		color: #666;
		font-weight: 500;
		flex-shrink: 0;
	}

	.med-value {
		flex: 1;
		font-size: 13px;
		color: #333;
		line-height: 1.5;
	}

	.med-row.warning {
		background: #fff2e8;
		padding: 8px;
		border-radius: 4px;
		border-left: 3px solid #fa541c;
		margin-top: 4px;
	}

	.med-row.warning .med-label {
		color: #fa541c;
		font-weight: 600;
	}

	.med-row.warning .med-value {
		color: #d4380d;
	}

	/* 治疗方案样式优化 */
	.treatment-item {
		margin-bottom: 12px;
		padding: 12px;
		background: #f6ffed;
		border-radius: 8px;
		border: 1px solid #b7eb8f;
		transition: all 0.3s ease;
	}

	.treatment-item:hover {
		background: #f0ffe6;
		transform: translateX(4px);
	}

	.treatment-content {
		display: flex;
		align-items: flex-start;
		line-height: 1.5;
	}

	.treatment-number {
		font-weight: bold;
		color: #52c41a;
		margin-right: 8px;
		flex-shrink: 0;
		font-size: 14px;
	}

	.treatment-text {
		flex: 1;
		color: #333;
		font-size: 14px;
	}

	/* 诊断建议气泡样式 */
	.diagnosis-bubble {
		border-left: 4px solid #1890ff;
		background: linear-gradient(135deg, #f0f7ff 0%, #e6f3ff 100%);
	}

	.diagnosis-header {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		color: #1890ff;
		font-weight: 600;
		font-size: 15px;
	}

	.diagnosis-header i {
		margin-right: 8px;
	}

	/* 治疗方案气泡样式 */
	.treatment-bubble {
		border-left: 4px solid #52c41a;
		background: linear-gradient(135deg, #f6ffed 0%, #f0ffe6 100%);
	}

	/* AI普通消息气泡 */
	.ai-bubble {
		background: white;
		border: 1px solid #e4e7ed;
	}

	/* 用户消息气泡 */
	.user-bubble {
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: white;
	}

	/* 治疗方案样式优化 */
	.treatment-item {
		display: flex;
		align-items: flex-start;
		margin-bottom: 8px;
		padding: 12px;
		background: #f6ffed;
		border-radius: 8px;
		border: 1px solid #b7eb8f;
		transition: all 0.3s ease;
	}

	.treatment-item:hover {
		background: #f0ffe6;
		transform: translateX(4px);
	}

	.treatment-number {
		width: 24px;
		height: 24px;
		background: #52c41a;
		color: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: bold;
		margin-right: 12px;
		flex-shrink: 0;
	}

	.treatment-text {
		flex: 1;
		line-height: 1.5;
		color: #333;
		font-size: 14px;
	}

	/* AI抽屉样式 */
	.ai-drawer .el-drawer__body {
		padding: 0;
		background: #f5f7fa;
	}

	.ai-chat-container {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.ai-messages {
		flex: 1;
		padding: 20px;
		overflow-y: auto;
		background: #f5f7fa;
	}

	/* 消息基础样式 */
	.message {
		display: flex;
		margin-bottom: 20px;
		align-items: flex-start;
	}

	.message.user {
		justify-content: flex-end;
	}

	.message.user .message-content {
		order: 1;
		align-items: flex-end;
	}

	.message.user .message-avatar {
		order: 2;
		margin-left: 12px;
		margin-right: 0;
	}

	.message-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		flex-shrink: 0;
	}

	.message-avatar i {
		color: white;
		font-size: 18px;
	}

	.message-avatar.user-avatar {
		background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
	}

	.message-content {
		display: flex;
		flex-direction: column;
		max-width: 80%;
	}

	.message-bubble {
		background: white;
		border-radius: 12px;
		padding: 16px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		border: 1px solid #e4e7ed;
	}

	.message.user .message-bubble {
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: white;
	}

	.message-time {
		font-size: 12px;
		color: #999;
		margin-top: 8px;
		text-align: right;
	}

	/* 诊断建议样式 */
	.diagnosis-content {
		line-height: 1.6;
		color: #333;
	}

	/* 治疗方案样式 */
	.treatment-section {
		margin-bottom: 20px;
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: #1890ff;
		margin-bottom: 12px;
		display: flex;
		align-items: center;
	}

	.treatment-item {
		display: flex;
		align-items: flex-start;
		margin-bottom: 8px;
		padding: 8px;
		background: #f6ffed;
		border-radius: 6px;
	}

	.treatment-number {
		width: 20px;
		height: 20px;
		background: #52c41a;
		color: white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: bold;
		margin-right: 8px;
		flex-shrink: 0;
	}

	.treatment-text {
		flex: 1;
		line-height: 1.5;
	}

	/* 处方样式 */
	.prescription-section {
		margin-top: 20px;
	}

	.med-category {
		margin-bottom: 16px;
	}

	.category-title {
		font-size: 14px;
		font-weight: 600;
		color: #333;
		margin-bottom: 8px;
		padding-bottom: 4px;
		border-bottom: 1px solid #e8e8e8;
	}

	.med-card {
		background: white;
		border: 1px solid #e8e8e8;
		border-radius: 6px;
		padding: 12px;
		margin-bottom: 8px;
	}

	.med-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.med-name {
		font-weight: 600;
		color: #1890ff;
		font-size: 14px;
	}

	.med-index {
		background: #f0f0f0;
		padding: 2px 8px;
		border-radius: 12px;
		font-size: 12px;
		color: #666;
	}

	.med-details {
		font-size: 13px;
		color: #666;
	}

	.med-row {
		display: flex;
		align-items: flex-start;
		margin-bottom: 4px;
	}

	.med-label {
		min-width: 50px;
		color: #999;
		flex-shrink: 0;
	}

	.med-value {
		flex: 1;
		line-height: 1.4;
	}

	.med-row.warning {
		color: #fa541c;
		background: #fff2e8;
		padding: 6px;
		border-radius: 4px;
		margin-top: 4px;
	}

	/* 生成中样式 */
	.generating-bubble {
		background: #f8f9fa;
		border: 1px dashed #d9d9d9;
	}

	.generating-content .generating-header {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
		color: #666;
	}

	.generating-content .generating-header i {
		margin-right: 8px;
	}

	.typing-indicator {
		display: flex;
		margin-top: 8px;
	}

	.typing-indicator span {
		height: 8px;
		width: 8px;
		background: #ccc;
		border-radius: 50%;
		margin-right: 4px;
		animation: typing 1.4s infinite ease-in-out;
	}

	.typing-indicator span:nth-child(1) {
		animation-delay: 0s;
	}

	.typing-indicator span:nth-child(2) {
		animation-delay: 0.2s;
	}

	.typing-indicator span:nth-child(3) {
		animation-delay: 0.4s;
	}

	@keyframes typing {

		0%,
		60%,
		100% {
			transform: translateY(0);
		}

		30% {
			transform: translateY(-4px);
		}
	}

	/* 系统消息样式 */
	.system-message {
		text-align: center;
		color: #999;
		font-size: 12px;
		margin: 10px 0;
	}

	.system-message i {
		margin-right: 6px;
	}

	.message.ai.generating {
		opacity: 0.9;
	}

	.generating-bubble {
		background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
		border-left: 4px solid #667eea;
		border: 1px solid #e6e8eb;
	}

	.generating-content {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.generating-header {
		display: flex;
		align-items: center;
		gap: 8px;
		color: #667eea;
		font-weight: 500;
		font-size: 14px;
	}

	.generating-header .el-icon-loading {
		animation: spin 1s linear infinite;
		font-size: 16px;
	}

	.partial-content {
		color: #666;
		line-height: 1.5;
		max-height: 200px;
		overflow-y: auto;
		padding: 8px;
		background: rgba(255, 255, 255, 0.7);
		border-radius: 8px;
		border: 1px dashed #ddd;
	}

	.typing-indicator {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		margin-top: 8px;
	}

	.typing-indicator span {
		height: 6px;
		width: 6px;
		background: #667eea;
		border-radius: 50%;
		display: inline-block;
		animation: bounce 1.3s linear infinite;
	}

	.typing-indicator span:nth-child(1) {
		animation-delay: 0s;
	}

	.typing-indicator span:nth-child(2) {
		animation-delay: 0.15s;
	}

	.typing-indicator span:nth-child(3) {
		animation-delay: 0.3s;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes bounce {

		0%,
		60%,
		100% {
			transform: translateY(0);
			opacity: 0.4;
		}

		30% {
			transform: translateY(-5px);
			opacity: 1;
		}
	}

	/* 其他样式保持不变 */
	.ai-messages {
		height: 100%;
		overflow-y: auto;
		padding: 20px;
	}

	.message {
		display: flex;
		margin-bottom: 20px;
	}

	.message-avatar {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 10px;
	}

	.message-content {
		display: flex;
		flex-direction: column;
		max-width: 70%;
	}

	.message-bubble {
		padding: 12px 16px;
		line-height: 1.5;
		word-wrap: break-word;
		border-radius: 18px;
	}

	.message.ai .message-bubble {
		background: white;
		color: #333;
		border-radius: 18px 18px 18px 5px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.message-time {
		font-size: 11px;
		color: #999;
		margin-top: 5px;
	}

	.ai-drawer {
		position: fixed;
		top: 40px !important;
		/* 根据导航栏高度调整 */

		::v-deep .el-drawer {
			background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);

			.el-drawer__header {
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				color: white;
				margin-bottom: 0;
				padding: 20px;
			}

			.el-drawer__body {
				padding: 0;
				display: flex;
				flex-direction: column;
				height: 100%;
			}
		}
	}

	.ai-chat-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 100%;
		padding: 20px;
	}

	.ai-messages {
		flex: 1;
		overflow-y: auto;
		padding: 10px 0;
		max-height: 100%;

		.message {
			display: flex;
			margin-bottom: 20px;
			animation: fadeInUp 0.3s ease;

			&.user {
				justify-content: flex-end;

				.message-bubble {
					background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
					color: white;
					border-radius: 18px 18px 5px 18px;
				}
			}

			&.ai {
				.message-bubble {
					background: white;
					color: #333;
					border-radius: 18px 18px 18px 5px;
					box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

					&.timeout-message {
						border: 1px solid #e6a23c;
					}
				}
			}

			&.system {
				justify-content: center;

				.message-bubble {
					background: #f0f2f5;
					color: #666;
					font-size: 12px;
					padding: 8px 16px;
					border-radius: 12px;
				}
			}
		}

		.message-avatar {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 10px;

			.el-icon-ai {
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				color: white;
				border-radius: 50%;
				padding: 8px;
				font-size: 16px;
			}

			.el-icon-user {
				background: #36a3f7;
				color: white;
				border-radius: 50%;
				padding: 8px;
				font-size: 16px;
			}

			.el-icon-info {
				background: #909399;
				color: white;
				border-radius: 50%;
				padding: 8px;
				font-size: 16px;
			}

			.el-icon-loading {
				color: #667eea;
				font-size: 16px;
			}
		}

		.message-content {
			display: flex;
			flex-direction: column;
			max-width: 80%;
		}

		.message-bubble {
			padding: 12px 16px;
			line-height: 1.5;
			word-wrap: break-word;
		}

		.message-time {
			font-size: 11px;
			color: #999;
			margin-top: 5px;

			.timeout-badge {
				background: #e6a23c;
				color: white;
				padding: 1px 4px;
				border-radius: 3px;
				margin-left: 5px;
			}
		}
	}

	.ai-input-area {
		border-top: 1px solid #e6e8eb;
		padding-top: 20px;
	}

	.input-actions {
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
		gap: 10px;
	}

	.drawer-actions {
		border-top: 1px solid #e6e8eb;
		padding: 15px 20px;
		display: flex;
		gap: 10px;
		justify-content: center;
	}

	::v-deep .ai-highlight {
		color: #e91e63;
		font-weight: 600;
	}

	::v-deep .ai-section-title {
		font-weight: 600;
		color: #667eea;
		margin: 10px 0 5px 0;
		font-size: 14px;
	}

	::v-deep .ai-list-item {
		margin: 3px 0;
		padding-left: 10px;
	}

	::v-deep .timeout-notice {
		color: #e6a23c;
		font-size: 12px;
		margin-top: 8px;
		padding: 4px;
		background: #fdf6ec;
		border-radius: 4px;
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(10px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.hidden-dialog {
		visibility: hidden;
		/* 如果不想占用布局空间，可以加上: */
		position: absolute;
	}

	.blood-pressure-error .el-input__inner {
		border-color: red;
		color: red;
	}

	/* 滚动条统一样式 */
	:root {
		scrollbar-width: thin !important;
		scrollbar-color: #c0c4cc #f5f7fa !important;
	}

	:deep(.el-table__body-wrapper) {
		overflow-x: auto;
		overflow-y: auto;
	}

	:deep(.el-table__body-wrapper::-webkit-scrollbar) {
		width: 0;
		height: 8px;
	}

	:deep(::-webkit-scrollbar) {
		width: 8px;
		height: 8px;
	}

	:deep(::-webkit-scrollbar-thumb) {
		background: #c0c4cc;
		border-radius: 10px;
		height: 20px;
	}

	:deep(::-webkit-scrollbar-track) {
		background: #f5f7fa;
		border-radius: 10px;
	}

	/* 基础布局 */
	.modern-sidebar {
		border-radius: 12px 0 0 12px;
		/* 修改:左上角和左下角12px圆角，右上角和右下角直角 */
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.sidebar-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* 表格容器 */
	.waiting-table,
	.reception-table {
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	.waiting-table {
		flex: 0 0 40%;
	}

	.reception-table {
		flex: 1;
		position: relative;
	}

	/* 表格样式 */
	.sticky-header-table {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		border-radius: 0 0 4px 4px;
	}

	.sticky-header-table :deep(.el-table__header-wrapper) {
		position: sticky;
		top: 0;
		z-index: 10;
		background: white;
	}

	.sticky-header-table :deep(.el-table__body-wrapper) {
		flex: 1;
		overflow: auto;
	}

	/* 现代风格搜索输入框 */
	.modern-search-input {
		width: 500px;
	}

	.modern-search-input /deep/ .el-input__inner {
		height: 36px;
		line-height: 36px;
		padding-left: 35px;
		border-radius: 18px;
		border: 1px solid #DCDFE6;
	}

	.modern-search-input /deep/ .el-input__prefix {
		font-size: 20px;
		/* 调整图标大小 */
		margin-top: -3px;
	}


	/* 确保表格容器正确计算宽度 */
	.disabled-table .el-table__body-wrapper {
		overflow-x: auto !important;
	}

	/* 强制表格布局模式 */
	.el-table {
		display: table !important;
		table-layout: fixed !important;
		/* 关键:固定布局 */
	}

	/* 修正固定列的层级 */
	.el-table__fixed-right {
		height: 100% !important;
		/* 避免固定列高度溢出 */
	}

	.audio-player {
		margin-right: 20px;
	}

	/* 适配紧凑布局 */
	.el-header {
		padding: 0 20px !important;
	}

	/* 音频控件样式优化 */
	audio {
		outline: none;
		border-radius: 4px;
	}

	.audio-placeholder {
		line-height: 60px;
		color: #909399;
	}

	.recording-status {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px;
		text-align: center;
	}

	.wave-animation {
		width: 100px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.wave-animation::before,
	.wave-animation::after,
	.wave-animation span {
		content: '';
		width: 10px;
		height: 100%;
		background: #f56c6c;
		border-radius: 5px;
		animation: wave 1s ease-in-out infinite;
	}

	.wave-animation::before {
		animation-delay: 0s;
	}

	.wave-animation span {
		animation-delay: 0.2s;
	}

	.wave-animation::after {
		animation-delay: 0.4s;
	}

	@keyframes wave {

		0%,
		100% {
			transform: scaleY(0.3);
		}

		50% {
			transform: scaleY(1);
		}
	}

	::v-deep .el-table .row-positive {
		background-color: #f1b0b9 !important;
	}

	::v-deep .el-table .row-negative {
		background-color: #bcfd76 !important;
	}

	.disabled-table {
		opacity: 0.6;
	}

	.disabled-table .el-table__body-wrapper * {
		pointer-events: none;
		cursor: not-allowed;
	}

	/* 允许滚动条交互 */
	.disabled-table .el-table__body-wrapper {
		pointer-events: auto !important;
	}

	::v-deep .el-table .warning-row {
		background-color: #ff0000 !important;

		td {
			background-color: transparent !important;
		}

		&:hover td {
			background-color: #ff0000 !important;
		}
	}

	/* 深度覆盖Element UI默认样式 */
	.compact-mini-table {
		font-size: 13px !important;
		/* 缩小字体 */
	}

	.compact-mini-table .el-table__header th,
	.compact-mini-table .el-table__body td {
		padding: 4px 0 !important;
		/* 减少单元格内边距 */
		line-height: 20px !important;
		/* 行高压缩 */
	}

	.compact-mini-table .el-table__row {
		height: 28px !important;
		/* 固定行高 */
	}

	/* 缩小复选框 */
	.compact-mini-table .el-checkbox__inner {
		width: 14px;
		height: 14px;
	}

	.compact-cell {
		.cell {
			padding-left: 3px !important;
			padding-right: 3px !important;
		}
	}

	.compact-content {
		white-space: pre-line;
		text-align: center;
		font-size: 11px;
		/* 内容区更小字号 */
		line-height: 1.2;
	}

	.patient-dialog {
		display: flex;
		justify-content: center;
		align-items: Center;
		overflow: auto;

		.el-dialog {
			margin: 0 auto !important;
			position: relative;

			.el-dialog__header {
				position: absolute;
				left: 0;
				top: 0;
				right: 0;
				width: 100%;
				height: 60px;
				z-index: 1;
			}

			.el-dialog__body {
				width: 100%;
				overflow: hidden;
				overflow-y: auto;
				max-height: 80vh; //最大高度为视口高度的90%
				padding-top: 80px;
				padding-bottom: 100px;
				z-index: 1;
			}

			.el-dialog__footer {
				position: absolute;
				left: 0;
				bottom: 0;
				right: 0;
				width: 100%;
				height: 80px;
				z-index: 1;
			}
		}
	}

	/* 容器高度控制链 */
	.medical-orders-container {
		flex: 1;
		/* 关键:占据剩余空间 */
		min-height: 200px;
		/* 最小高度 */
		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* 防止溢出 */
	}

	.medical-orders-tabs {
		flex: 1;
		/* 继承父容器高度 */
		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* 防止溢出 */
	}

	/* 标签页内容区域 */
	.medical-orders-tabs .el-tabs__content {
		flex: 1;
		/* 关键:占据剩余空间 */
		overflow: hidden;
		/* 防止溢出 */
		position: relative;
		/* 用于定位右键菜单 */
	}

	/* 表格样式修正 */
	.medical-orders-tabs .el-table {
		width: 100%;
		height: 100% !important;
		display: flex;
		flex-direction: column;
	}

	/* 真正控制滚动的部分 */
	.medical-orders-tabs .el-table__body-wrapper {
		flex: 1;
		overflow-y: auto !important;
		overflow-x: hidden !important;
	}

	/* 表头固定 */
	.medical-orders-tabs .el-table__header-wrapper {
		flex-shrink: 0;
	}

	::v-deep .el-cascader .el-input__inner::placeholder {
		color: var(--el-text-color-placeholder) !important;
		/* 使用官方变量 */
	}

	.prescription-button .el-button:hover {
		background-color: #f5f7fa !important;
	}

	.group-tag {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 6px;
		border-radius: 3px;
	}

	/* 分组图标（居中显示） */
	.group-icon {
		position: absolute;
		left: 10px;
		top: 50%;
		transform: translateY(-50%);
		font-size: 14px;
	}

	/* 调整第一列内边距 */
	.el-table .el-table__cell:first-child {
		padding-left: 30px !important;
	}


	.compact-form-box,
	.el-tab-pane {
		overflow: auto !important;
	}

	/* 表格布局统一设置 */
	.el-table {
		display: flex !important;
		flex-direction: column !important;
	}

	.el-table__header-wrapper {
		flex: 0 0 auto !important;
	}

	.el-table__body-wrapper {
		flex: 1 1 auto !important;
		overflow-y: auto !important;
		overflow-x: hidden !important;
	}

	/* 修复边框显示 */
	.el-table--border {
		border-bottom: none;
	}


	.no-line {
		border-top: none !important;
		padding-top: 0 !important;
	}

	/* 方法2:使用/deep/的正确姿势 */
	.blood-pressure-container /deep/ .blood-pressure-error .el-input__inner {
		color: #f56c6c !important;
	}

	/* 表单项整体样式 */
	.address-form-item {
		.el-form-item__content {
			display: flex;
			width: 100%;
		}
	}

	/* 统一宽度样式 */
	.wide-address-selector,
	.wide-address-input {
		width: 500px !important;
		/* 调整为需要的宽度 */
		min-width: 100%;
		/* 保证响应式 */

		/* 深度选择器穿透element-ui内部样式 */

		::v-deep {
			.el-input__inner {
				height: 30px;
				line-height: 40px;
				font-size: 14px;
			}

			/* 级联选择器下拉面板宽度 */

			.el-cascader-menu {
				min-width: 140px;
			}
		}
	}

	/* 移动端适配 */
	@media (max-width: 768px) {

		.wide-address-selector,
		.wide-address-input {
			width: 100% !important;
		}
	}

	.form-row {
		margin-bottom: 5px;
	}

	/* 调整地址选择器的间距 */
	.age-input-address>* {
		margin-right: 5px;
	}

	/* 年龄输入框样式 */
	.age-input-group>* {
		margin-right: 5px;
	}


	.empty-tip {
		width: 100%;
		height: 200px;
		/* 与min-height保持一致 */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.tip-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #909399;
		font-size: 14px;
	}

	.tip-content i {
		font-size: 24px;
		margin-bottom: 5px;
		color: #C0C4CC;
	}

	.highlight {
		background: #1890ff !important;
		/* 背景蓝色 */
		color: white;
		/* 文字白色（确保可读性） */
		border-color: #1890ff;
		/* 可选:边框也变蓝色 */
	}

	.compact-method-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		/* 确保每排4个 */
		gap: 10px;
		padding: 5px;
	}

	.compact-method-item {
		padding: 5px;
		text-align: center;
		background: white;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		cursor: pointer;
	}

	.compact-method-item:hover {
		background-color: #409EFF;
		color: white;
	}

	/* 按钮区域样式 */
	.dialog-footer {
		text-align: right;
		padding: 10px 15px;
		margin-top: 25px;
		padding-right: 15px;
		border-top: 1px solid #e1e4e8;
	}

	.medicine-whiteboard {
		border: 2px dashed #DCDFE6;
		border-radius: 8px;
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin: 5px 0;
		padding: 10px;
	}

	.medicine-block {
		width: 150px;
		height: 80px;
		border: 1px solid #409EFF;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		/* 均匀分布三个部分 */
		align-items: center;
		cursor: pointer;
		transition: all 0.3s;
		position: relative;
		padding: 10px 5px;
		/* 增加内边距 */
	}

	.medicine-method {
		font-size: 12px;
		color: #909399;
		width: 100%;
		text-align: center;
		margin-bottom: 5px;
		word-break: break-word;
		/* 长文本换行 */
	}

	.medicine-name {
		font-size: 16px;
		text-align: center;
		width: 100%;
		margin: auto 0;
		font-weight: 500;
		color: black;
	}

	.medicine-dose {
		font-size: 12px;
		color: #909399;
		width: 100%;
		text-align: center;
		margin-top: 5px;
	}

	.medicine-block:hover {
		box-shadow: 0 2px 12px 0 rgba(64, 158, 255, 0.2);
		transform: translateY(-2px);
	}

	.add-medicine {
		/* 保持原有添加按钮样式 */
		width: 150px;
		height: 100px;
		border: 1px dashed #DCDFE6;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #909399;
		cursor: pointer;
	}

	/* Vue 2样式穿透写法 */
	.medicine-dose-input::v-deep .el-input__inner {
		text-align: center;
		padding: 0 5px;
	}

	.medicine-dose-input::v-deep .el-input-group__append {
		padding: 0 5px;
		background-color: #f5f7fa;
	}

	.el-input-group__append,
	.el-input-group__prepend {
		padding: 0 10px;
	}

	/deep/ .el-table__row.red-row .cell {
		color: red !important;
	}


	.el-input {
		cursor: pointer;
	}

	/* 表格容器样式 */
	.table-container {
		width: 100%;
		/* 宽度100%适应弹窗 */
	}

	/* 自定义弹窗样式（全局样式） */
	:global(.medicine-popover) {
		padding: 0 !important;
		/* 去除内边距 */
		max-width: 1000px;
		/* 最大宽度限制 */
	}

	/* 表格滚动条相关样式 */
	.table-container::-webkit-scrollbar {
		height: 8px;
		/* 水平滚动条高度 */
		width: 8px;
		/* 垂直滚动条宽度 */
	}

	.table-container::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 4px;
	}

	/* 确保表格有固定高度和滚动条 */
	.fixed-height-table {
		height: 100vh;
		/* 固定高度 */
		overflow-y: auto;
		/* 垂直滚动 */
	}

	/* 确保 el-table 内部正确显示滚动条 */
	.fixed-height-table .el-table__body-wrapper {
		overflow-y: auto !important;
	}


	.menu-header {
		padding: 5px 12px;
		color: #909399;
		font-size: 12px;
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 5px;
	}

	.menu-divider {
		height: 1px;
		background-color: #ebeef5;
		margin: 5px 0;
	}

	.medical-info-form {
		border-radius: 4px;
		padding: 0 !important;
	}

	.medical-header {
		font-weight: bold;
		font-size: 15px;
		color: #333;
	}


	.form-item {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
	}

	.form-item label {
		width: 60px;
		text-align: right;
		padding-right: 8px;
		font-size: 13px;
		color: #666;
	}


	/* 表格标题容器 - 修改版 */
	.table-title-container {
		background-color: #0b5baf;
		border-radius: 5px;
		position: relative;
	}

	.quick-consult-btn {
		background-color: #1a7cff;
		border-color: #1a7cff;
		color: white;
		margin-left: auto;
		/* 关键:将按钮推到最右侧 */
		margin-right: 30px;
		/* 关键:将按钮推到最右侧 */
	}


	/* 标题内容包装 - 修改版 */
	.table-title-wrapper {
		padding: 8px 16px;
		/* 适当内边距 */
		display: flex;
		align-items: center;
		width: 100%;
	}

	/* 标题文本 */
	.title-text {
		font-size: 14px;
		font-weight: bold;
	}

	/* 病人数量 */
	.patient-count {
		margin-left: 8px;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.8);
		/* 半透明白色 */
	}

	/* 调整表格区域间距 */
	.table-area {
		margin-top: 0;
		/* 去除顶部间距 */
		margin-bottom: 16px;
	}

	/* 确保表格无边框间距 */
	.first-table,
	.second-table {
		border-top: none;
	}

	.main-container {
		height: 100%;
		width: 100vw;
		max-width: 100vw;
		/* 确保不超过视口宽度 */
		overflow: auto;
		position: relative;
		box-sizing: border-box;
		/* 包含padding和border */
		border-radius: 10px;
	}

	/* 修复Element UI表格的滚动问题 */
	.main-container .el-table__body-wrapper {
		flex: 1;
		overflow: auto;
	}

	/* 修复flex布局的列溢出问题 */
	.main-container .el-col {
		min-width: 0;
		/* 重要:允许列内容收缩 */
	}

	/* 主容器滚动条样式 */
	.main-container::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.main-container::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 4px;
	}

	.main-container .el-table {
		width: 100% !important;
		display: flex !important;
		flex-direction: column;
	}

	.left-col {
		z-index: 100;
		height: 100%;
		display: flex;
		flex-direction: column;
		border-right: 1px solid #ebeef5;
	}


	.right-col {
		height: 100%;
		width: 80vw;
		padding: 8px;
		background: #f5f7fa;
	}

	.table-area {
		height: 100%;
		padding: 1px;
	}

	.form-container {
		height: 100%;
	}

	.el-table {
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

	.el-form-item {
		margin-bottom: 18px;
	}

	/*=========================================================*/

	.celerity-filing-button {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
		/* 增加与表单的距离 */
	}

	/deep/ .el-dialog__header {
		padding: 18px;
		background-color: #007bb0;
	}

	/deep/ .el-dialog__title {
		font-size: 18px;
		color: #fff;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	/deep/ .el-input.is-disabled .el-input__inner {
		color: #87898f;
	}

	/deep/ .el-textarea.is-disabled .el-textarea__inner {
		color: #87898f;
	}

	.dialog {
		.addUnitDialog {
			.tabs {
				/deep/ .el-select>.el-input {
					width: 172px;
				}

				/deep/ .el-date-editor.el-input,
				.el-date-editor.el-input__inner {
					width: 172px;
				}

				/deep/ .el-form-item__content {
					display: flex;

					span {
						font-size: 12px;
					}
				}

				.oneLine {
					width: 524px;
					// background-color: indianred;
				}
			}

			/deep/ .el-dialog__title {
				font-size: 15px;
			}

			/deep/ .el-table {
				font-size: 15px;
			}
		}
	}

	.custom-dialog-footer {
		display: flex;
		justify-content: space-between;
		/* 左右两侧分开 */
		align-items: center;
		/* 垂直居中 */
		margin-top: 10px;
	}

	.left-buttons,
	.right-buttons {
		display: flex;
		gap: 10px;
		/* 按钮间距 */
	}

	/* 如果需要右侧按钮组靠右对齐 */
	.right-buttons {
		margin-left: 100px;
	}


	.auto-height-button {
		height: 100% !important;
		/* 继承父容器高度 */
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 0 4px 4px 0 !important;
		/* 保持圆角匹配 */
	}

	/* 确保输入框和按钮高度统一 */
	.input-with-button .el-input__inner {
		height: 40px;
		/* 调整这个值会同时改变按钮高度 */
	}

	.main {
		height: 480px;
		/* 改为自适应高度 */
		padding: 0 6px;
		/* 调整内边距 */
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	/* 侧边面板样式 */
	.side-panel {
		width: 240px;
		padding: 10px;
		background: #f5f7fa;
	}

	/* 右侧挂号盒子（固定宽度+贴顶） */
	.registration-box {
		width: 170px;
		background: white;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		padding: 12px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
		align-self: flex-start;
		/* 顶部对齐 */
		margin: 0 8px 0 0;
	}

	/* 数据行样式 */
	.data-row {
		display: flex;
		margin-bottom: 12px;
		align-items: center;
	}

	.label {
		width: 70px;
		font-size: 13px;
	}

	.el-input {
		flex: 1;
	}

	.label {
		width: 70px;
		font-size: 13px;
		color: #666;
		margin-right: 4px;
	}

	.el-input {
		flex: 1;
	}

	.el-input.is-disabled .el-input__inner {
		background-color: #f5f5f5;
		color: #666;
	}

	/* 新增样式 */
	.register-group {
		width: 50%;
		display: flex;
		gap: 16px;
		margin-top: 8px;
	}


	/* 强制同行显示 */
	.register-type+.clinic-room {
		margin-left: -8px;
		/* 补偿间距 */
	}

	/* 关键修复样式 */
	.compact-form {
		/* 在原有样式基础上添加 */

		.register-type,
		.clinic-room {
			flex: 1;
			/* 平分剩余空间 */
			min-width: 240px;
			/* 最小宽度保证换行后对齐 */
			max-width: 50%;
			/* 最大不超过50% */

			/deep/ .el-form-item__content {
				width: calc(100% - 90px) !important;
				/* 匹配label宽度 */
			}
		}

		/* 强制同行显示 */

		.register-type+.clinic-room {
			margin-left: -8px;
			/* 补偿间距 */
		}

		/deep/ .el-form-item__content {
			margin-left: 0 !important;
			/* 消除ElementUI默认的左侧间距 */
			width: auto !important;
			/* 取消固定宽度 */
		}

		/deep/ .el-form-item__label {
			padding-right: 6px !important;
			/* 标签与输入框间距 */
			width: auto !important;
			/* 取消标签固定宽度 */
			flex: none !important;
			/* 禁用flex自动分配 */
		}

		.el-form-item {
			/* 调整整体间距 */
			gap: 4px;
			/* 标签与控件间距 */

			/* 微调对齐方式 */
			align-items: baseline;
		}

		/* 特殊处理复选框 */

		.el-checkbox {
			margin-left: 2px;

			/deep/ .el-checkbox__label {
				display: none;
				/* 隐藏默认标签 */
			}
		}

		/* 输入框尺寸补偿 */

		.el-input--mini {
			line-height: 28px;

			/deep/ .el-input__inner {
				padding: 0 8px;
			}
		}
	}


	.compact-form {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 16px;
		/* 行列间距 */

		.el-form-item {
			margin: 0;
			display: inline-flex;
			align-items: center;

			/* 标签对齐 */

			/deep/ .el-form-item__label {
				line-height: 28px;
				padding-right: 4px;
			}

			/* 表单控件通用样式 */

			.el-input,
			.el-select,
			.el-date-editor {
				width: 100px;
				/* 默认宽度 */
			}

			/* 特定字段宽度调整 */

			&[label="性别:"] .el-select {
				width: 70px;
			}


			&[label="职业:"] .el-select {
				width: 130px;
			}

			&[label="病员费别:"] .el-select,
			&[label="病员类型:"] .el-select {
				width: 135px;
			}

			&[label="联系电话:"] .el-input {
				width: 135px;
			}


			&[label="挂号类别:"] .el-select,
			&[label="诊室:"] .el-select {
				width: 300px;
			}

			/* 年龄输入组 */

			.age-input-group {
				display: flex;
				align-items: center;

				.el-input {
					width: 32px !important;

					&+.age-unit {
						margin: 0 2px;
					}
				}
			}

			/* 地址输入组 */

			.age-select-address {
				display: flex;
				align-items: center;
				gap: 4px;

				.el-input {
					width: 60px !important;

					&:nth-last-child(2) {
						width: 150px !important;
					}

					/* 乡镇输入框 */
				}
			}
		}

		/* 分隔线样式 */

		.divider-line {
			width: 100%;
			margin: 5px 10px 0;
			border-top: 1px solid #ebeef5;
		}
	}


	.el-form-item {
		margin-bottom: 5px;
	}

	.age-unit {
		margin: 0 5px;
		color: #909399;
		font-size: 12px;
	}

	/*!* 强制所有模态框层级高于下拉框 *!
													.el-dialog__wrapper {
													  z-index: 3000 !important; !* Element默认2000 *!
													}

													!* 控制所有下拉框层级 *!
													.el-select-dropdown {
													  z-index: 2000 !important; !* 低于模态框 *!
													}

													.el-popper {
													  z-index: 2000 !important; !* 包括Tooltip等弹出层 *!
													}*/

	.no-border-select /deep/ .el-tag {
		background-color: rgba(253, 253, 253, 0.1) !important;
		/* 透明蓝背景 */
		border-color: rgba(64, 158, 255, 0.2) !important;
		/* 浅蓝色边框 */
		color: #409EFF !important;
		/* 蓝色文字 */
		margin: 2px 6px 2px 0 !important;
		/* 调整间距 */
	}

	/* 鼠标悬停效果 */
	.no-border-select /deep/ .el-tag:hover {
		opacity: 0.8;
	}

	/* 移除默认的关闭按钮（如需保留可删除此部分） */
	.no-border-select /deep/ .el-tag__close {
		color: #409EFF !important;
	}

	.no-border-select /deep/ .el-select-dropdown {
		border: none !important;
		box-shadow: none !important;
		margin-top: 0 !important;
		/* 移除下拉框与输入框的间距 */
	}

	/* 可选:移除输入框边框 */
	.no-border-select /deep/ .el-input__inner {
		border: none !important;
		box-shadow: none !important;
	}

	/deep/ .el-dialog__header {
		padding: 10px;
		background-color: #007bb0;
	}

	/deep/ .el-dialog__title {
		font-size: 14px;
		color: #fff;
	}

	/* 面板样式 */
	.keywords-panel {
		width: 100%;
		max-height: 60vh;
		background: white;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		overflow-y: auto;
		padding: 10px;
	}

	/* 标题头 */
	.keywords-header {
		padding: 5px 10px;
		font-weight: bold;
		border-bottom: 1px dashed #eee;
		margin-bottom: 10px;
		color: #1890ff;
	}

	/* 分组区块 */
	.group-section {
		margin-bottom: 15px;
	}

	.group-title {
		font-size: 13px;
		color: #666;
		margin-bottom: 8px;
		padding-left: 5px;
		border-left: 3px solid #1890ff;
	}

	.group-keywords {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	/* 标签样式 */
	.keyword-tag {
		cursor: pointer;
		transition: all 0.2s;
	}

	.keyword-tag:hover {
		background: #1890ff;
		color: white;
		transform: translateY(-2px);
	}

	.keywords-panel {
		display: flex;
		width: 600px;
		max-height: 400px;
		background: white;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		position: absolute;
		z-index: 9999;
	}

	.keywords-sidebar {
		width: 120px;
		padding: 10px 0;
		overflow-y: auto;
	}

	.divider {
		width: 1px;
		background: repeating-linear-gradient(#ebeef5, #ebeef5 2px, transparent 2px, transparent 4px);
		margin: 8px 0;
	}

	.group-title {
		padding: 8px 15px;
		cursor: pointer;
		font-size: 13px;
		color: #606266;
		transition: all 0.3s;
	}

	.group-title:hover {
		background-color: #f5f7fa;
		color: #409eff;
	}

	.group-title.active {
		background-color: #ecf5ff;
		color: #409eff;
		font-weight: 500;
		border-right: 2px solid #409eff;
	}

	.keywords-content {
		flex: 1;
		padding: 10px;
		overflow-y: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		gap: 8px;
	}

	.keyword-tag {
		cursor: pointer;
		margin: 2px;
		transition: all 0.2s;
	}

	.keyword-tag:hover {
		background-color: #409eff;
		color: white;
		transform: translateY(-1px);
	}

	.keywords-panel {
		position: absolute;
		z-index: 1000;
		background: white;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		padding: 10px;
		max-height: 300px;
		overflow-y: auto;
	}

	.keyword-tag {
		margin: 3px;
		cursor: pointer;
	}

	.keyword-tag:hover {
		background-color: #1890ff;
		color: white;
	}

	.cell-input ::v-deep .el-input__inner {
		border: none;
		background: transparent;
		color: #0c0c0c;
		font-size: 15px;
	}

	.cell-input ::v-deep .el-input__inner:focus {
		outline: none;
		box-shadow: none;
	}

	/* 确保所有描述项的标签不换行 - Vue 2 深度选择器语法 */
	/deep/ .el-descriptions-item__label {
		white-space: nowrap !important;
		min-width: 80px !important;
	}

	/* 调整描述项内容区域的宽度，使其自适应剩余空间 */
	/deep/ .el-descriptions-item__content {
		width: auto;
		flex: 1;
	}


	.sidebar-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* 防止内部溢出影响外部布局 */
	}

	.compact-form {
		flex: 1;
		overflow-y: auto;
		/* 表单内容超出时显示垂直滚动条 */
	}


	.el-main.content {
		// ... existing code ...
		padding: 0;
		/* 移除父容器内边距 */
	}


	.left-sidebar {
		background-color: transparent;
		border: 1px solid #e6e6e6;
		border-radius: 12px 0 0 12px;
		/* 修改:左上角和左下角12px圆角，右上角和右下角直角 */
		overflow: hidden;
		padding: 0;
		/* 修改:移除内边距 */
		display: flex;
		flex-direction: column;
	}

	.right-sidebar {
		height: 100%;
		background-color: transparent;
		border: 1px solid #e6e6e6;
		border-radius: 0 12px 12px 0;
		/* 修改:左上角和左下角12px圆角，右上角和右下角直角 */
		overflow: hidden;
		padding: 0;
		/* 修改:移除内边距 */
		display: flex;
		flex-direction: column;
	}

	.patient-tables {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding: 0 !important;
		/* 移除内边距 */
		margin: 0;
	}

	/* 基础布局样式 */
	.medical-workstation {
		width: 100%;
		display: flex;
		flex-direction: column;
		height: 85vh;
		overflow: hidden;
	}

	/* 顶部导航栏 */
	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20px;
		background-color: #fff;
		border-bottom: 1px solid #e6e6e6;
		height: 60px;
	}

	.header-left,
	.header-right {
		display: flex;
		align-items: center;
	}

	/* 主容器 */
	.main-container {
		width: 100%;
		display: flex;
		flex: 1;
		overflow: hidden;
	}


	/* 患者列表区域 */
	.patient-list {
		background-color: transparent;
		border-radius: 8px;
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}


	.table-header {
		padding: 8px 8px;
		background-color: #f0f7ff;
		border-bottom: 1px solid #e6e6e6;
		font-weight: 600;
		color: #1890ff;
		font-size: 14px;
		display: flex;
		/* 添加flex布局 */
		justify-content: space-between;
		/* 两端对齐 */
		align-items: center;
		/* 垂直居中 */
	}

	.content-header {
		background-color: #f0f7ff;
		font-weight: 600;
		color: #1890ff;
		font-size: 14px;
		width: 100%;
		margin-top: 0;
		/* 移除负边距 */
		box-sizing: border-box;
		/* 确保宽度包含内边距 */
		position: sticky;
		/* 粘性定位确保顶部显示 */
		top: 0;
		z-index: 1;
		/* 防止内容遮挡 */
		display: flex;
		/* 添加flex布局 */
		justify-content: space-between;
		/* 两端对齐 */
		align-items: center;
		/* 垂直居中 */
		padding: 8px 8px;
		/* 调整内边距 */
	}

	.header-content {
		display: flex;
		/* 标题区域flex布局 */
		align-items: center;
	}

	.clinic-title {
		margin-left: 20px;
		/* 门诊文字右移 */
		font-size: 14px;
	}

	.visit-count {
		margin-left: 30px;
		/* 就诊次数进一步右移 */
		color: #5dd94b;
		/* 次要信息颜色 */
		font-size: 12px;
		font-weight: bold;
		/* 字体加粗 */
	}

	.header-actions {
		display: flex;
		/* 按钮组flex布局 */
		gap: 8px;
		/* 按钮间距 */
	}


	.upper-table {
		flex: 4;
	}

	.lower-table {
		flex: 5;
	}

	.el-table {
		flex: 1;
		width: 100% !important;
		margin: 0;
		border-collapse: collapse;
		font-size: 13px;
	}


	.el-table__header-wrapper,
	.el-table__body-wrapper {
		border: none;
	}

	/* 主内容区域 */
	.content {
		flex: 1;
    height: 100%;
		overflow-y: auto;
		border: 1px solid #e6e6e6;
		display: flex;
		flex-direction: column;
	}

	/* 患者基本信息 */
	.patient-basic-info {
		display: flex;
		align-items: center;
		padding: 15px;
		background-color: #fff;
		border-radius: 4px;
		margin-bottom: 15px;
	}


	/* 病历记录区域 */
	.medical-record {
		background-color: #fff;
		border-radius: 4px;
		margin-bottom: 15px;
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		border: 1px solid #e6e6e6;
	}

	.record-tabs {
		padding: 15px;
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.record-content {
		flex: 1;
		overflow-y: auto;
	}

	/* 诊疗方案 */
	.treatment-plan {
		background-color: #fff;
		border-radius: 4px;
		margin-bottom: 15px;
		flex: 1.5;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.treatment-plan-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	/* 处方预览 */
	.prescription-preview {
		background-color: #fff;
		border-radius: 4px;
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.prescription-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.prescription-content {
		padding: 20px;
		flex: 1;
		overflow-y: auto;
	}

	/* 费用总计 */
	.cost-summary {
		padding: 15px;
		border-bottom: 1px solid #e6e6e6;
	}

	.cost-item {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.cost-total {
		display: flex;
		justify-content: space-between;
		font-weight: bold;
		margin-top: 15px;
		padding-top: 15px;
		border-top: 1px solid #ddd;
	}

	.total-value {
		color: #f56c6c;
		font-size: 18px;
	}

	/* 诊断结果 */
	.diagnosis-result {
		padding: 15px;
		border-radius: 4px;
		flex: 1;
		overflow-y: auto;
	}

	.diagnosis-item {
		padding: 10px;
		background-color: #fff;
		margin-bottom: 10px;
		border-radius: 4px;
		border-left: 3px solid #409eff;
	}

	.diagnosis-code {
		font-size: 12px;
		color: #999;
	}

	/* 底部工具栏 */
	.bottom-tools {
		display: flex;
		padding: 10px 20px;
		background-color: #fff;
		border-top: 1px solid #e6e6e6;
		height: 50px;
	}

	.seedoctorMedical {
		padding: 5px 10px;
	}

	.seedoctorMedical ::v-deep .el-descriptions {
		margin: 2px 0 !important;
	}

	.seedoctorMedical ::v-deep .el-descriptions__table {
		border-radius: 6px;
		overflow: hidden;
		background-color: #fffbe6;
		width: 100%;
		border-collapse: separate;
		/* 关键:独立边框控制 */
		border-spacing: 0;
		font-size: 12px !important;
		/* 缩小字体 */
	}

	.seedoctorMedical ::v-deep .el-descriptions-item__cell {
		background-color: #fffbe6 !important;
		padding: 0 !important;
		/* 移除默认内边距 */
	}

	.seedoctorMedical ::v-deep .el-descriptions-item__label.is-bordered-label {
		border-color: #e6e6e6;
		width: auto;
		/* 固定label宽度 */
		min-width: 100px;
	}

	.seedoctorMedical ::v-deep .el-descriptions-item__content {
		border-color: #e6e6e6;
		width: calc(100% - 100px);
		/* 剩余宽度给内容区 */
	}

	.seedoctorMedical ::v-deep .el-descriptions-item__label.is-bordered-label {
		width: 100px;
		min-width: 100px;
		border-color: #dcdfe6;
	}

	.seedoctorMedical ::v-deep .el-descriptions-item__content {
		width: calc(100% - 100px);
		border-color: #dcdfe6;
	}

	/* 病历表头样式 */
	.medical-header {
		background: white;
		border-radius: 8px 8px 0 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid #dcdfe6;
		border-bottom: none;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

	}

	.medical-header span {
		color: #1890ff;
		font-weight: bold;
	}

	.header-actions .el-button {
		margin-left: 10px;
	}

	/* 调整表格圆角 */
	.seedoctorMedical ::v-deep .el-descriptions__table {
		border-radius: 0 0 8px 8px;
		border-top: none;
	}

	.seedoctorMedical ::v-deep .el-descriptions-item__label.is-bordered-label,
	.seedoctorMedical ::v-deep .el-descriptions-item__content {
		border-color: #dcdfe6;
	}

	::v-deep .el-cascader .el-input__inner::placeholder {
		color: var(--el-text-color-placeholder) !important;
		/* 使用官方变量 */
	}
</style>
